import { property as Dt } from "../beacon-property.d/index.js";
import { h as Cs, i as As, a as ks, g as fi, j as Ss, k as Ts } from "./variables-DpYn0Mcl.js";
import { i as $e } from "./reactive-element-CzWTglSF.js";
import { html as Yi } from "../beacon-html.d/index.js";
import "./lit-element-sPTOReu4.js";
import { state as Ms } from "../beacon-state.d/index.js";
import { query as Es } from "../beacon-query.d/index.js";
import { classMap as mi } from "../beacon-class-map.d/index.js";
import { p as Ps, a as Os, m as Ls } from "./lifecycle-decorators-Cg3csm0R.js";
import { q as Ds } from "./query-assigned-k8xhF0hV.js";
import { s as je } from "./showIfUsed-CmxG6fny.js";
import { BeaconTable as Ns } from "../beacon-table/index.js";
import { B as Is } from "./abstract-base-DDNz9tUt.js";
import "../beacon-unsafe-svg.d/index.js";
var js = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ce(E) {
  return E && E.__esModule && Object.prototype.hasOwnProperty.call(E, "default") ? E.default : E;
}
var _i = { exports: {} };
(function(E) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(I, i) {
    E.exports ? (i.default = i, E.exports = I && I.document ? i(I) : i) : (I.Highcharts && I.Highcharts.error(16, !0), I.Highcharts = i(I));
  })(typeof window < "u" ? window : js, function(I) {
    var i = {};
    function nt(B, $, J, it) {
      !B.hasOwnProperty($) && (B[$] = it.apply(null, J), I && typeof CustomEvent == "function" && I.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: $, module: B[$] } })));
    }
    return nt(i, "Core/Globals.js", [], function() {
      var B, $;
      return ($ = B || (B = {})).SVG_NS = "http://www.w3.org/2000/svg", $.product = "Highcharts", $.version = "11.4.8", $.win = I !== void 0 ? I : {}, $.doc = $.win.document, $.svg = $.doc && $.doc.createElementNS && !!$.doc.createElementNS($.SVG_NS, "svg").createSVGRect, $.userAgent = $.win.navigator && $.win.navigator.userAgent || "", $.isChrome = $.win.chrome, $.isFirefox = $.userAgent.indexOf("Firefox") !== -1, $.isMS = /(edge|msie|trident)/i.test($.userAgent) && !$.win.opera, $.isSafari = !$.isChrome && $.userAgent.indexOf("Safari") !== -1, $.isTouchDevice = /(Mobile|Android|Windows Phone)/.test($.userAgent), $.isWebKit = $.userAgent.indexOf("AppleWebKit") !== -1, $.deg2rad = 2 * Math.PI / 360, $.hasBidiBug = $.isFirefox && 4 > parseInt($.userAgent.split("Firefox/")[1], 10), $.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], $.noop = function() {
      }, $.supportsPassiveEvents = function() {
        let J = !1;
        if (!$.isMS) {
          let it = Object.defineProperty({}, "passive", { get: function() {
            J = !0;
          } });
          $.win.addEventListener && $.win.removeEventListener && ($.win.addEventListener("testPassive", $.noop, it), $.win.removeEventListener("testPassive", $.noop, it));
        }
        return J;
      }(), $.charts = [], $.composed = [], $.dateFormats = {}, $.seriesTypes = {}, $.symbolSizes = {}, $.chartCount = 0, B;
    }), nt(i, "Core/Utilities.js", [i["Core/Globals.js"]], function(B) {
      let $, { charts: J, doc: it, win: st } = B;
      function tt(t, e, r, g) {
        let o = e ? "Highcharts error" : "Highcharts warning";
        t === 32 && (t = `${o}: Deprecated member`);
        let c = m(t), n = c ? `${o} #${t}: www.highcharts.com/errors/${t}/` : t.toString();
        if (g !== void 0) {
          let S = "";
          c && (n += "?"), O(g, function(j, v) {
            S += `
 - ${v}: ${j}`, c && (n += encodeURI(v) + "=" + encodeURI(j));
          }), n += S;
        }
        f(B, "displayError", { chart: r, code: t, message: n, params: g }, function() {
          if (e) throw Error(n);
          st.console && tt.messages.indexOf(n) === -1 && console.warn(n);
        }), tt.messages.push(n);
      }
      function V(t, e) {
        return parseInt(t, e || 10);
      }
      function _(t) {
        return typeof t == "string";
      }
      function N(t) {
        let e = Object.prototype.toString.call(t);
        return e === "[object Array]" || e === "[object Array Iterator]";
      }
      function D(t, e) {
        return !!t && typeof t == "object" && (!e || !N(t));
      }
      function p(t) {
        return D(t) && typeof t.nodeType == "number";
      }
      function y(t) {
        let e = t && t.constructor;
        return !!(D(t, !0) && !p(t) && e && e.name && e.name !== "Object");
      }
      function m(t) {
        return typeof t == "number" && !isNaN(t) && t < 1 / 0 && t > -1 / 0;
      }
      function w(t) {
        return t != null;
      }
      function a(t, e, r) {
        let g, o = _(e) && !w(r), c = (n, S) => {
          w(n) ? t.setAttribute(S, n) : o ? (g = t.getAttribute(S)) || S !== "class" || (g = t.getAttribute(S + "Name")) : t.removeAttribute(S);
        };
        return _(e) ? c(r, e) : O(e, c), g;
      }
      function u(t) {
        return N(t) ? t : [t];
      }
      function b(t, e) {
        let r;
        for (r in t || (t = {}), e) t[r] = e[r];
        return t;
      }
      function l() {
        let t = arguments, e = t.length;
        for (let r = 0; r < e; r++) {
          let g = t[r];
          if (g != null) return g;
        }
      }
      function d(t, e) {
        b(t.style, e);
      }
      function C(t) {
        return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
      }
      function R(t, e) {
        return t > 1e14 ? t : parseFloat(t.toPrecision(e || 14));
      }
      (tt || (tt = {})).messages = [], Math.easeInOutSine = function(t) {
        return -0.5 * (Math.cos(Math.PI * t) - 1);
      };
      let z = Array.prototype.find ? function(t, e) {
        return t.find(e);
      } : function(t, e) {
        let r, g = t.length;
        for (r = 0; r < g; r++) if (e(t[r], r)) return t[r];
      };
      function O(t, e, r) {
        for (let g in t) Object.hasOwnProperty.call(t, g) && e.call(r || t[g], t[g], g, t);
      }
      function h(t, e, r) {
        function g(n, S) {
          let j = t.removeEventListener;
          j && j.call(t, n, S, !1);
        }
        function o(n) {
          let S, j;
          t.nodeName && (e ? (S = {})[e] = !0 : S = n, O(S, function(v, P) {
            if (n[P]) for (j = n[P].length; j--; ) g(P, n[P][j].fn);
          }));
        }
        let c = typeof t == "function" && t.prototype || t;
        if (Object.hasOwnProperty.call(c, "hcEvents")) {
          let n = c.hcEvents;
          if (e) {
            let S = n[e] || [];
            r ? (n[e] = S.filter(function(j) {
              return r !== j.fn;
            }), g(e, r)) : (o(n), n[e] = []);
          } else o(n), delete c.hcEvents;
        }
      }
      function f(t, e, r, g) {
        if (r = r || {}, it.createEvent && (t.dispatchEvent || t.fireEvent && t !== B)) {
          let o = it.createEvent("Events");
          o.initEvent(e, !0, !0), r = b(o, r), t.dispatchEvent ? t.dispatchEvent(r) : t.fireEvent(e, r);
        } else if (t.hcEvents) {
          r.target || b(r, { preventDefault: function() {
            r.defaultPrevented = !0;
          }, target: t, type: e });
          let o = [], c = t, n = !1;
          for (; c.hcEvents; ) Object.hasOwnProperty.call(c, "hcEvents") && c.hcEvents[e] && (o.length && (n = !0), o.unshift.apply(o, c.hcEvents[e])), c = Object.getPrototypeOf(c);
          n && o.sort((S, j) => S.order - j.order), o.forEach((S) => {
            S.fn.call(t, r) === !1 && r.preventDefault();
          });
        }
        g && !r.defaultPrevented && g.call(t, r);
      }
      O({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(t, e) {
        B[e] = function(r) {
          return tt(32, !1, void 0, { [`Highcharts.${e}`]: `use Array.${t}` }), Array.prototype[t].apply(r, [].slice.call(arguments, 1));
        };
      });
      let s = function() {
        let t = Math.random().toString(36).substring(2, 9) + "-", e = 0;
        return function() {
          return "highcharts-" + ($ ? "" : t) + e++;
        };
      }();
      return st.jQuery && (st.jQuery.fn.highcharts = function() {
        let t = [].slice.call(arguments);
        if (this[0]) return t[0] ? (new B[_(t[0]) ? t.shift() : "Chart"](this[0], t[0], t[1]), this) : J[a(this[0], "data-highcharts-chart")];
      }), { addEvent: function(t, e, r, g = {}) {
        let o = typeof t == "function" && t.prototype || t;
        Object.hasOwnProperty.call(o, "hcEvents") || (o.hcEvents = {});
        let c = o.hcEvents;
        B.Point && t instanceof B.Point && t.series && t.series.chart && (t.series.chart.runTrackerClick = !0);
        let n = t.addEventListener;
        n && n.call(t, e, r, !!B.supportsPassiveEvents && { passive: g.passive === void 0 ? e.indexOf("touch") !== -1 : g.passive, capture: !1 }), c[e] || (c[e] = []);
        let S = { fn: r, order: typeof g.order == "number" ? g.order : 1 / 0 };
        return c[e].push(S), c[e].sort((j, v) => j.order - v.order), function() {
          h(t, e, r);
        };
      }, arrayMax: function(t) {
        let e = t.length, r = t[0];
        for (; e--; ) t[e] > r && (r = t[e]);
        return r;
      }, arrayMin: function(t) {
        let e = t.length, r = t[0];
        for (; e--; ) t[e] < r && (r = t[e]);
        return r;
      }, attr: a, clamp: function(t, e, r) {
        return t > e ? t < r ? t : r : e;
      }, clearTimeout: function(t) {
        w(t) && clearTimeout(t);
      }, correctFloat: R, createElement: function(t, e, r, g, o) {
        let c = it.createElement(t);
        return e && b(c, e), o && d(c, { padding: "0", border: "none", margin: "0" }), r && d(c, r), g && g.appendChild(c), c;
      }, crisp: (t, e = 0, r) => {
        let g = e % 2 / 2, o = r ? -1 : 1;
        return (Math.round(t * o - g) + g) * o;
      }, css: d, defined: w, destroyObjectProperties: function(t, e, r) {
        O(t, function(g, o) {
          g !== e && (g != null && g.destroy) && g.destroy(), (g != null && g.destroy || !r) && delete t[o];
        });
      }, diffObjects: function(t, e, r, g) {
        let o = {};
        return function c(n, S, j, v) {
          let P = r ? S : n;
          O(n, function(G, W) {
            if (!v && g && g.indexOf(W) > -1 && S[W]) {
              G = u(G), j[W] = [];
              for (let Q = 0; Q < Math.max(G.length, S[W].length); Q++) S[W][Q] && (G[Q] === void 0 ? j[W][Q] = S[W][Q] : (j[W][Q] = {}, c(G[Q], S[W][Q], j[W][Q], v + 1)));
            } else D(G, !0) && !G.nodeType ? (j[W] = N(G) ? [] : {}, c(G, S[W] || {}, j[W], v + 1), Object.keys(j[W]).length !== 0 || W === "colorAxis" && v === 0 || delete j[W]) : (n[W] !== S[W] || W in n && !(W in S)) && W !== "__proto__" && W !== "constructor" && (j[W] = P[W]);
          });
        }(t, e, o, 0), o;
      }, discardElement: function(t) {
        t && t.parentElement && t.parentElement.removeChild(t);
      }, erase: function(t, e) {
        let r = t.length;
        for (; r--; ) if (t[r] === e) {
          t.splice(r, 1);
          break;
        }
      }, error: tt, extend: b, extendClass: function(t, e) {
        let r = function() {
        };
        return r.prototype = new t(), b(r.prototype, e), r;
      }, find: z, fireEvent: f, getClosestDistance: function(t, e) {
        let r, g, o, c = !e;
        return t.forEach((n) => {
          if (n.length > 1) for (o = n.length - 1; o > 0; o--) (g = n[o] - n[o - 1]) < 0 && !c ? (e == null || e(), e = void 0) : g && (r === void 0 || g < r) && (r = g);
        }), r;
      }, getMagnitude: C, getNestedProperty: function(t, e) {
        let r = t.split(".");
        for (; r.length && w(e); ) {
          let g = r.shift();
          if (g === void 0 || g === "__proto__") return;
          if (g === "this") {
            let c;
            return D(e) && (c = e["@this"]), c != null ? c : e;
          }
          let o = e[g];
          if (!w(o) || typeof o == "function" || typeof o.nodeType == "number" || o === st) return;
          e = o;
        }
        return e;
      }, getStyle: function t(e, r, g) {
        let o;
        if (r === "width") {
          let n = Math.min(e.offsetWidth, e.scrollWidth), S = e.getBoundingClientRect && e.getBoundingClientRect().width;
          return S < n && S >= n - 1 && (n = Math.floor(S)), Math.max(0, n - (t(e, "padding-left", !0) || 0) - (t(e, "padding-right", !0) || 0));
        }
        if (r === "height") return Math.max(0, Math.min(e.offsetHeight, e.scrollHeight) - (t(e, "padding-top", !0) || 0) - (t(e, "padding-bottom", !0) || 0));
        let c = st.getComputedStyle(e, void 0);
        return c && (o = c.getPropertyValue(r), l(g, r !== "opacity") && (o = V(o))), o;
      }, inArray: function(t, e, r) {
        return tt(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), e.indexOf(t, r);
      }, insertItem: function(t, e) {
        let r, g = t.options.index, o = e.length;
        for (r = t.options.isInternal ? o : 0; r < o + 1; r++) if (!e[r] || m(g) && g < l(e[r].options.index, e[r]._i) || e[r].options.isInternal) {
          e.splice(r, 0, t);
          break;
        }
        return r;
      }, isArray: N, isClass: y, isDOMElement: p, isFunction: function(t) {
        return typeof t == "function";
      }, isNumber: m, isObject: D, isString: _, keys: function(t) {
        return tt(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(t);
      }, merge: function() {
        let t, e = arguments, r = {}, g = function(c, n) {
          return typeof c != "object" && (c = {}), O(n, function(S, j) {
            j !== "__proto__" && j !== "constructor" && (!D(S, !0) || y(S) || p(S) ? c[j] = n[j] : c[j] = g(c[j] || {}, S));
          }), c;
        };
        e[0] === !0 && (r = e[1], e = Array.prototype.slice.call(e, 2));
        let o = e.length;
        for (t = 0; t < o; t++) r = g(r, e[t]);
        return r;
      }, normalizeTickInterval: function(t, e, r, g, o) {
        let c, n = t;
        r = l(r, C(t));
        let S = t / r;
        for (!e && (e = o ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], g === !1 && (r === 1 ? e = e.filter(function(j) {
          return j % 1 == 0;
        }) : r <= 0.1 && (e = [1 / r]))), c = 0; c < e.length && (n = e[c], (!o || !(n * r >= t)) && (o || !(S <= (e[c] + (e[c + 1] || e[c])) / 2))); c++) ;
        return R(n * r, -Math.round(Math.log(1e-3) / Math.LN10));
      }, objectEach: O, offset: function(t) {
        let e = it.documentElement, r = t.parentElement || t.parentNode ? t.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
        return { top: r.top + (st.pageYOffset || e.scrollTop) - (e.clientTop || 0), left: r.left + (st.pageXOffset || e.scrollLeft) - (e.clientLeft || 0), width: r.width, height: r.height };
      }, pad: function(t, e, r) {
        return Array((e || 2) + 1 - String(t).replace("-", "").length).join(r || "0") + t;
      }, pick: l, pInt: V, pushUnique: function(t, e) {
        return 0 > t.indexOf(e) && !!t.push(e);
      }, relativeLength: function(t, e, r) {
        return /%$/.test(t) ? e * parseFloat(t) / 100 + (r || 0) : parseFloat(t);
      }, removeEvent: h, replaceNested: function(t, ...e) {
        let r, g;
        do
          for (g of (r = t, e)) t = t.replace(g[0], g[1]);
        while (t !== r);
        return t;
      }, splat: u, stableSort: function(t, e) {
        let r, g, o = t.length;
        for (g = 0; g < o; g++) t[g].safeI = g;
        for (t.sort(function(c, n) {
          return (r = e(c, n)) === 0 ? c.safeI - n.safeI : r;
        }), g = 0; g < o; g++) delete t[g].safeI;
      }, syncTimeout: function(t, e, r) {
        return e > 0 ? setTimeout(t, e, r) : (t.call(0, r), -1);
      }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: s, useSerialIds: function(t) {
        return $ = l(t, $);
      }, wrap: function(t, e, r) {
        let g = t[e];
        t[e] = function() {
          let o = arguments, c = this;
          return r.apply(this, [function() {
            return g.apply(c, arguments.length ? arguments : o);
          }].concat([].slice.call(arguments)));
        };
      } };
    }), nt(i, "Core/Chart/ChartDefaults.js", [], function() {
      return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: {}, position: {} }, reflow: !0, type: "line", zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#334eff", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
    }), nt(i, "Core/Color/Palettes.js", [], function() {
      return { colors: ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42", "#feb56a", "#91e8e1"] };
    }), nt(i, "Core/Time.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let { win: J } = B, { defined: it, error: st, extend: tt, isNumber: V, isObject: _, merge: N, objectEach: D, pad: p, pick: y, splat: m, timeUnits: w } = $, a = B.isSafari && J.Intl && J.Intl.DateTimeFormat.prototype.formatRange, u = B.isSafari && J.Intl && !J.Intl.DateTimeFormat.prototype.formatRange;
      class b {
        constructor(d) {
          this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = J.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(d);
        }
        get(d, C) {
          if (this.variableTimezone || this.timezoneOffset) {
            let R = C.getTime(), z = R - this.getTimezoneOffset(C);
            C.setTime(z);
            let O = C["getUTC" + d]();
            return C.setTime(R), O;
          }
          return this.useUTC ? C["getUTC" + d]() : C["get" + d]();
        }
        set(d, C, R) {
          if (this.variableTimezone || this.timezoneOffset) {
            if (d === "Milliseconds" || d === "Seconds" || d === "Minutes" && this.getTimezoneOffset(C) % 36e5 == 0) return C["setUTC" + d](R);
            let z = this.getTimezoneOffset(C), O = C.getTime() - z;
            C.setTime(O), C["setUTC" + d](R);
            let h = this.getTimezoneOffset(C);
            return O = C.getTime() + h, C.setTime(O);
          }
          return this.useUTC || a && d === "FullYear" ? C["setUTC" + d](R) : C["set" + d](R);
        }
        update(d = {}) {
          let C = y(d.useUTC, !0);
          this.options = d = N(!0, this.options, d), this.Date = d.Date || J.Date || Date, this.useUTC = C, this.timezoneOffset = C && d.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = C && !!(d.getTimezoneOffset || d.timezone);
        }
        makeTime(d, C, R, z, O, h) {
          let f, s, t;
          return this.useUTC ? (f = this.Date.UTC.apply(0, arguments), s = this.getTimezoneOffset(f), f += s, s !== (t = this.getTimezoneOffset(f)) ? f += t - s : s - 36e5 !== this.getTimezoneOffset(f - 36e5) || u || (f -= 36e5)) : f = new this.Date(d, C, y(R, 1), y(z, 0), y(O, 0), y(h, 0)).getTime(), f;
        }
        timezoneOffsetFunction() {
          let d = this, C = this.options, R = C.getTimezoneOffset;
          return this.useUTC ? C.timezone ? (z) => {
            try {
              let O = `shortOffset,${C.timezone || ""}`, [h, f, s, t, e = 0] = (b.formatCache[O] = b.formatCache[O] || Intl.DateTimeFormat("en", { timeZone: C.timezone, timeZoneName: "shortOffset" })).format(z).split(/(GMT|:)/).map(Number), r = -(36e5 * (s + e / 60));
              if (V(r)) return r;
            } catch {
              st(34);
            }
            return 0;
          } : this.useUTC && R ? (z) => 6e4 * R(z.valueOf()) : () => 6e4 * (d.timezoneOffset || 0) : (z) => 6e4 * new Date(z.toString()).getTimezoneOffset();
        }
        dateFormat(d, C, R) {
          if (!it(C) || isNaN(C)) return B.defaultOptions.lang && B.defaultOptions.lang.invalidDate || "";
          d = y(d, "%Y-%m-%d %H:%M:%S");
          let z = this, O = new this.Date(C), h = this.get("Hours", O), f = this.get("Day", O), s = this.get("Date", O), t = this.get("Month", O), e = this.get("FullYear", O), r = B.defaultOptions.lang, g = r && r.weekdays, o = r && r.shortWeekdays;
          return D(tt({ a: o ? o[f] : g[f].substr(0, 3), A: g[f], d: p(s), e: p(s, 2, " "), w: f, b: r.shortMonths[t], B: r.months[t], m: p(t + 1), o: t + 1, y: e.toString().substr(2, 2), Y: e, H: p(h), k: h, I: p(h % 12 || 12), l: h % 12 || 12, M: p(this.get("Minutes", O)), p: h < 12 ? "AM" : "PM", P: h < 12 ? "am" : "pm", S: p(this.get("Seconds", O)), L: p(Math.floor(C % 1e3), 3) }, B.dateFormats), function(c, n) {
            for (; d.indexOf("%" + n) !== -1; ) d = d.replace("%" + n, typeof c == "function" ? c.call(z, C) : c);
          }), R ? d.substr(0, 1).toUpperCase() + d.substr(1) : d;
        }
        resolveDTLFormat(d) {
          return _(d, !0) ? d : { main: (d = m(d))[0], from: d[1], to: d[2] };
        }
        getTimeTicks(d, C, R, z) {
          let O, h, f, s, t = this, e = t.Date, r = [], g = {}, o = new e(C), c = d.unitRange, n = d.count || 1;
          if (z = y(z, 1), it(C)) {
            t.set("Milliseconds", o, c >= w.second ? 0 : n * Math.floor(t.get("Milliseconds", o) / n)), c >= w.second && t.set("Seconds", o, c >= w.minute ? 0 : n * Math.floor(t.get("Seconds", o) / n)), c >= w.minute && t.set("Minutes", o, c >= w.hour ? 0 : n * Math.floor(t.get("Minutes", o) / n)), c >= w.hour && t.set("Hours", o, c >= w.day ? 0 : n * Math.floor(t.get("Hours", o) / n)), c >= w.day && t.set("Date", o, c >= w.month ? 1 : Math.max(1, n * Math.floor(t.get("Date", o) / n))), c >= w.month && (t.set("Month", o, c >= w.year ? 0 : n * Math.floor(t.get("Month", o) / n)), h = t.get("FullYear", o)), c >= w.year && (h -= h % n, t.set("FullYear", o, h)), c === w.week && (s = t.get("Day", o), t.set("Date", o, t.get("Date", o) - s + z + (s < z ? -7 : 0))), h = t.get("FullYear", o);
            let S = t.get("Month", o), j = t.get("Date", o), v = t.get("Hours", o);
            C = o.getTime(), (t.variableTimezone || !t.useUTC) && it(R) && (f = R - C > 4 * w.month || t.getTimezoneOffset(C) !== t.getTimezoneOffset(R));
            let P = o.getTime();
            for (O = 1; P < R; ) r.push(P), c === w.year ? P = t.makeTime(h + O * n, 0) : c === w.month ? P = t.makeTime(h, S + O * n) : f && (c === w.day || c === w.week) ? P = t.makeTime(h, S, j + O * n * (c === w.day ? 1 : 7)) : f && c === w.hour && n > 1 ? P = t.makeTime(h, S, j, v + O * n) : P += c * n, O++;
            r.push(P), c <= w.hour && r.length < 1e4 && r.forEach(function(G) {
              G % 18e5 == 0 && t.dateFormat("%H%M%S%L", G) === "000000000" && (g[G] = "day");
            });
          }
          return r.info = tt(d, { higherRanks: g, totalRange: c * n }), r;
        }
        getDateFormat(d, C, R, z) {
          let O = this.dateFormat("%m-%d %H:%M:%S.%L", C), h = "01-01 00:00:00.000", f = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, s = "millisecond", t = s;
          for (s in w) {
            if (d === w.week && +this.dateFormat("%w", C) === R && O.substr(6) === h.substr(6)) {
              s = "week";
              break;
            }
            if (w[s] > d) {
              s = t;
              break;
            }
            if (f[s] && O.substr(f[s]) !== h.substr(f[s])) break;
            s !== "week" && (t = s);
          }
          return this.resolveDTLFormat(z[s]).main;
        }
      }
      return b.formatCache = {}, b;
    }), nt(i, "Core/Defaults.js", [i["Core/Chart/ChartDefaults.js"], i["Core/Globals.js"], i["Core/Color/Palettes.js"], i["Core/Time.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      let { isTouchDevice: tt } = $, { fireEvent: V, merge: _ } = st, N = { colors: J.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { buttonTheme: { fill: "#f7f7f7", padding: 8, r: 2, stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer", fontSize: "0.8em", fontWeight: "normal" }, states: { hover: { fill: "#e6e6e6" }, select: { fill: "#e6e9ff", style: { color: "#000000", fontWeight: "bold" } }, disabled: { style: { color: "#cccccc" } } } } }, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: B, title: { style: { color: "#333333", fontWeight: "bold" }, text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", events: {}, layout: "horizontal", itemMarginBottom: 2, itemMarginTop: 2, labelFormatter: function() {
        return this.name;
      }, borderColor: "#999999", borderRadius: 0, navigation: { style: { fontSize: "0.8em" }, activeColor: "#0022ff", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "0.8em", textDecoration: "none", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#666666", textDecoration: "line-through" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontSize: "0.8em", fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: { duration: 300, easing: (p) => Math.sqrt(1 - Math.pow(p - 1, 2)) }, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %e %b, %H:%M:%S.%L", second: "%A, %e %b, %H:%M:%S", minute: "%A, %e %b, %H:%M", hour: "%A, %e %b, %H:%M", day: "%A, %e %b %Y", week: "Week from %A, %e %b %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: tt ? 25 : 10, headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: "#ffffff", borderWidth: void 0, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "0.8em" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "0.6em" }, text: "Highcharts.com" } };
      N.chart.styledMode = !1;
      let D = new it(N.time);
      return { defaultOptions: N, defaultTime: D, getOptions: function() {
        return N;
      }, setOptions: function(p) {
        return V($, "setOptions", { options: p }), _(!0, N, p), (p.time || p.global) && ($.time ? $.time.update(_(N.global, N.time, p.global, p.time)) : $.time = D), N;
      } };
    }), nt(i, "Core/Color/Color.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let { isNumber: J, merge: it, pInt: st } = $;
      class tt {
        static parse(_) {
          return _ ? new tt(_) : tt.None;
        }
        constructor(_) {
          let N, D, p, y;
          this.rgba = [NaN, NaN, NaN, NaN], this.input = _;
          let m = B.Color;
          if (m && m !== tt) return new m(_);
          if (typeof _ == "object" && _.stops !== void 0) this.stops = _.stops.map((w) => new tt(w[1]));
          else if (typeof _ == "string") {
            if (this.input = _ = tt.names[_.toLowerCase()] || _, _.charAt(0) === "#") {
              let w = _.length, a = parseInt(_.substr(1), 16);
              w === 7 ? D = [(16711680 & a) >> 16, (65280 & a) >> 8, 255 & a, 1] : w === 4 && (D = [(3840 & a) >> 4 | (3840 & a) >> 8, (240 & a) >> 4 | 240 & a, (15 & a) << 4 | 15 & a, 1]);
            }
            if (!D) for (p = tt.parsers.length; p-- && !D; ) (N = (y = tt.parsers[p]).regex.exec(_)) && (D = y.parse(N));
          }
          D && (this.rgba = D);
        }
        get(_) {
          let N = this.input, D = this.rgba;
          if (typeof N == "object" && this.stops !== void 0) {
            let p = it(N);
            return p.stops = [].slice.call(p.stops), this.stops.forEach((y, m) => {
              p.stops[m] = [p.stops[m][0], y.get(_)];
            }), p;
          }
          return D && J(D[0]) ? _ !== "rgb" && (_ || D[3] !== 1) ? _ === "a" ? `${D[3]}` : "rgba(" + D.join(",") + ")" : "rgb(" + D[0] + "," + D[1] + "," + D[2] + ")" : N;
        }
        brighten(_) {
          let N = this.rgba;
          if (this.stops) this.stops.forEach(function(D) {
            D.brighten(_);
          });
          else if (J(_) && _ !== 0) for (let D = 0; D < 3; D++) N[D] += st(255 * _), N[D] < 0 && (N[D] = 0), N[D] > 255 && (N[D] = 255);
          return this;
        }
        setOpacity(_) {
          return this.rgba[3] = _, this;
        }
        tweenTo(_, N) {
          let D = this.rgba, p = _.rgba;
          if (!J(D[0]) || !J(p[0])) return _.input || "none";
          let y = p[3] !== 1 || D[3] !== 1;
          return (y ? "rgba(" : "rgb(") + Math.round(p[0] + (D[0] - p[0]) * (1 - N)) + "," + Math.round(p[1] + (D[1] - p[1]) * (1 - N)) + "," + Math.round(p[2] + (D[2] - p[2]) * (1 - N)) + (y ? "," + (p[3] + (D[3] - p[3]) * (1 - N)) : "") + ")";
        }
      }
      return tt.names = { white: "#ffffff", black: "#000000" }, tt.parsers = [{ regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/, parse: function(V) {
        return [st(V[1]), st(V[2]), st(V[3]), parseFloat(V[4], 10)];
      } }, { regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/, parse: function(V) {
        return [st(V[1]), st(V[2]), st(V[3]), 1];
      } }], tt.None = new tt(""), tt;
    }), nt(i, "Core/Animation/Fx.js", [i["Core/Color/Color.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { parse: it } = B, { win: st } = $, { isNumber: tt, objectEach: V } = J;
      class _ {
        constructor(D, p, y) {
          this.pos = NaN, this.options = p, this.elem = D, this.prop = y;
        }
        dSetter() {
          let D = this.paths, p = D && D[0], y = D && D[1], m = this.now || 0, w = [];
          if (m !== 1 && p && y)
            if (p.length === y.length && m < 1) for (let a = 0; a < y.length; a++) {
              let u = p[a], b = y[a], l = [];
              for (let d = 0; d < b.length; d++) {
                let C = u[d], R = b[d];
                tt(C) && tt(R) && !(b[0] === "A" && (d === 4 || d === 5)) ? l[d] = C + m * (R - C) : l[d] = R;
              }
              w.push(l);
            }
            else w = y;
          else w = this.toD || [];
          this.elem.attr("d", w, void 0, !0);
        }
        update() {
          let D = this.elem, p = this.prop, y = this.now, m = this.options.step;
          this[p + "Setter"] ? this[p + "Setter"]() : D.attr ? D.element && D.attr(p, y, null, !0) : D.style[p] = y + this.unit, m && m.call(D, y, this);
        }
        run(D, p, y) {
          let m = this, w = m.options, a = function(l) {
            return !a.stopped && m.step(l);
          }, u = st.requestAnimationFrame || function(l) {
            setTimeout(l, 13);
          }, b = function() {
            for (let l = 0; l < _.timers.length; l++) _.timers[l]() || _.timers.splice(l--, 1);
            _.timers.length && u(b);
          };
          D !== p || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = D, this.end = p, this.unit = y, this.now = this.start, this.pos = 0, a.elem = this.elem, a.prop = this.prop, a() && _.timers.push(a) === 1 && u(b)) : (delete w.curAnim[this.prop], w.complete && Object.keys(w.curAnim).length === 0 && w.complete.call(this.elem));
        }
        step(D) {
          let p, y, m = +/* @__PURE__ */ new Date(), w = this.options, a = this.elem, u = w.complete, b = w.duration, l = w.curAnim;
          return a.attr && !a.element ? p = !1 : D || m >= b + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), l[this.prop] = !0, y = !0, V(l, function(d) {
            d !== !0 && (y = !1);
          }), y && u && u.call(a), p = !1) : (this.pos = w.easing((m - this.startTime) / b), this.now = this.start + (this.end - this.start) * this.pos, this.update(), p = !0), p;
        }
        initPath(D, p, y) {
          let m = D.startX, w = D.endX, a = y.slice(), u = D.isArea, b = u ? 2 : 1, l = p && y.length > p.length && y.hasStackedCliffs, d, C, R, z, O = p && p.slice();
          if (!O || l) return [a, a];
          function h(s, t) {
            for (; s.length < C; ) {
              let e = s[0], r = t[C - s.length];
              if (r && e[0] === "M" && (r[0] === "C" ? s[0] = ["C", e[1], e[2], e[1], e[2], e[1], e[2]] : s[0] = ["L", e[1], e[2]]), s.unshift(e), u) {
                let g = s.pop();
                s.push(s[s.length - 1], g);
              }
            }
          }
          function f(s) {
            for (; s.length < C; ) {
              let t = s[Math.floor(s.length / b) - 1].slice();
              if (t[0] === "C" && (t[1] = t[5], t[2] = t[6]), u) {
                let e = s[Math.floor(s.length / b)].slice();
                s.splice(s.length / 2, 0, t, e);
              } else s.push(t);
            }
          }
          if (m && w && w.length) {
            for (R = 0; R < m.length; R++) {
              if (m[R] === w[0]) {
                d = R;
                break;
              }
              if (m[0] === w[w.length - m.length + R]) {
                d = R, z = !0;
                break;
              }
              if (m[m.length - 1] === w[w.length - m.length + R]) {
                d = m.length - R;
                break;
              }
            }
            d === void 0 && (O = []);
          }
          return O.length && tt(d) && (C = a.length + d * b, z ? (h(O, a), f(a)) : (h(a, O), f(O))), [O, a];
        }
        fillSetter() {
          _.prototype.strokeSetter.apply(this, arguments);
        }
        strokeSetter() {
          this.elem.attr(this.prop, it(this.start).tweenTo(it(this.end), this.pos), void 0, !0);
        }
      }
      return _.timers = [], _;
    }), nt(i, "Core/Animation/AnimationUtilities.js", [i["Core/Animation/Fx.js"], i["Core/Utilities.js"]], function(B, $) {
      let { defined: J, getStyle: it, isArray: st, isNumber: tt, isObject: V, merge: _, objectEach: N, pick: D } = $;
      function p(m) {
        return V(m) ? _({ duration: 500, defer: 0 }, m) : { duration: m ? 500 : 0, defer: 0 };
      }
      function y(m, w) {
        let a = B.timers.length;
        for (; a--; ) B.timers[a].elem !== m || w && w !== B.timers[a].prop || (B.timers[a].stopped = !0);
      }
      return { animate: function(m, w, a) {
        let u, b = "", l, d, C;
        V(a) || (C = arguments, a = { duration: C[2], easing: C[3], complete: C[4] }), tt(a.duration) || (a.duration = 400), a.easing = typeof a.easing == "function" ? a.easing : Math[a.easing] || Math.easeInOutSine, a.curAnim = _(w), N(w, function(R, z) {
          y(m, z), d = new B(m, a, z), l = void 0, z === "d" && st(w.d) ? (d.paths = d.initPath(m, m.pathArray, w.d), d.toD = w.d, u = 0, l = 1) : m.attr ? u = m.attr(z) : (u = parseFloat(it(m, z)) || 0, z !== "opacity" && (b = "px")), l || (l = R), typeof l == "string" && l.match("px") && (l = l.replace(/px/g, "")), d.run(u, l, b);
        });
      }, animObject: p, getDeferredAnimation: function(m, w, a) {
        let u = p(w), b = a ? [a] : m.series, l = 0, d = 0;
        return b.forEach((C) => {
          let R = p(C.options.animation);
          l = V(w) && J(w.defer) ? u.defer : Math.max(l, R.duration + R.defer), d = Math.min(u.duration, R.duration);
        }), m.renderer.forExport && (l = 0), { defer: Math.max(0, l - d), duration: Math.min(l, d) };
      }, setAnimation: function(m, w) {
        w.renderer.globalAnimation = D(m, w.options.chart.animation, !0);
      }, stop: y };
    }), nt(i, "Core/Renderer/HTML/AST.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let { SVG_NS: J, win: it } = B, { attr: st, createElement: tt, css: V, error: _, isFunction: N, isString: D, objectEach: p, splat: y } = $, { trustedTypes: m } = it, w = m && N(m.createPolicy) && m.createPolicy("highcharts", { createHTML: (l) => l }), a = w ? w.createHTML("") : "", u = function() {
        try {
          return !!new DOMParser().parseFromString(a, "text/html");
        } catch {
          return !1;
        }
      }();
      class b {
        static filterUserAttributes(d) {
          return p(d, (C, R) => {
            let z = !0;
            b.allowedAttributes.indexOf(R) === -1 && (z = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(R) !== -1 && (z = D(C) && b.allowedReferences.some((O) => C.indexOf(O) === 0)), z || (_(33, !1, void 0, { "Invalid attribute in config": `${R}` }), delete d[R]), D(C) && d[R] && (d[R] = C.replace(/</g, "&lt;"));
          }), d;
        }
        static parseStyle(d) {
          return d.split(";").reduce((C, R) => {
            let z = R.split(":").map((h) => h.trim()), O = z.shift();
            return O && z.length && (C[O.replace(/-([a-z])/g, (h) => h[1].toUpperCase())] = z.join(":")), C;
          }, {});
        }
        static setElementHTML(d, C) {
          d.innerHTML = b.emptyHTML, C && new b(C).addToDOM(d);
        }
        constructor(d) {
          this.nodes = typeof d == "string" ? this.parseMarkup(d) : d;
        }
        addToDOM(d) {
          return function C(R, z) {
            let O;
            return y(R).forEach(function(h) {
              let f, s = h.tagName, t = h.textContent ? B.doc.createTextNode(h.textContent) : void 0, e = b.bypassHTMLFiltering;
              if (s)
                if (s === "#text") f = t;
                else if (b.allowedTags.indexOf(s) !== -1 || e) {
                  let r = s === "svg" ? J : z.namespaceURI || J, g = B.doc.createElementNS(r, s), o = h.attributes || {};
                  p(h, function(c, n) {
                    n !== "tagName" && n !== "attributes" && n !== "children" && n !== "style" && n !== "textContent" && (o[n] = c);
                  }), st(g, e ? o : b.filterUserAttributes(o)), h.style && V(g, h.style), t && g.appendChild(t), C(h.children || [], g), f = g;
                } else _(33, !1, void 0, { "Invalid tagName in config": s });
              f && z.appendChild(f), O = f;
            }), O;
          }(this.nodes, d);
        }
        parseMarkup(d) {
          let C, R = [];
          if (d = d.trim().replace(/ style=(["'])/g, " data-style=$1"), u) C = new DOMParser().parseFromString(w ? w.createHTML(d) : d, "text/html");
          else {
            let O = tt("div");
            O.innerHTML = d, C = { body: O };
          }
          let z = (O, h) => {
            let f = O.nodeName.toLowerCase(), s = { tagName: f };
            f === "#text" && (s.textContent = O.textContent || "");
            let t = O.attributes;
            if (t) {
              let e = {};
              [].forEach.call(t, (r) => {
                r.name === "data-style" ? s.style = b.parseStyle(r.value) : e[r.name] = r.value;
              }), s.attributes = e;
            }
            if (O.childNodes.length) {
              let e = [];
              [].forEach.call(O.childNodes, (r) => {
                z(r, e);
              }), e.length && (s.children = e);
            }
            h.push(s);
          };
          return [].forEach.call(C.body.childNodes, (O) => z(O, R)), R;
        }
      }
      return b.allowedAttributes = ["alt", "aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "filterUnits", "flood-color", "flood-opacity", "height", "href", "id", "in", "in2", "markerHeight", "markerWidth", "offset", "opacity", "operator", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "radius", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], b.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], b.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feComposite", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMorphology", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], b.emptyHTML = a, b.bypassHTMLFiltering = !1, b;
    }), nt(i, "Core/Templating.js", [i["Core/Defaults.js"], i["Core/Utilities.js"]], function(B, $) {
      let { defaultOptions: J, defaultTime: it } = B, { extend: st, getNestedProperty: tt, isArray: V, isNumber: _, isObject: N, pick: D, pInt: p } = $, y = { add: (a, u) => a + u, divide: (a, u) => u !== 0 ? a / u : "", eq: (a, u) => a == u, each: function(a) {
        let u = arguments[arguments.length - 1];
        return !!V(a) && a.map((b, l) => m(u.body, st(N(b) ? b : { "@this": b }, { "@index": l, "@first": l === 0, "@last": l === a.length - 1 }))).join("");
      }, ge: (a, u) => a >= u, gt: (a, u) => a > u, if: (a) => !!a, le: (a, u) => a <= u, lt: (a, u) => a < u, multiply: (a, u) => a * u, ne: (a, u) => a != u, subtract: (a, u) => a - u, unless: (a) => !a };
      function m(a = "", u, b) {
        let l = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, d = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, C = [], R = /f$/, z = /\.(\d)/, O = J.lang, h = b && b.time || it, f = b && b.numberFormatter || w, s = (o = "") => {
          let c;
          return o === "true" || o !== "false" && ((c = Number(o)).toString() === o ? c : tt(o, u));
        }, t, e, r = 0, g;
        for (; (t = l.exec(a)) !== null; ) {
          let o = d.exec(t[1]);
          o && (t = o, g = !0), e && e.isBlock || (e = { ctx: u, expression: t[1], find: t[0], isBlock: t[1].charAt(0) === "#", start: t.index, startInner: t.index + t[0].length, length: t[0].length });
          let c = t[1].split(" ")[0].replace("#", "");
          y[c] && (e.isBlock && c === e.fn && r++, e.fn || (e.fn = c));
          let n = t[1] === "else";
          if (e.isBlock && e.fn && (t[1] === `/${e.fn}` || n))
            if (r) !n && r--;
            else {
              let S = e.startInner, j = a.substr(S, t.index - S);
              e.body === void 0 ? (e.body = j, e.startInner = t.index + t[0].length) : e.elseBody = j, e.find += j + t[0], n || (C.push(e), e = void 0);
            }
          else e.isBlock || C.push(e);
          if (o && !(e != null && e.isBlock)) break;
        }
        return C.forEach((o) => {
          let c, n, { body: S, elseBody: j, expression: v, fn: P } = o;
          if (P) {
            let G = [o], W = v.split(" ");
            for (n = y[P].length; n--; ) G.unshift(s(W[n + 1]));
            c = y[P].apply(u, G), o.isBlock && typeof c == "boolean" && (c = m(c ? S : j, u, b));
          } else {
            let G = v.split(":");
            if (c = s(G.shift() || ""), G.length && typeof c == "number") {
              let W = G.join(":");
              if (R.test(W)) {
                let Q = parseInt((W.match(z) || ["", "-1"])[1], 10);
                c !== null && (c = f(c, Q, O.decimalPoint, W.indexOf(",") > -1 ? O.thousandsSep : ""));
              } else c = h.dateFormat(W, c);
            }
          }
          a = a.replace(o.find, D(c, ""));
        }), g ? m(a, u, b) : a;
      }
      function w(a, u, b, l) {
        let d, C;
        a = +a || 0, u = +u;
        let R = J.lang, z = (a.toString().split(".")[1] || "").split("e")[0].length, O = a.toString().split("e"), h = u;
        u === -1 ? u = Math.min(z, 20) : _(u) ? u && O[1] && O[1] < 0 && ((C = u + +O[1]) >= 0 ? (O[0] = (+O[0]).toExponential(C).split("e")[0], u = C) : (O[0] = O[0].split(".")[0] || 0, a = u < 20 ? (O[0] * Math.pow(10, O[1])).toFixed(u) : 0, O[1] = 0)) : u = 2;
        let f = (Math.abs(O[1] ? O[0] : a) + Math.pow(10, -Math.max(u, z) - 1)).toFixed(u), s = String(p(f)), t = s.length > 3 ? s.length % 3 : 0;
        return b = D(b, R.decimalPoint), l = D(l, R.thousandsSep), d = (a < 0 ? "-" : "") + (t ? s.substr(0, t) + l : ""), 0 > +O[1] && !h ? d = "0" : d += s.substr(t).replace(/(\d{3})(?=\d)/g, "$1" + l), u ? d += b + f.slice(-u) : +d == 0 && (d = "0"), O[1] && +d != 0 && (d += "e" + O[1]), d;
      }
      return { dateFormat: function(a, u, b) {
        return it.dateFormat(a, u, b);
      }, format: m, helpers: y, numberFormat: w };
    }), nt(i, "Core/Renderer/RendererRegistry.js", [i["Core/Globals.js"]], function(B) {
      var $, J;
      let it;
      return (J = $ || ($ = {})).rendererTypes = {}, J.getRendererType = function(st = it) {
        return J.rendererTypes[st] || J.rendererTypes[it];
      }, J.registerRendererType = function(st, tt, V) {
        J.rendererTypes[st] = tt, (!it || V) && (it = st, B.Renderer = tt);
      }, $;
    }), nt(i, "Core/Renderer/RendererUtilities.js", [i["Core/Utilities.js"]], function(B) {
      var $;
      let { clamp: J, pick: it, pushUnique: st, stableSort: tt } = B;
      return ($ || ($ = {})).distribute = function V(_, N, D) {
        let p = _, y = p.reducedLen || N, m = (s, t) => s.target - t.target, w = [], a = _.length, u = [], b = w.push, l, d, C, R = !0, z, O, h = 0, f;
        for (l = a; l--; ) h += _[l].size;
        if (h > y) {
          for (tt(_, (s, t) => (t.rank || 0) - (s.rank || 0)), C = (f = _[0].rank === _[_.length - 1].rank) ? a / 2 : -1, d = f ? C : a - 1; C && h > y; ) z = _[l = Math.floor(d)], st(u, l) && (h -= z.size), d += C, f && d >= _.length && (C /= 2, d = C);
          u.sort((s, t) => t - s).forEach((s) => b.apply(w, _.splice(s, 1)));
        }
        for (tt(_, m), _ = _.map((s) => ({ size: s.size, targets: [s.target], align: it(s.align, 0.5) })); R; ) {
          for (l = _.length; l--; ) z = _[l], O = (Math.min.apply(0, z.targets) + Math.max.apply(0, z.targets)) / 2, z.pos = J(O - z.size * z.align, 0, N - z.size);
          for (l = _.length, R = !1; l--; ) l > 0 && _[l - 1].pos + _[l - 1].size > _[l].pos && (_[l - 1].size += _[l].size, _[l - 1].targets = _[l - 1].targets.concat(_[l].targets), _[l - 1].align = 0.5, _[l - 1].pos + _[l - 1].size > N && (_[l - 1].pos = N - _[l - 1].size), _.splice(l, 1), R = !0);
        }
        return b.apply(p, w), l = 0, _.some((s) => {
          let t = 0;
          return (s.targets || []).some(() => (p[l].pos = s.pos + t, D !== void 0 && Math.abs(p[l].pos - p[l].target) > D ? (p.slice(0, l + 1).forEach((e) => delete e.pos), p.reducedLen = (p.reducedLen || N) - 0.1 * N, p.reducedLen > 0.1 * N && V(p, N, D), !0) : (t += p[l].size, l++, !1)));
        }), tt(p, m), p;
      }, $;
    }), nt(i, "Core/Renderer/SVG/SVGElement.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Color/Color.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $, J, it) {
      let { animate: st, animObject: tt, stop: V } = B, { deg2rad: _, doc: N, svg: D, SVG_NS: p, win: y } = J, { addEvent: m, attr: w, createElement: a, crisp: u, css: b, defined: l, erase: d, extend: C, fireEvent: R, isArray: z, isFunction: O, isObject: h, isString: f, merge: s, objectEach: t, pick: e, pInt: r, pushUnique: g, replaceNested: o, syncTimeout: c, uniqueKey: n } = it;
      class S {
        _defaultGetter(v) {
          let P = e(this[v + "Value"], this[v], this.element ? this.element.getAttribute(v) : null, 0);
          return /^-?[\d\.]+$/.test(P) && (P = parseFloat(P)), P;
        }
        _defaultSetter(v, P, G) {
          G.setAttribute(P, v);
        }
        add(v) {
          let P, G = this.renderer, W = this.element;
          return v && (this.parentGroup = v), this.textStr !== void 0 && this.element.nodeName === "text" && G.buildText(this), this.added = !0, (!v || v.handleZ || this.zIndex) && (P = this.zIndexSetter()), P || (v ? v.element : G.box).appendChild(W), this.onAdd && this.onAdd(), this;
        }
        addClass(v, P) {
          let G = P ? "" : this.attr("class") || "";
          return (v = (v || "").split(/ /g).reduce(function(W, Q) {
            return G.indexOf(Q) === -1 && W.push(Q), W;
          }, G ? [G] : []).join(" ")) !== G && this.attr("class", v), this;
        }
        afterSetters() {
          this.doTransform && (this.updateTransform(), this.doTransform = !1);
        }
        align(v, P, G, W = !0) {
          let Q, k, A, L, Y = {}, x = this.renderer, T = x.alignedObjects, M = !!v;
          v ? (this.alignOptions = v, this.alignByTranslate = P, this.alignTo = G) : (v = this.alignOptions || {}, P = this.alignByTranslate, G = this.alignTo);
          let U = !G || f(G) ? G || "renderer" : void 0;
          U && (M && g(T, this), G = void 0);
          let H = e(G, x[U], x), q = v.align, F = v.verticalAlign;
          return Q = (H.x || 0) + (v.x || 0), k = (H.y || 0) + (v.y || 0), q === "right" ? A = 1 : q === "center" && (A = 2), A && (Q += ((H.width || 0) - (v.width || 0)) / A), Y[P ? "translateX" : "x"] = Math.round(Q), F === "bottom" ? L = 1 : F === "middle" && (L = 2), L && (k += ((H.height || 0) - (v.height || 0)) / L), Y[P ? "translateY" : "y"] = Math.round(k), W && (this[this.placed ? "animate" : "attr"](Y), this.placed = !0), this.alignAttr = Y, this;
        }
        alignSetter(v) {
          let P = { left: "start", center: "middle", right: "end" };
          P[v] && (this.alignValue = v, this.element.setAttribute("text-anchor", P[v]));
        }
        animate(v, P, G) {
          let W = tt(e(P, this.renderer.globalAnimation, !0)), Q = W.defer;
          return N.hidden && (W.duration = 0), W.duration !== 0 ? (G && (W.complete = G), c(() => {
            this.element && st(this, v, W);
          }, Q)) : (this.attr(v, void 0, G || W.complete), t(v, function(k, A) {
            W.step && W.step.call(this, k, { prop: A, pos: 1, elem: this });
          }, this)), this;
        }
        applyTextOutline(v) {
          let P = this.element;
          v.indexOf("contrast") !== -1 && (v = v.replace(/contrast/g, this.renderer.getContrast(P.style.fill)));
          let G = v.split(" "), W = G[G.length - 1], Q = G[0];
          if (Q && Q !== "none" && J.svg) {
            this.fakeTS = !0, Q = Q.replace(/(^[\d\.]+)(.*?)$/g, function(x, T, M) {
              return 2 * Number(T) + M;
            }), this.removeTextOutline();
            let k = N.createElementNS(p, "tspan");
            w(k, { class: "highcharts-text-outline", fill: W, stroke: W, "stroke-width": Q, "stroke-linejoin": "round" });
            let A = P.querySelector("textPath") || P;
            [].forEach.call(A.childNodes, (x) => {
              let T = x.cloneNode(!0);
              T.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach((M) => T.removeAttribute(M)), k.appendChild(T);
            });
            let L = 0;
            [].forEach.call(A.querySelectorAll("text tspan"), (x) => {
              L += Number(x.getAttribute("dy"));
            });
            let Y = N.createElementNS(p, "tspan");
            Y.textContent = "​", w(Y, { x: Number(P.getAttribute("x")), dy: -L }), k.appendChild(Y), A.insertBefore(k, A.firstChild);
          }
        }
        attr(v, P, G, W) {
          let { element: Q } = this, k = S.symbolCustomAttribs, A, L, Y = this, x;
          return typeof v == "string" && P !== void 0 && (A = v, (v = {})[A] = P), typeof v == "string" ? Y = (this[v + "Getter"] || this._defaultGetter).call(this, v, Q) : (t(v, function(T, M) {
            x = !1, W || V(this, M), this.symbolName && k.indexOf(M) !== -1 && (L || (this.symbolAttr(v), L = !0), x = !0), this.rotation && (M === "x" || M === "y") && (this.doTransform = !0), x || (this[M + "Setter"] || this._defaultSetter).call(this, T, M, Q);
          }, this), this.afterSetters()), G && G.call(this), Y;
        }
        clip(v) {
          if (v && !v.clipPath) {
            let P = n() + "-", G = this.renderer.createElement("clipPath").attr({ id: P }).add(this.renderer.defs);
            C(v, { clipPath: G, id: P, count: 0 }), v.add(G);
          }
          return this.attr("clip-path", v ? `url(${this.renderer.url}#${v.id})` : "none");
        }
        crisp(v, P) {
          P = Math.round(P || v.strokeWidth || 0);
          let G = v.x || this.x || 0, W = v.y || this.y || 0, Q = (v.width || this.width || 0) + G, k = (v.height || this.height || 0) + W, A = u(G, P), L = u(W, P);
          return C(v, { x: A, y: L, width: u(Q, P) - A, height: u(k, P) - L }), l(v.strokeWidth) && (v.strokeWidth = P), v;
        }
        complexColor(v, P, G) {
          let W = this.renderer, Q, k, A, L, Y, x, T, M, U, H, q = [], F;
          R(this.renderer, "complexColor", { args: arguments }, function() {
            if (v.radialGradient ? k = "radialGradient" : v.linearGradient && (k = "linearGradient"), k) {
              if (A = v[k], Y = W.gradients, x = v.stops, U = G.radialReference, z(A) && (v[k] = A = { x1: A[0], y1: A[1], x2: A[2], y2: A[3], gradientUnits: "userSpaceOnUse" }), k === "radialGradient" && U && !l(A.gradientUnits) && (L = A, A = s(A, W.getRadialAttr(U, L), { gradientUnits: "userSpaceOnUse" })), t(A, function(et, rt) {
                rt !== "id" && q.push(rt, et);
              }), t(x, function(et) {
                q.push(et);
              }), Y[q = q.join(",")]) H = Y[q].attr("id");
              else {
                A.id = H = n();
                let et = Y[q] = W.createElement(k).attr(A).add(W.defs);
                et.radAttr = L, et.stops = [], x.forEach(function(rt) {
                  rt[1].indexOf("rgba") === 0 ? (T = (Q = $.parse(rt[1])).get("rgb"), M = Q.get("a")) : (T = rt[1], M = 1);
                  let at = W.createElement("stop").attr({ offset: rt[0], "stop-color": T, "stop-opacity": M }).add(et);
                  et.stops.push(at);
                });
              }
              F = "url(" + W.url + "#" + H + ")", G.setAttribute(P, F), G.gradient = q, v.toString = function() {
                return F;
              };
            }
          });
        }
        css(v) {
          let P = this.styles, G = {}, W = this.element, Q, k = !P;
          if (P && t(v, function(A, L) {
            P && P[L] !== A && (G[L] = A, k = !0);
          }), k) {
            P && (v = C(P, G)), v.width === null || v.width === "auto" ? delete this.textWidth : W.nodeName.toLowerCase() === "text" && v.width && (Q = this.textWidth = r(v.width)), C(this.styles, v), Q && !D && this.renderer.forExport && delete v.width;
            let A = s(v);
            W.namespaceURI === this.SVG_NS && (["textOutline", "textOverflow", "width"].forEach((L) => A && delete A[L]), A.color && (A.fill = A.color)), b(W, A);
          }
          return this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), v.textOutline && this.applyTextOutline(v.textOutline)), this;
        }
        dashstyleSetter(v) {
          let P, G = this["stroke-width"];
          if (G === "inherit" && (G = 1), v = v && v.toLowerCase()) {
            let W = v.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
            for (P = W.length; P--; ) W[P] = "" + r(W[P]) * e(G, NaN);
            v = W.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", v);
          }
        }
        destroy() {
          var L;
          let v = this, P = v.element || {}, G = v.renderer, W = P.ownerSVGElement, Q = P.nodeName === "SPAN" && v.parentGroup || void 0, k, A;
          if (P.onclick = P.onmouseout = P.onmouseover = P.onmousemove = P.point = null, V(v), v.clipPath && W) {
            let Y = v.clipPath;
            [].forEach.call(W.querySelectorAll("[clip-path],[CLIP-PATH]"), function(x) {
              x.getAttribute("clip-path").indexOf(Y.element.id) > -1 && x.removeAttribute("clip-path");
            }), v.clipPath = Y.destroy();
          }
          if (v.connector = (L = v.connector) == null ? void 0 : L.destroy(), v.stops) {
            for (A = 0; A < v.stops.length; A++) v.stops[A].destroy();
            v.stops.length = 0, v.stops = void 0;
          }
          for (v.safeRemoveChild(P); Q && Q.div && Q.div.childNodes.length === 0; ) k = Q.parentGroup, v.safeRemoveChild(Q.div), delete Q.div, Q = k;
          v.alignOptions && d(G.alignedObjects, v), t(v, function(Y, x) {
            v[x] && v[x].parentGroup === v && v[x].destroy && v[x].destroy(), delete v[x];
          });
        }
        dSetter(v, P, G) {
          z(v) && (typeof v[0] == "string" && (v = this.renderer.pathToSegments(v)), this.pathArray = v, v = v.reduce((W, Q, k) => Q && Q.join ? (k ? W + " " : "") + Q.join(" ") : (Q || "").toString(), "")), /(NaN| {2}|^$)/.test(v) && (v = "M 0 0"), this[P] !== v && (G.setAttribute(P, v), this[P] = v);
        }
        fillSetter(v, P, G) {
          typeof v == "string" ? G.setAttribute(P, v) : v && this.complexColor(v, P, G);
        }
        hrefSetter(v, P, G) {
          G.setAttributeNS("http://www.w3.org/1999/xlink", P, v);
        }
        getBBox(v, P) {
          let G, W, Q, k, { alignValue: A, element: L, renderer: Y, styles: x, textStr: T } = this, { cache: M, cacheKeys: U } = Y, H = L.namespaceURI === this.SVG_NS, q = e(P, this.rotation, 0), F = Y.styledMode ? L && S.prototype.getStyle.call(L, "font-size") : x.fontSize;
          if (l(T) && ((k = T.toString()).indexOf("<") === -1 && (k = k.replace(/\d/g, "0")), k += ["", Y.rootFontSize, F, q, this.textWidth, A, x.textOverflow, x.fontWeight].join(",")), k && !v && (G = M[k]), !G || G.polygon) {
            if (H || Y.forExport) {
              try {
                Q = this.fakeTS && function(rt) {
                  let at = L.querySelector(".highcharts-text-outline");
                  at && b(at, { display: rt });
                }, O(Q) && Q("none"), G = L.getBBox ? C({}, L.getBBox()) : { width: L.offsetWidth, height: L.offsetHeight, x: 0, y: 0 }, O(Q) && Q("");
              } catch {
              }
              (!G || G.width < 0) && (G = { x: 0, y: 0, width: 0, height: 0 });
            } else G = this.htmlGetBBox();
            W = G.height, H && (G.height = W = { "11px,17": 14, "13px,20": 16 }[`${F || ""},${Math.round(W)}`] || W), q && (G = this.getRotatedBox(G, q));
            let et = { bBox: G };
            R(this, "afterGetBBox", et), G = et.bBox;
          }
          if (k && (T === "" || G.height > 0)) {
            for (; U.length > 250; ) delete M[U.shift()];
            M[k] || U.push(k), M[k] = G;
          }
          return G;
        }
        getRotatedBox(v, P) {
          let { x: G, y: W, width: Q, height: k } = v, { alignValue: A, translateY: L, rotationOriginX: Y = 0, rotationOriginY: x = 0 } = this, T = { right: 1, center: 0.5 }[A || 0] || 0, M = Number(this.element.getAttribute("y") || 0) - (L ? 0 : W), U = P * _, H = (P - 90) * _, q = Math.cos(U), F = Math.sin(U), et = Q * q, rt = Q * F, at = Math.cos(H), ct = Math.sin(H), [[Z, X], [K, ot]] = [Y, x].map((Ct) => [Ct - Ct * q, Ct * F]), ht = G + T * (Q - et) + Z + ot + M * at, dt = ht + et, lt = dt - k * at, ut = lt - et, ft = W + M - T * rt - X + K + M * ct, gt = ft + rt, pt = gt - k * ct, mt = pt - rt, yt = Math.min(ht, dt, lt, ut), vt = Math.min(ft, gt, pt, mt), xt = Math.max(ht, dt, lt, ut) - yt, bt = Math.max(ft, gt, pt, mt) - vt;
          return { x: yt, y: vt, width: xt, height: bt, polygon: [[ht, ft], [dt, gt], [lt, pt], [ut, mt]] };
        }
        getStyle(v) {
          return y.getComputedStyle(this.element || this, "").getPropertyValue(v);
        }
        hasClass(v) {
          return ("" + this.attr("class")).split(" ").indexOf(v) !== -1;
        }
        hide() {
          return this.attr({ visibility: "hidden" });
        }
        htmlGetBBox() {
          return { height: 0, width: 0, x: 0, y: 0 };
        }
        constructor(v, P) {
          this.onEvents = {}, this.opacity = 1, this.SVG_NS = p, this.element = P === "span" || P === "body" ? a(P) : N.createElementNS(this.SVG_NS, P), this.renderer = v, this.styles = {}, R(this, "afterInit");
        }
        on(v, P) {
          let { onEvents: G } = this;
          return G[v] && G[v](), G[v] = m(this.element, v, P), this;
        }
        opacitySetter(v, P, G) {
          let W = Number(Number(v).toFixed(3));
          this.opacity = W, G.setAttribute(P, W);
        }
        reAlign() {
          var v;
          (v = this.alignOptions) != null && v.width && this.alignOptions.align !== "left" && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
        }
        removeClass(v) {
          return this.attr("class", ("" + this.attr("class")).replace(f(v) ? RegExp(`(^| )${v}( |$)`) : v, " ").replace(/ +/g, " ").trim());
        }
        removeTextOutline() {
          let v = this.element.querySelector("tspan.highcharts-text-outline");
          v && this.safeRemoveChild(v);
        }
        safeRemoveChild(v) {
          let P = v.parentNode;
          P && P.removeChild(v);
        }
        setRadialReference(v) {
          let P = this.element.gradient && this.renderer.gradients[this.element.gradient];
          return this.element.radialReference = v, P && P.radAttr && P.animate(this.renderer.getRadialAttr(v, P.radAttr)), this;
        }
        shadow(v) {
          var Q;
          let { renderer: P } = this, G = s(((Q = this.parentGroup) == null ? void 0 : Q.rotation) === 90 ? { offsetX: -1, offsetY: -1 } : {}, h(v) ? v : {}), W = P.shadowDefinition(G);
          return this.attr({ filter: v ? `url(${P.url}#${W})` : "none" });
        }
        show(v = !0) {
          return this.attr({ visibility: v ? "inherit" : "visible" });
        }
        "stroke-widthSetter"(v, P, G) {
          this[P] = v, G.setAttribute(P, v);
        }
        strokeWidth() {
          if (!this.renderer.styledMode) return this["stroke-width"] || 0;
          let v = this.getStyle("stroke-width"), P = 0, G;
          return /px$/.test(v) ? P = r(v) : v !== "" && (w(G = N.createElementNS(p, "rect"), { width: v, "stroke-width": 0 }), this.element.parentNode.appendChild(G), P = G.getBBox().width, G.parentNode.removeChild(G)), P;
        }
        symbolAttr(v) {
          let P = this;
          S.symbolCustomAttribs.forEach(function(G) {
            P[G] = e(v[G], P[G]);
          }), P.attr({ d: P.renderer.symbols[P.symbolName](P.x, P.y, P.width, P.height, P) });
        }
        textSetter(v) {
          v !== this.textStr && (delete this.textPxLength, this.textStr = v, this.added && this.renderer.buildText(this), this.reAlign());
        }
        titleSetter(v) {
          let P = this.element, G = P.getElementsByTagName("title")[0] || N.createElementNS(this.SVG_NS, "title");
          P.insertBefore ? P.insertBefore(G, P.firstChild) : P.appendChild(G), G.textContent = o(e(v, ""), [/<[^>]*>/g, ""]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }
        toFront() {
          let v = this.element;
          return v.parentNode.appendChild(v), this;
        }
        translate(v, P) {
          return this.attr({ translateX: v, translateY: P });
        }
        updateTransform(v = "transform") {
          var M;
          let { element: P, matrix: G, rotation: W = 0, rotationOriginX: Q, rotationOriginY: k, scaleX: A, scaleY: L, translateX: Y = 0, translateY: x = 0 } = this, T = ["translate(" + Y + "," + x + ")"];
          l(G) && T.push("matrix(" + G.join(",") + ")"), W && (T.push("rotate(" + W + " " + e(Q, P.getAttribute("x"), 0) + " " + e(k, P.getAttribute("y") || 0) + ")"), ((M = this.text) == null ? void 0 : M.element.tagName) === "SPAN" && this.text.attr({ rotation: W, rotationOriginX: (Q || 0) - this.padding, rotationOriginY: (k || 0) - this.padding })), (l(A) || l(L)) && T.push("scale(" + e(A, 1) + " " + e(L, 1) + ")"), T.length && !(this.text || this).textPath && P.setAttribute(v, T.join(" "));
        }
        visibilitySetter(v, P, G) {
          v === "inherit" ? G.removeAttribute(P) : this[P] !== v && G.setAttribute(P, v), this[P] = v;
        }
        xGetter(v) {
          return this.element.nodeName === "circle" && (v === "x" ? v = "cx" : v === "y" && (v = "cy")), this._defaultGetter(v);
        }
        zIndexSetter(v, P) {
          let G = this.renderer, W = this.parentGroup, Q = (W || G).element || G.box, k = this.element, A = Q === G.box, L, Y, x, T = !1, M, U = this.added, H;
          if (l(v) ? (k.setAttribute("data-z-index", v), v = +v, this[P] === v && (U = !1)) : l(this[P]) && k.removeAttribute("data-z-index"), this[P] = v, U) {
            for ((v = this.zIndex) && W && (W.handleZ = !0), H = (L = Q.childNodes).length - 1; H >= 0 && !T; H--) M = !l(x = (Y = L[H]).getAttribute("data-z-index")), Y !== k && (v < 0 && M && !A && !H ? (Q.insertBefore(k, L[H]), T = !0) : (r(x) <= v || M && (!l(v) || v >= 0)) && (Q.insertBefore(k, L[H + 1]), T = !0));
            T || (Q.insertBefore(k, L[A ? 3 : 0]), T = !0);
          }
          return T;
        }
      }
      return S.symbolCustomAttribs = ["anchorX", "anchorY", "clockwise", "end", "height", "innerR", "r", "start", "width", "x", "y"], S.prototype.strokeSetter = S.prototype.fillSetter, S.prototype.yGetter = S.prototype.xGetter, S.prototype.matrixSetter = S.prototype.rotationOriginXSetter = S.prototype.rotationOriginYSetter = S.prototype.rotationSetter = S.prototype.scaleXSetter = S.prototype.scaleYSetter = S.prototype.translateXSetter = S.prototype.translateYSetter = S.prototype.verticalAlignSetter = function(j, v) {
        this[v] = j, this.doTransform = !0;
      }, S;
    }), nt(i, "Core/Renderer/SVG/SVGLabel.js", [i["Core/Renderer/SVG/SVGElement.js"], i["Core/Utilities.js"]], function(B, $) {
      let { defined: J, extend: it, isNumber: st, merge: tt, pick: V, removeEvent: _ } = $;
      class N extends B {
        constructor(p, y, m, w, a, u, b, l, d, C) {
          let R;
          super(p, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = y, this.x = m, this.y = w, this.anchorX = u, this.anchorY = b, this.baseline = d, this.className = C, this.addClass(C === "button" ? "highcharts-no-tooltip" : "highcharts-label"), C && this.addClass("highcharts-" + C), this.text = p.text(void 0, 0, 0, l).attr({ zIndex: 1 }), typeof a == "string" && ((R = /^url\((.*?)\)$/.test(a)) || this.renderer.symbols[a]) && (this.symbolKey = a), this.bBox = N.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = p.styledMode || R, this.deferredAttr = {}, this.alignFactor = 0;
        }
        alignSetter(p) {
          let y = { left: 0, center: 0.5, right: 1 }[p];
          y !== this.alignFactor && (this.alignFactor = y, this.bBox && st(this.xSetting) && this.attr({ x: this.xSetting }));
        }
        anchorXSetter(p, y) {
          this.anchorX = p, this.boxAttr(y, Math.round(p) - this.getCrispAdjust() - this.xSetting);
        }
        anchorYSetter(p, y) {
          this.anchorY = p, this.boxAttr(y, p - this.ySetting);
        }
        boxAttr(p, y) {
          this.box ? this.box.attr(p, y) : this.deferredAttr[p] = y;
        }
        css(p) {
          if (p) {
            let y = {};
            p = tt(p), N.textProps.forEach((m) => {
              p[m] !== void 0 && (y[m] = p[m], delete p[m]);
            }), this.text.css(y), "fontSize" in y || "fontWeight" in y ? this.updateTextPadding() : ("width" in y || "textOverflow" in y) && this.updateBoxSize();
          }
          return B.prototype.css.call(this, p);
        }
        destroy() {
          _(this.element, "mouseenter"), _(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), B.prototype.destroy.call(this);
        }
        fillSetter(p, y) {
          p && (this.needsBox = !0), this.fill = p, this.boxAttr(y, p);
        }
        getBBox(p, y) {
          this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
          let { padding: m, height: w = 0, translateX: a = 0, translateY: u = 0, width: b = 0 } = this, l = V(this.paddingLeft, m), d = y != null ? y : this.rotation || 0, C = { width: b, height: w, x: a + this.bBox.x - l, y: u + this.bBox.y - m + this.baselineOffset };
          return d && (C = this.getRotatedBox(C, d)), C;
        }
        getCrispAdjust() {
          return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
        }
        heightSetter(p) {
          this.heightSetting = p, this.doUpdate = !0;
        }
        afterSetters() {
          super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
        }
        onAdd() {
          this.text.add(this), this.attr({ text: V(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && J(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
        }
        paddingSetter(p, y) {
          st(p) ? p !== this[y] && (this[y] = p, this.updateTextPadding()) : this[y] = void 0;
        }
        rSetter(p, y) {
          this.boxAttr(y, p);
        }
        strokeSetter(p, y) {
          this.stroke = p, this.boxAttr(y, p);
        }
        "stroke-widthSetter"(p, y) {
          p && (this.needsBox = !0), this["stroke-width"] = p, this.boxAttr(y, p);
        }
        "text-alignSetter"(p) {
          this.textAlign = p;
        }
        textSetter(p) {
          p !== void 0 && this.text.attr({ text: p }), this.updateTextPadding(), this.reAlign();
        }
        updateBoxSize() {
          let p, y = this.text, m = {}, w = this.padding, a = this.bBox = (!st(this.widthSetting) || !st(this.heightSetting) || this.textAlign) && J(y.textStr) ? y.getBBox(void 0, 0) : N.emptyBBox;
          this.width = this.getPaddedWidth(), this.height = (this.heightSetting || a.height || 0) + 2 * w;
          let u = this.renderer.fontMetrics(y);
          if (this.baselineOffset = w + Math.min((this.text.firstLineMetrics || u).b, a.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - u.h) / 2), this.needsBox && !y.textPath) {
            if (!this.box) {
              let b = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
              b.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), b.add(this);
            }
            p = this.getCrispAdjust(), m.x = p, m.y = (this.baseline ? -this.baselineOffset : 0) + p, m.width = Math.round(this.width), m.height = Math.round(this.height), this.box.attr(it(m, this.deferredAttr)), this.deferredAttr = {};
          }
        }
        updateTextPadding() {
          let p = this.text;
          if (!p.textPath) {
            this.updateBoxSize();
            let y = this.baseline ? 0 : this.baselineOffset, m = V(this.paddingLeft, this.padding);
            J(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (m += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), (m !== p.x || y !== p.y) && (p.attr("x", m), p.hasBoxWidthChanged && (this.bBox = p.getBBox(!0)), y !== void 0 && p.attr("y", y)), p.x = m, p.y = y;
          }
        }
        widthSetter(p) {
          this.widthSetting = st(p) ? p : void 0, this.doUpdate = !0;
        }
        getPaddedWidth() {
          let p = this.padding, y = V(this.paddingLeft, p), m = V(this.paddingRight, p);
          return (this.widthSetting || this.bBox.width || 0) + y + m;
        }
        xSetter(p) {
          this.x = p, this.alignFactor && (p -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(p), this.attr("translateX", this.xSetting);
        }
        ySetter(p) {
          this.ySetting = this.y = Math.round(p), this.attr("translateY", this.ySetting);
        }
      }
      return N.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, N.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "whiteSpace", "width"], N;
    }), nt(i, "Core/Renderer/SVG/Symbols.js", [i["Core/Utilities.js"]], function(B) {
      let { defined: $, isNumber: J, pick: it } = B;
      function st(_, N, D, p, y) {
        let m = [];
        if (y) {
          let w = y.start || 0, a = it(y.r, D), u = it(y.r, p || D), b = 2e-4 / (y.borderRadius ? 1 : Math.max(a, 1)), l = Math.abs((y.end || 0) - w - 2 * Math.PI) < b, d = (y.end || 0) - (l ? b : 0), C = y.innerR, R = it(y.open, l), z = Math.cos(w), O = Math.sin(w), h = Math.cos(d), f = Math.sin(d), s = it(y.longArc, d - w - Math.PI < b ? 0 : 1), t = ["A", a, u, 0, s, it(y.clockwise, 1), _ + a * h, N + u * f];
          t.params = { start: w, end: d, cx: _, cy: N }, m.push(["M", _ + a * z, N + u * O], t), $(C) && ((t = ["A", C, C, 0, s, $(y.clockwise) ? 1 - y.clockwise : 0, _ + C * z, N + C * O]).params = { start: d, end: w, cx: _, cy: N }, m.push(R ? ["M", _ + C * h, N + C * f] : ["L", _ + C * h, N + C * f], t)), R || m.push(["Z"]);
        }
        return m;
      }
      function tt(_, N, D, p, y) {
        return y && y.r ? V(_, N, D, p, y) : [["M", _, N], ["L", _ + D, N], ["L", _ + D, N + p], ["L", _, N + p], ["Z"]];
      }
      function V(_, N, D, p, y) {
        let m = (y == null ? void 0 : y.r) || 0;
        return [["M", _ + m, N], ["L", _ + D - m, N], ["A", m, m, 0, 0, 1, _ + D, N + m], ["L", _ + D, N + p - m], ["A", m, m, 0, 0, 1, _ + D - m, N + p], ["L", _ + m, N + p], ["A", m, m, 0, 0, 1, _, N + p - m], ["L", _, N + m], ["A", m, m, 0, 0, 1, _ + m, N], ["Z"]];
      }
      return { arc: st, callout: function(_, N, D, p, y) {
        let m = Math.min(y && y.r || 0, D, p), w = m + 6, a = y && y.anchorX, u = y && y.anchorY || 0, b = V(_, N, D, p, { r: m });
        if (!J(a) || a < D && a > 0 && u < p && u > 0) return b;
        if (_ + a > D - w)
          if (u > N + w && u < N + p - w) b.splice(3, 1, ["L", _ + D, u - 6], ["L", _ + D + 6, u], ["L", _ + D, u + 6], ["L", _ + D, N + p - m]);
          else if (a < D) {
            let l = u < N + w, d = l ? N : N + p;
            b.splice(l ? 2 : 5, 0, ["L", a, u], ["L", _ + D - m, d]);
          } else b.splice(3, 1, ["L", _ + D, p / 2], ["L", a, u], ["L", _ + D, p / 2], ["L", _ + D, N + p - m]);
        else if (_ + a < w)
          if (u > N + w && u < N + p - w) b.splice(7, 1, ["L", _, u + 6], ["L", _ - 6, u], ["L", _, u - 6], ["L", _, N + m]);
          else if (a > 0) {
            let l = u < N + w, d = l ? N : N + p;
            b.splice(l ? 1 : 6, 0, ["L", a, u], ["L", _ + m, d]);
          } else b.splice(7, 1, ["L", _, p / 2], ["L", a, u], ["L", _, p / 2], ["L", _, N + m]);
        else u > p && a < D - w ? b.splice(5, 1, ["L", a + 6, N + p], ["L", a, N + p + 6], ["L", a - 6, N + p], ["L", _ + m, N + p]) : u < 0 && a > w && b.splice(1, 1, ["L", a - 6, N], ["L", a, N - 6], ["L", a + 6, N], ["L", D - m, N]);
        return b;
      }, circle: function(_, N, D, p) {
        return st(_ + D / 2, N + p / 2, D / 2, p / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
      }, diamond: function(_, N, D, p) {
        return [["M", _ + D / 2, N], ["L", _ + D, N + p / 2], ["L", _ + D / 2, N + p], ["L", _, N + p / 2], ["Z"]];
      }, rect: tt, roundedRect: V, square: tt, triangle: function(_, N, D, p) {
        return [["M", _ + D / 2, N], ["L", _ + D, N + p], ["L", _, N + p], ["Z"]];
      }, "triangle-down": function(_, N, D, p) {
        return [["M", _, N], ["L", _ + D, N], ["L", _ + D / 2, N + p], ["Z"]];
      } };
    }), nt(i, "Core/Renderer/SVG/TextBuilder.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { doc: it, SVG_NS: st, win: tt } = $, { attr: V, extend: _, fireEvent: N, isString: D, objectEach: p, pick: y } = J;
      return class {
        constructor(m) {
          let w = m.styles;
          this.renderer = m.renderer, this.svgElement = m, this.width = m.textWidth, this.textLineHeight = w && w.lineHeight, this.textOutline = w && w.textOutline, this.ellipsis = !!(w && w.textOverflow === "ellipsis"), this.noWrap = !!(w && w.whiteSpace === "nowrap");
        }
        buildSVG() {
          let m = this.svgElement, w = m.element, a = m.renderer, u = y(m.textStr, "").toString(), b = u.indexOf("<") !== -1, l = w.childNodes, d = !m.added && a.box, C = [u, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, m.getStyle("font-size"), this.width].join(",");
          if (C !== m.textCache) {
            m.textCache = C, delete m.actualWidth;
            for (let R = l.length; R--; ) w.removeChild(l[R]);
            if (b || this.ellipsis || this.width || m.textPath || u.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(u))) {
              if (u !== "") {
                d && d.appendChild(w);
                let R = new B(u);
                this.modifyTree(R.nodes), R.addToDOM(w), this.modifyDOM(), this.ellipsis && (w.textContent || "").indexOf("…") !== -1 && m.attr("title", this.unescapeEntities(m.textStr || "", ["&lt;", "&gt;"])), d && d.removeChild(w);
              }
            } else w.appendChild(it.createTextNode(this.unescapeEntities(u)));
            D(this.textOutline) && m.applyTextOutline && m.applyTextOutline(this.textOutline);
          }
        }
        modifyDOM() {
          let m, w = this.svgElement, a = V(w.element, "x");
          for (w.firstLineMetrics = void 0; (m = w.element.firstChild) && /^[\s\u200B]*$/.test(m.textContent || " "); ) w.element.removeChild(m);
          [].forEach.call(w.element.querySelectorAll("tspan.highcharts-br"), (d, C) => {
            d.nextSibling && d.previousSibling && (C === 0 && d.previousSibling.nodeType === 1 && (w.firstLineMetrics = w.renderer.fontMetrics(d.previousSibling)), V(d, { dy: this.getLineHeight(d.nextSibling), x: a }));
          });
          let u = this.width || 0;
          if (!u) return;
          let b = (d, C) => {
            let R = d.textContent || "", z = R.replace(/([^\^])-/g, "$1- ").split(" "), O = !this.noWrap && (z.length > 1 || w.element.childNodes.length > 1), h = this.getLineHeight(C), f = 0, s = w.actualWidth;
            if (this.ellipsis) R && this.truncate(d, R, void 0, 0, Math.max(0, u - 0.8 * h), (t, e) => t.substring(0, e) + "…");
            else if (O) {
              let t = [], e = [];
              for (; C.firstChild && C.firstChild !== d; ) e.push(C.firstChild), C.removeChild(C.firstChild);
              for (; z.length; ) z.length && !this.noWrap && f > 0 && (t.push(d.textContent || ""), d.textContent = z.join(" ").replace(/- /g, "-")), this.truncate(d, void 0, z, f === 0 && s || 0, u, (r, g) => z.slice(0, g).join(" ").replace(/- /g, "-")), s = w.actualWidth, f++;
              e.forEach((r) => {
                C.insertBefore(r, d);
              }), t.forEach((r) => {
                C.insertBefore(it.createTextNode(r), d);
                let g = it.createElementNS(st, "tspan");
                g.textContent = "​", V(g, { dy: h, x: a }), C.insertBefore(g, d);
              });
            }
          }, l = (d) => {
            [].slice.call(d.childNodes).forEach((C) => {
              C.nodeType === tt.Node.TEXT_NODE ? b(C, d) : (C.className.baseVal.indexOf("highcharts-br") !== -1 && (w.actualWidth = 0), l(C));
            });
          };
          l(w.element);
        }
        getLineHeight(m) {
          let w = m.nodeType === tt.Node.TEXT_NODE ? m.parentElement : m;
          return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(w || this.svgElement.element).h;
        }
        modifyTree(m) {
          let w = (a, u) => {
            let { attributes: b = {}, children: l, style: d = {}, tagName: C } = a, R = this.renderer.styledMode;
            if (C === "b" || C === "strong" ? R ? b.class = "highcharts-strong" : d.fontWeight = "bold" : (C === "i" || C === "em") && (R ? b.class = "highcharts-emphasized" : d.fontStyle = "italic"), d && d.color && (d.fill = d.color), C === "br") {
              b.class = "highcharts-br", a.textContent = "​";
              let z = m[u + 1];
              z && z.textContent && (z.textContent = z.textContent.replace(/^ +/gm, ""));
            } else C === "a" && l && l.some((z) => z.tagName === "#text") && (a.children = [{ children: l, tagName: "tspan" }]);
            C !== "#text" && C !== "a" && (a.tagName = "tspan"), _(a, { attributes: b, style: d }), l && l.filter((z) => z.tagName !== "#text").forEach(w);
          };
          m.forEach(w), N(this.svgElement, "afterModifyTree", { nodes: m });
        }
        truncate(m, w, a, u, b, l) {
          let d, C, R = this.svgElement, { rotation: z } = R, O = [], h = a ? 1 : 0, f = (w || a || "").length, s = f, t = function(e, r) {
            let g = r || e, o = m.parentNode;
            if (o && O[g] === void 0 && o.getSubStringLength) try {
              O[g] = u + o.getSubStringLength(0, a ? g + 1 : g);
            } catch {
            }
            return O[g];
          };
          if (R.rotation = 0, u + (C = t(m.textContent.length)) > b) {
            for (; h <= f; ) s = Math.ceil((h + f) / 2), a && (d = l(a, s)), C = t(s, d && d.length - 1), h === f ? h = f + 1 : C > b ? f = s - 1 : h = s;
            f === 0 ? m.textContent = "" : w && f === w.length - 1 || (m.textContent = d || l(w || a, s));
          }
          a && a.splice(0, s), R.actualWidth = C, R.rotation = z;
        }
        unescapeEntities(m, w) {
          return p(this.renderer.escapes, function(a, u) {
            w && w.indexOf(a) !== -1 || (m = m.toString().replace(RegExp(a, "g"), u));
          }), m;
        }
      };
    }), nt(i, "Core/Renderer/SVG/SVGRenderer.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Defaults.js"], i["Core/Color/Color.js"], i["Core/Globals.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Renderer/SVG/SVGElement.js"], i["Core/Renderer/SVG/SVGLabel.js"], i["Core/Renderer/SVG/Symbols.js"], i["Core/Renderer/SVG/TextBuilder.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _, N, D) {
      let p, { defaultOptions: y } = $, { charts: m, deg2rad: w, doc: a, isFirefox: u, isMS: b, isWebKit: l, noop: d, SVG_NS: C, symbolSizes: R, win: z } = it, { addEvent: O, attr: h, createElement: f, crisp: s, css: t, defined: e, destroyObjectProperties: r, extend: g, isArray: o, isNumber: c, isObject: n, isString: S, merge: j, pick: v, pInt: P, replaceNested: G, uniqueKey: W } = D;
      class Q {
        constructor(A, L, Y, x, T, M, U) {
          let H, q, F = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), et = F.element;
          U || F.css(this.getStyle(x || {})), A.appendChild(et), h(A, "dir", "ltr"), A.innerHTML.indexOf("xmlns") === -1 && h(et, "xmlns", this.SVG_NS), this.box = et, this.boxWrapper = F, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(a.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = M, this.forExport = T, this.styledMode = U, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = F.getStyle("font-size"), this.setSize(L, Y, !1), u && A.getBoundingClientRect && ((H = function() {
            t(A, { left: 0, top: 0 }), q = A.getBoundingClientRect(), t(A, { left: Math.ceil(q.left) - q.left + "px", top: Math.ceil(q.top) - q.top + "px" });
          })(), this.unSubPixelFix = O(z, "resize", H));
        }
        definition(A) {
          return new B([A]).addToDOM(this.defs.element);
        }
        getReferenceURL() {
          if ((u || l) && a.getElementsByTagName("base").length) {
            if (!e(p)) {
              let A = W(), L = new B([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: A }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": `url(#${A})`, fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(a.body);
              t(L, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
              let Y = a.elementFromPoint(6, 6);
              p = (Y && Y.id) === "hitme", a.body.removeChild(L);
            }
            if (p) return G(z.location.href.split("#")[0], [/<[^>]*>/g, ""], [/([\('\)])/g, "\\$1"], [/ /g, "%20"]);
          }
          return "";
        }
        getStyle(A) {
          return this.style = g({ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "1rem" }, A), this.style;
        }
        setStyle(A) {
          this.boxWrapper.css(this.getStyle(A));
        }
        isHidden() {
          return !this.boxWrapper.getBBox().width;
        }
        destroy() {
          let A = this.defs;
          return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), r(this.gradients || {}), this.gradients = null, this.defs = A.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
        }
        createElement(A) {
          return new this.Element(this, A);
        }
        getRadialAttr(A, L) {
          return { cx: A[0] - A[2] / 2 + (L.cx || 0) * A[2], cy: A[1] - A[2] / 2 + (L.cy || 0) * A[2], r: (L.r || 0) * A[2] };
        }
        shadowDefinition(A) {
          let L = [`highcharts-drop-shadow-${this.chartIndex}`, ...Object.keys(A).map((x) => `${x}-${A[x]}`)].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), Y = j({ color: "#000000", offsetX: 1, offsetY: 1, opacity: 0.15, width: 5 }, A);
          return this.defs.element.querySelector(`#${L}`) || this.definition({ tagName: "filter", attributes: { id: L, filterUnits: Y.filterUnits }, children: this.getShadowFilterContent(Y) }), L;
        }
        getShadowFilterContent(A) {
          return [{ tagName: "feDropShadow", attributes: { dx: A.offsetX, dy: A.offsetY, "flood-color": A.color, "flood-opacity": Math.min(5 * A.opacity, 1), stdDeviation: A.width / 2 } }];
        }
        buildText(A) {
          new N(A).buildSVG();
        }
        getContrast(A) {
          let L = J.parse(A).rgba.map((x) => {
            let T = x / 255;
            return T <= 0.03928 ? T / 12.92 : Math.pow((T + 0.055) / 1.055, 2.4);
          }), Y = 0.2126 * L[0] + 0.7152 * L[1] + 0.0722 * L[2];
          return 1.05 / (Y + 0.05) > (Y + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
        }
        button(A, L, Y, x, T = {}, M, U, H, q, F) {
          let et = this.label(A, L, Y, q, void 0, void 0, F, void 0, "button"), rt = this.styledMode, at = arguments, ct = 0;
          T = j(y.global.buttonTheme, T), rt && (delete T.fill, delete T.stroke, delete T["stroke-width"]);
          let Z = T.states || {}, X = T.style || {};
          delete T.states, delete T.style;
          let K = [B.filterUserAttributes(T)], ot = [X];
          return rt || ["hover", "select", "disabled"].forEach((ht, dt) => {
            K.push(j(K[0], B.filterUserAttributes(at[dt + 5] || Z[ht] || {}))), ot.push(K[dt + 1].style), delete K[dt + 1].style;
          }), O(et.element, b ? "mouseover" : "mouseenter", function() {
            ct !== 3 && et.setState(1);
          }), O(et.element, b ? "mouseout" : "mouseleave", function() {
            ct !== 3 && et.setState(ct);
          }), et.setState = (ht = 0) => {
            if (ht !== 1 && (et.state = ct = ht), et.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][ht]), !rt) {
              et.attr(K[ht]);
              let dt = ot[ht];
              n(dt) && et.css(dt);
            }
          }, et.attr(K[0]), !rt && (et.css(g({ cursor: "default" }, X)), F && et.text.css({ pointerEvents: "none" })), et.on("touchstart", (ht) => ht.stopPropagation()).on("click", function(ht) {
            ct !== 3 && x.call(et, ht);
          });
        }
        crispLine(A, L) {
          let [Y, x] = A;
          return e(Y[1]) && Y[1] === x[1] && (Y[1] = x[1] = s(Y[1], L)), e(Y[2]) && Y[2] === x[2] && (Y[2] = x[2] = s(Y[2], L)), A;
        }
        path(A) {
          let L = this.styledMode ? {} : { fill: "none" };
          return o(A) ? L.d = A : n(A) && g(L, A), this.createElement("path").attr(L);
        }
        circle(A, L, Y) {
          let x = n(A) ? A : A === void 0 ? {} : { x: A, y: L, r: Y }, T = this.createElement("circle");
          return T.xSetter = T.ySetter = function(M, U, H) {
            H.setAttribute("c" + U, M);
          }, T.attr(x);
        }
        arc(A, L, Y, x, T, M) {
          let U;
          n(A) ? (L = (U = A).y, Y = U.r, x = U.innerR, T = U.start, M = U.end, A = U.x) : U = { innerR: x, start: T, end: M };
          let H = this.symbol("arc", A, L, Y, Y, U);
          return H.r = Y, H;
        }
        rect(A, L, Y, x, T, M) {
          let U = n(A) ? A : A === void 0 ? {} : { x: A, y: L, r: T, width: Math.max(Y || 0, 0), height: Math.max(x || 0, 0) }, H = this.createElement("rect");
          return this.styledMode || (M !== void 0 && (U["stroke-width"] = M, g(U, H.crisp(U))), U.fill = "none"), H.rSetter = function(q, F, et) {
            H.r = q, h(et, { rx: q, ry: q });
          }, H.rGetter = function() {
            return H.r || 0;
          }, H.attr(U);
        }
        roundedRect(A) {
          return this.symbol("roundedRect").attr(A);
        }
        setSize(A, L, Y) {
          this.width = A, this.height = L, this.boxWrapper.animate({ width: A, height: L }, { step: function() {
            this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
          }, duration: v(Y, !0) ? void 0 : 0 }), this.alignElements();
        }
        g(A) {
          let L = this.createElement("g");
          return A ? L.attr({ class: "highcharts-" + A }) : L;
        }
        image(A, L, Y, x, T, M) {
          let U = { preserveAspectRatio: "none" };
          c(L) && (U.x = L), c(Y) && (U.y = Y), c(x) && (U.width = x), c(T) && (U.height = T);
          let H = this.createElement("image").attr(U), q = function(F) {
            H.attr({ href: A }), M.call(H, F);
          };
          if (M) {
            H.attr({ href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" });
            let F = new z.Image();
            O(F, "load", q), F.src = A, F.complete && q({});
          } else H.attr({ href: A });
          return H;
        }
        symbol(A, L, Y, x, T, M) {
          let U, H, q, F, et = this, rt = /^url\((.*?)\)$/, at = rt.test(A), ct = !at && (this.symbols[A] ? A : "circle"), Z = ct && this.symbols[ct];
          if (Z) typeof L == "number" && (H = Z.call(this.symbols, L || 0, Y || 0, x || 0, T || 0, M)), U = this.path(H), et.styledMode || U.attr("fill", "none"), g(U, { symbolName: ct || void 0, x: L, y: Y, width: x, height: T }), M && g(U, M);
          else if (at) {
            q = A.match(rt)[1];
            let X = U = this.image(q);
            X.imgwidth = v(M && M.width, R[q] && R[q].width), X.imgheight = v(M && M.height, R[q] && R[q].height), F = (K) => K.attr({ width: K.width, height: K.height }), ["width", "height"].forEach((K) => {
              X[`${K}Setter`] = function(ot, ht) {
                this[ht] = ot;
                let { alignByTranslate: dt, element: lt, width: ut, height: ft, imgwidth: gt, imgheight: pt } = this, mt = ht === "width" ? gt : pt, yt = 1;
                M && M.backgroundSize === "within" && ut && ft && gt && pt ? (yt = Math.min(ut / gt, ft / pt), h(lt, { width: Math.round(gt * yt), height: Math.round(pt * yt) })) : lt && mt && lt.setAttribute(ht, mt), !dt && gt && pt && this.translate(((ut || 0) - gt * yt) / 2, ((ft || 0) - pt * yt) / 2);
              };
            }), e(L) && X.attr({ x: L, y: Y }), X.isImg = !0, X.symbolUrl = A, e(X.imgwidth) && e(X.imgheight) ? F(X) : (X.attr({ width: 0, height: 0 }), f("img", { onload: function() {
              let K = m[et.chartIndex];
              this.width === 0 && (t(this, { position: "absolute", top: "-999em" }), a.body.appendChild(this)), R[q] = { width: this.width, height: this.height }, X.imgwidth = this.width, X.imgheight = this.height, X.element && F(X), this.parentNode && this.parentNode.removeChild(this), et.imgCount--, et.imgCount || !K || K.hasLoaded || K.onload();
            }, src: q }), this.imgCount++);
          }
          return U;
        }
        clipRect(A, L, Y, x) {
          return this.rect(A, L, Y, x, 0);
        }
        text(A, L, Y, x) {
          let T = {};
          if (x && (this.allowHTML || !this.forExport)) return this.html(A, L, Y);
          T.x = Math.round(L || 0), Y && (T.y = Math.round(Y)), e(A) && (T.text = A);
          let M = this.createElement("text").attr(T);
          return x && (!this.forExport || this.allowHTML) || (M.xSetter = function(U, H, q) {
            let F = q.getElementsByTagName("tspan"), et = q.getAttribute(H);
            for (let rt = 0, at; rt < F.length; rt++) (at = F[rt]).getAttribute(H) === et && at.setAttribute(H, U);
            q.setAttribute(H, U);
          }), M;
        }
        fontMetrics(A) {
          let L = P(tt.prototype.getStyle.call(A, "font-size") || 0), Y = L < 24 ? L + 3 : Math.round(1.2 * L), x = Math.round(0.8 * Y);
          return { h: Y, b: x, f: L };
        }
        rotCorr(A, L, Y) {
          let x = A;
          return L && Y && (x = Math.max(x * Math.cos(L * w), 4)), { x: -A / 3 * Math.sin(L * w), y: x };
        }
        pathToSegments(A) {
          let L = [], Y = [], x = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 };
          for (let T = 0; T < A.length; T++) S(Y[0]) && c(A[T]) && Y.length === x[Y[0].toUpperCase()] && A.splice(T, 0, Y[0].replace("M", "L").replace("m", "l")), typeof A[T] == "string" && (Y.length && L.push(Y.slice(0)), Y.length = 0), Y.push(A[T]);
          return L.push(Y.slice(0)), L;
        }
        label(A, L, Y, x, T, M, U, H, q) {
          return new V(this, A, L, Y, x, T, M, U, H, q);
        }
        alignElements() {
          this.alignedObjects.forEach((A) => A.align());
        }
      }
      return g(Q.prototype, { Element: tt, SVG_NS: C, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: _, draw: d }), st.registerRendererType("svg", Q, !0), Q;
    }), nt(i, "Core/Renderer/HTML/HTMLElement.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Globals.js"], i["Core/Renderer/SVG/SVGElement.js"], i["Core/Utilities.js"]], function(B, $, J, it) {
      let { composed: st } = $, { attr: tt, css: V, createElement: _, defined: N, extend: D, pInt: p, pushUnique: y } = it;
      function m(b, l, d) {
        var R;
        let C = ((R = this.div) == null ? void 0 : R.style) || d.style;
        J.prototype[`${l}Setter`].call(this, b, l, d), C && (C[l] = b);
      }
      let w = (b, l) => {
        var d;
        if (!b.div) {
          let C = tt(b.element, "class"), R = b.css, z = _("div", C ? { className: C } : void 0, { position: "absolute", left: `${b.translateX || 0}px`, top: `${b.translateY || 0}px`, ...b.styles, display: b.display, opacity: b.opacity, visibility: b.visibility }, ((d = b.parentGroup) == null ? void 0 : d.div) || l);
          b.classSetter = (O, h, f) => {
            f.setAttribute("class", O), z.className = O;
          }, b.translateXSetter = b.translateYSetter = (O, h) => {
            b[h] = O, z.style[h === "translateX" ? "left" : "top"] = `${O}px`, b.doTransform = !0;
          }, b.opacitySetter = b.visibilitySetter = m, b.css = (O) => (R.call(b, O), O.cursor && (z.style.cursor = O.cursor), O.pointerEvents && (z.style.pointerEvents = O.pointerEvents), b), b.on = function() {
            return J.prototype.on.apply({ element: z, onEvents: b.onEvents }, arguments), b;
          }, b.div = z;
        }
        return b.div;
      };
      class a extends J {
        static compose(l) {
          y(st, this.compose) && (l.prototype.html = function(d, C, R) {
            return new a(this, "span").attr({ text: d, x: Math.round(C), y: Math.round(R) });
          });
        }
        constructor(l, d) {
          super(l, d), this.css({ position: "absolute", ...l.styledMode ? {} : { fontFamily: l.style.fontFamily, fontSize: l.style.fontSize } }), this.element.style.whiteSpace = "nowrap";
        }
        getSpanCorrection(l, d, C) {
          this.xCorr = -l * C, this.yCorr = -d;
        }
        css(l) {
          let d, { element: C } = this, R = C.tagName === "SPAN" && l && "width" in l, z = R && l.width;
          return R && (delete l.width, this.textWidth = p(z) || void 0, d = !0), (l == null ? void 0 : l.textOverflow) === "ellipsis" && (l.whiteSpace = "nowrap", l.overflow = "hidden"), D(this.styles, l), V(C, l), d && this.updateTransform(), this;
        }
        htmlGetBBox() {
          let { element: l } = this;
          return { x: l.offsetLeft, y: l.offsetTop, width: l.offsetWidth, height: l.offsetHeight };
        }
        updateTransform() {
          var c;
          if (!this.added) {
            this.alignOnAdd = !0;
            return;
          }
          let { element: l, renderer: d, rotation: C, rotationOriginX: R, rotationOriginY: z, styles: O, textAlign: h = "left", textWidth: f, translateX: s = 0, translateY: t = 0, x: e = 0, y: r = 0 } = this, g = { left: 0, center: 0.5, right: 1 }[h], o = O.whiteSpace;
          if (V(l, { marginLeft: `${s}px`, marginTop: `${t}px` }), l.tagName === "SPAN") {
            let n = [C, h, l.innerHTML, f, this.textAlign].join(","), S = -(((c = this.parentGroup) == null ? void 0 : c.padding) * 1) || 0, j, v = !1;
            if (f !== this.oldTextWidth) {
              let k = this.textPxLength ? this.textPxLength : (V(l, { width: "", whiteSpace: o || "nowrap" }), l.offsetWidth), A = f || 0;
              (A > this.oldTextWidth || k > A) && (/[ \-]/.test(l.textContent || l.innerText) || l.style.textOverflow === "ellipsis") && (V(l, { width: k > A || C ? f + "px" : "auto", display: "block", whiteSpace: o || "normal" }), this.oldTextWidth = f, v = !0);
            }
            this.hasBoxWidthChanged = v, n !== this.cTT && (j = d.fontMetrics(l).b, N(C) && (C !== (this.oldRotation || 0) || h !== this.oldAlign) && this.setSpanRotation(C, S, S), this.getSpanCorrection(!N(C) && this.textPxLength || l.offsetWidth, j, g));
            let { xCorr: P = 0, yCorr: G = 0 } = this, W = (R != null ? R : e) - P - e - S, Q = (z != null ? z : r) - G - r - S;
            V(l, { left: `${e + P}px`, top: `${r + G}px`, transformOrigin: `${W}px ${Q}px` }), this.cTT = n, this.oldRotation = C, this.oldAlign = h;
          }
        }
        setSpanRotation(l, d, C) {
          V(this.element, { transform: `rotate(${l}deg)`, transformOrigin: `${d}% ${C}px` });
        }
        add(l) {
          let d, C = this.renderer.box.parentNode, R = [];
          if (this.parentGroup = l, l && !(d = l.div)) {
            let z = l;
            for (; z; ) R.push(z), z = z.parentGroup;
            for (let O of R.reverse()) d = w(O, C);
          }
          return (d || C).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
        }
        textSetter(l) {
          l !== this.textStr && (delete this.bBox, delete this.oldTextWidth, B.setElementHTML(this.element, l != null ? l : ""), this.textStr = l, this.doTransform = !0);
        }
        alignSetter(l) {
          this.alignValue = this.textAlign = l, this.doTransform = !0;
        }
        xSetter(l, d) {
          this[d] = l, this.doTransform = !0;
        }
      }
      let u = a.prototype;
      return u.visibilitySetter = u.opacitySetter = m, u.ySetter = u.rotationSetter = u.rotationOriginXSetter = u.rotationOriginYSetter = u.xSetter, a;
    }), nt(i, "Core/Axis/AxisDefaults.js", [], function() {
      var B, $;
      return ($ = B || (B = {})).xAxis = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e %b" }, week: { main: "%e %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotationLimit: 80, distance: 15, enabled: !0, indentation: 10, overflow: "justify", reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, zIndex: 7, style: { color: "#333333", cursor: "default", fontSize: "0.8em" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minorTicksPerMajor: 5, minPadding: 0.01, offset: void 0, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", useHTML: !1, x: 0, y: 0, style: { color: "#666666", fontSize: "0.8em" } }, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#333333", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#333333" }, $.yAxis = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: void 0 }, startOnTick: !0, title: { text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
        let { numberFormatter: J } = this.axis.chart;
        return J(this.total || 0, -1);
      }, style: { color: "#000000", fontSize: "0.7em", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, B;
    }), nt(i, "Core/Foundation.js", [i["Core/Utilities.js"]], function(B) {
      var $;
      let { addEvent: J, isFunction: it, objectEach: st, removeEvent: tt } = B;
      return ($ || ($ = {})).registerEventOptions = function(V, _) {
        V.eventOptions = V.eventOptions || {}, st(_.events, function(N, D) {
          V.eventOptions[D] !== N && (V.eventOptions[D] && (tt(V, D, V.eventOptions[D]), delete V.eventOptions[D]), it(N) && (V.eventOptions[D] = N, J(V, D, N, { order: 0 })));
        });
      }, $;
    }), nt(i, "Core/Axis/Tick.js", [i["Core/Templating.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { deg2rad: it } = $, { clamp: st, correctFloat: tt, defined: V, destroyObjectProperties: _, extend: N, fireEvent: D, isNumber: p, merge: y, objectEach: m, pick: w } = J;
      return class {
        constructor(a, u, b, l, d) {
          this.isNew = !0, this.isNewLabel = !0, this.axis = a, this.pos = u, this.type = b || "", this.parameters = d || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, D(this, "init"), b || l || this.addLabel();
        }
        addLabel() {
          let a = this, u = a.axis, b = u.options, l = u.chart, d = u.categories, C = u.logarithmic, R = u.names, z = a.pos, O = w(a.options && a.options.labels, b.labels), h = u.tickPositions, f = z === h[0], s = z === h[h.length - 1], t = (!O.step || O.step === 1) && u.tickInterval === 1, e = h.info, r = a.label, g, o, c, n = this.parameters.category || (d ? w(d[z], R[z], z) : z);
          C && p(n) && (n = tt(C.lin2log(n))), u.dateTime && (e ? g = (o = l.time.resolveDTLFormat(b.dateTimeLabelFormats[!b.grid && e.higherRanks[z] || e.unitName])).main : p(n) && (g = u.dateTime.getXDateFormat(n, b.dateTimeLabelFormats || {}))), a.isFirst = f, a.isLast = s;
          let S = { axis: u, chart: l, dateTimeLabelFormat: g, isFirst: f, isLast: s, pos: z, tick: a, tickPositionInfo: e, value: n };
          D(this, "labelFormat", S);
          let j = (G) => O.formatter ? O.formatter.call(G, G) : O.format ? (G.text = u.defaultLabelFormatter.call(G), B.format(O.format, G, l)) : u.defaultLabelFormatter.call(G), v = j.call(S, S), P = o && o.list;
          P ? a.shortenLabel = function() {
            for (c = 0; c < P.length; c++) if (N(S, { dateTimeLabelFormat: P[c] }), r.attr({ text: j.call(S, S) }), r.getBBox().width < u.getSlotWidth(a) - 2 * (O.padding || 0)) return;
            r.attr({ text: "" });
          } : a.shortenLabel = void 0, t && u._addedPlotLB && a.moveLabel(v, O), V(r) || a.movedLabel ? r && r.textStr !== v && !t && (!r.textWidth || O.style.width || r.styles.width || r.css({ width: null }), r.attr({ text: v }), r.textPxLength = r.getBBox().width) : (a.label = r = a.createLabel(v, O), a.rotation = 0);
        }
        createLabel(a, u, b) {
          let l = this.axis, d = l.chart, C = V(a) && u.enabled ? d.renderer.text(a, b == null ? void 0 : b.x, b == null ? void 0 : b.y, u.useHTML).add(l.labelGroup) : void 0;
          return C && (d.styledMode || C.css(y(u.style)), C.textPxLength = C.getBBox().width), C;
        }
        destroy() {
          _(this, this.axis);
        }
        getPosition(a, u, b, l) {
          let d = this.axis, C = d.chart, R = l && C.oldChartHeight || C.chartHeight, z = { x: a ? tt(d.translate(u + b, void 0, void 0, l) + d.transB) : d.left + d.offset + (d.opposite ? (l && C.oldChartWidth || C.chartWidth) - d.right - d.left : 0), y: a ? R - d.bottom + d.offset - (d.opposite ? d.height : 0) : tt(R - d.translate(u + b, void 0, void 0, l) - d.transB) };
          return z.y = st(z.y, -1e9, 1e9), D(this, "afterGetPosition", { pos: z }), z;
        }
        getLabelPosition(a, u, b, l, d, C, R, z) {
          let O, h, f = this.axis, s = f.transA, t = f.isLinked && f.linkedParent ? f.linkedParent.reversed : f.reversed, e = f.staggerLines, r = f.tickRotCorr || { x: 0, y: 0 }, g = l || f.reserveSpaceDefault ? 0 : -f.labelOffset * (f.labelAlign === "center" ? 0.5 : 1), o = d.distance, c = {};
          return O = f.side === 0 ? b.rotation ? -o : -b.getBBox().height : f.side === 2 ? r.y + o : Math.cos(b.rotation * it) * (r.y - b.getBBox(!1, 0).height / 2), V(d.y) && (O = f.side === 0 && f.horiz ? d.y + O : d.y), a = a + w(d.x, [0, 1, 0, -1][f.side] * o) + g + r.x - (C && l ? C * s * (t ? -1 : 1) : 0), u = u + O - (C && !l ? C * s * (t ? 1 : -1) : 0), e && (h = R / (z || 1) % e, f.opposite && (h = e - h - 1), u += h * (f.labelOffset / e)), c.x = a, c.y = Math.round(u), D(this, "afterGetLabelPosition", { pos: c, tickmarkOffset: C, index: R }), c;
        }
        getLabelSize() {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        }
        getMarkPath(a, u, b, l, d = !1, C) {
          return C.crispLine([["M", a, u], ["L", a + (d ? 0 : -b), u + (d ? b : 0)]], l);
        }
        handleOverflow(a) {
          let u = this.axis, b = u.options.labels, l = a.x, d = u.chart.chartWidth, C = u.chart.spacing, R = w(u.labelLeft, Math.min(u.pos, C[3])), z = w(u.labelRight, Math.max(u.isRadial ? 0 : u.pos + u.len, d - C[1])), O = this.label, h = this.rotation, f = { left: 0, center: 0.5, right: 1 }[u.labelAlign || O.attr("align")], s = O.getBBox().width, t = u.getSlotWidth(this), e = {}, r = t, g = 1, o, c, n;
          h || b.overflow !== "justify" ? h < 0 && l - f * s < R ? n = Math.round(l / Math.cos(h * it) - R) : h > 0 && l + f * s > z && (n = Math.round((d - l) / Math.cos(h * it))) : (o = l - f * s, c = l + (1 - f) * s, o < R ? r = a.x + r * (1 - f) - R : c > z && (r = z - a.x + r * f, g = -1), (r = Math.min(t, r)) < t && u.labelAlign === "center" && (a.x += g * (t - r - f * (t - Math.min(s, r)))), (s > r || u.autoRotation && (O.styles || {}).width) && (n = r)), n && (this.shortenLabel ? this.shortenLabel() : (e.width = Math.floor(n) + "px", (b.style || {}).textOverflow || (e.textOverflow = "ellipsis"), O.css(e)));
        }
        moveLabel(a, u) {
          let b = this, l = b.label, d = b.axis, C = !1, R;
          l && l.textStr === a ? (b.movedLabel = l, C = !0, delete b.label) : m(d.ticks, function(z) {
            C || z.isNew || z === b || !z.label || z.label.textStr !== a || (b.movedLabel = z.label, C = !0, z.labelPos = b.movedLabel.xy, delete z.label);
          }), !C && (b.labelPos || l) && (R = b.labelPos || l.xy, b.movedLabel = b.createLabel(a, u, R), b.movedLabel && b.movedLabel.attr({ opacity: 0 }));
        }
        render(a, u, b) {
          let l = this.axis, d = l.horiz, C = this.pos, R = w(this.tickmarkOffset, l.tickmarkOffset), z = this.getPosition(d, C, R, u), O = z.x, h = z.y, f = l.pos, s = f + l.len, t = d ? O : h;
          !l.chart.polar && this.isNew && (tt(t) < f || t > s) && (b = 0);
          let e = w(b, this.label && this.label.newOpacity, 1);
          b = w(b, 1), this.isActive = !0, this.renderGridLine(u, b), this.renderMark(z, b), this.renderLabel(z, u, e, a), this.isNew = !1, D(this, "afterRender");
        }
        renderGridLine(a, u) {
          let b = this.axis, l = b.options, d = {}, C = this.pos, R = this.type, z = w(this.tickmarkOffset, b.tickmarkOffset), O = b.chart.renderer, h = this.gridLine, f, s = l.gridLineWidth, t = l.gridLineColor, e = l.gridLineDashStyle;
          this.type === "minor" && (s = l.minorGridLineWidth, t = l.minorGridLineColor, e = l.minorGridLineDashStyle), h || (b.chart.styledMode || (d.stroke = t, d["stroke-width"] = s || 0, d.dashstyle = e), R || (d.zIndex = 1), a && (u = 0), this.gridLine = h = O.path().attr(d).addClass("highcharts-" + (R ? R + "-" : "") + "grid-line").add(b.gridGroup)), h && (f = b.getPlotLinePath({ value: C + z, lineWidth: h.strokeWidth(), force: "pass", old: a, acrossPanes: !1 })) && h[a || this.isNew ? "attr" : "animate"]({ d: f, opacity: u });
        }
        renderMark(a, u) {
          let b = this.axis, l = b.options, d = b.chart.renderer, C = this.type, R = b.tickSize(C ? C + "Tick" : "tick"), z = a.x, O = a.y, h = w(l[C !== "minor" ? "tickWidth" : "minorTickWidth"], !C && b.isXAxis ? 1 : 0), f = l[C !== "minor" ? "tickColor" : "minorTickColor"], s = this.mark, t = !s;
          R && (b.opposite && (R[0] = -R[0]), s || (this.mark = s = d.path().addClass("highcharts-" + (C ? C + "-" : "") + "tick").add(b.axisGroup), b.chart.styledMode || s.attr({ stroke: f, "stroke-width": h })), s[t ? "attr" : "animate"]({ d: this.getMarkPath(z, O, R[0], s.strokeWidth(), b.horiz, d), opacity: u }));
        }
        renderLabel(a, u, b, l) {
          let d = this.axis, C = d.horiz, R = d.options, z = this.label, O = R.labels, h = O.step, f = w(this.tickmarkOffset, d.tickmarkOffset), s = a.x, t = a.y, e = !0;
          z && p(s) && (z.xy = a = this.getLabelPosition(s, t, z, C, O, f, l, h), (!this.isFirst || this.isLast || R.showFirstLabel) && (!this.isLast || this.isFirst || R.showLastLabel) ? !C || O.step || O.rotation || u || b === 0 || this.handleOverflow(a) : e = !1, h && l % h && (e = !1), e && p(a.y) ? (a.opacity = b, z[this.isNewLabel ? "attr" : "animate"](a).show(!0), this.isNewLabel = !1) : (z.hide(), this.isNewLabel = !0));
        }
        replaceMovedLabel() {
          let a = this.label, u = this.axis;
          a && !this.isNew && (a.animate({ opacity: 0 }, void 0, a.destroy), delete this.label), u.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
        }
      };
    }), nt(i, "Core/Axis/Axis.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Axis/AxisDefaults.js"], i["Core/Color/Color.js"], i["Core/Defaults.js"], i["Core/Foundation.js"], i["Core/Globals.js"], i["Core/Axis/Tick.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _) {
      let { animObject: N } = B, { xAxis: D, yAxis: p } = $, { defaultOptions: y } = it, { registerEventOptions: m } = st, { deg2rad: w } = tt, { arrayMax: a, arrayMin: u, clamp: b, correctFloat: l, defined: d, destroyObjectProperties: C, erase: R, error: z, extend: O, fireEvent: h, getClosestDistance: f, insertItem: s, isArray: t, isNumber: e, isString: r, merge: g, normalizeTickInterval: o, objectEach: c, pick: n, relativeLength: S, removeEvent: j, splat: v, syncTimeout: P } = _, G = (Q, k) => o(k, void 0, void 0, n(Q.options.allowDecimals, k < 0.5 || Q.tickAmount !== void 0), !!Q.tickAmount);
      O(y, { xAxis: D, yAxis: g(D, p) });
      class W {
        constructor(k, A, L) {
          this.init(k, A, L);
        }
        init(k, A, L = this.coll) {
          var H, q, F, et;
          let Y = L === "xAxis", x = this.isZAxis || (k.inverted ? !Y : Y);
          this.chart = k, this.horiz = x, this.isXAxis = Y, this.coll = L, h(this, "init", { userOptions: A }), this.opposite = n(A.opposite, this.opposite), this.side = n(A.side, this.side, x ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(A);
          let T = this.options, M = T.labels;
          (H = this.type) != null || (this.type = T.type || "linear"), (F = this.uniqueNames) != null || (this.uniqueNames = (q = T.uniqueNames) != null ? q : !0), h(this, "afterSetType"), this.userOptions = A, this.minPixelPadding = 0, this.reversed = n(T.reversed, this.reversed), this.visible = T.visible, this.zoomEnabled = T.zoomEnabled, this.hasNames = this.type === "category" || T.categories === !0, this.categories = t(T.categories) && T.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = d(T.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, (et = this.len) != null || (this.len = 0), this.minRange = this.userMinRange = T.minRange || T.maxZoom, this.range = T.range, this.offset = T.offset || 0, this.max = void 0, this.min = void 0;
          let U = n(T.crosshair, v(k.options.tooltip.crosshairs)[Y ? 0 : 1]);
          this.crosshair = U === !0 ? {} : U, k.axes.indexOf(this) === -1 && (Y ? k.axes.splice(k.xAxis.length, 0, this) : k.axes.push(this), s(this, k[this.coll])), k.orderItems(this.coll), this.series = this.series || [], k.inverted && !this.isZAxis && Y && !d(this.reversed) && (this.reversed = !0), this.labelRotation = e(M.rotation) ? M.rotation : void 0, m(this, T), h(this, "afterInit");
        }
        setOptions(k) {
          let A = this.horiz ? { labels: { autoRotation: [-45], padding: 4 }, margin: 15 } : { labels: { padding: 1 }, title: { rotation: 90 * this.side } };
          this.options = g(A, y[this.coll], k), h(this, "afterSetOptions", { userOptions: k });
        }
        defaultLabelFormatter() {
          let k = this.axis, { numberFormatter: A } = this.chart, L = e(this.value) ? this.value : NaN, Y = k.chart.time, x = k.categories, T = this.dateTimeLabelFormat, M = y.lang, U = M.numericSymbols, H = M.numericSymbolMagnitude || 1e3, q = k.logarithmic ? Math.abs(L) : k.tickInterval, F = U && U.length, et, rt;
          if (x) rt = `${this.value}`;
          else if (T) rt = Y.dateFormat(T, L);
          else if (F && U && q >= 1e3) for (; F-- && rt === void 0; ) q >= (et = Math.pow(H, F + 1)) && 10 * L % et == 0 && U[F] !== null && L !== 0 && (rt = A(L / et, -1) + U[F]);
          return rt === void 0 && (rt = Math.abs(L) >= 1e4 ? A(L, -1) : A(L, -1, void 0, "")), rt;
        }
        getSeriesExtremes() {
          let k, A = this;
          h(this, "getSeriesExtremes", null, function() {
            A.hasVisibleSeries = !1, A.dataMin = A.dataMax = A.threshold = void 0, A.softThreshold = !A.isXAxis, A.series.forEach((L) => {
              if (L.reserveSpace()) {
                let Y = L.options, x, T = Y.threshold, M, U;
                if (A.hasVisibleSeries = !0, A.positiveValuesOnly && 0 >= (T || 0) && (T = void 0), A.isXAxis) (x = L.xData) && x.length && (x = A.logarithmic ? x.filter((H) => H > 0) : x, M = (k = L.getXExtremes(x)).min, U = k.max, e(M) || M instanceof Date || (x = x.filter(e), M = (k = L.getXExtremes(x)).min, U = k.max), x.length && (A.dataMin = Math.min(n(A.dataMin, M), M), A.dataMax = Math.max(n(A.dataMax, U), U)));
                else {
                  let H = L.applyExtremes();
                  e(H.dataMin) && (M = H.dataMin, A.dataMin = Math.min(n(A.dataMin, M), M)), e(H.dataMax) && (U = H.dataMax, A.dataMax = Math.max(n(A.dataMax, U), U)), d(T) && (A.threshold = T), (!Y.softThreshold || A.positiveValuesOnly) && (A.softThreshold = !1);
                }
              }
            });
          }), h(this, "afterGetSeriesExtremes");
        }
        translate(k, A, L, Y, x, T) {
          var ct;
          let M = this.linkedParent || this, U = Y && M.old ? M.old.min : M.min;
          if (!e(U)) return NaN;
          let H = M.minPixelPadding, q = (M.isOrdinal || ((ct = M.brokenAxis) == null ? void 0 : ct.hasBreaks) || M.logarithmic && x) && M.lin2val, F = 1, et = 0, rt = Y && M.old ? M.old.transA : M.transA, at = 0;
          return rt || (rt = M.transA), L && (F *= -1, et = M.len), M.reversed && (F *= -1, et -= F * (M.sector || M.len)), A ? (at = (k = k * F + et - H) / rt + U, q && (at = M.lin2val(at))) : (q && (k = M.val2lin(k)), at = F * (k - U) * rt + et + F * H + (e(T) ? rt * T : 0), M.isRadial || (at = l(at))), at;
        }
        toPixels(k, A) {
          return this.translate(k, !1, !this.horiz, void 0, !0) + (A ? 0 : this.pos);
        }
        toValue(k, A) {
          return this.translate(k - (A ? 0 : this.pos), !0, !this.horiz, void 0, !0);
        }
        getPlotLinePath(k) {
          let A = this, L = A.chart, Y = A.left, x = A.top, T = k.old, M = k.value, U = k.lineWidth, H = T && L.oldChartHeight || L.chartHeight, q = T && L.oldChartWidth || L.chartWidth, F = A.transB, et = k.translatedValue, rt = k.force, at, ct, Z, X, K;
          function ot(dt, lt, ut) {
            return rt !== "pass" && (dt < lt || dt > ut) && (rt ? dt = b(dt, lt, ut) : K = !0), dt;
          }
          let ht = { value: M, lineWidth: U, old: T, force: rt, acrossPanes: k.acrossPanes, translatedValue: et };
          return h(this, "getPlotLinePath", ht, function(dt) {
            at = Z = (et = b(et = n(et, A.translate(M, void 0, void 0, T)), -1e9, 1e9)) + F, ct = X = H - et - F, e(et) ? A.horiz ? (ct = x, X = H - A.bottom + (A.options.isInternal ? 0 : L.scrollablePixelsY || 0), at = Z = ot(at, Y, Y + A.width)) : (at = Y, Z = q - A.right + (L.scrollablePixelsX || 0), ct = X = ot(ct, x, x + A.height)) : (K = !0, rt = !1), dt.path = K && !rt ? void 0 : L.renderer.crispLine([["M", at, ct], ["L", Z, X]], U || 1);
          }), ht.path;
        }
        getLinearTickPositions(k, A, L) {
          let Y, x, T, M = l(Math.floor(A / k) * k), U = l(Math.ceil(L / k) * k), H = [];
          if (l(M + k) === M && (T = 20), this.single) return [A];
          for (Y = M; Y <= U && (H.push(Y), (Y = l(Y + k, T)) !== x); ) x = Y;
          return H;
        }
        getMinorTickInterval() {
          let { minorTicks: k, minorTickInterval: A } = this.options;
          return k === !0 ? n(A, "auto") : k !== !1 ? A : void 0;
        }
        getMinorTickPositions() {
          let k = this.options, A = this.tickPositions, L = this.minorTickInterval, Y = this.pointRangePadding || 0, x = (this.min || 0) - Y, T = (this.max || 0) + Y, M = T - x, U = [], H;
          if (M && M / L < this.len / 3) {
            let q = this.logarithmic;
            if (q) this.paddedTicks.forEach(function(F, et, rt) {
              et && U.push.apply(U, q.getLogTickPositions(L, rt[et - 1], rt[et], !0));
            });
            else if (this.dateTime && this.getMinorTickInterval() === "auto") U = U.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(L), x, T, k.startOfWeek));
            else for (H = x + (A[0] - x) % L; H <= T && H !== U[0]; H += L) U.push(H);
          }
          return U.length !== 0 && this.trimTicks(U), U;
        }
        adjustForMinRange() {
          let k = this.options, A = this.logarithmic, { max: L, min: Y, minRange: x } = this, T, M, U, H;
          this.isXAxis && x === void 0 && !A && (x = d(k.min) || d(k.max) || d(k.floor) || d(k.ceiling) ? null : Math.min(5 * (f(this.series.map((q) => {
            var F;
            return (q.xIncrement ? (F = q.xData) == null ? void 0 : F.slice(0, 2) : q.xData) || [];
          })) || 0), this.dataMax - this.dataMin)), e(L) && e(Y) && e(x) && L - Y < x && (M = this.dataMax - this.dataMin >= x, T = (x - L + Y) / 2, U = [Y - T, n(k.min, Y - T)], M && (U[2] = A ? A.log2lin(this.dataMin) : this.dataMin), H = [(Y = a(U)) + x, n(k.max, Y + x)], M && (H[2] = A ? A.log2lin(this.dataMax) : this.dataMax), (L = u(H)) - Y < x && (U[0] = L - x, U[1] = n(k.min, L - x), Y = a(U))), this.minRange = x, this.min = Y, this.max = L;
        }
        getClosest() {
          let k, A;
          if (this.categories) A = 1;
          else {
            let L = [];
            this.series.forEach(function(Y) {
              var T;
              let x = Y.closestPointRange;
              ((T = Y.xData) == null ? void 0 : T.length) === 1 ? L.push(Y.xData[0]) : !Y.noSharedTooltip && d(x) && Y.reserveSpace() && (A = d(A) ? Math.min(A, x) : x);
            }), L.length && (L.sort((Y, x) => Y - x), k = f([L]));
          }
          return k && A ? Math.min(k, A) : k || A;
        }
        nameToX(k) {
          let A = t(this.options.categories), L = A ? this.categories : this.names, Y = k.options.x, x;
          return k.series.requireSorting = !1, d(Y) || (Y = this.uniqueNames && L ? A ? L.indexOf(k.name) : n(L.keys[k.name], -1) : k.series.autoIncrement()), Y === -1 ? !A && L && (x = L.length) : x = Y, x !== void 0 ? (this.names[x] = k.name, this.names.keys[k.name] = x) : k.x && (x = k.x), x;
        }
        updateNames() {
          let k = this, A = this.names;
          A.length > 0 && (Object.keys(A.keys).forEach(function(L) {
            delete A.keys[L];
          }), A.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((L) => {
            L.xIncrement = null, (!L.points || L.isDirtyData) && (k.max = Math.max(k.max, L.xData.length - 1), L.processData(), L.generatePoints()), L.data.forEach(function(Y, x) {
              let T;
              Y != null && Y.options && Y.name !== void 0 && (T = k.nameToX(Y)) !== void 0 && T !== Y.x && (Y.x = T, L.xData[x] = T);
            });
          }));
        }
        setAxisTranslation() {
          let k = this, A = k.max - k.min, L = k.linkedParent, Y = !!k.categories, x = k.isXAxis, T = k.axisPointRange || 0, M, U = 0, H = 0, q, F = k.transA;
          (x || Y || T) && (M = k.getClosest(), L ? (U = L.minPointOffset, H = L.pointRangePadding) : k.series.forEach(function(et) {
            let rt = Y ? 1 : x ? n(et.options.pointRange, M, 0) : k.axisPointRange || 0, at = et.options.pointPlacement;
            if (T = Math.max(T, rt), !k.single || Y) {
              let ct = et.is("xrange") ? !x : x;
              U = Math.max(U, ct && r(at) ? 0 : rt / 2), H = Math.max(H, ct && at === "on" ? 0 : rt);
            }
          }), q = k.ordinal && k.ordinal.slope && M ? k.ordinal.slope / M : 1, k.minPointOffset = U *= q, k.pointRangePadding = H *= q, k.pointRange = Math.min(T, k.single && Y ? 1 : A), x && M && (k.closestPointRange = M)), k.translationSlope = k.transA = F = k.staticScale || k.len / (A + H || 1), k.transB = k.horiz ? k.left : k.bottom, k.minPixelPadding = F * U, h(this, "afterSetAxisTranslation");
        }
        minFromRange() {
          let { max: k, min: A } = this;
          return e(k) && e(A) && k - A || void 0;
        }
        setTickInterval(k) {
          var xt, bt, Ct, wt;
          let { categories: A, chart: L, dataMax: Y, dataMin: x, dateTime: T, isXAxis: M, logarithmic: U, options: H, softThreshold: q } = this, F = e(this.threshold) ? this.threshold : void 0, et = this.minRange || 0, { ceiling: rt, floor: at, linkedTo: ct, softMax: Z, softMin: X } = H, K = e(ct) && ((xt = L[this.coll]) == null ? void 0 : xt[ct]), ot = H.tickPixelInterval, ht = H.maxPadding, dt = H.minPadding, lt = 0, ut, ft = e(H.tickInterval) && H.tickInterval >= 0 ? H.tickInterval : void 0, gt, pt, mt, yt;
          if (T || A || K || this.getTickAmount(), mt = n(this.userMin, H.min), yt = n(this.userMax, H.max), K ? (this.linkedParent = K, ut = K.getExtremes(), this.min = n(ut.min, ut.dataMin), this.max = n(ut.max, ut.dataMax), this.type !== K.type && z(11, !0, L)) : (q && d(F) && e(Y) && e(x) && (x >= F ? (gt = F, dt = 0) : Y <= F && (pt = F, ht = 0)), this.min = n(mt, gt, x), this.max = n(yt, pt, Y)), e(this.max) && e(this.min) && (U && (this.positiveValuesOnly && !k && 0 >= Math.min(this.min, n(x, this.min)) && z(10, !0, L), this.min = l(U.log2lin(this.min), 16), this.max = l(U.log2lin(this.max), 16)), this.range && e(x) && (this.userMin = this.min = mt = Math.max(x, this.minFromRange() || 0), this.userMax = yt = this.max, this.range = void 0)), h(this, "foundExtremes"), this.adjustForMinRange(), e(this.min) && e(this.max)) {
            if (!e(this.userMin) && e(X) && X < this.min && (this.min = mt = X), !e(this.userMax) && e(Z) && Z > this.max && (this.max = yt = Z), A || this.axisPointRange || (bt = this.stacking) != null && bt.usePercentage || K || !(lt = this.max - this.min) || (!d(mt) && dt && (this.min -= lt * dt), d(yt) || !ht || (this.max += lt * ht)), !e(this.userMin) && e(at) && (this.min = Math.max(this.min, at)), !e(this.userMax) && e(rt) && (this.max = Math.min(this.max, rt)), q && e(x) && e(Y)) {
              let At = F || 0;
              !d(mt) && this.min < At && x >= At ? this.min = H.minRange ? Math.min(At, this.max - et) : At : !d(yt) && this.max > At && Y <= At && (this.max = H.minRange ? Math.max(At, this.min + et) : At);
            }
            !L.polar && this.min > this.max && (d(H.min) ? this.max = this.min : d(H.max) && (this.min = this.max)), lt = this.max - this.min;
          }
          if (this.min !== this.max && e(this.min) && e(this.max) ? K && !ft && ot === K.options.tickPixelInterval ? this.tickInterval = ft = K.tickInterval : this.tickInterval = n(ft, this.tickAmount ? lt / Math.max(this.tickAmount - 1, 1) : void 0, A ? 1 : lt * ot / Math.max(this.len, ot)) : this.tickInterval = 1, M && !k) {
            let At = this.min !== ((Ct = this.old) == null ? void 0 : Ct.min) || this.max !== ((wt = this.old) == null ? void 0 : wt.max);
            this.series.forEach(function(St) {
              var kt;
              St.forceCrop = (kt = St.forceCropping) == null ? void 0 : kt.call(St), St.processData(At);
            }), h(this, "postProcessData", { hasExtremesChanged: At });
          }
          this.setAxisTranslation(), h(this, "initialAxisTranslation"), this.pointRange && !ft && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
          let vt = n(H.minTickInterval, T && !this.series.some((At) => At.noSharedTooltip) ? this.closestPointRange : 0);
          !ft && this.tickInterval < vt && (this.tickInterval = vt), T || U || ft || (this.tickInterval = G(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
        }
        setTickPositions() {
          var q, F;
          let k = this.options, A = k.tickPositions, L = k.tickPositioner, Y = this.getMinorTickInterval(), x = !this.isPanning, T = x && k.startOnTick, M = x && k.endOnTick, U = [], H;
          if (this.tickmarkOffset = this.categories && k.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.single = this.min === this.max && d(this.min) && !this.tickAmount && (this.min % 1 == 0 || k.allowDecimals !== !1), A) U = A.slice();
          else if (e(this.min) && e(this.max)) {
            if (!((q = this.ordinal) != null && q.positions) && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) U = [this.min, this.max], z(19, !1, this.chart);
            else if (this.dateTime) U = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, k.units), this.min, this.max, k.startOfWeek, (F = this.ordinal) == null ? void 0 : F.positions, this.closestPointRange, !0);
            else if (this.logarithmic) U = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
            else {
              let et = this.tickInterval, rt = et;
              for (; rt <= 2 * et && (U = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && U.length > this.tickAmount); ) this.tickInterval = G(this, rt *= 1.1);
            }
            U.length > this.len && (U = [U[0], U[U.length - 1]])[0] === U[1] && (U.length = 1), L && (this.tickPositions = U, (H = L.apply(this, [this.min, this.max])) && (U = H));
          }
          this.tickPositions = U, this.minorTickInterval = Y === "auto" && this.tickInterval ? this.tickInterval / k.minorTicksPerMajor : Y, this.paddedTicks = U.slice(0), this.trimTicks(U, T, M), !this.isLinked && e(this.min) && e(this.max) && (this.single && U.length < 2 && !this.categories && !this.series.some((et) => et.is("heatmap") && et.options.pointPlacement === "between") && (this.min -= 0.5, this.max += 0.5), A || H || this.adjustTickAmount()), h(this, "afterSetTickPositions");
        }
        trimTicks(k, A, L) {
          let Y = k[0], x = k[k.length - 1], T = !this.isOrdinal && this.minPointOffset || 0;
          if (h(this, "trimTicks"), !this.isLinked) {
            if (A && Y !== -1 / 0) this.min = Y;
            else for (; this.min - T > k[0]; ) k.shift();
            if (L) this.max = x;
            else for (; this.max + T < k[k.length - 1]; ) k.pop();
            k.length === 0 && d(Y) && !this.options.tickPositions && k.push((x + Y) / 2);
          }
        }
        alignToOthers() {
          let k, A = this, L = A.chart, Y = [this], x = A.options, T = L.options.chart, M = this.coll === "yAxis" && T.alignThresholds, U = [];
          if (A.thresholdAlignment = void 0, (T.alignTicks !== !1 && x.alignTicks || M) && x.startOnTick !== !1 && x.endOnTick !== !1 && !A.logarithmic) {
            let H = (F) => {
              let { horiz: et, options: rt } = F;
              return [et ? rt.left : rt.top, rt.width, rt.height, rt.pane].join(",");
            }, q = H(this);
            L[this.coll].forEach(function(F) {
              let { series: et } = F;
              et.length && et.some((rt) => rt.visible) && F !== A && H(F) === q && (k = !0, Y.push(F));
            });
          }
          if (k && M) {
            Y.forEach((q) => {
              let F = q.getThresholdAlignment(A);
              e(F) && U.push(F);
            });
            let H = U.length > 1 ? U.reduce((q, F) => q += F, 0) / U.length : void 0;
            Y.forEach((q) => {
              q.thresholdAlignment = H;
            });
          }
          return k;
        }
        getThresholdAlignment(k) {
          if ((!e(this.dataMin) || this !== k && this.series.some((A) => A.isDirty || A.isDirtyData)) && this.getSeriesExtremes(), e(this.threshold)) {
            let A = b((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
            return this.options.reversed && (A = 1 - A), A;
          }
        }
        getTickAmount() {
          let k = this.options, A = k.tickPixelInterval, L = k.tickAmount;
          d(k.tickInterval) || L || !(this.len < A) || this.isRadial || this.logarithmic || !k.startOnTick || !k.endOnTick || (L = 2), !L && this.alignToOthers() && (L = Math.ceil(this.len / A) + 1), L < 4 && (this.finalTickAmt = L, L = 5), this.tickAmount = L;
        }
        adjustTickAmount() {
          let k = this, { finalTickAmt: A, max: L, min: Y, options: x, tickPositions: T, tickAmount: M, thresholdAlignment: U } = k, H = T == null ? void 0 : T.length, q = n(k.threshold, k.softThreshold ? 0 : null), F, et, rt = k.tickInterval, at, ct = () => T.push(l(T[T.length - 1] + rt)), Z = () => T.unshift(l(T[0] - rt));
          if (e(U) && (at = U < 0.5 ? Math.ceil(U * (M - 1)) : Math.floor(U * (M - 1)), x.reversed && (at = M - 1 - at)), k.hasData() && e(Y) && e(L)) {
            let X = () => {
              k.transA *= (H - 1) / (M - 1), k.min = x.startOnTick ? T[0] : Math.min(Y, T[0]), k.max = x.endOnTick ? T[T.length - 1] : Math.max(L, T[T.length - 1]);
            };
            if (e(at) && e(k.threshold)) {
              for (; T[at] !== q || T.length !== M || T[0] > Y || T[T.length - 1] < L; ) {
                for (T.length = 0, T.push(k.threshold); T.length < M; ) T[at] === void 0 || T[at] > k.threshold ? Z() : ct();
                if (rt > 8 * k.tickInterval) break;
                rt *= 2;
              }
              X();
            } else if (H < M) {
              for (; T.length < M; ) T.length % 2 || Y === q ? ct() : Z();
              X();
            }
            if (d(A)) {
              for (et = F = T.length; et--; ) (A === 3 && et % 2 == 1 || A <= 2 && et > 0 && et < F - 1) && T.splice(et, 1);
              k.finalTickAmt = void 0;
            }
          }
        }
        setScale() {
          var T, M;
          let { coll: k, stacking: A } = this, L = !1, Y = !1;
          this.series.forEach((U) => {
            L = L || U.isDirtyData || U.isDirty, Y = Y || U.xAxis && U.xAxis.isDirty || !1;
          }), this.setAxisSize();
          let x = this.len !== (this.old && this.old.len);
          x || L || Y || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (A && k === "yAxis" && A.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), A && k === "xAxis" && A.buildStacks(), this.isDirty || (this.isDirty = x || this.min !== ((T = this.old) == null ? void 0 : T.min) || this.max !== ((M = this.old) == null ? void 0 : M.max))) : A && A.cleanStacks(), L && delete this.allExtremes, h(this, "afterSetScale");
        }
        setExtremes(k, A, L = !0, Y, x) {
          this.series.forEach((T) => {
            delete T.kdTree;
          }), h(this, "setExtremes", x = O(x, { min: k, max: A }), (T) => {
            this.userMin = T.min, this.userMax = T.max, this.eventArgs = T, L && this.chart.redraw(Y);
          });
        }
        setAxisSize() {
          let k = this.chart, A = this.options, L = A.offsets || [0, 0, 0, 0], Y = this.horiz, x = this.width = Math.round(S(n(A.width, k.plotWidth - L[3] + L[1]), k.plotWidth)), T = this.height = Math.round(S(n(A.height, k.plotHeight - L[0] + L[2]), k.plotHeight)), M = this.top = Math.round(S(n(A.top, k.plotTop + L[0]), k.plotHeight, k.plotTop)), U = this.left = Math.round(S(n(A.left, k.plotLeft + L[3]), k.plotWidth, k.plotLeft));
          this.bottom = k.chartHeight - T - M, this.right = k.chartWidth - x - U, this.len = Math.max(Y ? x : T, 0), this.pos = Y ? U : M;
        }
        getExtremes() {
          let k = this.logarithmic;
          return { min: k ? l(k.lin2log(this.min)) : this.min, max: k ? l(k.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
        }
        getThreshold(k) {
          let A = this.logarithmic, L = A ? A.lin2log(this.min) : this.min, Y = A ? A.lin2log(this.max) : this.max;
          return k === null || k === -1 / 0 ? k = L : k === 1 / 0 ? k = Y : L > k ? k = L : Y < k && (k = Y), this.translate(k, 0, 1, 0, 1);
        }
        autoLabelAlign(k) {
          let A = (n(k, 0) - 90 * this.side + 720) % 360, L = { align: "center" };
          return h(this, "autoLabelAlign", L, function(Y) {
            A > 15 && A < 165 ? Y.align = "right" : A > 195 && A < 345 && (Y.align = "left");
          }), L.align;
        }
        tickSize(k) {
          let A = this.options, L = n(A[k === "tick" ? "tickWidth" : "minorTickWidth"], k === "tick" && this.isXAxis && !this.categories ? 1 : 0), Y = A[k === "tick" ? "tickLength" : "minorTickLength"], x;
          L && Y && (A[k + "Position"] === "inside" && (Y = -Y), x = [Y, L]);
          let T = { tickSize: x };
          return h(this, "afterTickSize", T), T.tickSize;
        }
        labelMetrics() {
          let k = this.chart.renderer, A = this.ticks, L = A[Object.keys(A)[0]] || {};
          return this.chart.renderer.fontMetrics(L.label || L.movedLabel || k.box);
        }
        unsquish() {
          let k = this.options.labels, A = k.padding || 0, L = this.horiz, Y = this.tickInterval, x = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / Y), T = k.rotation, M = l(0.8 * this.labelMetrics().h), U = Math.max(this.max - this.min, 0), H = function(at) {
            let ct = (at + 2 * A) / (x || 1);
            return (ct = ct > 1 ? Math.ceil(ct) : 1) * Y > U && at !== 1 / 0 && x !== 1 / 0 && U && (ct = Math.ceil(U / Y)), l(ct * Y);
          }, q = Y, F, et = Number.MAX_VALUE, rt;
          if (L) {
            if (!k.staggerLines && (e(T) ? rt = [T] : x < k.autoRotationLimit && (rt = k.autoRotation)), rt) {
              let at, ct;
              for (let Z of rt) (Z === T || Z && Z >= -90 && Z <= 90) && (ct = (at = H(Math.abs(M / Math.sin(w * Z)))) + Math.abs(Z / 360)) < et && (et = ct, F = Z, q = at);
            }
          } else q = H(0.75 * M);
          return this.autoRotation = rt, this.labelRotation = n(F, e(T) ? T : 0), k.step ? Y : q;
        }
        getSlotWidth(k) {
          let A = this.chart, L = this.horiz, Y = this.options.labels, x = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), T = A.margin[3];
          if (k && e(k.slotWidth)) return k.slotWidth;
          if (L && Y.step < 2) return Y.rotation ? 0 : (this.staggerLines || 1) * this.len / x;
          if (!L) {
            let M = Y.style.width;
            if (M !== void 0) return parseInt(String(M), 10);
            if (T) return T - A.spacing[3];
          }
          return 0.33 * A.chartWidth;
        }
        renderUnsquish() {
          let k = this.chart, A = k.renderer, L = this.tickPositions, Y = this.ticks, x = this.options.labels, T = x.style, M = this.horiz, U = this.getSlotWidth(), H = Math.max(1, Math.round(U - (M ? 2 * (x.padding || 0) : x.distance || 0))), q = {}, F = this.labelMetrics(), et = T.textOverflow, rt, at, ct = 0, Z, X;
          if (r(x.rotation) || (q.rotation = x.rotation || 0), L.forEach(function(K) {
            let ot = Y[K];
            ot.movedLabel && ot.replaceMovedLabel(), ot && ot.label && ot.label.textPxLength > ct && (ct = ot.label.textPxLength);
          }), this.maxLabelLength = ct, this.autoRotation) ct > H && ct > F.h ? q.rotation = this.labelRotation : this.labelRotation = 0;
          else if (U && (rt = H, !et)) for (at = "clip", X = L.length; !M && X--; ) (Z = Y[L[X]].label) && (Z.styles.textOverflow === "ellipsis" ? Z.css({ textOverflow: "clip" }) : Z.textPxLength > U && Z.css({ width: U + "px" }), Z.getBBox().height > this.len / L.length - (F.h - F.f) && (Z.specificTextOverflow = "ellipsis"));
          q.rotation && (rt = ct > 0.5 * k.chartHeight ? 0.33 * k.chartHeight : ct, et || (at = "ellipsis")), this.labelAlign = x.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && (q.align = this.labelAlign), L.forEach(function(K) {
            let ot = Y[K], ht = ot && ot.label, dt = T.width, lt = {};
            ht && (ht.attr(q), ot.shortenLabel ? ot.shortenLabel() : rt && !dt && T.whiteSpace !== "nowrap" && (rt < ht.textPxLength || ht.element.tagName === "SPAN") ? (lt.width = rt + "px", et || (lt.textOverflow = ht.specificTextOverflow || at), ht.css(lt)) : !ht.styles.width || lt.width || dt || ht.css({ width: null }), delete ht.specificTextOverflow, ot.rotation = q.rotation);
          }, this), this.tickRotCorr = A.rotCorr(F.b, this.labelRotation || 0, this.side !== 0);
        }
        hasData() {
          return this.series.some(function(k) {
            return k.hasData();
          }) || this.options.showEmpty && d(this.min) && d(this.max);
        }
        addTitle(k) {
          let A, L = this.chart.renderer, Y = this.horiz, x = this.opposite, T = this.options.title, M = this.chart.styledMode;
          this.axisTitle || ((A = T.textAlign) || (A = (Y ? { low: "left", middle: "center", high: "right" } : { low: x ? "right" : "left", middle: "center", high: x ? "left" : "right" })[T.align]), this.axisTitle = L.text(T.text || "", 0, 0, T.useHTML).attr({ zIndex: 7, rotation: T.rotation || 0, align: A }).addClass("highcharts-axis-title"), M || this.axisTitle.css(g(T.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), M || T.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[k ? "show" : "hide"](k);
        }
        generateTick(k) {
          let A = this.ticks;
          A[k] ? A[k].addLabel() : A[k] = new V(this, k);
        }
        createGroups() {
          let { axisParent: k, chart: A, coll: L, options: Y } = this, x = A.renderer, T = (M, U, H) => x.g(M).attr({ zIndex: H }).addClass(`highcharts-${L.toLowerCase()}${U} ` + (this.isRadial ? `highcharts-radial-axis${U} ` : "") + (Y.className || "")).add(k);
          this.axisGroup || (this.gridGroup = T("grid", "-grid", Y.gridZIndex), this.axisGroup = T("axis", "", Y.zIndex), this.labelGroup = T("axis-labels", "-labels", Y.labels.zIndex));
        }
        getOffset() {
          let k = this, { chart: A, horiz: L, options: Y, side: x, ticks: T, tickPositions: M, coll: U } = k, H = A.inverted && !k.isZAxis ? [1, 0, 3, 2][x] : x, q = k.hasData(), F = Y.title, et = Y.labels, rt = e(Y.crossing), at = A.axisOffset, ct = A.clipOffset, Z = [-1, 1, 1, -1][x], X, K = 0, ot, ht = 0, dt = 0, lt, ut;
          if (k.showAxis = X = q || Y.showEmpty, k.staggerLines = k.horiz && et.staggerLines || void 0, k.createGroups(), q || k.isLinked ? (M.forEach(function(ft) {
            k.generateTick(ft);
          }), k.renderUnsquish(), k.reserveSpaceDefault = x === 0 || x === 2 || { 1: "left", 3: "right" }[x] === k.labelAlign, n(et.reserveSpace, !rt && null, k.labelAlign === "center" || null, k.reserveSpaceDefault) && M.forEach(function(ft) {
            dt = Math.max(T[ft].getLabelSize(), dt);
          }), k.staggerLines && (dt *= k.staggerLines), k.labelOffset = dt * (k.opposite ? -1 : 1)) : c(T, function(ft, gt) {
            ft.destroy(), delete T[gt];
          }), F != null && F.text && F.enabled !== !1 && (k.addTitle(X), X && !rt && F.reserveSpace !== !1 && (k.titleOffset = K = k.axisTitle.getBBox()[L ? "height" : "width"], ht = d(ot = F.offset) ? 0 : n(F.margin, L ? 5 : 10))), k.renderLine(), k.offset = Z * n(Y.offset, at[x] ? at[x] + (Y.margin || 0) : 0), k.tickRotCorr = k.tickRotCorr || { x: 0, y: 0 }, ut = x === 0 ? -k.labelMetrics().h : x === 2 ? k.tickRotCorr.y : 0, lt = Math.abs(dt) + ht, dt && (lt -= ut, lt += Z * (L ? n(et.y, k.tickRotCorr.y + Z * et.distance) : n(et.x, Z * et.distance))), k.axisTitleMargin = n(ot, lt), k.getMaxLabelDimensions && (k.maxLabelDimensions = k.getMaxLabelDimensions(T, M)), U !== "colorAxis" && ct) {
            let ft = this.tickSize("tick");
            at[x] = Math.max(at[x], (k.axisTitleMargin || 0) + K + Z * k.offset, lt, M && M.length && ft ? ft[0] + Z * k.offset : 0);
            let gt = !k.axisLine || Y.offset ? 0 : k.axisLine.strokeWidth() / 2;
            ct[H] = Math.max(ct[H], gt);
          }
          h(this, "afterGetOffset");
        }
        getLinePath(k) {
          let A = this.chart, L = this.opposite, Y = this.offset, x = this.horiz, T = this.left + (L ? this.width : 0) + Y, M = A.chartHeight - this.bottom - (L ? this.height : 0) + Y;
          return L && (k *= -1), A.renderer.crispLine([["M", x ? this.left : T, x ? M : this.top], ["L", x ? A.chartWidth - this.right : T, x ? M : A.chartHeight - this.bottom]], k);
        }
        renderLine() {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
        }
        getTitlePosition(k) {
          let A = this.horiz, L = this.left, Y = this.top, x = this.len, T = this.options.title, M = A ? L : Y, U = this.opposite, H = this.offset, q = T.x, F = T.y, et = this.chart.renderer.fontMetrics(k), rt = k ? Math.max(k.getBBox(!1, 0).height - et.h - 1, 0) : 0, at = { low: M + (A ? 0 : x), middle: M + x / 2, high: M + (A ? x : 0) }[T.align], ct = (A ? Y + this.height : L) + (A ? 1 : -1) * (U ? -1 : 1) * (this.axisTitleMargin || 0) + [-rt, rt, et.f, -rt][this.side], Z = { x: A ? at + q : ct + (U ? this.width : 0) + H + q, y: A ? ct + F - (U ? this.height : 0) + H : at + F };
          return h(this, "afterGetTitlePosition", { titlePosition: Z }), Z;
        }
        renderMinorTick(k, A) {
          let L = this.minorTicks;
          L[k] || (L[k] = new V(this, k, "minor")), A && L[k].isNew && L[k].render(null, !0), L[k].render(null, !1, 1);
        }
        renderTick(k, A, L) {
          let Y = this.isLinked, x = this.ticks;
          (!Y || k >= this.min && k <= this.max || this.grid && this.grid.isColumn) && (x[k] || (x[k] = new V(this, k)), L && x[k].isNew && x[k].render(A, !0, -1), x[k].render(A));
        }
        render() {
          let k, A, L = this, Y = L.chart, x = L.logarithmic, T = Y.renderer, M = L.options, U = L.isLinked, H = L.tickPositions, q = L.axisTitle, F = L.ticks, et = L.minorTicks, rt = L.alternateBands, at = M.stackLabels, ct = M.alternateGridColor, Z = M.crossing, X = L.tickmarkOffset, K = L.axisLine, ot = L.showAxis, ht = N(T.globalAnimation);
          if (L.labelEdge.length = 0, L.overlap = !1, [F, et, rt].forEach(function(dt) {
            c(dt, function(lt) {
              lt.isActive = !1;
            });
          }), e(Z)) {
            let dt = this.isXAxis ? Y.yAxis[0] : Y.xAxis[0], lt = [1, -1, -1, 1][this.side];
            if (dt) {
              let ut = dt.toPixels(Z, !0);
              L.horiz && (ut = dt.len - ut), L.offset = lt * ut;
            }
          }
          if (L.hasData() || U) {
            let dt = L.chart.hasRendered && L.old && e(L.old.min);
            L.minorTickInterval && !L.categories && L.getMinorTickPositions().forEach(function(lt) {
              L.renderMinorTick(lt, dt);
            }), H.length && (H.forEach(function(lt, ut) {
              L.renderTick(lt, ut, dt);
            }), X && (L.min === 0 || L.single) && (F[-1] || (F[-1] = new V(L, -1, null, !0)), F[-1].render(-1))), ct && H.forEach(function(lt, ut) {
              A = H[ut + 1] !== void 0 ? H[ut + 1] + X : L.max - X, ut % 2 == 0 && lt < L.max && A <= L.max + (Y.polar ? -X : X) && (rt[lt] || (rt[lt] = new tt.PlotLineOrBand(L, {})), k = lt + X, rt[lt].options = { from: x ? x.lin2log(k) : k, to: x ? x.lin2log(A) : A, color: ct, className: "highcharts-alternate-grid" }, rt[lt].render(), rt[lt].isActive = !0);
            }), L._addedPlotLB || (L._addedPlotLB = !0, (M.plotLines || []).concat(M.plotBands || []).forEach(function(lt) {
              L.addPlotBandOrLine(lt);
            }));
          }
          [F, et, rt].forEach(function(dt) {
            let lt = [], ut = ht.duration;
            c(dt, function(ft, gt) {
              ft.isActive || (ft.render(gt, !1, 0), ft.isActive = !1, lt.push(gt));
            }), P(function() {
              let ft = lt.length;
              for (; ft--; ) dt[lt[ft]] && !dt[lt[ft]].isActive && (dt[lt[ft]].destroy(), delete dt[lt[ft]]);
            }, dt !== rt && Y.hasRendered && ut ? ut : 0);
          }), K && (K[K.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(K.strokeWidth()) }), K.isPlaced = !0, K[ot ? "show" : "hide"](ot)), q && ot && (q[q.isNew ? "attr" : "animate"](L.getTitlePosition(q)), q.isNew = !1), at && at.enabled && L.stacking && L.stacking.renderStackTotals(), L.old = { len: L.len, max: L.max, min: L.min, transA: L.transA, userMax: L.userMax, userMin: L.userMin }, L.isDirty = !1, h(this, "afterRender");
        }
        redraw() {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function(k) {
            k.render();
          })), this.series.forEach(function(k) {
            k.isDirty = !0;
          });
        }
        getKeepProps() {
          return this.keepProps || W.keepProps;
        }
        destroy(k) {
          let A = this, L = A.plotLinesAndBands, Y = this.eventOptions;
          if (h(this, "destroy", { keepEvents: k }), k || j(A), [A.ticks, A.minorTicks, A.alternateBands].forEach(function(x) {
            C(x);
          }), L) {
            let x = L.length;
            for (; x--; ) L[x].destroy();
          }
          for (let x in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function(T) {
            A[T] && (A[T] = A[T].destroy());
          }), A.plotLinesAndBandsGroups) A.plotLinesAndBandsGroups[x] = A.plotLinesAndBandsGroups[x].destroy();
          c(A, function(x, T) {
            A.getKeepProps().indexOf(T) === -1 && delete A[T];
          }), this.eventOptions = Y;
        }
        drawCrosshair(k, A) {
          let L = this.crosshair, Y = n(L && L.snap, !0), x = this.chart, T, M, U, H = this.cross, q;
          if (h(this, "drawCrosshair", { e: k, point: A }), k || (k = this.cross && this.cross.e), L && (d(A) || !Y) !== !1) {
            if (Y ? d(A) && (M = n(this.coll !== "colorAxis" ? A.crosshairPos : null, this.isXAxis ? A.plotX : this.len - A.plotY)) : M = k && (this.horiz ? k.chartX - this.pos : this.len - k.chartY + this.pos), d(M) && (q = { value: A && (this.isXAxis ? A.x : n(A.stackY, A.y)), translatedValue: M }, x.polar && O(q, { isCrosshair: !0, chartX: k && k.chartX, chartY: k && k.chartY, point: A }), T = this.getPlotLinePath(q) || null), !d(T)) {
              this.hideCrosshair();
              return;
            }
            U = this.categories && !this.isRadial, H || (this.cross = H = x.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (U ? "category " : "thin ") + (L.className || "")).attr({ zIndex: n(L.zIndex, 2) }).add(), !x.styledMode && (H.attr({ stroke: L.color || (U ? J.parse("#ccd3ff").setOpacity(0.25).get() : "#cccccc"), "stroke-width": n(L.width, 1) }).css({ "pointer-events": "none" }), L.dashStyle && H.attr({ dashstyle: L.dashStyle }))), H.show().attr({ d: T }), U && !L.width && H.attr({ "stroke-width": this.transA }), this.cross.e = k;
          } else this.hideCrosshair();
          h(this, "afterDrawCrosshair", { e: k, point: A });
        }
        hideCrosshair() {
          this.cross && this.cross.hide(), h(this, "afterHideCrosshair");
        }
        update(k, A) {
          let L = this.chart;
          k = g(this.userOptions, k), this.destroy(!0), this.init(L, k), L.isDirtyBox = !0, n(A, !0) && L.redraw();
        }
        remove(k) {
          let A = this.chart, L = this.coll, Y = this.series, x = Y.length;
          for (; x--; ) Y[x] && Y[x].remove(!1);
          R(A.axes, this), R(A[L] || [], this), A.orderItems(L), this.destroy(), A.isDirtyBox = !0, n(k, !0) && A.redraw();
        }
        setTitle(k, A) {
          this.update({ title: k }, A);
        }
        setCategories(k, A) {
          this.update({ categories: k }, A);
        }
      }
      return W.keepProps = ["coll", "extKey", "hcEvents", "len", "names", "series", "userMax", "userMin"], W;
    }), nt(i, "Core/Axis/DateTimeAxis.js", [i["Core/Utilities.js"]], function(B) {
      var $;
      let { addEvent: J, getMagnitude: it, normalizeTickInterval: st, timeUnits: tt } = B;
      return function(V) {
        function _() {
          return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        }
        function N() {
          if (this.type !== "datetime") {
            this.dateTime = void 0;
            return;
          }
          this.dateTime || (this.dateTime = new D(this));
        }
        V.compose = function(p) {
          return p.keepProps.includes("dateTime") || (p.keepProps.push("dateTime"), p.prototype.getTimeTicks = _, J(p, "afterSetType", N)), p;
        };
        class D {
          constructor(y) {
            this.axis = y;
          }
          normalizeTimeTickInterval(y, m) {
            let w = m || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], a = w[w.length - 1], u = tt[a[0]], b = a[1], l;
            for (l = 0; l < w.length && (u = tt[(a = w[l])[0]], b = a[1], !w[l + 1] || !(y <= (u * b[b.length - 1] + tt[w[l + 1][0]]) / 2)); l++) ;
            u === tt.year && y < 5 * u && (b = [1, 2, 5]);
            let d = st(y / u, b, a[0] === "year" ? Math.max(it(y / u), 1) : 1);
            return { unitRange: u, count: d, unitName: a[0] };
          }
          getXDateFormat(y, m) {
            let { axis: w } = this, a = w.chart.time;
            return w.closestPointRange ? a.getDateFormat(w.closestPointRange, y, w.options.startOfWeek, m) || a.resolveDTLFormat(m.year).main : a.resolveDTLFormat(m.day).main;
          }
        }
        V.Additions = D;
      }($ || ($ = {})), $;
    }), nt(i, "Core/Axis/LogarithmicAxis.js", [i["Core/Utilities.js"]], function(B) {
      var $;
      let { addEvent: J, normalizeTickInterval: it, pick: st } = B;
      return function(tt) {
        function V() {
          var D;
          this.type !== "logarithmic" ? this.logarithmic = void 0 : (D = this.logarithmic) != null || (this.logarithmic = new N(this));
        }
        function _() {
          let D = this.logarithmic;
          D && (this.lin2val = function(p) {
            return D.lin2log(p);
          }, this.val2lin = function(p) {
            return D.log2lin(p);
          });
        }
        tt.compose = function(D) {
          return D.keepProps.includes("logarithmic") || (D.keepProps.push("logarithmic"), J(D, "afterSetType", V), J(D, "afterInit", _)), D;
        };
        class N {
          constructor(p) {
            this.axis = p;
          }
          getLogTickPositions(p, y, m, w) {
            let a = this.axis, u = a.len, b = a.options, l = [];
            if (w || (this.minorAutoInterval = void 0), p >= 0.5) p = Math.round(p), l = a.getLinearTickPositions(p, y, m);
            else if (p >= 0.08) {
              let d, C, R, z, O, h, f, s = Math.floor(y);
              for (d = p > 0.3 ? [1, 2, 4] : p > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], C = s; C < m + 1 && !f; C++) for (R = 0, z = d.length; R < z && !f; R++) (O = this.log2lin(this.lin2log(C) * d[R])) > y && (!w || h <= m) && h !== void 0 && l.push(h), h > m && (f = !0), h = O;
            } else {
              let d = this.lin2log(y), C = this.lin2log(m), R = w ? a.getMinorTickInterval() : b.tickInterval, z = b.tickPixelInterval / (w ? 5 : 1), O = w ? u / a.tickPositions.length : u;
              p = it(p = st(R === "auto" ? null : R, this.minorAutoInterval, (C - d) * z / (O || 1))), l = a.getLinearTickPositions(p, d, C).map(this.log2lin), w || (this.minorAutoInterval = p / 5);
            }
            return w || (a.tickInterval = p), l;
          }
          lin2log(p) {
            return Math.pow(10, p);
          }
          log2lin(p) {
            return Math.log(p) / Math.LN10;
          }
        }
        tt.Additions = N;
      }($ || ($ = {})), $;
    }), nt(i, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [i["Core/Utilities.js"]], function(B) {
      var $;
      let { erase: J, extend: it, isNumber: st } = B;
      return function(tt) {
        let V;
        function _(a) {
          return this.addPlotBandOrLine(a, "plotBands");
        }
        function N(a, u) {
          let b = this.userOptions, l = new V(this, a);
          if (this.visible && (l = l.render()), l) {
            if (this._addedPlotLB || (this._addedPlotLB = !0, (b.plotLines || []).concat(b.plotBands || []).forEach((d) => {
              this.addPlotBandOrLine(d);
            })), u) {
              let d = b[u] || [];
              d.push(a), b[u] = d;
            }
            this.plotLinesAndBands.push(l);
          }
          return l;
        }
        function D(a) {
          return this.addPlotBandOrLine(a, "plotLines");
        }
        function p(a, u, b) {
          b = b || this.options;
          let l = this.getPlotLinePath({ value: u, force: !0, acrossPanes: b.acrossPanes }), d = [], C = this.horiz, R = !st(this.min) || !st(this.max) || a < this.min && u < this.min || a > this.max && u > this.max, z = this.getPlotLinePath({ value: a, force: !0, acrossPanes: b.acrossPanes }), O, h = 1, f;
          if (z && l) for (R && (f = z.toString() === l.toString(), h = 0), O = 0; O < z.length; O += 2) {
            let s = z[O], t = z[O + 1], e = l[O], r = l[O + 1];
            (s[0] === "M" || s[0] === "L") && (t[0] === "M" || t[0] === "L") && (e[0] === "M" || e[0] === "L") && (r[0] === "M" || r[0] === "L") && (C && e[1] === s[1] ? (e[1] += h, r[1] += h) : C || e[2] !== s[2] || (e[2] += h, r[2] += h), d.push(["M", s[1], s[2]], ["L", t[1], t[2]], ["L", r[1], r[2]], ["L", e[1], e[2]], ["Z"])), d.isFlat = f;
          }
          return d;
        }
        function y(a) {
          this.removePlotBandOrLine(a);
        }
        function m(a) {
          let u = this.plotLinesAndBands, b = this.options, l = this.userOptions;
          if (u) {
            let d = u.length;
            for (; d--; ) u[d].id === a && u[d].destroy();
            [b.plotLines || [], l.plotLines || [], b.plotBands || [], l.plotBands || []].forEach(function(C) {
              for (d = C.length; d--; ) (C[d] || {}).id === a && J(C, C[d]);
            });
          }
        }
        function w(a) {
          this.removePlotBandOrLine(a);
        }
        tt.compose = function(a, u) {
          let b = u.prototype;
          return b.addPlotBand || (V = a, it(b, { addPlotBand: _, addPlotLine: D, addPlotBandOrLine: N, getPlotBandPath: p, removePlotBand: y, removePlotLine: w, removePlotBandOrLine: m })), u;
        };
      }($ || ($ = {})), $;
    }), nt(i, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [i["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], i["Core/Utilities.js"]], function(B, $) {
      let { addEvent: J, arrayMax: it, arrayMin: st, defined: tt, destroyObjectProperties: V, erase: _, fireEvent: N, merge: D, objectEach: p, pick: y } = $;
      class m {
        static compose(a, u) {
          return J(a, "afterInit", function() {
            this.labelCollectors.push(() => {
              var l;
              let b = [];
              for (let d of this.axes) for (let { label: C, options: R } of d.plotLinesAndBands) C && !((l = R == null ? void 0 : R.label) != null && l.allowOverlap) && b.push(C);
              return b;
            });
          }), B.compose(m, u);
        }
        constructor(a, u) {
          this.axis = a, this.options = u, this.id = u.id;
        }
        render() {
          var G, W, Q;
          N(this, "render");
          let { axis: a, options: u } = this, { horiz: b, logarithmic: l } = a, { color: d, events: C, zIndex: R = 0 } = u, z = {}, O = a.chart.renderer, h = u.to, f = u.from, s = u.value, t = u.borderWidth, e = u.label, { label: r, svgElem: g } = this, o = [], c, n = tt(f) && tt(h), S = tt(s), j = !g, v = { class: "highcharts-plot-" + (n ? "band " : "line ") + (u.className || "") }, P = n ? "bands" : "lines";
          if (!a.chart.styledMode && (S ? (v.stroke = d || "#999999", v["stroke-width"] = y(u.width, 1), u.dashStyle && (v.dashstyle = u.dashStyle)) : n && (v.fill = d || "#e6e9ff", t && (v.stroke = u.borderColor, v["stroke-width"] = t))), z.zIndex = R, P += "-" + R, (c = a.plotLinesAndBandsGroups[P]) || (a.plotLinesAndBandsGroups[P] = c = O.g("plot-" + P).attr(z).add()), g || (this.svgElem = g = O.path().attr(v).add(c)), tt(s)) o = a.getPlotLinePath({ value: (G = l == null ? void 0 : l.log2lin(s)) != null ? G : s, lineWidth: g.strokeWidth(), acrossPanes: u.acrossPanes });
          else {
            if (!(tt(f) && tt(h))) return;
            o = a.getPlotBandPath((W = l == null ? void 0 : l.log2lin(f)) != null ? W : f, (Q = l == null ? void 0 : l.log2lin(h)) != null ? Q : h, u);
          }
          return !this.eventsAdded && C && (p(C, (k, A) => {
            g == null || g.on(A, (L) => {
              C[A].apply(this, [L]);
            });
          }), this.eventsAdded = !0), (j || !g.d) && (o != null && o.length) ? g.attr({ d: o }) : g && (o ? (g.show(), g.animate({ d: o })) : g.d && (g.hide(), r && (this.label = r = r.destroy()))), e && (tt(e.text) || tt(e.formatter)) && (o != null && o.length) && a.width > 0 && a.height > 0 && !o.isFlat ? (e = D({ align: b && n ? "center" : void 0, x: b ? !n && 4 : 10, verticalAlign: !b && n ? "middle" : void 0, y: b ? n ? 16 : 10 : n ? 6 : -4, rotation: b && !n ? 90 : 0, ...n ? { inside: !0 } : {} }, e), this.renderLabel(e, o, n, R)) : r && r.hide(), this;
        }
        renderLabel(a, u, b, l) {
          var e;
          let d = this.axis, C = d.chart.renderer, R = a.inside, z = this.label;
          z || (this.label = z = C.text(this.getLabelText(a), 0, 0, a.useHTML).attr({ align: a.textAlign || a.align, rotation: a.rotation, class: "highcharts-plot-" + (b ? "band" : "line") + "-label " + (a.className || ""), zIndex: l }), d.chart.styledMode || z.css(D({ fontSize: "0.8em", textOverflow: b && !R ? "" : "ellipsis" }, a.style)), z.add());
          let O = u.xBounds || [u[0][1], u[1][1], b ? u[2][1] : u[0][1]], h = u.yBounds || [u[0][2], u[1][2], b ? u[2][2] : u[0][2]], f = st(O), s = st(h), t = it(O) - f;
          z.align(a, !1, { x: f, y: s, width: t, height: it(h) - s }), (!z.alignValue || z.alignValue === "left" || tt(R)) && z.css({ width: (((e = a.style) == null ? void 0 : e.width) || (b && R ? t : z.rotation === 90 ? d.height - (z.alignAttr.y - d.top) : (a.clip ? d.width : d.chart.chartWidth) - (z.alignAttr.x - d.left))) + "px" }), z.show(!0);
        }
        getLabelText(a) {
          return tt(a.formatter) ? a.formatter.call(this) : a.text;
        }
        destroy() {
          _(this.axis.plotLinesAndBands, this), delete this.axis, V(this);
        }
      }
      return m;
    }), nt(i, "Core/Tooltip.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Templating.js"], i["Core/Globals.js"], i["Core/Renderer/RendererUtilities.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt) {
      var V;
      let { animObject: _ } = B, { format: N } = $, { composed: D, doc: p, isSafari: y } = J, { distribute: m } = it, { addEvent: w, clamp: a, css: u, discardElement: b, extend: l, fireEvent: d, isArray: C, isNumber: R, isString: z, merge: O, pick: h, pushUnique: f, splat: s, syncTimeout: t } = tt;
      class e {
        constructor(g, o, c) {
          this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = g, this.init(g, o), this.pointer = c;
        }
        bodyFormatter(g) {
          return g.map(function(o) {
            let c = o.series.tooltipOptions;
            return (c[(o.point.formatPrefix || "point") + "Formatter"] || o.point.tooltipFormatter).call(o.point, c[(o.point.formatPrefix || "point") + "Format"] || "");
          });
        }
        cleanSplit(g) {
          this.chart.series.forEach(function(o) {
            let c = o && o.tt;
            c && (!c.isActive || g ? o.tt = c.destroy() : c.isActive = !1);
          });
        }
        defaultFormatter(g) {
          let o, c = this.points || s(this);
          return (o = (o = [g.tooltipFooterHeaderFormatter(c[0])]).concat(g.bodyFormatter(c))).push(g.tooltipFooterHeaderFormatter(c[0], !0)), o;
        }
        destroy() {
          this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), b(this.container)), tt.clearTimeout(this.hideTimer);
        }
        getAnchor(g, o) {
          let c, { chart: n, pointer: S } = this, j = n.inverted, v = n.plotTop, P = n.plotLeft;
          if ((g = s(g))[0].series && g[0].series.yAxis && !g[0].series.yAxis.options.reversedStacks && (g = g.slice().reverse()), this.followPointer && o) o.chartX === void 0 && (o = S.normalize(o)), c = [o.chartX - P, o.chartY - v];
          else if (g[0].tooltipPos) c = g[0].tooltipPos;
          else {
            let G = 0, W = 0;
            g.forEach(function(Q) {
              let k = Q.pos(!0);
              k && (G += k[0], W += k[1]);
            }), G /= g.length, W /= g.length, this.shared && g.length > 1 && o && (j ? G = o.chartX : W = o.chartY), c = [G - P, W - v];
          }
          return c.map(Math.round);
        }
        getClassName(g, o, c) {
          let n = this.options, S = g.series, j = S.options;
          return [n.className, "highcharts-label", c && "highcharts-tooltip-header", o ? "highcharts-tooltip-box" : "highcharts-tooltip", !c && "highcharts-color-" + h(g.colorIndex, S.colorIndex), j && j.className].filter(z).join(" ");
        }
        getLabel({ anchorX: g, anchorY: o } = { anchorX: 0, anchorY: 0 }) {
          let c = this, n = this.chart.styledMode, S = this.options, j = this.split && this.allowShared, v = this.container, P = this.chart.renderer;
          if (this.label) {
            let G = !this.label.hasClass("highcharts-label");
            (!j && G || j && !G) && this.destroy();
          }
          if (!this.label) {
            if (this.outside) {
              let G = this.chart.options.chart.style, W = st.getRendererType();
              this.container = v = J.doc.createElement("div"), v.className = "highcharts-tooltip-container", u(v, { position: "absolute", top: "1px", pointerEvents: "none", zIndex: Math.max(this.options.style.zIndex || 0, (G && G.zIndex || 0) + 3) }), this.renderer = P = new W(v, 0, 0, G, void 0, void 0, P.styledMode);
            }
            if (j ? this.label = P.g("tooltip") : (this.label = P.label("", g, o, S.shape, void 0, void 0, S.useHTML, void 0, "tooltip").attr({ padding: S.padding, r: S.borderRadius }), n || this.label.attr({ fill: S.backgroundColor, "stroke-width": S.borderWidth || 0 }).css(S.style).css({ pointerEvents: S.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none") })), c.outside) {
              let G = this.label;
              [G.xSetter, G.ySetter].forEach((W, Q) => {
                G[Q ? "ySetter" : "xSetter"] = (k) => {
                  W.call(G, c.distance), G[Q ? "y" : "x"] = k, v && (v.style[Q ? "top" : "left"] = `${k}px`);
                };
              });
            }
            this.label.attr({ zIndex: 8 }).shadow(S.shadow).add();
          }
          return v && !v.parentElement && J.doc.body.appendChild(v), this.label;
        }
        getPlayingField() {
          let { body: g, documentElement: o } = p, { chart: c, distance: n, outside: S } = this;
          return { width: S ? Math.max(g.scrollWidth, o.scrollWidth, g.offsetWidth, o.offsetWidth, o.clientWidth) - 2 * n : c.chartWidth, height: S ? Math.max(g.scrollHeight, o.scrollHeight, g.offsetHeight, o.offsetHeight, o.clientHeight) : c.chartHeight };
        }
        getPosition(g, o, c) {
          var ht, dt;
          let { distance: n, chart: S, outside: j, pointer: v } = this, { inverted: P, plotLeft: G, plotTop: W, polar: Q } = S, { plotX: k = 0, plotY: A = 0 } = c, L = {}, Y = P && c.h || 0, { height: x, width: T } = this.getPlayingField(), M = v.getChartPosition(), U = (lt) => lt * M.scaleX, H = (lt) => lt * M.scaleY, q = (lt) => {
            let ut = lt === "x";
            return [lt, ut ? T : x, ut ? g : o].concat(j ? [ut ? U(g) : H(o), ut ? M.left - n + U(k + G) : M.top - n + H(A + W), 0, ut ? T : x] : [ut ? g : o, ut ? k + G : A + W, ut ? G : W, ut ? G + S.plotWidth : W + S.plotHeight]);
          }, F = q("y"), et = q("x"), rt, at = !!c.negative;
          !Q && ((dt = (ht = S.hoverSeries) == null ? void 0 : ht.yAxis) != null && dt.reversed) && (at = !at);
          let ct = !this.followPointer && h(c.ttBelow, !Q && !P === at), Z = function(lt, ut, ft, gt, pt, mt, yt) {
            let vt = j ? lt === "y" ? H(n) : U(n) : n, xt = (ft - gt) / 2, bt = gt < pt - n, Ct = pt + n + gt < ut, wt = pt - vt - ft + xt, At = pt + vt - xt;
            if (ct && Ct) L[lt] = At;
            else if (!ct && bt) L[lt] = wt;
            else if (bt) L[lt] = Math.min(yt - gt, wt - Y < 0 ? wt : wt - Y);
            else {
              if (!Ct) return !1;
              L[lt] = Math.max(mt, At + Y + ft > ut ? At : At + Y);
            }
          }, X = function(lt, ut, ft, gt, pt) {
            if (pt < n || pt > ut - n) return !1;
            pt < ft / 2 ? L[lt] = 1 : pt > ut - gt / 2 ? L[lt] = ut - gt - 2 : L[lt] = pt - ft / 2;
          }, K = function(lt) {
            [F, et] = [et, F], rt = lt;
          }, ot = () => {
            Z.apply(0, F) !== !1 ? X.apply(0, et) !== !1 || rt || (K(!0), ot()) : rt ? L.x = L.y = 0 : (K(!0), ot());
          };
          return (P && !Q || this.len > 1) && K(), ot(), L;
        }
        hide(g) {
          let o = this;
          tt.clearTimeout(this.hideTimer), g = h(g, this.options.hideDelay), this.isHidden || (this.hideTimer = t(function() {
            let c = o.getLabel();
            o.getLabel().animate({ opacity: 0 }, { duration: g && 150, complete: () => {
              c.hide(), o.container && o.container.remove();
            } }), o.isHidden = !0;
          }, g));
        }
        init(g, o) {
          this.chart = g, this.options = o, this.crosshairs = [], this.isHidden = !0, this.split = o.split && !g.inverted && !g.polar, this.shared = o.shared || this.split, this.outside = h(o.outside, !!(g.scrollablePixelsX || g.scrollablePixelsY));
        }
        shouldStickOnContact(g) {
          return !!(!this.followPointer && this.options.stickOnContact && (!g || this.pointer.inClass(g.target, "highcharts-tooltip")));
        }
        move(g, o, c, n) {
          let S = this, j = _(!S.isHidden && S.options.animation), v = S.followPointer || (S.len || 0) > 1, P = { x: g, y: o };
          v || (P.anchorX = c, P.anchorY = n), j.step = () => S.drawTracker(), S.getLabel().animate(P, j);
        }
        refresh(g, o) {
          let { chart: c, options: n, pointer: S, shared: j } = this, v = s(g), P = v[0], G = [], W = n.format, Q = n.formatter || this.defaultFormatter, k = c.styledMode, A = {}, L = this.allowShared;
          if (!n.enabled || !P.series) return;
          tt.clearTimeout(this.hideTimer), this.allowShared = !(!C(g) && g.series && g.series.noSharedTooltip), L = L && !this.allowShared, this.followPointer = !this.split && P.series.tooltipOptions.followPointer;
          let Y = this.getAnchor(g, o), x = Y[0], T = Y[1];
          j && this.allowShared ? (S.applyInactiveState(v), v.forEach(function(H) {
            H.setState("hover"), G.push(H.getLabelConfig());
          }), (A = P.getLabelConfig()).points = G) : A = P.getLabelConfig(), this.len = G.length;
          let M = z(W) ? N(W, A, c) : Q.call(A, this), U = P.series;
          if (this.distance = h(U.tooltipOptions.distance, 16), M === !1) this.hide();
          else {
            if (this.split && this.allowShared) this.renderSplit(M, v);
            else {
              let H = x, q = T;
              if (o && S.isDirectTouch && (H = o.chartX - c.plotLeft, q = o.chartY - c.plotTop), c.polar || U.options.clip === !1 || v.some((F) => S.isDirectTouch || F.series.shouldShowTooltip(H, q))) {
                let F = this.getLabel(L && this.tt || {});
                (!n.style.width || k) && F.css({ width: (this.outside ? this.getPlayingField() : c.spacingBox).width + "px" }), F.attr({ class: this.getClassName(P), text: M && M.join ? M.join("") : M }), this.outside && F.attr({ x: a(F.x || 0, 0, this.getPlayingField().width - (F.width || 0)) }), k || F.attr({ stroke: n.borderColor || P.color || U.color || "#666666" }), this.updatePosition({ plotX: x, plotY: T, negative: P.negative, ttBelow: P.ttBelow, h: Y[2] || 0 });
              } else {
                this.hide();
                return;
              }
            }
            this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = !1;
          }
          d(this, "refresh");
        }
        renderSplit(g, o) {
          var ut;
          let c = this, { chart: n, chart: { chartWidth: S, chartHeight: j, plotHeight: v, plotLeft: P, plotTop: G, scrollablePixelsY: W = 0, scrollablePixelsX: Q, styledMode: k }, distance: A, options: L, options: { positioner: Y }, pointer: x } = c, { scrollLeft: T = 0, scrollTop: M = 0 } = ((ut = n.scrollablePlotArea) == null ? void 0 : ut.scrollingContainer) || {}, U = c.outside && typeof Q != "number" ? p.documentElement.getBoundingClientRect() : { left: T, right: T + S }, H = c.getLabel(), q = this.renderer || n.renderer, F = !!(n.xAxis[0] && n.xAxis[0].opposite), { left: et, top: rt } = x.getChartPosition(), at = G + M, ct = 0, Z = v - W;
          function X(ft, gt, pt, mt, yt = !0) {
            let vt, xt;
            return pt ? (vt = F ? 0 : Z, xt = a(ft - mt / 2, U.left, U.right - mt - (c.outside ? et : 0))) : (vt = gt - at, xt = a(xt = yt ? ft - mt - A : ft + A, yt ? xt : U.left, U.right)), { x: xt, y: vt };
          }
          z(g) && (g = [!1, g]);
          let K = g.slice(0, o.length + 1).reduce(function(ft, gt, pt) {
            if (gt !== !1 && gt !== "") {
              let mt = o[pt - 1] || { isHeader: !0, plotX: o[0].plotX, plotY: v, series: {} }, yt = mt.isHeader, vt = yt ? c : mt.series, xt = vt.tt = function(St, kt, Et) {
                var Ut;
                let Pt = St, { isHeader: _t, series: Jt } = kt;
                if (!Pt) {
                  let Gt = { padding: L.padding, r: L.borderRadius };
                  k || (Gt.fill = L.backgroundColor, Gt["stroke-width"] = (Ut = L.borderWidth) != null ? Ut : 1), Pt = q.label("", 0, 0, L[_t ? "headerShape" : "shape"], void 0, void 0, L.useHTML).addClass(c.getClassName(kt, !0, _t)).attr(Gt).add(H);
                }
                return Pt.isActive = !0, Pt.attr({ text: Et }), k || Pt.css(L.style).attr({ stroke: L.borderColor || kt.color || Jt.color || "#333333" }), Pt;
              }(vt.tt, mt, gt.toString()), bt = xt.getBBox(), Ct = bt.width + xt.strokeWidth();
              yt && (ct = bt.height, Z += ct, F && (at -= ct));
              let { anchorX: wt, anchorY: At } = function(St) {
                let kt, Et, { isHeader: Pt, plotX: _t = 0, plotY: Jt = 0, series: Ut } = St;
                if (Pt) kt = Math.max(P + _t, P), Et = G + v / 2;
                else {
                  let { xAxis: Gt, yAxis: jt } = Ut;
                  kt = Gt.pos + a(_t, -A, Gt.len + A), Ut.shouldShowTooltip(0, jt.pos - G + Jt, { ignoreX: !0 }) && (Et = jt.pos + Jt);
                }
                return { anchorX: kt = a(kt, U.left - A, U.right + A), anchorY: Et };
              }(mt);
              if (typeof At == "number") {
                let St = bt.height + 1, kt = Y ? Y.call(c, Ct, St, mt) : X(wt, At, yt, Ct);
                ft.push({ align: Y ? 0 : void 0, anchorX: wt, anchorY: At, boxWidth: Ct, point: mt, rank: h(kt.rank, yt ? 1 : 0), size: St, target: kt.y, tt: xt, x: kt.x });
              } else xt.isActive = !1;
            }
            return ft;
          }, []);
          !Y && K.some((ft) => {
            let { outside: gt } = c, pt = (gt ? et : 0) + ft.anchorX;
            return pt < U.left && pt + ft.boxWidth < U.right || pt < et - U.left + ft.boxWidth && U.right - pt > pt;
          }) && (K = K.map((ft) => {
            let { x: gt, y: pt } = X(ft.anchorX, ft.anchorY, ft.point.isHeader, ft.boxWidth, !1);
            return l(ft, { target: pt, x: gt });
          })), c.cleanSplit(), m(K, Z);
          let ot = { left: et, right: et };
          K.forEach(function(ft) {
            let { x: gt, boxWidth: pt, isHeader: mt } = ft;
            !mt && (c.outside && et + gt < ot.left && (ot.left = et + gt), !mt && c.outside && ot.left + pt > ot.right && (ot.right = et + gt));
          }), K.forEach(function(ft) {
            let { x: gt, anchorX: pt, anchorY: mt, pos: yt, point: { isHeader: vt } } = ft, xt = { visibility: yt === void 0 ? "hidden" : "inherit", x: gt, y: (yt || 0) + at, anchorX: pt, anchorY: mt };
            if (c.outside && gt < pt) {
              let bt = et - ot.left;
              bt > 0 && (vt || (xt.x = gt + bt, xt.anchorX = pt + bt), vt && (xt.x = (ot.right - ot.left) / 2, xt.anchorX = pt + bt));
            }
            ft.tt.attr(xt);
          });
          let { container: ht, outside: dt, renderer: lt } = c;
          if (dt && ht && lt) {
            let { width: ft, height: gt, x: pt, y: mt } = H.getBBox();
            lt.setSize(ft + pt, gt + mt, !1), ht.style.left = ot.left + "px", ht.style.top = rt + "px";
          }
          y && H.attr({ opacity: H.opacity === 1 ? 0.999 : 1 });
        }
        drawTracker() {
          if (!this.shouldStickOnContact()) {
            this.tracker && (this.tracker = this.tracker.destroy());
            return;
          }
          let g = this.chart, o = this.label, c = this.shared ? g.hoverPoints : g.hoverPoint;
          if (!o || !c) return;
          let n = { x: 0, y: 0, width: 0, height: 0 }, S = this.getAnchor(c), j = o.getBBox();
          S[0] += g.plotLeft - (o.translateX || 0), S[1] += g.plotTop - (o.translateY || 0), n.x = Math.min(0, S[0]), n.y = Math.min(0, S[1]), n.width = S[0] < 0 ? Math.max(Math.abs(S[0]), j.width - S[0]) : Math.max(Math.abs(S[0]), j.width), n.height = S[1] < 0 ? Math.max(Math.abs(S[1]), j.height - Math.abs(S[1])) : Math.max(Math.abs(S[1]), j.height), this.tracker ? this.tracker.attr(n) : (this.tracker = o.renderer.rect(n).addClass("highcharts-tracker").add(o), g.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
        }
        styledModeFormat(g) {
          return g.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
        }
        tooltipFooterHeaderFormatter(g, o) {
          let c = g.series, n = c.tooltipOptions, S = c.xAxis, j = S && S.dateTime, v = { isFooter: o, labelConfig: g }, P = n.xDateFormat, G = n[o ? "footerFormat" : "headerFormat"];
          return d(this, "headerFormatter", v, function(W) {
            j && !P && R(g.key) && (P = j.getXDateFormat(g.key, n.dateTimeLabelFormats)), j && P && (g.point && g.point.tooltipDateKeys || ["key"]).forEach(function(Q) {
              G = G.replace("{point." + Q + "}", "{point." + Q + ":" + P + "}");
            }), c.chart.styledMode && (G = this.styledModeFormat(G)), W.text = N(G, { point: g, series: c }, this.chart);
          }), v.text;
        }
        update(g) {
          this.destroy(), this.init(this.chart, O(!0, this.options, g));
        }
        updatePosition(g) {
          let { chart: o, container: c, distance: n, options: S, pointer: j, renderer: v } = this, { height: P = 0, width: G = 0 } = this.getLabel(), { left: W, top: Q, scaleX: k, scaleY: A } = j.getChartPosition(), L = (S.positioner || this.getPosition).call(this, G, P, g), Y = (g.plotX || 0) + o.plotLeft, x = (g.plotY || 0) + o.plotTop, T;
          v && c && (S.positioner && (L.x += W - n, L.y += Q - n), T = (S.borderWidth || 0) + 2 * n + 2, v.setSize(G + T, P + T, !1), (k !== 1 || A !== 1) && (u(c, { transform: `scale(${k}, ${A})` }), Y *= k, x *= A), Y += W - L.x, x += Q - L.y), this.move(Math.round(L.x), Math.round(L.y || 0), Y, x);
        }
      }
      return (V = e || (e = {})).compose = function(r) {
        f(D, "Core.Tooltip") && w(r, "afterInit", function() {
          let g = this.chart;
          g.options.tooltip && (g.tooltip = new V(g, g.options.tooltip, this));
        });
      }, e;
    }), nt(i, "Core/Series/Point.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Animation/AnimationUtilities.js"], i["Core/Defaults.js"], i["Core/Templating.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      let { animObject: tt } = $, { defaultOptions: V } = J, { format: _ } = it, { addEvent: N, crisp: D, erase: p, extend: y, fireEvent: m, getNestedProperty: w, isArray: a, isFunction: u, isNumber: b, isObject: l, merge: d, pick: C, syncTimeout: R, removeEvent: z, uniqueKey: O } = st;
      class h {
        animateBeforeDestroy() {
          let s = this, t = { x: s.startXPos, opacity: 0 }, e = s.getGraphicalProps();
          e.singular.forEach(function(r) {
            s[r] = s[r].animate(r === "dataLabel" ? { x: s[r].startXPos, y: s[r].startYPos, opacity: 0 } : t);
          }), e.plural.forEach(function(r) {
            s[r].forEach(function(g) {
              g.element && g.animate(y({ x: s.startXPos }, g.startYPos ? { x: g.startXPos, y: g.startYPos } : {}));
            });
          });
        }
        applyOptions(s, t) {
          let e = this.series, r = e.options.pointValKey || e.pointValKey;
          return y(this, s = h.prototype.optionsToObject.call(this, s)), this.options = this.options ? y(this.options, s) : s, s.group && delete this.group, s.dataLabels && delete this.dataLabels, r && (this.y = h.prototype.getNestedProperty.call(this, r)), this.selected && (this.state = "select"), "name" in this && t === void 0 && e.xAxis && e.xAxis.hasNames && (this.x = e.xAxis.nameToX(this)), this.x === void 0 && e ? this.x = t != null ? t : e.autoIncrement() : b(s.x) && e.options.relativeXValue && (this.x = e.autoIncrement(s.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
        }
        destroy() {
          if (!this.destroyed) {
            let s = this, t = s.series, e = t.chart, r = t.options.dataSorting, g = e.hoverPoints, o = tt(s.series.chart.renderer.globalAnimation), c = () => {
              for (let n in (s.graphic || s.graphics || s.dataLabel || s.dataLabels) && (z(s), s.destroyElements()), s) delete s[n];
            };
            s.legendItem && e.legend.destroyItem(s), g && (s.setState(), p(g, s), g.length || (e.hoverPoints = null)), s === e.hoverPoint && s.onMouseOut(), r && r.enabled ? (this.animateBeforeDestroy(), R(c, o.duration)) : c(), e.pointCount--;
          }
          this.destroyed = !0;
        }
        destroyElements(s) {
          let t = this, e = t.getGraphicalProps(s);
          e.singular.forEach(function(r) {
            t[r] = t[r].destroy();
          }), e.plural.forEach(function(r) {
            t[r].forEach(function(g) {
              g && g.element && g.destroy();
            }), delete t[r];
          });
        }
        firePointEvent(s, t, e) {
          let r = this, g = this.series.options;
          r.manageEvent(s), s === "click" && g.allowPointSelect && (e = function(o) {
            !r.destroyed && r.select && r.select(null, o.ctrlKey || o.metaKey || o.shiftKey);
          }), m(r, s, t, e);
        }
        getClassName() {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        }
        getGraphicalProps(s) {
          let t, e, r = this, g = [], o = { singular: [], plural: [] };
          for ((s = s || { graphic: 1, dataLabel: 1 }).graphic && g.push("graphic", "connector"), s.dataLabel && g.push("dataLabel", "dataLabelPath", "dataLabelUpper"), e = g.length; e--; ) r[t = g[e]] && o.singular.push(t);
          return ["graphic", "dataLabel"].forEach(function(c) {
            let n = c + "s";
            s[c] && r[n] && o.plural.push(n);
          }), o;
        }
        getLabelConfig() {
          return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
        }
        getNestedProperty(s) {
          return s ? s.indexOf("custom.") === 0 ? w(s, this.options) : this[s] : void 0;
        }
        getZone() {
          let s = this.series, t = s.zones, e = s.zoneAxis || "y", r, g = 0;
          for (r = t[0]; this[e] >= r.value; ) r = t[++g];
          return this.nonZonedColor || (this.nonZonedColor = this.color), r && r.color && !this.options.color ? this.color = r.color : this.color = this.nonZonedColor, r;
        }
        hasNewShapeType() {
          return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
        }
        constructor(s, t, e) {
          var r;
          this.formatPrefix = "point", this.visible = !0, this.series = s, this.applyOptions(t, e), (r = this.id) != null || (this.id = O()), this.resolveColor(), s.chart.pointCount++, m(this, "afterInit");
        }
        isValid() {
          return (b(this.x) || this.x instanceof Date) && b(this.y);
        }
        optionsToObject(s) {
          let t = this.series, e = t.options.keys, r = e || t.pointArrayMap || ["y"], g = r.length, o = {}, c, n = 0, S = 0;
          if (b(s) || s === null) o[r[0]] = s;
          else if (a(s)) for (!e && s.length > g && ((c = typeof s[0]) == "string" ? o.name = s[0] : c === "number" && (o.x = s[0]), n++); S < g; ) e && s[n] === void 0 || (r[S].indexOf(".") > 0 ? h.prototype.setNestedProperty(o, s[n], r[S]) : o[r[S]] = s[n]), n++, S++;
          else typeof s == "object" && (o = s, s.dataLabels && (t.hasDataLabels = () => !0), s.marker && (t._hasPointMarkers = !0));
          return o;
        }
        pos(s, t = this.plotY) {
          if (!this.destroyed) {
            let { plotX: e, series: r } = this, { chart: g, xAxis: o, yAxis: c } = r, n = 0, S = 0;
            if (b(e) && b(t)) return s && (n = o ? o.pos : g.plotLeft, S = c ? c.pos : g.plotTop), g.inverted && o && c ? [c.len - t + S, o.len - e + n] : [e + n, t + S];
          }
        }
        resolveColor() {
          let s = this.series, t = s.chart.options.chart, e = s.chart.styledMode, r, g, o = t.colorCount, c;
          delete this.nonZonedColor, s.options.colorByPoint ? (e || (r = (g = s.options.colors || s.chart.options.colors)[s.colorCounter], o = g.length), c = s.colorCounter, s.colorCounter++, s.colorCounter === o && (s.colorCounter = 0)) : (e || (r = s.color), c = s.colorIndex), this.colorIndex = C(this.options.colorIndex, c), this.color = C(this.options.color, r);
        }
        setNestedProperty(s, t, e) {
          return e.split(".").reduce(function(r, g, o, c) {
            let n = c.length - 1 === o;
            return r[g] = n ? t : l(r[g], !0) ? r[g] : {}, r[g];
          }, s), s;
        }
        shouldDraw() {
          return !this.isNull;
        }
        tooltipFormatter(s) {
          let t = this.series, e = t.tooltipOptions, r = C(e.valueDecimals, ""), g = e.valuePrefix || "", o = e.valueSuffix || "";
          return t.chart.styledMode && (s = t.chart.tooltip.styledModeFormat(s)), (t.pointArrayMap || ["y"]).forEach(function(c) {
            c = "{point." + c, (g || o) && (s = s.replace(RegExp(c + "}", "g"), g + c + "}" + o)), s = s.replace(RegExp(c + "}", "g"), c + ":,." + r + "f}");
          }), _(s, { point: this, series: this.series }, t.chart);
        }
        update(s, t, e, r) {
          let g, o = this, c = o.series, n = o.graphic, S = c.chart, j = c.options;
          function v() {
            o.applyOptions(s);
            let P = n && o.hasMockGraphic, G = o.y === null ? !P : P;
            n && G && (o.graphic = n.destroy(), delete o.hasMockGraphic), l(s, !0) && (n && n.element && s && s.marker && s.marker.symbol !== void 0 && (o.graphic = n.destroy()), s != null && s.dataLabels && o.dataLabel && (o.dataLabel = o.dataLabel.destroy())), g = o.index, c.updateParallelArrays(o, g), j.data[g] = l(j.data[g], !0) || l(s, !0) ? o.options : C(s, j.data[g]), c.isDirty = c.isDirtyData = !0, !c.fixedBox && c.hasCartesianSeries && (S.isDirtyBox = !0), j.legendType === "point" && (S.isDirtyLegend = !0), t && S.redraw(e);
          }
          t = C(t, !0), r === !1 ? v() : o.firePointEvent("update", { options: s }, v);
        }
        remove(s, t) {
          this.series.removePoint(this.series.data.indexOf(this), s, t);
        }
        select(s, t) {
          let e = this, r = e.series, g = r.chart;
          s = C(s, !e.selected), this.selectedStaging = s, e.firePointEvent(s ? "select" : "unselect", { accumulate: t }, function() {
            e.selected = e.options.selected = s, r.options.data[r.data.indexOf(e)] = e.options, e.setState(s && "select"), t || g.getSelectedPoints().forEach(function(o) {
              let c = o.series;
              o.selected && o !== e && (o.selected = o.options.selected = !1, c.options.data[c.data.indexOf(o)] = o.options, o.setState(g.hoverPoints && c.options.inactiveOtherPoints ? "inactive" : ""), o.firePointEvent("unselect"));
            });
          }), delete this.selectedStaging;
        }
        onMouseOver(s) {
          let { inverted: t, pointer: e } = this.series.chart;
          e && (s = s ? e.normalize(s) : e.getChartCoordinatesFromPoint(this, t), e.runPointActions(s, this));
        }
        onMouseOut() {
          let s = this.series.chart;
          this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (s.hoverPoints || []).forEach(function(t) {
            t.setState();
          }), s.hoverPoints = s.hoverPoint = null;
        }
        manageEvent(s) {
          var r, g, o, c, n, S;
          let t = d(this.series.options.point, this.options), e = (r = t.events) == null ? void 0 : r[s];
          u(e) && (!((g = this.hcEvents) != null && g[s]) || ((c = (o = this.hcEvents) == null ? void 0 : o[s]) == null ? void 0 : c.map((j) => j.fn).indexOf(e)) === -1) ? ((n = this.importedUserEvent) == null || n.call(this), this.importedUserEvent = N(this, s, e)) : this.importedUserEvent && !e && ((S = this.hcEvents) != null && S[s]) && (z(this, s), delete this.hcEvents[s], Object.keys(this.hcEvents) || delete this.importedUserEvent);
        }
        setState(s, t) {
          var M;
          let e = this.series, r = this.state, g = e.options.states[s || "normal"] || {}, o = V.plotOptions[e.type].marker && e.options.marker, c = o && o.enabled === !1, n = o && o.states && o.states[s || "normal"] || {}, S = n.enabled === !1, j = this.marker || {}, v = e.chart, P = o && e.markerAttribs, G = e.halo, W, Q, k, A = e.stateMarkerGraphic, L;
          if ((s = s || "") === this.state && !t || this.selected && s !== "select" || g.enabled === !1 || s && (S || c && n.enabled === !1) || s && j.states && j.states[s] && j.states[s].enabled === !1) return;
          if (this.state = s, P && (W = e.markerAttribs(this, s)), this.graphic && !this.hasMockGraphic) {
            if (r && this.graphic.removeClass("highcharts-point-" + r), s && this.graphic.addClass("highcharts-point-" + s), !v.styledMode) {
              Q = e.pointAttribs(this, s), k = C(v.options.chart.animation, g.animation);
              let U = Q.opacity;
              e.options.inactiveOtherPoints && b(U) && (this.dataLabels || []).forEach(function(H) {
                H && !H.hasClass("highcharts-data-label-hidden") && (H.animate({ opacity: U }, k), H.connector && H.connector.animate({ opacity: U }, k));
              }), this.graphic.animate(Q, k);
            }
            W && this.graphic.animate(W, C(v.options.chart.animation, n.animation, o.animation)), A && A.hide();
          } else s && n && (L = j.symbol || e.symbol, A && A.currentSymbol !== L && (A = A.destroy()), W && (A ? A[t ? "animate" : "attr"]({ x: W.x, y: W.y }) : L && (e.stateMarkerGraphic = A = v.renderer.symbol(L, W.x, W.y, W.width, W.height).add(e.markerGroup), A.currentSymbol = L)), !v.styledMode && A && this.state !== "inactive" && A.attr(e.pointAttribs(this, s))), A && (A[s && this.isInside ? "show" : "hide"](), A.element.point = this, A.addClass(this.getClassName(), !0));
          let Y = g.halo, x = this.graphic || A, T = x && x.visibility || "inherit";
          Y && Y.size && x && T !== "hidden" && !this.isCluster ? (G || (e.halo = G = v.renderer.path().add(x.parentGroup)), G.show()[t ? "animate" : "attr"]({ d: this.haloPath(Y.size) }), G.attr({ class: "highcharts-halo highcharts-color-" + C(this.colorIndex, e.colorIndex) + (this.className ? " " + this.className : ""), visibility: T, zIndex: -1 }), G.point = this, v.styledMode || G.attr(y({ fill: this.color || e.color, "fill-opacity": Y.opacity }, B.filterUserAttributes(Y.attributes || {})))) : (M = G == null ? void 0 : G.point) != null && M.haloPath && !G.point.destroyed && G.animate({ d: G.point.haloPath(0) }, null, G.hide), m(this, "afterSetState", { state: s });
        }
        haloPath(s) {
          let t = this.pos();
          return t ? this.series.chart.renderer.symbols.circle(D(t[0], 1) - s, t[1] - s, 2 * s, 2 * s) : [];
        }
      }
      return h;
    }), nt(i, "Core/Pointer.js", [i["Core/Color/Color.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $, J) {
      var it;
      let { parse: st } = B, { charts: tt, composed: V, isTouchDevice: _ } = $, { addEvent: N, attr: D, css: p, extend: y, find: m, fireEvent: w, isNumber: a, isObject: u, objectEach: b, offset: l, pick: d, pushUnique: C, splat: R } = J;
      class z {
        applyInactiveState(h) {
          let f = [], s;
          (h || []).forEach(function(t) {
            s = t.series, f.push(s), s.linkedParent && f.push(s.linkedParent), s.linkedSeries && (f = f.concat(s.linkedSeries)), s.navigatorSeries && f.push(s.navigatorSeries);
          }), this.chart.series.forEach(function(t) {
            f.indexOf(t) === -1 ? t.setState("inactive", !0) : t.options.inactiveOtherPoints && t.setAllPointsToState("inactive");
          });
        }
        destroy() {
          let h = this;
          this.eventsToUnbind.forEach((f) => f()), this.eventsToUnbind = [], !$.chartCount && (z.unbindDocumentMouseUp && z.unbindDocumentMouseUp.forEach((f) => f()), z.unbindDocumentTouchEnd && (z.unbindDocumentTouchEnd = z.unbindDocumentTouchEnd())), clearInterval(h.tooltipTimeout), b(h, function(f, s) {
            h[s] = void 0;
          });
        }
        getSelectionMarkerAttrs(h, f) {
          let s = { args: { chartX: h, chartY: f }, attrs: {}, shapeType: "rect" };
          return w(this, "getSelectionMarkerAttrs", s, (t) => {
            let e, { chart: r, zoomHor: g, zoomVert: o } = this, { mouseDownX: c = 0, mouseDownY: n = 0 } = r, S = t.attrs;
            S.x = r.plotLeft, S.y = r.plotTop, S.width = g ? 1 : r.plotWidth, S.height = o ? 1 : r.plotHeight, g && (e = h - c, S.width = Math.max(1, Math.abs(e)), S.x = (e > 0 ? 0 : e) + c), o && (e = f - n, S.height = Math.max(1, Math.abs(e)), S.y = (e > 0 ? 0 : e) + n);
          }), s;
        }
        drag(h) {
          let { chart: f } = this, { mouseDownX: s = 0, mouseDownY: t = 0 } = f, { panning: e, panKey: r, selectionMarkerFill: g } = f.options.chart, o = f.plotLeft, c = f.plotTop, n = f.plotWidth, S = f.plotHeight, j = u(e) ? e.enabled : e, v = r && h[`${r}Key`], P = h.chartX, G = h.chartY, W, Q = this.selectionMarker;
          if ((!Q || !Q.touch) && (P < o ? P = o : P > o + n && (P = o + n), G < c ? G = c : G > c + S && (G = c + S), this.hasDragged = Math.sqrt(Math.pow(s - P, 2) + Math.pow(t - G, 2)), this.hasDragged > 10)) {
            W = f.isInsidePlot(s - o, t - c, { visiblePlotOnly: !0 });
            let { shapeType: k, attrs: A } = this.getSelectionMarkerAttrs(P, G);
            (f.hasCartesianSeries || f.mapView) && this.hasZoom && W && !v && !Q && (this.selectionMarker = Q = f.renderer[k](), Q.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), f.styledMode || Q.attr({ fill: g || st("#334eff").setOpacity(0.25).get() })), Q && Q.attr(A), W && !Q && j && f.pan(h, e);
          }
        }
        dragStart(h) {
          let f = this.chart;
          f.mouseIsDown = h.type, f.cancelClick = !1, f.mouseDownX = h.chartX, f.mouseDownY = h.chartY;
        }
        getSelectionBox(h) {
          let f = { args: { marker: h }, result: h.getBBox() };
          return w(this, "getSelectionBox", f), f.result;
        }
        drop(h) {
          let f, { chart: s, selectionMarker: t } = this;
          for (let e of s.axes) e.isPanning && (e.isPanning = !1, (e.options.startOnTick || e.options.endOnTick || e.series.some((r) => r.boosted)) && (e.forceRedraw = !0, e.setExtremes(e.userMin, e.userMax, !1), f = !0));
          if (f && s.redraw(), t && h) {
            if (this.hasDragged) {
              let e = this.getSelectionBox(t);
              s.transform({ axes: s.axes.filter((r) => r.zoomEnabled && (r.coll === "xAxis" && this.zoomX || r.coll === "yAxis" && this.zoomY)), selection: { originalEvent: h, xAxis: [], yAxis: [], ...e }, from: e });
            }
            a(s.index) && (this.selectionMarker = t.destroy());
          }
          s && a(s.index) && (p(s.container, { cursor: s._cursor }), s.cancelClick = this.hasDragged > 10, s.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
        }
        findNearestKDPoint(h, f, s) {
          let t;
          return h.forEach(function(e) {
            let r = !(e.noSharedTooltip && f) && 0 > e.options.findNearestPointBy.indexOf("y"), g = e.searchPoint(s, r);
            u(g, !0) && g.series && (!u(t, !0) || function(o, c) {
              var v, P;
              let n = o.distX - c.distX, S = o.dist - c.dist, j = ((v = c.series.group) == null ? void 0 : v.zIndex) - ((P = o.series.group) == null ? void 0 : P.zIndex);
              return n !== 0 && f ? n : S !== 0 ? S : j !== 0 ? j : o.series.index > c.series.index ? -1 : 1;
            }(t, g) > 0) && (t = g);
          }), t;
        }
        getChartCoordinatesFromPoint(h, f) {
          var r, g;
          let { xAxis: s, yAxis: t } = h.series, e = h.shapeArgs;
          if (s && t) {
            let o = (g = (r = h.clientX) != null ? r : h.plotX) != null ? g : 0, c = h.plotY || 0;
            return h.isNode && e && a(e.x) && a(e.y) && (o = e.x, c = e.y), f ? { chartX: t.len + t.pos - c, chartY: s.len + s.pos - o } : { chartX: o + s.pos, chartY: c + t.pos };
          }
          if (e && e.x && e.y) return { chartX: e.x, chartY: e.y };
        }
        getChartPosition() {
          if (this.chartPosition) return this.chartPosition;
          let { container: h } = this.chart, f = l(h);
          this.chartPosition = { left: f.left, top: f.top, scaleX: 1, scaleY: 1 };
          let { offsetHeight: s, offsetWidth: t } = h;
          return t > 2 && s > 2 && (this.chartPosition.scaleX = f.width / t, this.chartPosition.scaleY = f.height / s), this.chartPosition;
        }
        getCoordinates(h) {
          let f = { xAxis: [], yAxis: [] };
          for (let s of this.chart.axes) f[s.isXAxis ? "xAxis" : "yAxis"].push({ axis: s, value: s.toValue(h[s.horiz ? "chartX" : "chartY"]) });
          return f;
        }
        getHoverData(h, f, s, t, e, r) {
          let g = [], o = function(v) {
            return v.visible && !(!e && v.directTouch) && d(v.options.enableMouseTracking, !0);
          }, c = f, n, S = { chartX: r ? r.chartX : void 0, chartY: r ? r.chartY : void 0, shared: e };
          w(this, "beforeGetHoverData", S), n = c && !c.stickyTracking ? [c] : s.filter((v) => v.stickyTracking && (S.filter || o)(v));
          let j = t && h || !r ? h : this.findNearestKDPoint(n, e, r);
          return c = j && j.series, j && (e && !c.noSharedTooltip ? (n = s.filter(function(v) {
            return S.filter ? S.filter(v) : o(v) && !v.noSharedTooltip;
          })).forEach(function(v) {
            let P = m(v.points, function(G) {
              return G.x === j.x && !G.isNull;
            });
            u(P) && (v.boosted && v.boost && (P = v.boost.getPoint(P)), g.push(P));
          }) : g.push(j)), w(this, "afterGetHoverData", S = { hoverPoint: j }), { hoverPoint: S.hoverPoint, hoverSeries: c, hoverPoints: g };
        }
        getPointFromEvent(h) {
          let f = h.target, s;
          for (; f && !s; ) s = f.point, f = f.parentNode;
          return s;
        }
        onTrackerMouseOut(h) {
          let f = this.chart, s = h.relatedTarget, t = f.hoverSeries;
          this.isDirectTouch = !1, !t || !s || t.stickyTracking || this.inClass(s, "highcharts-tooltip") || this.inClass(s, "highcharts-series-" + t.index) && this.inClass(s, "highcharts-tracker") || t.onMouseOut();
        }
        inClass(h, f) {
          let s = h, t;
          for (; s; ) {
            if (t = D(s, "class")) {
              if (t.indexOf(f) !== -1) return !0;
              if (t.indexOf("highcharts-container") !== -1) return !1;
            }
            s = s.parentElement;
          }
        }
        constructor(h, f) {
          var s;
          this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = f, this.chart = h, this.runChartClick = !!((s = f.chart.events) != null && s.click), this.pinchDown = [], this.setDOMEvents(), w(this, "afterInit");
        }
        normalize(h, f) {
          let s = h.touches, t = s ? s.length ? s.item(0) : d(s.changedTouches, h.changedTouches)[0] : h;
          f || (f = this.getChartPosition());
          let e = t.pageX - f.left, r = t.pageY - f.top;
          return y(h, { chartX: Math.round(e /= f.scaleX), chartY: Math.round(r /= f.scaleY) });
        }
        onContainerClick(h) {
          let f = this.chart, s = f.hoverPoint, t = this.normalize(h), e = f.plotLeft, r = f.plotTop;
          !f.cancelClick && (s && this.inClass(t.target, "highcharts-tracker") ? (w(s.series, "click", y(t, { point: s })), f.hoverPoint && s.firePointEvent("click", t)) : (y(t, this.getCoordinates(t)), f.isInsidePlot(t.chartX - e, t.chartY - r, { visiblePlotOnly: !0 }) && w(f, "click", t)));
        }
        onContainerMouseDown(h) {
          var s;
          let f = (1 & (h.buttons || h.button)) == 1;
          h = this.normalize(h), $.isFirefox && h.button !== 0 && this.onContainerMouseMove(h), (h.button === void 0 || f) && (this.zoomOption(h), f && ((s = h.preventDefault) == null || s.call(h)), this.dragStart(h));
        }
        onContainerMouseLeave(h) {
          let { pointer: f } = tt[d(z.hoverChartIndex, -1)] || {};
          h = this.normalize(h), this.onContainerMouseMove(h), f && !this.inClass(h.relatedTarget, "highcharts-tooltip") && (f.reset(), f.chartPosition = void 0);
        }
        onContainerMouseEnter() {
          delete this.chartPosition;
        }
        onContainerMouseMove(h) {
          let f = this.chart, s = f.tooltip, t = this.normalize(h);
          this.setHoverChartIndex(h), (f.mouseIsDown === "mousedown" || this.touchSelect(t)) && this.drag(t), !f.openMenu && (this.inClass(t.target, "highcharts-tracker") || f.isInsidePlot(t.chartX - f.plotLeft, t.chartY - f.plotTop, { visiblePlotOnly: !0 })) && !(s && s.shouldStickOnContact(t)) && (this.inClass(t.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(t));
        }
        onDocumentTouchEnd(h) {
          this.onDocumentMouseUp(h);
        }
        onContainerTouchMove(h) {
          this.touchSelect(h) ? this.onContainerMouseMove(h) : this.touch(h);
        }
        onContainerTouchStart(h) {
          this.touchSelect(h) ? this.onContainerMouseDown(h) : (this.zoomOption(h), this.touch(h, !0));
        }
        onDocumentMouseMove(h) {
          let f = this.chart, s = f.tooltip, t = this.chartPosition, e = this.normalize(h, t);
          !t || f.isInsidePlot(e.chartX - f.plotLeft, e.chartY - f.plotTop, { visiblePlotOnly: !0 }) || s && s.shouldStickOnContact(e) || e.target !== f.container.ownerDocument && this.inClass(e.target, "highcharts-tracker") || this.reset();
        }
        onDocumentMouseUp(h) {
          var f, s;
          (s = (f = tt[d(z.hoverChartIndex, -1)]) == null ? void 0 : f.pointer) == null || s.drop(h);
        }
        pinch(h) {
          let f = this, { chart: s, hasZoom: t, lastTouches: e } = f, r = [].map.call(h.touches || [], (S) => f.normalize(S)), g = r.length, o = g === 1 && (f.inClass(h.target, "highcharts-tracker") && s.runTrackerClick || f.runChartClick), c = s.tooltip, n = g === 1 && d(c == null ? void 0 : c.options.followTouchMove, !0);
          g > 1 ? f.initiated = !0 : n && (f.initiated = !1), t && f.initiated && !o && h.cancelable !== !1 && h.preventDefault(), h.type === "touchstart" ? (f.pinchDown = r, f.res = !0, s.mouseDownX = h.chartX) : n ? this.runPointActions(f.normalize(h)) : e && (w(s, "touchpan", { originalEvent: h, touches: r }, () => {
            let S = (j) => {
              let v = j[0], P = j[1] || v;
              return { x: v.chartX, y: v.chartY, width: P.chartX - v.chartX, height: P.chartY - v.chartY };
            };
            s.transform({ axes: s.axes.filter((j) => j.zoomEnabled && (this.zoomHor && j.horiz || this.zoomVert && !j.horiz)), to: S(r), from: S(e), trigger: h.type });
          }), f.res && (f.res = !1, this.reset(!1, 0))), f.lastTouches = r;
        }
        reset(h, f) {
          let s = this.chart, t = s.hoverSeries, e = s.hoverPoint, r = s.hoverPoints, g = s.tooltip, o = g && g.shared ? r : e;
          h && o && R(o).forEach(function(c) {
            c.series.isCartesian && c.plotX === void 0 && (h = !1);
          }), h ? g && o && R(o).length && (g.refresh(o), g.shared && r ? r.forEach(function(c) {
            c.setState(c.state, !0), c.series.isCartesian && (c.series.xAxis.crosshair && c.series.xAxis.drawCrosshair(null, c), c.series.yAxis.crosshair && c.series.yAxis.drawCrosshair(null, c));
          }) : e && (e.setState(e.state, !0), s.axes.forEach(function(c) {
            c.crosshair && e.series[c.coll] === c && c.drawCrosshair(null, e);
          }))) : (e && e.onMouseOut(), r && r.forEach(function(c) {
            c.setState();
          }), t && t.onMouseOut(), g && g.hide(f), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), s.axes.forEach(function(c) {
            c.hideCrosshair();
          }), s.hoverPoints = s.hoverPoint = void 0);
        }
        runPointActions(h, f, s) {
          let t = this.chart, e = t.series, r = t.tooltip && t.tooltip.options.enabled ? t.tooltip : void 0, g = !!r && r.shared, o = f || t.hoverPoint, c = o && o.series || t.hoverSeries, n = (!h || h.type !== "touchmove") && (!!f || c && c.directTouch && this.isDirectTouch), S = this.getHoverData(o, c, e, n, g, h);
          o = S.hoverPoint, c = S.hoverSeries;
          let j = S.hoverPoints, v = c && c.tooltipOptions.followPointer && !c.tooltipOptions.split, P = g && c && !c.noSharedTooltip;
          if (o && (s || o !== t.hoverPoint || r && r.isHidden)) {
            if ((t.hoverPoints || []).forEach(function(G) {
              j.indexOf(G) === -1 && G.setState();
            }), t.hoverSeries !== c && c.onMouseOver(), this.applyInactiveState(j), (j || []).forEach(function(G) {
              G.setState("hover");
            }), t.hoverPoint && t.hoverPoint.firePointEvent("mouseOut"), !o.series) return;
            t.hoverPoints = j, t.hoverPoint = o, o.firePointEvent("mouseOver", void 0, () => {
              r && o && r.refresh(P ? j : o, h);
            });
          } else if (v && r && !r.isHidden) {
            let G = r.getAnchor([{}], h);
            t.isInsidePlot(G[0], G[1], { visiblePlotOnly: !0 }) && r.updatePosition({ plotX: G[0], plotY: G[1] });
          }
          this.unDocMouseMove || (this.unDocMouseMove = N(t.container.ownerDocument, "mousemove", (G) => {
            var W, Q, k;
            return (k = (Q = tt[(W = z.hoverChartIndex) != null ? W : -1]) == null ? void 0 : Q.pointer) == null ? void 0 : k.onDocumentMouseMove(G);
          }), this.eventsToUnbind.push(this.unDocMouseMove)), t.axes.forEach(function(G) {
            let W, Q = d((G.crosshair || {}).snap, !0);
            !Q || (W = t.hoverPoint) && W.series[G.coll] === G || (W = m(j, (k) => k.series && k.series[G.coll] === G)), W || !Q ? G.drawCrosshair(h, W) : G.hideCrosshair();
          });
        }
        setDOMEvents() {
          let h = this.chart.container, f = h.ownerDocument;
          h.onmousedown = this.onContainerMouseDown.bind(this), h.onmousemove = this.onContainerMouseMove.bind(this), h.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(N(h, "mouseenter", this.onContainerMouseEnter.bind(this)), N(h, "mouseleave", this.onContainerMouseLeave.bind(this))), z.unbindDocumentMouseUp || (z.unbindDocumentMouseUp = []), z.unbindDocumentMouseUp.push(N(f, "mouseup", this.onDocumentMouseUp.bind(this)));
          let s = this.chart.renderTo.parentElement;
          for (; s && s.tagName !== "BODY"; ) this.eventsToUnbind.push(N(s, "scroll", () => {
            delete this.chartPosition;
          })), s = s.parentElement;
          this.eventsToUnbind.push(N(h, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 }), N(h, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), z.unbindDocumentTouchEnd || (z.unbindDocumentTouchEnd = N(f, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })), this.setPointerCapture(), N(this.chart, "redraw", this.setPointerCapture.bind(this));
        }
        setPointerCapture() {
          var e, r;
          if (!_) return;
          let h = this.pointerCaptureEventsToUnbind, f = this.chart, s = f.container, t = d((e = f.options.tooltip) == null ? void 0 : e.followTouchMove, !0) && f.series.some((g) => g.options.findNearestPointBy.indexOf("y") > -1);
          !this.hasPointerCapture && t ? (h.push(N(s, "pointerdown", (g) => {
            var o, c;
            (o = g.target) != null && o.hasPointerCapture(g.pointerId) && ((c = g.target) == null || c.releasePointerCapture(g.pointerId));
          }), N(s, "pointermove", (g) => {
            var o, c;
            (c = (o = f.pointer) == null ? void 0 : o.getPointFromEvent(g)) == null || c.onMouseOver(g);
          })), f.styledMode || p(s, { "touch-action": "none" }), s.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !t && (h.forEach((g) => g()), h.length = 0, f.styledMode || p(s, { "touch-action": d((r = f.options.chart.style) == null ? void 0 : r["touch-action"], "manipulation") }), s.className = s.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
        }
        setHoverChartIndex(h) {
          var t;
          let f = this.chart, s = $.charts[d(z.hoverChartIndex, -1)];
          if (s && s !== f) {
            let e = { relatedTarget: f.container };
            h && !(h != null && h.relatedTarget) && (h = { ...e, ...h }), (t = s.pointer) == null || t.onContainerMouseLeave(h || e);
          }
          s && s.mouseIsDown || (z.hoverChartIndex = f.index);
        }
        touch(h, f) {
          let s, { chart: t, pinchDown: e = [] } = this;
          this.setHoverChartIndex(), (h = this.normalize(h)).touches.length === 1 ? t.isInsidePlot(h.chartX - t.plotLeft, h.chartY - t.plotTop, { visiblePlotOnly: !0 }) && !t.openMenu ? (f && this.runPointActions(h), h.type === "touchmove" && (s = !!e[0] && Math.pow(e[0].chartX - h.chartX, 2) + Math.pow(e[0].chartY - h.chartY, 2) >= 16), d(s, !0) && this.pinch(h)) : f && this.reset() : h.touches.length === 2 && this.pinch(h);
        }
        touchSelect(h) {
          return !!(this.chart.zooming.singleTouch && h.touches && h.touches.length === 1);
        }
        zoomOption(h) {
          let f = this.chart, s = f.inverted, t = f.zooming.type || "", e, r;
          /touch/.test(h.type) && (t = d(f.zooming.pinchType, t)), this.zoomX = e = /x/.test(t), this.zoomY = r = /y/.test(t), this.zoomHor = e && !s || r && s, this.zoomVert = r && !s || e && s, this.hasZoom = e || r;
        }
      }
      return (it = z || (z = {})).compose = function(O) {
        C(V, "Core.Pointer") && N(O, "beforeRender", function() {
          this.pointer = new it(this, this.options);
        });
      }, z;
    }), nt(i, "Core/Legend/LegendSymbol.js", [i["Core/Utilities.js"]], function(B) {
      var $;
      let { extend: J, merge: it, pick: st } = B;
      return function(tt) {
        function V(_, N, D) {
          var s, t;
          let p = this.legendItem = this.legendItem || {}, { chart: y, options: m } = this, { baseline: w = 0, symbolWidth: a, symbolHeight: u } = _, b = this.symbol || "circle", l = u / 2, d = y.renderer, C = p.group, R = w - Math.round((((s = _.fontMetrics) == null ? void 0 : s.b) || u) * (D ? 0.4 : 0.3)), z = {}, O, h = m.marker, f = 0;
          if (y.styledMode || (z["stroke-width"] = Math.min(m.lineWidth || 0, 24), m.dashStyle ? z.dashstyle = m.dashStyle : m.linecap === "square" || (z["stroke-linecap"] = "round")), p.line = d.path().addClass("highcharts-graph").attr(z).add(C), D && (p.area = d.path().addClass("highcharts-area").add(C)), z["stroke-linecap"] && (f = Math.min(p.line.strokeWidth(), a) / 2), a) {
            let e = [["M", f, R], ["L", a - f, R]];
            p.line.attr({ d: e }), (t = p.area) == null || t.attr({ d: [...e, ["L", a - f, w], ["L", f, w]] });
          }
          if (h && h.enabled !== !1 && a) {
            let e = Math.min(st(h.radius, l), l);
            b.indexOf("url") === 0 && (h = it(h, { width: u, height: u }), e = 0), p.symbol = O = d.symbol(b, a / 2 - e, R - e, 2 * e, 2 * e, J({ context: "legend" }, h)).addClass("highcharts-point").add(C), O.isMarker = !0;
          }
        }
        tt.areaMarker = function(_, N) {
          V.call(this, _, N, !0);
        }, tt.lineMarker = V, tt.rectangle = function(_, N) {
          let D = N.legendItem || {}, p = _.options, y = _.symbolHeight, m = p.squareSymbol, w = m ? y : _.symbolWidth;
          D.symbol = this.chart.renderer.rect(m ? (_.symbolWidth - y) / 2 : 0, _.baseline - y + 1, w, y, st(_.options.symbolRadius, y / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(D.group);
        };
      }($ || ($ = {})), $;
    }), nt(i, "Core/Series/SeriesDefaults.js", [], function() {
      return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, enableMouseTracking: !0, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
        let { numberFormatter: B } = this.series.chart;
        return typeof this.y != "number" ? "" : B(this.y, -1);
      }, padding: 5, style: { fontSize: "0.7em", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 150 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
    }), nt(i, "Core/Series/SeriesRegistry.js", [i["Core/Globals.js"], i["Core/Defaults.js"], i["Core/Series/Point.js"], i["Core/Utilities.js"]], function(B, $, J, it) {
      var st;
      let { defaultOptions: tt } = $, { extend: V, extendClass: _, merge: N } = it;
      return function(D) {
        function p(y, m) {
          let w = tt.plotOptions || {}, a = m.defaultOptions, u = m.prototype;
          return u.type = y, u.pointClass || (u.pointClass = J), !D.seriesTypes[y] && (a && (w[y] = a), D.seriesTypes[y] = m, !0);
        }
        D.seriesTypes = B.seriesTypes, D.registerSeriesType = p, D.seriesType = function(y, m, w, a, u) {
          let b = tt.plotOptions || {};
          if (m = m || "", b[y] = N(b[m], w), delete D.seriesTypes[y], p(y, _(D.seriesTypes[m] || function() {
          }, a)), D.seriesTypes[y].prototype.type = y, u) {
            class l extends J {
            }
            V(l.prototype, u), D.seriesTypes[y].prototype.pointClass = l;
          }
          return D.seriesTypes[y];
        };
      }(st || (st = {})), st;
    }), nt(i, "Core/Series/Series.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Defaults.js"], i["Core/Foundation.js"], i["Core/Globals.js"], i["Core/Legend/LegendSymbol.js"], i["Core/Series/Point.js"], i["Core/Series/SeriesDefaults.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Renderer/SVG/SVGElement.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _, N, D) {
      let { animObject: p, setAnimation: y } = B, { defaultOptions: m } = $, { registerEventOptions: w } = J, { svg: a, win: u } = it, { seriesTypes: b } = _, { arrayMax: l, arrayMin: d, clamp: C, correctFloat: R, crisp: z, defined: O, destroyObjectProperties: h, diffObjects: f, erase: s, error: t, extend: e, find: r, fireEvent: g, getClosestDistance: o, getNestedProperty: c, insertItem: n, isArray: S, isNumber: j, isString: v, merge: P, objectEach: G, pick: W, removeEvent: Q, splat: k, syncTimeout: A } = D;
      class L {
        constructor() {
          this.zoneAxis = "y";
        }
        init(x, T) {
          let M;
          g(this, "init", { options: T });
          let U = this, H = x.series;
          this.eventsToUnbind = [], U.chart = x, U.options = U.setOptions(T);
          let q = U.options, F = q.visible !== !1;
          U.linkedSeries = [], U.bindAxes(), e(U, { name: q.name, state: "", visible: F, selected: q.selected === !0 }), w(this, q);
          let et = q.events;
          (et && et.click || q.point && q.point.events && q.point.events.click || q.allowPointSelect) && (x.runTrackerClick = !0), U.getColor(), U.getSymbol(), U.parallelArrays.forEach(function(rt) {
            U[rt + "Data"] || (U[rt + "Data"] = []);
          }), U.isCartesian && (x.hasCartesianSeries = !0), H.length && (M = H[H.length - 1]), U._i = W(M && M._i, -1) + 1, U.opacity = U.options.opacity, x.orderItems("series", n(this, H)), q.dataSorting && q.dataSorting.enabled ? U.setDataSortingOptions() : U.points || U.data || U.setData(q.data, !1), g(this, "afterInit");
        }
        is(x) {
          return b[x] && this instanceof b[x];
        }
        bindAxes() {
          let x, T = this, M = T.options, U = T.chart;
          g(this, "bindAxes", null, function() {
            (T.axisTypes || []).forEach(function(H) {
              (U[H] || []).forEach(function(q) {
                x = q.options, (W(M[H], 0) === q.index || M[H] !== void 0 && M[H] === x.id) && (n(T, q.series), T[H] = q, q.isDirty = !0);
              }), T[H] || T.optionalAxis === H || t(18, !0, U);
            });
          }), g(this, "afterBindAxes");
        }
        updateParallelArrays(x, T, M) {
          let U = x.series, H = j(T) ? function(q) {
            let F = q === "y" && U.toYData ? U.toYData(x) : x[q];
            U[q + "Data"][T] = F;
          } : function(q) {
            Array.prototype[T].apply(U[q + "Data"], M);
          };
          U.parallelArrays.forEach(H);
        }
        hasData() {
          return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
        }
        hasMarkerChanged(x, T) {
          let M = x.marker, U = T.marker || {};
          return M && (U.enabled && !M.enabled || U.symbol !== M.symbol || U.height !== M.height || U.width !== M.width);
        }
        autoIncrement(x) {
          let T = this.options, M = T.pointIntervalUnit, U = T.relativeXValue, H = this.chart.time, q = this.xIncrement, F, et;
          return q = W(q, T.pointStart, 0), this.pointInterval = et = W(this.pointInterval, T.pointInterval, 1), U && j(x) && (et *= x), M && (F = new H.Date(q), M === "day" ? H.set("Date", F, H.get("Date", F) + et) : M === "month" ? H.set("Month", F, H.get("Month", F) + et) : M === "year" && H.set("FullYear", F, H.get("FullYear", F) + et), et = F.getTime() - q), U && j(x) ? q + et : (this.xIncrement = q + et, q);
        }
        setDataSortingOptions() {
          let x = this.options;
          e(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), O(x.pointRange) || (x.pointRange = 1);
        }
        setOptions(x) {
          var ht, dt;
          let T, M = this.chart, U = M.options.plotOptions, H = M.userOptions || {}, q = P(x), F = M.styledMode, et = { plotOptions: U, userOptions: q };
          g(this, "setOptions", et);
          let rt = et.plotOptions[this.type], at = H.plotOptions || {}, ct = at.series || {}, Z = m.plotOptions[this.type] || {}, X = at[this.type] || {};
          this.userOptions = et.userOptions;
          let K = P(rt, U.series, X, q);
          this.tooltipOptions = P(m.tooltip, (ht = m.plotOptions.series) == null ? void 0 : ht.tooltip, Z == null ? void 0 : Z.tooltip, M.userOptions.tooltip, (dt = at.series) == null ? void 0 : dt.tooltip, X.tooltip, q.tooltip), this.stickyTracking = W(q.stickyTracking, X.stickyTracking, ct.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || K.stickyTracking), rt.marker === null && delete K.marker, this.zoneAxis = K.zoneAxis || "y";
          let ot = this.zones = (K.zones || []).map((lt) => ({ ...lt }));
          return (K.negativeColor || K.negativeFillColor) && !K.zones && (T = { value: K[this.zoneAxis + "Threshold"] || K.threshold || 0, className: "highcharts-negative" }, F || (T.color = K.negativeColor, T.fillColor = K.negativeFillColor), ot.push(T)), ot.length && O(ot[ot.length - 1].value) && ot.push(F ? {} : { color: this.color, fillColor: this.fillColor }), g(this, "afterSetOptions", { options: K }), K;
        }
        getName() {
          return W(this.options.name, "Series " + (this.index + 1));
        }
        getCyclic(x, T, M) {
          let U, H, q = this.chart, F = `${x}Index`, et = `${x}Counter`, rt = (M == null ? void 0 : M.length) || q.options.chart.colorCount;
          !T && (O(H = W(x === "color" ? this.options.colorIndex : void 0, this[F])) ? U = H : (q.series.length || (q[et] = 0), U = q[et] % rt, q[et] += 1), M && (T = M[U])), U !== void 0 && (this[F] = U), this[x] = T;
        }
        getColor() {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || m.plotOptions[this.type].color, this.chart.options.colors);
        }
        getPointsCollection() {
          return (this.hasGroupedData ? this.points : this.data) || [];
        }
        getSymbol() {
          let x = this.options.marker;
          this.getCyclic("symbol", x.symbol, this.chart.options.symbols);
        }
        findPointIndex(x, T) {
          let M, U, H, q = x.id, F = x.x, et = this.points, rt = this.options.dataSorting;
          if (q) {
            let at = this.chart.get(q);
            at instanceof tt && (M = at);
          } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
            let at = (ct) => !ct.touched && ct.index === x.index;
            if (rt && rt.matchByName ? at = (ct) => !ct.touched && ct.name === x.name : this.options.relativeXValue && (at = (ct) => !ct.touched && ct.options.x === x.x), !(M = r(et, at))) return;
          }
          return M && (H = M && M.index) !== void 0 && (U = !0), H === void 0 && j(F) && (H = this.xData.indexOf(F, T)), H !== -1 && H !== void 0 && this.cropped && (H = H >= this.cropStart ? H - this.cropStart : H), !U && j(H) && et[H] && et[H].touched && (H = void 0), H;
        }
        updateData(x, T) {
          let M = this.options, U = M.dataSorting, H = this.points, q = [], F = this.requireSorting, et = x.length === H.length, rt, at, ct, Z, X = !0;
          if (this.xIncrement = null, x.forEach(function(K, ot) {
            let ht, dt = O(K) && this.pointClass.prototype.optionsToObject.call({ series: this }, K) || {}, lt = dt.x;
            dt.id || j(lt) ? ((ht = this.findPointIndex(dt, Z)) === -1 || ht === void 0 ? q.push(K) : H[ht] && K !== M.data[ht] ? (H[ht].update(K, !1, null, !1), H[ht].touched = !0, F && (Z = ht + 1)) : H[ht] && (H[ht].touched = !0), (!et || ot !== ht || U && U.enabled || this.hasDerivedData) && (rt = !0)) : q.push(K);
          }, this), rt) for (at = H.length; at--; ) (ct = H[at]) && !ct.touched && ct.remove && ct.remove(!1, T);
          else !et || U && U.enabled ? X = !1 : (x.forEach(function(K, ot) {
            K === H[ot].y || H[ot].destroyed || H[ot].update(K, !1, null, !1);
          }), q.length = 0);
          return H.forEach(function(K) {
            K && (K.touched = !1);
          }), !!X && (q.forEach(function(K) {
            this.addPoint(K, !1, null, null, !1);
          }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = l(this.xData), this.autoIncrement()), !0);
        }
        setData(x, T = !0, M, U) {
          var vt;
          let H = this, q = H.points, F = q && q.length || 0, et = H.options, rt = H.chart, at = et.dataSorting, ct = H.xAxis, Z = et.turboThreshold, X = this.xData, K = this.yData, ot = H.pointArrayMap, ht = ot && ot.length, dt = et.keys, lt, ut, ft, gt = 0, pt = 1, mt;
          rt.options.chart.allowMutatingData || (et.data && delete H.options.data, H.userOptions.data && delete H.userOptions.data, mt = P(!0, x));
          let yt = (x = mt || x || []).length;
          if (at && at.enabled && (x = this.sortData(x)), rt.options.chart.allowMutatingData && U !== !1 && yt && F && !H.cropped && !H.hasGroupedData && H.visible && !H.boosted && (ft = this.updateData(x, M)), !ft) {
            H.xIncrement = null, H.colorCounter = 0, this.parallelArrays.forEach(function(bt) {
              H[bt + "Data"].length = 0;
            });
            let xt = Z && yt > Z;
            if (xt) {
              let bt = H.getFirstValidPoint(x), Ct = H.getFirstValidPoint(x, yt - 1, -1), wt = (At) => !!(S(At) && (dt || j(At[0])));
              if (j(bt) && j(Ct)) for (lt = 0; lt < yt; lt++) X[lt] = this.autoIncrement(), K[lt] = x[lt];
              else if (wt(bt) && wt(Ct))
                if (ht)
                  if (bt.length === ht) for (lt = 0; lt < yt; lt++) X[lt] = this.autoIncrement(), K[lt] = x[lt];
                  else for (lt = 0; lt < yt; lt++) ut = x[lt], X[lt] = ut[0], K[lt] = ut.slice(1, ht + 1);
                else if (dt && (gt = dt.indexOf("x"), pt = dt.indexOf("y"), gt = gt >= 0 ? gt : 0, pt = pt >= 0 ? pt : 1), bt.length === 1 && (pt = 0), gt === pt) for (lt = 0; lt < yt; lt++) X[lt] = this.autoIncrement(), K[lt] = x[lt][pt];
                else for (lt = 0; lt < yt; lt++) ut = x[lt], X[lt] = ut[gt], K[lt] = ut[pt];
              else xt = !1;
            }
            if (!xt) for (lt = 0; lt < yt; lt++) ut = { series: H }, H.pointClass.prototype.applyOptions.apply(ut, [x[lt]]), H.updateParallelArrays(ut, lt);
            for (K && v(K[0]) && t(14, !0, rt), H.data = [], H.options.data = H.userOptions.data = x, lt = F; lt--; ) (vt = q[lt]) == null || vt.destroy();
            ct && (ct.minRange = ct.userMinRange), H.isDirty = rt.isDirtyBox = !0, H.isDirtyData = !!q, M = !1;
          }
          et.legendType === "point" && (this.processData(), this.generatePoints()), T && rt.redraw(M);
        }
        sortData(x) {
          let T = this, M = T.options.dataSorting.sortKey || "y", U = function(H, q) {
            return O(q) && H.pointClass.prototype.optionsToObject.call({ series: H }, q) || {};
          };
          return x.forEach(function(H, q) {
            x[q] = U(T, H), x[q].index = q;
          }, this), x.concat().sort((H, q) => {
            let F = c(M, H), et = c(M, q);
            return et < F ? -1 : et > F ? 1 : 0;
          }).forEach(function(H, q) {
            H.x = q;
          }, this), T.linkedSeries && T.linkedSeries.forEach(function(H) {
            let q = H.options, F = q.data;
            q.dataSorting && q.dataSorting.enabled || !F || (F.forEach(function(et, rt) {
              F[rt] = U(H, et), x[rt] && (F[rt].x = x[rt].x, F[rt].index = rt);
            }), H.setData(F, !1));
          }), x;
        }
        getProcessedData(x) {
          let T = this, M = T.xAxis, U = T.options.cropThreshold, H = M == null ? void 0 : M.logarithmic, q = T.isCartesian, F, et, rt = 0, at, ct, Z, X = T.xData, K = T.yData, ot = !1, ht = X.length;
          M && (ct = (at = M.getExtremes()).min, Z = at.max, ot = !!(M.categories && !M.names.length)), q && T.sorted && !x && (!U || ht > U || T.forceCrop) && (X[ht - 1] < ct || X[0] > Z ? (X = [], K = []) : T.yData && (X[0] < ct || X[ht - 1] > Z) && (X = (F = this.cropData(T.xData, T.yData, ct, Z)).xData, K = F.yData, rt = F.start, et = !0));
          let dt = o([H ? X.map(H.log2lin) : X], () => T.requireSorting && !ot && t(15, !1, T.chart));
          return { xData: X, yData: K, cropped: et, cropStart: rt, closestPointRange: dt };
        }
        processData(x) {
          let T = this.xAxis;
          if (this.isCartesian && !this.isDirty && !T.isDirty && !this.yAxis.isDirty && !x) return !1;
          let M = this.getProcessedData();
          this.cropped = M.cropped, this.cropStart = M.cropStart, this.processedXData = M.xData, this.processedYData = M.yData, this.closestPointRange = this.basePointRange = M.closestPointRange, g(this, "afterProcessData");
        }
        cropData(x, T, M, U) {
          let H = x.length, q, F, et = 0, rt = H;
          for (q = 0; q < H; q++) if (x[q] >= M) {
            et = Math.max(0, q - 1);
            break;
          }
          for (F = q; F < H; F++) if (x[F] > U) {
            rt = F + 1;
            break;
          }
          return { xData: x.slice(et, rt), yData: T.slice(et, rt), start: et, end: rt };
        }
        generatePoints() {
          let x = this.options, T = this.processedData || x.data, M = this.processedXData, U = this.processedYData, H = this.pointClass, q = M.length, F = this.cropStart || 0, et = this.hasGroupedData, rt = x.keys, at = [], ct = x.dataGrouping && x.dataGrouping.groupAll ? F : 0, Z, X, K, ot, ht = this.data;
          if (!ht && !et) {
            let dt = [];
            dt.length = T.length, ht = this.data = dt;
          }
          for (rt && et && (this.options.keys = !1), ot = 0; ot < q; ot++) X = F + ot, et ? ((K = new H(this, [M[ot]].concat(k(U[ot])))).dataGroup = this.groupMap[ct + ot], K.dataGroup.options && (K.options = K.dataGroup.options, e(K, K.dataGroup.options), delete K.dataLabels)) : (K = ht[X]) || T[X] === void 0 || (ht[X] = K = new H(this, T[X], M[ot])), K && (K.index = et ? ct + ot : X, at[ot] = K);
          if (this.options.keys = rt, ht && (q !== (Z = ht.length) || et)) for (ot = 0; ot < Z; ot++) ot !== F || et || (ot += q), ht[ot] && (ht[ot].destroyElements(), ht[ot].plotX = void 0);
          this.data = ht, this.points = at, g(this, "afterGeneratePoints");
        }
        getXExtremes(x) {
          return { min: d(x), max: l(x) };
        }
        getExtremes(x, T) {
          let M = this.xAxis, U = this.yAxis, H = [], q = this.requireSorting && !this.is("column") ? 1 : 0, F = !!U && U.positiveValuesOnly, et = T || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: rt, processedYData: at } = this, ct, Z, X, K, ot, ht, dt, lt = 0, ut = 0, ft = 0;
          if (this.cropped && et) {
            let yt = this.getProcessedData(!0);
            rt = yt.xData, at = yt.yData;
          }
          let gt = (x = x || this.stackedYData || at || []).length, pt = rt || this.xData;
          for (M && (lt = (ct = M.getExtremes()).min, ut = ct.max), ht = 0; ht < gt; ht++) if (K = pt[ht], Z = (j(ot = x[ht]) || S(ot)) && ((j(ot) ? ot > 0 : ot.length) || !F), X = T || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !M || (pt[ht + q] || K) >= lt && (pt[ht - q] || K) <= ut, Z && X)
            if (dt = ot.length) for (; dt--; ) j(ot[dt]) && (H[ft++] = ot[dt]);
            else H[ft++] = ot;
          let mt = { activeYData: H, dataMin: d(H), dataMax: l(H) };
          return g(this, "afterGetExtremes", { dataExtremes: mt }), mt;
        }
        applyExtremes() {
          let x = this.getExtremes();
          return this.dataMin = x.dataMin, this.dataMax = x.dataMax, x;
        }
        getFirstValidPoint(x, T = 0, M = 1) {
          let U = x.length, H = T;
          for (; H >= 0 && H < U; ) {
            if (O(x[H])) return x[H];
            H += M;
          }
        }
        translate() {
          var ut;
          this.processedXData || this.processData(), this.generatePoints();
          let x = this.options, T = x.stacking, M = this.xAxis, U = M.categories, H = this.enabledDataSorting, q = this.yAxis, F = this.points, et = F.length, rt = this.pointPlacementToXValue(), at = !!rt, ct = x.threshold, Z = x.startFromThreshold ? ct : 0, X, K, ot, ht, dt = Number.MAX_VALUE;
          function lt(ft) {
            return C(ft, -1e9, 1e9);
          }
          for (X = 0; X < et; X++) {
            let ft, gt = F[X], pt = gt.x, mt, yt, vt = gt.y, xt = gt.low, bt = T && ((ut = q.stacking) == null ? void 0 : ut.stacks[(this.negStacks && vt < (Z ? 0 : ct) ? "-" : "") + this.stackKey]);
            K = M.translate(pt, !1, !1, !1, !0, rt), gt.plotX = j(K) ? R(lt(K)) : void 0, T && this.visible && bt && bt[pt] && (ht = this.getStackIndicator(ht, pt, this.index), !gt.isNull && ht.key && (yt = (mt = bt[pt]).points[ht.key]), mt && S(yt) && (xt = yt[0], vt = yt[1], xt === Z && ht.key === bt[pt].base && (xt = W(j(ct) ? ct : q.min)), q.positiveValuesOnly && O(xt) && xt <= 0 && (xt = void 0), gt.total = gt.stackTotal = W(mt.total), gt.percentage = O(gt.y) && mt.total ? gt.y / mt.total * 100 : void 0, gt.stackY = vt, this.irregularWidths || mt.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), gt.yBottom = O(xt) ? lt(q.translate(xt, !1, !0, !1, !0)) : void 0, this.dataModify && (vt = this.dataModify.modifyValue(vt, X)), j(vt) && gt.plotX !== void 0 && (ft = j(ft = q.translate(vt, !1, !0, !1, !0)) ? lt(ft) : void 0), gt.plotY = ft, gt.isInside = this.isPointInside(gt), gt.clientX = at ? R(M.translate(pt, !1, !1, !1, !0, rt)) : K, gt.negative = (gt.y || 0) < (ct || 0), gt.category = W(U && U[gt.x], gt.x), gt.isNull || gt.visible === !1 || (ot !== void 0 && (dt = Math.min(dt, Math.abs(K - ot))), ot = K), gt.zone = this.zones.length ? gt.getZone() : void 0, !gt.graphic && this.group && H && (gt.isNew = !0);
          }
          this.closestPointRangePx = dt, g(this, "afterTranslate");
        }
        getValidPoints(x, T, M) {
          let U = this.chart;
          return (x || this.points || []).filter(function(H) {
            let { plotX: q, plotY: F } = H;
            return !!((M || !H.isNull && j(F)) && (!T || U.isInsidePlot(q, F, { inverted: U.inverted }))) && H.visible !== !1;
          });
        }
        getClipBox() {
          let { chart: x, xAxis: T, yAxis: M } = this, { x: U, y: H, width: q, height: F } = P(x.clipBox);
          return T && T.len !== x.plotSizeX && (q = T.len), M && M.len !== x.plotSizeY && (F = M.len), x.inverted && !this.invertible && ([q, F] = [F, q]), { x: U, y: H, width: q, height: F };
        }
        getSharedClipKey() {
          return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
        }
        setClip() {
          let { chart: x, group: T, markerGroup: M } = this, U = x.sharedClips, H = x.renderer, q = this.getClipBox(), F = this.getSharedClipKey(), et = U[F];
          et ? et.animate(q) : U[F] = et = H.clipRect(q), T && T.clip(this.options.clip === !1 ? void 0 : et), M && M.clip();
        }
        animate(x) {
          let { chart: T, group: M, markerGroup: U } = this, H = T.inverted, q = p(this.options.animation), F = [this.getSharedClipKey(), q.duration, q.easing, q.defer].join(","), et = T.sharedClips[F], rt = T.sharedClips[F + "m"];
          if (x && M) {
            let at = this.getClipBox();
            if (et) et.attr("height", at.height);
            else {
              at.width = 0, H && (at.x = T.plotHeight), et = T.renderer.clipRect(at), T.sharedClips[F] = et;
              let ct = { x: -99, y: -99, width: H ? T.plotWidth + 199 : 99, height: H ? 99 : T.plotHeight + 199 };
              rt = T.renderer.clipRect(ct), T.sharedClips[F + "m"] = rt;
            }
            M.clip(et), U == null || U.clip(rt);
          } else if (et && !et.hasClass("highcharts-animating")) {
            let at = this.getClipBox(), ct = q.step;
            (U != null && U.element.childNodes.length || T.series.length > 1) && (q.step = function(Z, X) {
              ct && ct.apply(X, arguments), X.prop === "width" && (rt != null && rt.element) && rt.attr(H ? "height" : "width", Z + 99);
            }), et.addClass("highcharts-animating").animate(at, q);
          }
        }
        afterAnimate() {
          this.setClip(), G(this.chart.sharedClips, (x, T, M) => {
            x && !this.chart.container.querySelector(`[clip-path="url(#${x.id})"]`) && (x.destroy(), delete M[T]);
          }), this.finishedAnimating = !0, g(this, "afterAnimate");
        }
        drawPoints(x = this.points) {
          let T, M, U, H, q, F, et, rt = this.chart, at = rt.styledMode, { colorAxis: ct, options: Z } = this, X = Z.marker, K = this[this.specialGroup || "markerGroup"], ot = this.xAxis, ht = W(X.enabled, !ot || !!ot.isRadial || null, this.closestPointRangePx >= X.enabledThreshold * X.radius);
          if (X.enabled !== !1 || this._hasPointMarkers) for (T = 0; T < x.length; T++) if (H = (U = (M = x[T]).graphic) ? "animate" : "attr", q = M.marker || {}, F = !!M.marker, (ht && q.enabled === void 0 || q.enabled) && !M.isNull && M.visible !== !1) {
            let dt = W(q.symbol, this.symbol, "rect");
            et = this.markerAttribs(M, M.selected && "select"), this.enabledDataSorting && (M.startXPos = ot.reversed ? -(et.width || 0) : ot.width);
            let lt = M.isInside !== !1;
            if (!U && lt && ((et.width || 0) > 0 || M.hasImage) && (M.graphic = U = rt.renderer.symbol(dt, et.x, et.y, et.width, et.height, F ? q : X).add(K), this.enabledDataSorting && rt.hasRendered && (U.attr({ x: M.startXPos }), H = "animate")), U && H === "animate" && U[lt ? "show" : "hide"](lt).animate(et), U) {
              let ut = this.pointAttribs(M, at || !M.selected ? void 0 : "select");
              at ? ct && U.css({ fill: ut.fill }) : U[H](ut);
            }
            U && U.addClass(M.getClassName(), !0);
          } else U && (M.graphic = U.destroy());
        }
        markerAttribs(x, T) {
          let M = this.options, U = M.marker, H = x.marker || {}, q = H.symbol || U.symbol, F = {}, et, rt, at = W(H.radius, U && U.radius);
          T && (et = U.states[T], at = W((rt = H.states && H.states[T]) && rt.radius, et && et.radius, at && at + (et && et.radiusPlus || 0))), x.hasImage = q && q.indexOf("url") === 0, x.hasImage && (at = 0);
          let ct = x.pos();
          return j(at) && ct && (M.crisp && (ct[0] = z(ct[0], x.hasImage ? 0 : q === "rect" ? (U == null ? void 0 : U.lineWidth) || 0 : 1)), F.x = ct[0] - at, F.y = ct[1] - at), at && (F.width = F.height = 2 * at), F;
        }
        pointAttribs(x, T) {
          let M = this.options.marker, U = x && x.options, H = U && U.marker || {}, q = U && U.color, F = x && x.color, et = x && x.zone && x.zone.color, rt, at, ct = this.color, Z, X, K = W(H.lineWidth, M.lineWidth), ot = 1;
          return ct = q || et || F || ct, Z = H.fillColor || M.fillColor || ct, X = H.lineColor || M.lineColor || ct, T = T || "normal", rt = M.states[T] || {}, K = W((at = H.states && H.states[T] || {}).lineWidth, rt.lineWidth, K + W(at.lineWidthPlus, rt.lineWidthPlus, 0)), Z = at.fillColor || rt.fillColor || Z, { stroke: X = at.lineColor || rt.lineColor || X, "stroke-width": K, fill: Z, opacity: ot = W(at.opacity, rt.opacity, ot) };
        }
        destroy(x) {
          let T, M, U, H = this, q = H.chart, F = /AppleWebKit\/533/.test(u.navigator.userAgent), et = H.data || [];
          for (g(H, "destroy", { keepEventsForUpdate: x }), this.removeEvents(x), (H.axisTypes || []).forEach(function(rt) {
            (U = H[rt]) && U.series && (s(U.series, H), U.isDirty = U.forceRedraw = !0);
          }), H.legendItem && H.chart.legend.destroyItem(H), T = et.length; T--; ) (M = et[T]) && M.destroy && M.destroy();
          for (let rt of H.zones) h(rt, void 0, !0);
          D.clearTimeout(H.animationTimeout), G(H, function(rt, at) {
            rt instanceof N && !rt.survive && rt[F && at === "group" ? "hide" : "destroy"]();
          }), q.hoverSeries === H && (q.hoverSeries = void 0), s(q.series, H), q.orderItems("series"), G(H, function(rt, at) {
            x && at === "hcEvents" || delete H[at];
          });
        }
        applyZones() {
          let { area: x, chart: T, graph: M, zones: U, points: H, xAxis: q, yAxis: F, zoneAxis: et } = this, { inverted: rt, renderer: at } = T, ct = this[`${et}Axis`], { isXAxis: Z, len: X = 0 } = ct || {}, K = ((M == null ? void 0 : M.strokeWidth()) || 0) / 2 + 1, ot = (ht, dt = 0, lt = 0) => {
            rt && (lt = X - lt);
            let { translated: ut = 0, lineClip: ft } = ht, gt = lt - ut;
            ft == null || ft.push(["L", dt, Math.abs(gt) < K ? lt - K * (gt <= 0 ? -1 : 1) : ut]);
          };
          if (U.length && (M || x) && ct && j(ct.min)) {
            let ht = ct.getExtremes().max, dt = (ft) => {
              ft.forEach((gt, pt) => {
                (gt[0] === "M" || gt[0] === "L") && (ft[pt] = [gt[0], Z ? X - gt[1] : gt[1], Z ? gt[2] : X - gt[2]]);
              });
            };
            if (U.forEach((ft) => {
              ft.lineClip = [], ft.translated = C(ct.toPixels(W(ft.value, ht), !0) || 0, 0, X);
            }), M && !this.showLine && M.hide(), x && x.hide(), et === "y" && H.length < q.len) for (let ft of H) {
              let { plotX: gt, plotY: pt, zone: mt } = ft, yt = mt && U[U.indexOf(mt) - 1];
              mt && ot(mt, gt, pt), yt && ot(yt, gt, pt);
            }
            let lt = [], ut = ct.toPixels(ct.getExtremes().min, !0);
            U.forEach((ft) => {
              var St, kt;
              let gt = ft.lineClip || [], pt = Math.round(ft.translated || 0);
              q.reversed && gt.reverse();
              let { clip: mt, simpleClip: yt } = ft, vt = 0, xt = 0, bt = q.len, Ct = F.len;
              Z ? (vt = pt, bt = ut) : (xt = pt, Ct = ut);
              let wt = [["M", vt, xt], ["L", bt, xt], ["L", bt, Ct], ["L", vt, Ct], ["Z"]], At = [wt[0], ...gt, wt[1], wt[2], ...lt, wt[3], wt[4]];
              lt = gt.reverse(), ut = pt, rt && (dt(At), x && dt(wt)), mt ? (mt.animate({ d: At }), yt == null || yt.animate({ d: wt })) : (mt = ft.clip = at.path(At), x && (yt = ft.simpleClip = at.path(wt))), M && ((St = ft.graph) == null || St.clip(mt)), x && ((kt = ft.area) == null || kt.clip(yt));
            });
          } else this.visible && (M && M.show(), x && x.show());
        }
        plotGroup(x, T, M, U, H) {
          let q = this[x], F = !q, et = { visibility: M, zIndex: U || 0.1 };
          return O(this.opacity) && !this.chart.styledMode && this.state !== "inactive" && (et.opacity = this.opacity), q || (this[x] = q = this.chart.renderer.g().add(H)), q.addClass("highcharts-" + T + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (O(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (q.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), q.attr(et)[F ? "attr" : "animate"](this.getPlotBox(T)), q;
        }
        getPlotBox(x) {
          let T = this.xAxis, M = this.yAxis, U = this.chart, H = U.inverted && !U.polar && T && this.invertible && x === "series";
          return U.inverted && (T = M, M = this.xAxis), { translateX: T ? T.left : U.plotLeft, translateY: M ? M.top : U.plotTop, rotation: H ? 90 : 0, rotationOriginX: H ? (T.len - M.len) / 2 : 0, rotationOriginY: H ? (T.len + M.len) / 2 : 0, scaleX: H ? -1 : 1, scaleY: 1 };
        }
        removeEvents(x) {
          let { eventsToUnbind: T } = this;
          x || Q(this), T.length && (T.forEach((M) => {
            M();
          }), T.length = 0);
        }
        render() {
          var at, ct, Z, X, K;
          let x = this, { chart: T, options: M, hasRendered: U } = x, H = p(M.animation), q = x.visible ? "inherit" : "hidden", F = M.zIndex, et = T.seriesGroup, rt = x.finishedAnimating ? 0 : H.duration;
          g(this, "render"), x.plotGroup("group", "series", q, F, et), x.markerGroup = x.plotGroup("markerGroup", "markers", q, F, et), M.clip !== !1 && x.setClip(), rt && ((at = x.animate) == null || at.call(x, !0)), x.drawGraph && (x.drawGraph(), x.applyZones()), x.visible && x.drawPoints(), (ct = x.drawDataLabels) == null || ct.call(x), (Z = x.redrawPoints) == null || Z.call(x), M.enableMouseTracking && ((X = x.drawTracker) == null || X.call(x)), rt && ((K = x.animate) == null || K.call(x)), U || (rt && H.defer && (rt += H.defer), x.animationTimeout = A(() => {
            x.afterAnimate();
          }, rt || 0)), x.isDirty = !1, x.hasRendered = !0, g(x, "afterRender");
        }
        redraw() {
          let x = this.isDirty || this.isDirtyData;
          this.translate(), this.render(), x && delete this.kdTree;
        }
        reserveSpace() {
          return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
        }
        searchPoint(x, T) {
          let { xAxis: M, yAxis: U } = this, H = this.chart.inverted;
          return this.searchKDTree({ clientX: H ? M.len - x.chartY + M.pos : x.chartX - M.pos, plotY: H ? U.len - x.chartX + U.pos : x.chartY - U.pos }, T, x);
        }
        buildKDTree(x) {
          this.buildingKdTree = !0;
          let T = this, M = T.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
          delete T.kdTree, A(function() {
            T.kdTree = function U(H, q, F) {
              let et, rt, at = H == null ? void 0 : H.length;
              if (at) return et = T.kdAxisArray[q % F], H.sort((ct, Z) => (ct[et] || 0) - (Z[et] || 0)), { point: H[rt = Math.floor(at / 2)], left: U(H.slice(0, rt), q + 1, F), right: U(H.slice(rt + 1), q + 1, F) };
            }(T.getValidPoints(void 0, !T.directTouch), M, M), T.buildingKdTree = !1;
          }, T.options.kdNow || (x == null ? void 0 : x.type) === "touchstart" ? 0 : 1);
        }
        searchKDTree(x, T, M) {
          let U = this, [H, q] = this.kdAxisArray, F = T ? "distX" : "dist", et = (U.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, rt = !!U.isBubble;
          if (this.kdTree || this.buildingKdTree || this.buildKDTree(M), this.kdTree) return function at(ct, Z, X, K) {
            var mt;
            let ot = Z.point, ht = U.kdAxisArray[X % K], dt, lt, ut = ot;
            (function(yt, vt) {
              var Et;
              let xt = yt[H], bt = vt[H], Ct = O(xt) && O(bt) ? xt - bt : null, wt = yt[q], At = vt[q], St = O(wt) && O(At) ? wt - At : 0, kt = rt && ((Et = vt.marker) == null ? void 0 : Et.radius) || 0;
              vt.dist = Math.sqrt((Ct && Ct * Ct || 0) + St * St) - kt, vt.distX = O(Ct) ? Math.abs(Ct) - kt : Number.MAX_VALUE;
            })(ct, ot);
            let ft = (ct[ht] || 0) - (ot[ht] || 0) + (rt && ((mt = ot.marker) == null ? void 0 : mt.radius) || 0), gt = ft < 0 ? "left" : "right", pt = ft < 0 ? "right" : "left";
            return Z[gt] && (ut = (dt = at(ct, Z[gt], X + 1, K))[F] < ut[F] ? dt : ot), Z[pt] && Math.sqrt(ft * ft) < ut[F] && (ut = (lt = at(ct, Z[pt], X + 1, K))[F] < ut[F] ? lt : ut), ut;
          }(x, this.kdTree, et, et);
        }
        pointPlacementToXValue() {
          let { options: x, xAxis: T } = this, M = x.pointPlacement;
          return M === "between" && (M = T.reversed ? -0.5 : 0.5), j(M) ? M * (x.pointRange || T.pointRange) : 0;
        }
        isPointInside(x) {
          let { chart: T, xAxis: M, yAxis: U } = this, { plotX: H = -1, plotY: q = -1 } = x;
          return q >= 0 && q <= (U ? U.len : T.plotHeight) && H >= 0 && H <= (M ? M.len : T.plotWidth);
        }
        drawTracker() {
          var Z;
          let x = this, T = x.options, M = T.trackByArea, U = [].concat((M ? x.areaPath : x.graphPath) || []), H = x.chart, q = H.pointer, F = H.renderer, et = ((Z = H.options.tooltip) == null ? void 0 : Z.snap) || 0, rt = () => {
            T.enableMouseTracking && H.hoverSeries !== x && x.onMouseOver();
          }, at = "rgba(192,192,192," + (a ? 1e-4 : 2e-3) + ")", ct = x.tracker;
          ct ? ct.attr({ d: U }) : x.graph && (x.tracker = ct = F.path(U).attr({ visibility: x.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(M ? "highcharts-tracker-area" : "highcharts-tracker-line").add(x.group), H.styledMode || ct.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: at, fill: M ? at : "none", "stroke-width": x.graph.strokeWidth() + (M ? 0 : 2 * et) }), [x.tracker, x.markerGroup, x.dataLabelsGroup].forEach((X) => {
            X && (X.addClass("highcharts-tracker").on("mouseover", rt).on("mouseout", (K) => {
              q == null || q.onTrackerMouseOut(K);
            }), T.cursor && !H.styledMode && X.css({ cursor: T.cursor }), X.on("touchstart", rt));
          })), g(this, "afterDrawTracker");
        }
        addPoint(x, T, M, U, H) {
          let q, F, et = this.options, rt = this.data, at = this.chart, ct = this.xAxis, Z = ct && ct.hasNames && ct.names, X = et.data, K = this.xData;
          T = W(T, !0);
          let ot = { series: this };
          this.pointClass.prototype.applyOptions.apply(ot, [x]);
          let ht = ot.x;
          if (F = K.length, this.requireSorting && ht < K[F - 1]) for (q = !0; F && K[F - 1] > ht; ) F--;
          this.updateParallelArrays(ot, "splice", [F, 0, 0]), this.updateParallelArrays(ot, F), Z && ot.name && (Z[ht] = ot.name), X.splice(F, 0, x), (q || this.processedData) && (this.data.splice(F, 0, null), this.processData()), et.legendType === "point" && this.generatePoints(), M && (rt[0] && rt[0].remove ? rt[0].remove(!1) : (rt.shift(), this.updateParallelArrays(ot, "shift"), X.shift())), H !== !1 && g(this, "addPoint", { point: ot }), this.isDirty = !0, this.isDirtyData = !0, T && at.redraw(U);
        }
        removePoint(x, T, M) {
          let U = this, H = U.data, q = H[x], F = U.points, et = U.chart, rt = function() {
            F && F.length === H.length && F.splice(x, 1), H.splice(x, 1), U.options.data.splice(x, 1), U.updateParallelArrays(q || { series: U }, "splice", [x, 1]), q && q.destroy(), U.isDirty = !0, U.isDirtyData = !0, T && et.redraw();
          };
          y(M, et), T = W(T, !0), q ? q.firePointEvent("remove", null, rt) : rt();
        }
        remove(x, T, M, U) {
          let H = this, q = H.chart;
          function F() {
            H.destroy(U), q.isDirtyLegend = q.isDirtyBox = !0, q.linkSeries(U), W(x, !0) && q.redraw(T);
          }
          M !== !1 ? g(H, "remove", null, F) : F();
        }
        update(x, T) {
          var dt, lt, ut, ft, gt;
          g(this, "update", { options: x = f(x, this.userOptions) });
          let M = this, U = M.chart, H = M.userOptions, q = M.initialType || M.type, F = U.options.plotOptions, et = b[q].prototype, rt = M.finishedAnimating && { animation: !1 }, at = {}, ct, Z, X = ["colorIndex", "eventOptions", "navigatorSeries", "symbolIndex", "baseSeries"], K = x.type || H.type || U.options.chart.type, ot = !(this.hasDerivedData || K && K !== this.type || x.pointStart !== void 0 || x.pointInterval !== void 0 || x.relativeXValue !== void 0 || x.joinBy || x.mapData || ["dataGrouping", "pointStart", "pointInterval", "pointIntervalUnit", "keys"].some((pt) => M.hasOptionChanged(pt)));
          K = K || q, ot && (X.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), x.visible !== !1 && X.push("area", "graph"), M.parallelArrays.forEach(function(pt) {
            X.push(pt + "Data");
          }), x.data && (x.dataSorting && e(M.options.dataSorting, x.dataSorting), this.setData(x.data, !1))), x = P(H, { index: H.index === void 0 ? M.index : H.index, pointStart: (ft = (lt = (dt = F == null ? void 0 : F.series) == null ? void 0 : dt.pointStart) != null ? lt : H.pointStart) != null ? ft : (ut = M.xData) == null ? void 0 : ut[0] }, !ot && { data: M.options.data }, x, rt), ot && x.data && (x.data = M.options.data), (X = ["group", "markerGroup", "dataLabelsGroup", "transformGroup"].concat(X)).forEach(function(pt) {
            X[pt] = M[pt], delete M[pt];
          });
          let ht = !1;
          if (b[K]) {
            if (ht = K !== M.type, M.remove(!1, !1, !1, !0), ht)
              if (U.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(M, b[K].prototype);
              else {
                let pt = Object.hasOwnProperty.call(M, "hcEvents") && M.hcEvents;
                for (Z in et) M[Z] = void 0;
                e(M, b[K].prototype), pt ? M.hcEvents = pt : delete M.hcEvents;
              }
          } else t(17, !0, U, { missingModuleFor: K });
          if (X.forEach(function(pt) {
            M[pt] = X[pt];
          }), M.init(U, x), ot && this.points) for (let pt of ((ct = M.options).visible === !1 ? (at.graphic = 1, at.dataLabel = 1) : (this.hasMarkerChanged(ct, H) && (at.graphic = 1), (gt = M.hasDataLabels) != null && gt.call(M) || (at.dataLabel = 1)), this.points)) pt && pt.series && (pt.resolveColor(), Object.keys(at).length && pt.destroyElements(at), ct.showInLegend === !1 && pt.legendItem && U.legend.destroyItem(pt));
          M.initialType = q, U.linkSeries(), U.setSortedData(), ht && M.linkedSeries.length && (M.isDirtyData = !0), g(this, "afterUpdate"), W(T, !0) && U.redraw(!!ot && void 0);
        }
        setName(x) {
          this.name = this.options.name = this.userOptions.name = x, this.chart.isDirtyLegend = !0;
        }
        hasOptionChanged(x) {
          var F, et;
          let T = this.chart, M = this.options[x], U = T.options.plotOptions, H = this.userOptions[x], q = W((F = U == null ? void 0 : U[this.type]) == null ? void 0 : F[x], (et = U == null ? void 0 : U.series) == null ? void 0 : et[x]);
          return H && !O(q) ? M !== H : M !== W(q, M);
        }
        onMouseOver() {
          let x = this.chart, T = x.hoverSeries, M = x.pointer;
          M == null || M.setHoverChartIndex(), T && T !== this && T.onMouseOut(), this.options.events.mouseOver && g(this, "mouseOver"), this.setState("hover"), x.hoverSeries = this;
        }
        onMouseOut() {
          let x = this.options, T = this.chart, M = T.tooltip, U = T.hoverPoint;
          T.hoverSeries = null, U && U.onMouseOut(), this && x.events.mouseOut && g(this, "mouseOut"), M && !this.stickyTracking && (!M.shared || this.noSharedTooltip) && M.hide(), T.series.forEach(function(H) {
            H.setState("", !0);
          });
        }
        setState(x, T) {
          let M = this, U = M.options, H = M.graph, q = U.inactiveOtherPoints, F = U.states, et = W(F[x || "normal"] && F[x || "normal"].animation, M.chart.options.chart.animation), rt = U.lineWidth, at = U.opacity;
          if (x = x || "", M.state !== x && ([M.group, M.markerGroup, M.dataLabelsGroup].forEach(function(ct) {
            ct && (M.state && ct.removeClass("highcharts-series-" + M.state), x && ct.addClass("highcharts-series-" + x));
          }), M.state = x, !M.chart.styledMode)) {
            if (F[x] && F[x].enabled === !1) return;
            if (x && (rt = F[x].lineWidth || rt + (F[x].lineWidthPlus || 0), at = W(F[x].opacity, at)), H && !H.dashstyle && j(rt)) for (let ct of [H, ...this.zones.map((Z) => Z.graph)]) ct == null || ct.animate({ "stroke-width": rt }, et);
            q || [M.group, M.markerGroup, M.dataLabelsGroup, M.labelBySeries].forEach(function(ct) {
              ct && ct.animate({ opacity: at }, et);
            });
          }
          T && q && M.points && M.setAllPointsToState(x || void 0);
        }
        setAllPointsToState(x) {
          this.points.forEach(function(T) {
            T.setState && T.setState(x);
          });
        }
        setVisible(x, T) {
          var et;
          let M = this, U = M.chart, H = U.options.chart.ignoreHiddenSeries, q = M.visible;
          M.visible = x = M.options.visible = M.userOptions.visible = x === void 0 ? !q : x;
          let F = x ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach((rt) => {
            var at;
            (at = M[rt]) == null || at[F]();
          }), (U.hoverSeries === M || ((et = U.hoverPoint) == null ? void 0 : et.series) === M) && M.onMouseOut(), M.legendItem && U.legend.colorizeItem(M, x), M.isDirty = !0, M.options.stacking && U.series.forEach((rt) => {
            rt.options.stacking && rt.visible && (rt.isDirty = !0);
          }), M.linkedSeries.forEach((rt) => {
            rt.setVisible(x, !1);
          }), H && (U.isDirtyBox = !0), g(M, F), T !== !1 && U.redraw();
        }
        show() {
          this.setVisible(!0);
        }
        hide() {
          this.setVisible(!1);
        }
        select(x) {
          this.selected = x = this.options.selected = x === void 0 ? !this.selected : x, this.checkbox && (this.checkbox.checked = x), g(this, x ? "select" : "unselect");
        }
        shouldShowTooltip(x, T, M = {}) {
          return M.series = this, M.visiblePlotOnly = !0, this.chart.isInsidePlot(x, T, M);
        }
        drawLegendSymbol(x, T) {
          var M;
          (M = st[this.options.legendSymbol || "rectangle"]) == null || M.call(this, x, T);
        }
      }
      return L.defaultOptions = V, L.types = _.seriesTypes, L.registerType = _.registerSeriesType, e(L.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, directTouch: !1, invertible: !0, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: tt, requireSorting: !0, sorted: !0 }), _.series = L, L;
    }), nt(i, "Core/Legend/Legend.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Foundation.js"], i["Core/Globals.js"], i["Core/Series/Series.js"], i["Core/Series/Point.js"], i["Core/Renderer/RendererUtilities.js"], i["Core/Templating.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _) {
      var N;
      let { animObject: D, setAnimation: p } = B, { registerEventOptions: y } = $, { composed: m, marginNames: w } = J, { distribute: a } = tt, { format: u } = V, { addEvent: b, createElement: l, css: d, defined: C, discardElement: R, find: z, fireEvent: O, isNumber: h, merge: f, pick: s, pushUnique: t, relativeLength: e, stableSort: r, syncTimeout: g } = _;
      class o {
        constructor(n, S) {
          this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = n, this.setOptions(S), S.enabled && (this.render(), y(this, S), b(this.chart, "endResize", function() {
            this.legend.positionCheckboxes();
          })), b(this.chart, "render", () => {
            this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
          });
        }
        setOptions(n) {
          let S = s(n.padding, 8);
          this.options = n, this.chart.styledMode || (this.itemStyle = n.itemStyle, this.itemHiddenStyle = f(this.itemStyle, n.itemHiddenStyle)), this.itemMarginTop = n.itemMarginTop, this.itemMarginBottom = n.itemMarginBottom, this.padding = S, this.initialItemY = S - 5, this.symbolWidth = s(n.symbolWidth, 16), this.pages = [], this.proximate = n.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
        }
        update(n, S) {
          let j = this.chart;
          this.setOptions(f(!0, this.options, n)), "events" in this.options && y(this, this.options), this.destroy(), j.isDirtyLegend = j.isDirtyBox = !0, s(S, !0) && j.redraw(), O(this, "afterUpdate", { redraw: S });
        }
        colorizeItem(n, S) {
          let { area: j, group: v, label: P, line: G, symbol: W } = n.legendItem || {};
          if (v == null || v[S ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
            let { itemHiddenStyle: Q = {} } = this, k = Q.color, { fillColor: A, fillOpacity: L, lineColor: Y, marker: x } = n.options, T = (M) => (!S && (M.fill && (M.fill = k), M.stroke && (M.stroke = k)), M);
            P == null || P.css(f(S ? this.itemStyle : Q)), G == null || G.attr(T({ stroke: Y || n.color })), W && W.attr(T(x && W.isMarker ? n.pointAttribs() : { fill: n.color })), j == null || j.attr(T({ fill: A || n.color, "fill-opacity": A ? 1 : L != null ? L : 0.75 }));
          }
          O(this, "afterColorizeItem", { item: n, visible: S });
        }
        positionItems() {
          this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
        }
        positionItem(n) {
          let { group: S, x: j = 0, y: v = 0 } = n.legendItem || {}, P = this.options, G = P.symbolPadding, W = !P.rtl, Q = n.checkbox;
          if (S && S.element) {
            let k = { translateX: W ? j : this.legendWidth - j - 2 * G - 4, translateY: v };
            S[C(S.translateY) ? "animate" : "attr"](k, void 0, () => {
              O(this, "afterPositionItem", { item: n });
            });
          }
          Q && (Q.x = j, Q.y = v);
        }
        destroyItem(n) {
          let S = n.checkbox, j = n.legendItem || {};
          for (let v of ["group", "label", "line", "symbol"]) j[v] && (j[v] = j[v].destroy());
          S && R(S), n.legendItem = void 0;
        }
        destroy() {
          for (let n of this.getAllItems()) this.destroyItem(n);
          for (let n of ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"]) this[n] && (this[n] = this[n].destroy());
          this.display = null;
        }
        positionCheckboxes() {
          let n, S = this.group && this.group.alignAttr, j = this.clipHeight || this.legendHeight, v = this.titleHeight;
          S && (n = S.translateY, this.allItems.forEach(function(P) {
            let G, W = P.checkbox;
            W && (G = n + v + W.y + (this.scrollOffset || 0) + 3, d(W, { left: S.translateX + P.checkboxOffset + W.x - 20 + "px", top: G + "px", display: this.proximate || G > n - 6 && G < n + j - 6 ? "" : "none" }));
          }, this));
        }
        renderTitle() {
          let n = this.options, S = this.padding, j = n.title, v, P = 0;
          j.text && (this.title || (this.title = this.chart.renderer.label(j.text, S - 3, S - 4, void 0, void 0, void 0, n.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(j.style), this.title.add(this.group)), j.width || this.title.css({ width: this.maxLegendWidth + "px" }), P = (v = this.title.getBBox()).height, this.offsetWidth = v.width, this.contentGroup.attr({ translateY: P })), this.titleHeight = P;
        }
        setText(n) {
          let S = this.options;
          n.legendItem.label.attr({ text: S.labelFormat ? u(S.labelFormat, n, this.chart) : S.labelFormatter.call(n) });
        }
        renderItem(n) {
          let S = n.legendItem = n.legendItem || {}, j = this.chart, v = j.renderer, P = this.options, G = P.layout === "horizontal", W = this.symbolWidth, Q = P.symbolPadding || 0, k = this.itemStyle, A = this.itemHiddenStyle, L = G ? s(P.itemDistance, 20) : 0, Y = !P.rtl, x = !n.series, T = !x && n.series.drawLegendSymbol ? n.series : n, M = T.options, U = !!this.createCheckboxForItem && M && M.showCheckbox, H = P.useHTML, q = n.options.className, F = S.label, et = W + Q + L + (U ? 20 : 0);
          !F && (S.group = v.g("legend-item").addClass("highcharts-" + T.type + "-series highcharts-color-" + n.colorIndex + (q ? " " + q : "") + (x ? " highcharts-series-" + n.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), S.label = F = v.text("", Y ? W + Q : -Q, this.baseline || 0, H), j.styledMode || F.css(f(n.visible ? k : A)), F.attr({ align: Y ? "left" : "right", zIndex: 2 }).add(S.group), !this.baseline && (this.fontMetrics = v.fontMetrics(F), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, F.attr("y", this.baseline), this.symbolHeight = s(P.symbolHeight, this.fontMetrics.f), P.squareSymbol && (this.symbolWidth = s(P.symbolWidth, Math.max(this.symbolHeight, 16)), et = this.symbolWidth + Q + L + (U ? 20 : 0), Y && F.attr("x", this.symbolWidth + Q))), T.drawLegendSymbol(this, n), this.setItemEvents && this.setItemEvents(n, F, H)), U && !n.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(n), this.colorizeItem(n, n.visible), (j.styledMode || !k.width) && F.css({ width: (P.itemWidth || this.widthOption || j.spacingBox.width) - et + "px" }), this.setText(n);
          let rt = F.getBBox(), at = this.fontMetrics && this.fontMetrics.h || 0;
          n.itemWidth = n.checkboxOffset = P.itemWidth || S.labelWidth || rt.width + et, this.maxItemWidth = Math.max(this.maxItemWidth, n.itemWidth), this.totalItemWidth += n.itemWidth, this.itemHeight = n.itemHeight = Math.round(S.labelHeight || (rt.height > 1.5 * at ? rt.height : at));
        }
        layoutItem(n) {
          let S = this.options, j = this.padding, v = S.layout === "horizontal", P = n.itemHeight, G = this.itemMarginBottom, W = this.itemMarginTop, Q = v ? s(S.itemDistance, 20) : 0, k = this.maxLegendWidth, A = S.alignColumns && this.totalItemWidth > k ? this.maxItemWidth : n.itemWidth, L = n.legendItem || {};
          v && this.itemX - j + A > k && (this.itemX = j, this.lastLineHeight && (this.itemY += W + this.lastLineHeight + G), this.lastLineHeight = 0), this.lastItemY = W + this.itemY + G, this.lastLineHeight = Math.max(P, this.lastLineHeight), L.x = this.itemX, L.y = this.itemY, v ? this.itemX += A : (this.itemY += W + P + G, this.lastLineHeight = P), this.offsetWidth = this.widthOption || Math.max((v ? this.itemX - j - (n.checkbox ? 0 : Q) : A) + j, this.offsetWidth);
        }
        getAllItems() {
          let n = [];
          return this.chart.series.forEach(function(S) {
            let j = S && S.options;
            S && s(j.showInLegend, !C(j.linkedTo) && void 0, !0) && (n = n.concat((S.legendItem || {}).labels || (j.legendType === "point" ? S.data : S)));
          }), O(this, "afterGetAllItems", { allItems: n }), n;
        }
        getAlignment() {
          let n = this.options;
          return this.proximate ? n.align.charAt(0) + "tv" : n.floating ? "" : n.align.charAt(0) + n.verticalAlign.charAt(0) + n.layout.charAt(0);
        }
        adjustMargins(n, S) {
          let j = this.chart, v = this.options, P = this.getAlignment();
          P && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(G, W) {
            G.test(P) && !C(n[W]) && (j[w[W]] = Math.max(j[w[W]], j.legend[(W + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][W] * v[W % 2 ? "x" : "y"] + s(v.margin, 12) + S[W] + (j.titleOffset[W] || 0)));
          });
        }
        proximatePositions() {
          let n, S = this.chart, j = [], v = this.options.align === "left";
          for (let P of (this.allItems.forEach(function(G) {
            let W, Q, k = v, A, L;
            G.yAxis && (G.xAxis.options.reversed && (k = !k), G.points && (W = z(k ? G.points : G.points.slice(0).reverse(), function(Y) {
              return h(Y.plotY);
            })), Q = this.itemMarginTop + G.legendItem.label.getBBox().height + this.itemMarginBottom, L = G.yAxis.top - S.plotTop, A = G.visible ? (W ? W.plotY : G.yAxis.height) + (L - 0.3 * Q) : L + G.yAxis.height, j.push({ target: A, size: Q, item: G }));
          }, this), a(j, S.plotHeight))) n = P.item.legendItem || {}, h(P.pos) && (n.y = S.plotTop - S.spacing[0] + P.pos);
        }
        render() {
          let n = this.chart, S = n.renderer, j = this.options, v = this.padding, P = this.getAllItems(), G, W, Q, k = this.group, A, L = this.box;
          this.itemX = v, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = e(j.width, n.spacingBox.width - v), A = n.spacingBox.width - 2 * v - j.x, ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) > -1 && (A /= 2), this.maxLegendWidth = this.widthOption || A, k || (this.group = k = S.g("legend").addClass(j.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = S.g().attr({ zIndex: 1 }).add(k), this.scrollGroup = S.g().add(this.contentGroup)), this.renderTitle(), r(P, (Y, x) => (Y.options && Y.options.legendIndex || 0) - (x.options && x.options.legendIndex || 0)), j.reversed && P.reverse(), this.allItems = P, this.display = G = !!P.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, P.forEach(this.renderItem, this), P.forEach(this.layoutItem, this), W = (this.widthOption || this.offsetWidth) + v, Q = this.lastItemY + this.lastLineHeight + this.titleHeight, Q = this.handleOverflow(Q) + v, L || (this.box = L = S.rect().addClass("highcharts-legend-box").attr({ r: j.borderRadius }).add(k)), n.styledMode || L.attr({ stroke: j.borderColor, "stroke-width": j.borderWidth || 0, fill: j.backgroundColor || "none" }).shadow(j.shadow), W > 0 && Q > 0 && L[L.placed ? "animate" : "attr"](L.crisp.call({}, { x: 0, y: 0, width: W, height: Q }, L.strokeWidth())), k[G ? "show" : "hide"](), n.styledMode && k.getStyle("display") === "none" && (W = Q = 0), this.legendWidth = W, this.legendHeight = Q, G && this.align(), this.proximate || this.positionItems(), O(this, "afterRender");
        }
        align(n = this.chart.spacingBox) {
          let S = this.chart, j = this.options, v = n.y;
          /(lth|ct|rth)/.test(this.getAlignment()) && S.titleOffset[0] > 0 ? v += S.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && S.titleOffset[2] > 0 && (v -= S.titleOffset[2]), v !== n.y && (n = f(n, { y: v })), S.hasRendered || (this.group.placed = !1), this.group.align(f(j, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : j.verticalAlign }), !0, n);
        }
        handleOverflow(n) {
          let S = this, j = this.chart, v = j.renderer, P = this.options, G = P.y, W = P.verticalAlign === "top", Q = this.padding, k = P.maxHeight, A = P.navigation, L = s(A.animation, !0), Y = A.arrowSize || 12, x = this.pages, T = this.allItems, M = function(ct) {
            typeof ct == "number" ? at.attr({ height: ct }) : at && (S.clipRect = at.destroy(), S.contentGroup.clip()), S.contentGroup.div && (S.contentGroup.div.style.clip = ct ? "rect(" + Q + "px,9999px," + (Q + ct) + "px,0)" : "auto");
          }, U = function(ct) {
            return S[ct] = v.circle(0, 0, 1.3 * Y).translate(Y / 2, Y / 2).add(rt), j.styledMode || S[ct].attr("fill", "rgba(0,0,0,0.0001)"), S[ct];
          }, H, q, F, et = j.spacingBox.height + (W ? -G : G) - Q, rt = this.nav, at = this.clipRect;
          return P.layout !== "horizontal" || P.verticalAlign === "middle" || P.floating || (et /= 2), k && (et = Math.min(et, k)), x.length = 0, n && et > 0 && n > et && A.enabled !== !1 ? (this.clipHeight = H = Math.max(et - 20 - this.titleHeight - Q, 0), this.currentPage = s(this.currentPage, 1), this.fullHeight = n, T.forEach((ct, Z) => {
            let X = (F = ct.legendItem || {}).y || 0, K = Math.round(F.label.getBBox().height), ot = x.length;
            (!ot || X - x[ot - 1] > H && (q || X) !== x[ot - 1]) && (x.push(q || X), ot++), F.pageIx = ot - 1, q && ((T[Z - 1].legendItem || {}).pageIx = ot - 1), Z === T.length - 1 && X + K - x[ot - 1] > H && X > x[ot - 1] && (x.push(X), F.pageIx = ot), X !== q && (q = X);
          }), at || (at = S.clipRect = v.clipRect(0, Q - 2, 9999, 0), S.contentGroup.clip(at)), M(H), rt || (this.nav = rt = v.g().attr({ zIndex: 1 }).add(this.group), this.up = v.symbol("triangle", 0, 0, Y, Y).add(rt), U("upTracker").on("click", function() {
            S.scroll(-1, L);
          }), this.pager = v.text("", 15, 10).addClass("highcharts-legend-navigation"), !j.styledMode && A.style && this.pager.css(A.style), this.pager.add(rt), this.down = v.symbol("triangle-down", 0, 0, Y, Y).add(rt), U("downTracker").on("click", function() {
            S.scroll(1, L);
          })), S.scroll(0), n = et) : rt && (M(), this.nav = rt.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), n;
        }
        scroll(n, S) {
          let j = this.chart, v = this.pages, P = v.length, G = this.clipHeight, W = this.options.navigation, Q = this.pager, k = this.padding, A = this.currentPage + n;
          A > P && (A = P), A > 0 && (S !== void 0 && p(S, j), this.nav.attr({ translateX: k, translateY: G + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(L) {
            L.attr({ class: A === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }), Q.attr({ text: A + "/" + P }), [this.down, this.downTracker].forEach(function(L) {
            L.attr({ x: 18 + this.pager.getBBox().width, class: A === P ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }, this), j.styledMode || (this.up.attr({ fill: A === 1 ? W.inactiveColor : W.activeColor }), this.upTracker.css({ cursor: A === 1 ? "default" : "pointer" }), this.down.attr({ fill: A === P ? W.inactiveColor : W.activeColor }), this.downTracker.css({ cursor: A === P ? "default" : "pointer" })), this.scrollOffset = -v[A - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = A, this.positionCheckboxes(), g(() => {
            O(this, "afterScroll", { currentPage: A });
          }, D(s(S, j.renderer.globalAnimation, !0)).duration));
        }
        setItemEvents(n, S, j) {
          let v = this, P = n.legendItem || {}, G = v.chart.renderer.boxWrapper, W = n instanceof st, Q = n instanceof it, k = "highcharts-legend-" + (W ? "point" : "series") + "-active", A = v.chart.styledMode, L = j ? [S, P.symbol] : [P.group], Y = (x) => {
            v.allItems.forEach((T) => {
              n !== T && [T].concat(T.linkedSeries || []).forEach((M) => {
                M.setState(x, !W);
              });
            });
          };
          for (let x of L) x && x.on("mouseover", function() {
            n.visible && Y("inactive"), n.setState("hover"), n.visible && G.addClass(k), A || S.css(v.options.itemHoverStyle);
          }).on("mouseout", function() {
            v.chart.styledMode || S.css(f(n.visible ? v.itemStyle : v.itemHiddenStyle)), Y(""), G.removeClass(k), n.setState();
          }).on("click", function(T) {
            let M = function() {
              n.setVisible && n.setVisible(), Y(n.visible ? "inactive" : "");
            };
            G.removeClass(k), O(v, "itemClick", { browserEvent: T, legendItem: n }, M), W ? n.firePointEvent("legendItemClick", { browserEvent: T }) : Q && O(n, "legendItemClick", { browserEvent: T });
          });
        }
        createCheckboxForItem(n) {
          n.checkbox = l("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: n.selected, defaultChecked: n.selected }, this.options.itemCheckboxStyle, this.chart.container), b(n.checkbox, "click", function(S) {
            let j = S.target;
            O(n.series || n, "checkboxClick", { checked: j.checked, item: n }, function() {
              n.select();
            });
          });
        }
      }
      return (N = o || (o = {})).compose = function(c) {
        t(m, "Core.Legend") && b(c, "beforeMargins", function() {
          this.legend = new N(this, this.options.legend);
        });
      }, o;
    }), nt(i, "Core/Chart/Chart.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Axis/Axis.js"], i["Core/Defaults.js"], i["Core/Templating.js"], i["Core/Foundation.js"], i["Core/Globals.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Renderer/SVG/SVGRenderer.js"], i["Core/Time.js"], i["Core/Utilities.js"], i["Core/Renderer/HTML/AST.js"], i["Core/Axis/Tick.js"]], function(B, $, J, it, st, tt, V, _, N, D, p, y, m, w) {
      let { animate: a, animObject: u, setAnimation: b } = B, { defaultOptions: l, defaultTime: d } = J, { numberFormat: C } = it, { registerEventOptions: R } = st, { charts: z, doc: O, marginNames: h, svg: f, win: s } = tt, { seriesTypes: t } = N, { addEvent: e, attr: r, createElement: g, css: o, defined: c, diffObjects: n, discardElement: S, erase: j, error: v, extend: P, find: G, fireEvent: W, getStyle: Q, isArray: k, isNumber: A, isObject: L, isString: Y, merge: x, objectEach: T, pick: M, pInt: U, relativeLength: H, removeEvent: q, splat: F, syncTimeout: et, uniqueKey: rt } = y;
      class at {
        static chart(Z, X, K) {
          return new at(Z, X, K);
        }
        constructor(Z, X, K) {
          this.sharedClips = {};
          let ot = [...arguments];
          (Y(Z) || Z.nodeName) && (this.renderTo = ot.shift()), this.init(ot[0], ot[1]);
        }
        setZoomOptions() {
          let Z = this.options.chart, X = Z.zooming;
          this.zooming = { ...X, type: M(Z.zoomType, X.type), key: M(Z.zoomKey, X.key), pinchType: M(Z.pinchType, X.pinchType), singleTouch: M(Z.zoomBySingleTouch, X.singleTouch, !1), resetButton: x(X.resetButton, Z.resetZoomButton) };
        }
        init(Z, X) {
          W(this, "init", { args: arguments }, function() {
            let K = x(l, Z), ot = K.chart;
            this.userOptions = P({}, Z), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = X, this.isResizing = 0, this.options = K, this.axes = [], this.series = [], this.time = Z.time && Object.keys(Z.time).length ? new p(Z.time) : tt.time, this.numberFormatter = ot.numberFormatter || C, this.styledMode = ot.styledMode, this.hasCartesianSeries = ot.showAxes, this.index = z.length, z.push(this), tt.chartCount++, R(this, ot), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), W(this, "afterInit"), this.firstRender();
          });
        }
        initSeries(Z) {
          let X = this.options.chart, K = Z.type || X.type, ot = t[K];
          ot || v(17, !0, this, { missingModuleFor: K });
          let ht = new ot();
          return typeof ht.init == "function" && ht.init(this, Z), ht;
        }
        setSortedData() {
          this.getSeriesOrderByLinks().forEach(function(Z) {
            Z.points || Z.data || !Z.enabledDataSorting || Z.setData(Z.options.data, !1);
          });
        }
        getSeriesOrderByLinks() {
          return this.series.concat().sort(function(Z, X) {
            return Z.linkedSeries.length || X.linkedSeries.length ? X.linkedSeries.length - Z.linkedSeries.length : 0;
          });
        }
        orderItems(Z, X = 0) {
          let K = this[Z], ot = this.options[Z] = F(this.options[Z]).slice(), ht = this.userOptions[Z] = this.userOptions[Z] ? F(this.userOptions[Z]).slice() : [];
          if (this.hasRendered && (ot.splice(X), ht.splice(X)), K) for (let dt = X, lt = K.length; dt < lt; ++dt) {
            let ut = K[dt];
            ut && (ut.index = dt, ut instanceof _ && (ut.name = ut.getName()), ut.options.isInternal || (ot[dt] = ut.options, ht[dt] = ut.userOptions));
          }
        }
        isInsidePlot(Z, X, K = {}) {
          var bt;
          let { inverted: ot, plotBox: ht, plotLeft: dt, plotTop: lt, scrollablePlotBox: ut } = this, { scrollLeft: ft = 0, scrollTop: gt = 0 } = K.visiblePlotOnly && ((bt = this.scrollablePlotArea) == null ? void 0 : bt.scrollingContainer) || {}, pt = K.series, mt = K.visiblePlotOnly && ut || ht, yt = K.inverted ? X : Z, vt = K.inverted ? Z : X, xt = { x: yt, y: vt, isInsidePlot: !0, options: K };
          if (!K.ignoreX) {
            let Ct = pt && (ot && !this.polar ? pt.yAxis : pt.xAxis) || { pos: dt, len: 1 / 0 }, wt = K.paneCoordinates ? Ct.pos + yt : dt + yt;
            wt >= Math.max(ft + dt, Ct.pos) && wt <= Math.min(ft + dt + mt.width, Ct.pos + Ct.len) || (xt.isInsidePlot = !1);
          }
          if (!K.ignoreY && xt.isInsidePlot) {
            let Ct = !ot && K.axis && !K.axis.isXAxis && K.axis || pt && (ot ? pt.xAxis : pt.yAxis) || { pos: lt, len: 1 / 0 }, wt = K.paneCoordinates ? Ct.pos + vt : lt + vt;
            wt >= Math.max(gt + lt, Ct.pos) && wt <= Math.min(gt + lt + mt.height, Ct.pos + Ct.len) || (xt.isInsidePlot = !1);
          }
          return W(this, "afterIsInsidePlot", xt), xt.isInsidePlot;
        }
        redraw(Z) {
          W(this, "beforeRedraw");
          let X = this.hasCartesianSeries ? this.axes : this.colorAxis || [], K = this.series, ot = this.pointer, ht = this.legend, dt = this.userOptions.legend, lt = this.renderer, ut = lt.isHidden(), ft = [], gt, pt, mt, yt = this.isDirtyBox, vt = this.isDirtyLegend, xt;
          for (lt.rootFontSize = lt.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), b(!!this.hasRendered && Z, this), ut && this.temporaryDisplay(), this.layOutTitles(!1), mt = K.length; mt--; ) if (((xt = K[mt]).options.stacking || xt.options.centerInCategory) && (pt = !0, xt.isDirty)) {
            gt = !0;
            break;
          }
          if (gt) for (mt = K.length; mt--; ) (xt = K[mt]).options.stacking && (xt.isDirty = !0);
          K.forEach(function(bt) {
            bt.isDirty && (bt.options.legendType === "point" ? (typeof bt.updateTotals == "function" && bt.updateTotals(), vt = !0) : dt && (dt.labelFormatter || dt.labelFormat) && (vt = !0)), bt.isDirtyData && W(bt, "updatedData");
          }), vt && ht && ht.options.enabled && (ht.render(), this.isDirtyLegend = !1), pt && this.getStacks(), X.forEach(function(bt) {
            bt.updateNames(), bt.setScale();
          }), this.getMargins(), X.forEach(function(bt) {
            bt.isDirty && (yt = !0);
          }), X.forEach(function(bt) {
            let Ct = bt.min + "," + bt.max;
            bt.extKey !== Ct && (bt.extKey = Ct, ft.push(function() {
              W(bt, "afterSetExtremes", P(bt.eventArgs, bt.getExtremes())), delete bt.eventArgs;
            })), (yt || pt) && bt.redraw();
          }), yt && this.drawChartBox(), W(this, "predraw"), K.forEach(function(bt) {
            (yt || bt.isDirty) && bt.visible && bt.redraw(), bt.isDirtyData = !1;
          }), ot && ot.reset(!0), lt.draw(), W(this, "redraw"), W(this, "render"), ut && this.temporaryDisplay(!0), ft.forEach(function(bt) {
            bt.call();
          });
        }
        get(Z) {
          let X = this.series;
          function K(ht) {
            return ht.id === Z || ht.options && ht.options.id === Z;
          }
          let ot = G(this.axes, K) || G(this.series, K);
          for (let ht = 0; !ot && ht < X.length; ht++) ot = G(X[ht].points || [], K);
          return ot;
        }
        getAxes() {
          let Z = this.userOptions;
          for (let X of (W(this, "getAxes"), ["xAxis", "yAxis"])) for (let K of Z[X] = F(Z[X] || {})) new $(this, K, X);
          W(this, "afterGetAxes");
        }
        getSelectedPoints() {
          return this.series.reduce((Z, X) => (X.getPointsCollection().forEach((K) => {
            M(K.selectedStaging, K.selected) && Z.push(K);
          }), Z), []);
        }
        getSelectedSeries() {
          return this.series.filter(function(Z) {
            return Z.selected;
          });
        }
        setTitle(Z, X, K) {
          this.applyDescription("title", Z), this.applyDescription("subtitle", X), this.applyDescription("caption", void 0), this.layOutTitles(K);
        }
        applyDescription(Z, X) {
          let K = this, ot = this.options[Z] = x(this.options[Z], X), ht = this[Z];
          ht && X && (this[Z] = ht = ht.destroy()), ot && !ht && ((ht = this.renderer.text(ot.text, 0, 0, ot.useHTML).attr({ align: ot.align, class: "highcharts-" + Z, zIndex: ot.zIndex || 4 }).add()).update = function(dt, lt) {
            K.applyDescription(Z, dt), K.layOutTitles(lt);
          }, this.styledMode || ht.css(P(Z === "title" ? { fontSize: this.options.isStock ? "1em" : "1.2em" } : {}, ot.style)), this[Z] = ht);
        }
        layOutTitles(Z = !0) {
          let X = [0, 0, 0], K = this.renderer, ot = this.spacingBox;
          ["title", "subtitle", "caption"].forEach(function(dt) {
            let lt = this[dt], ut = this.options[dt], ft = ut.verticalAlign || "top", gt = dt === "title" ? ft === "top" ? -3 : 0 : ft === "top" ? X[0] + 2 : 0;
            if (lt) {
              lt.css({ width: (ut.width || ot.width + (ut.widthAdjust || 0)) + "px" });
              let pt = K.fontMetrics(lt).b, mt = Math.round(lt.getBBox(ut.useHTML).height);
              lt.align(P({ y: ft === "bottom" ? pt : gt + pt, height: mt }, ut), !1, "spacingBox"), ut.floating || (ft === "top" ? X[0] = Math.ceil(X[0] + mt) : ft === "bottom" && (X[2] = Math.ceil(X[2] + mt)));
            }
          }, this), X[0] && (this.options.title.verticalAlign || "top") === "top" && (X[0] += this.options.title.margin), X[2] && this.options.caption.verticalAlign === "bottom" && (X[2] += this.options.caption.margin);
          let ht = !this.titleOffset || this.titleOffset.join(",") !== X.join(",");
          this.titleOffset = X, W(this, "afterLayOutTitles"), !this.isDirtyBox && ht && (this.isDirtyBox = this.isDirtyLegend = ht, this.hasRendered && Z && this.isDirtyBox && this.redraw());
        }
        getContainerBox() {
          let Z = [].map.call(this.renderTo.children, (K) => {
            if (K !== this.container) {
              let ot = K.style.display;
              return K.style.display = "none", [K, ot];
            }
          }), X = { width: Q(this.renderTo, "width", !0) || 0, height: Q(this.renderTo, "height", !0) || 0 };
          return Z.filter(Boolean).forEach(([K, ot]) => {
            K.style.display = ot;
          }), X;
        }
        getChartSize() {
          var dt;
          let Z = this.options.chart, X = Z.width, K = Z.height, ot = this.getContainerBox(), ht = ot.height > 1 && !(!((dt = this.renderTo.parentElement) != null && dt.style.height) && this.renderTo.style.height === "100%");
          this.chartWidth = Math.max(0, X || ot.width || 600), this.chartHeight = Math.max(0, H(K, this.chartWidth) || (ht ? ot.height : 400)), this.containerBox = ot;
        }
        temporaryDisplay(Z) {
          let X = this.renderTo, K;
          if (Z) for (; X && X.style; ) X.hcOrigStyle && (o(X, X.hcOrigStyle), delete X.hcOrigStyle), X.hcOrigDetached && (O.body.removeChild(X), X.hcOrigDetached = !1), X = X.parentNode;
          else for (; X && X.style && (O.body.contains(X) || X.parentNode || (X.hcOrigDetached = !0, O.body.appendChild(X)), (Q(X, "display", !1) === "none" || X.hcOricDetached) && (X.hcOrigStyle = { display: X.style.display, height: X.style.height, overflow: X.style.overflow }, K = { display: "block", overflow: "hidden" }, X !== this.renderTo && (K.height = 0), o(X, K), X.offsetWidth || X.style.setProperty("display", "block", "important")), (X = X.parentNode) !== O.body); ) ;
        }
        setClassName(Z) {
          this.container.className = "highcharts-container " + (Z || "");
        }
        getContainer() {
          var mt;
          let Z = this.options, X = Z.chart, K = "data-highcharts-chart", ot = rt(), ht, dt = this.renderTo;
          dt || (this.renderTo = dt = X.renderTo), Y(dt) && (this.renderTo = dt = O.getElementById(dt)), dt || v(13, !0, this);
          let lt = U(r(dt, K));
          A(lt) && z[lt] && z[lt].hasRendered && z[lt].destroy(), r(dt, K, this.index), dt.innerHTML = m.emptyHTML, X.skipClone || dt.offsetWidth || this.temporaryDisplay(), this.getChartSize();
          let ut = this.chartHeight, ft = this.chartWidth;
          o(dt, { overflow: "hidden" }), this.styledMode || (ht = P({ position: "relative", overflow: "hidden", width: ft + "px", height: ut + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none", padding: "0px" }, X.style || {}));
          let gt = g("div", { id: ot }, ht, dt);
          this.container = gt, this.getChartSize(), ft === this.chartWidth || (ft = this.chartWidth, this.styledMode || o(gt, { width: M((mt = X.style) == null ? void 0 : mt.width, ft + "px") })), this.containerBox = this.getContainerBox(), this._cursor = gt.style.cursor;
          let pt = X.renderer || !f ? V.getRendererType(X.renderer) : D;
          if (this.renderer = new pt(gt, ft, ut, void 0, X.forExport, Z.exporting && Z.exporting.allowHTML, this.styledMode), b(void 0, this), this.setClassName(X.className), this.styledMode) for (let yt in Z.defs) this.renderer.definition(Z.defs[yt]);
          else this.renderer.setStyle(X.style);
          this.renderer.chartIndex = this.index, W(this, "afterGetContainer");
        }
        getMargins(Z) {
          let { spacing: X, margin: K, titleOffset: ot } = this;
          this.resetMargins(), ot[0] && !c(K[0]) && (this.plotTop = Math.max(this.plotTop, ot[0] + X[0])), ot[2] && !c(K[2]) && (this.marginBottom = Math.max(this.marginBottom, ot[2] + X[2])), this.legend && this.legend.display && this.legend.adjustMargins(K, X), W(this, "getMargins"), Z || this.getAxisMargins();
        }
        getAxisMargins() {
          let Z = this, X = Z.axisOffset = [0, 0, 0, 0], K = Z.colorAxis, ot = Z.margin, ht = function(dt) {
            dt.forEach(function(lt) {
              lt.visible && lt.getOffset();
            });
          };
          Z.hasCartesianSeries ? ht(Z.axes) : K && K.length && ht(K), h.forEach(function(dt, lt) {
            c(ot[lt]) || (Z[dt] += X[lt]);
          }), Z.setChartSize();
        }
        getOptions() {
          return n(this.userOptions, l);
        }
        reflow(Z) {
          var ht;
          let X = this, K = X.containerBox, ot = X.getContainerBox();
          (ht = X.pointer) == null || delete ht.chartPosition, !X.isPrinting && !X.isResizing && K && ot.width && ((ot.width !== K.width || ot.height !== K.height) && (y.clearTimeout(X.reflowTimeout), X.reflowTimeout = et(function() {
            X.container && X.setSize(void 0, void 0, !1);
          }, Z ? 100 : 0)), X.containerBox = ot);
        }
        setReflow() {
          let Z = this, X = (K) => {
            var ot;
            (ot = Z.options) != null && ot.chart.reflow && Z.hasLoaded && Z.reflow(K);
          };
          if (typeof ResizeObserver == "function") new ResizeObserver(X).observe(Z.renderTo);
          else {
            let K = e(s, "resize", X);
            e(this, "destroy", K);
          }
        }
        setSize(Z, X, K) {
          let ot = this, ht = ot.renderer;
          ot.isResizing += 1, b(K, ot);
          let dt = ht.globalAnimation;
          ot.oldChartHeight = ot.chartHeight, ot.oldChartWidth = ot.chartWidth, Z !== void 0 && (ot.options.chart.width = Z), X !== void 0 && (ot.options.chart.height = X), ot.getChartSize();
          let { chartWidth: lt, chartHeight: ut, scrollablePixelsX: ft = 0, scrollablePixelsY: gt = 0 } = ot;
          (ot.isDirtyBox || lt !== ot.oldChartWidth || ut !== ot.oldChartHeight) && (ot.styledMode || (dt ? a : o)(ot.container, { width: `${lt + ft}px`, height: `${ut + gt}px` }, dt), ot.setChartSize(!0), ht.setSize(lt, ut, dt), ot.axes.forEach(function(pt) {
            pt.isDirty = !0, pt.setScale();
          }), ot.isDirtyLegend = !0, ot.isDirtyBox = !0, ot.layOutTitles(), ot.getMargins(), ot.redraw(dt), ot.oldChartHeight = void 0, W(ot, "resize"), setTimeout(() => {
            ot && W(ot, "endResize");
          }, u(dt).duration)), ot.isResizing -= 1;
        }
        setChartSize(Z) {
          let X, K, ot, ht, { chartHeight: dt, chartWidth: lt, inverted: ut, spacing: ft, renderer: gt } = this, pt = this.clipOffset, mt = Math[ut ? "floor" : "round"];
          this.plotLeft = X = Math.round(this.plotLeft), this.plotTop = K = Math.round(this.plotTop), this.plotWidth = ot = Math.max(0, Math.round(lt - X - this.marginRight)), this.plotHeight = ht = Math.max(0, Math.round(dt - K - this.marginBottom)), this.plotSizeX = ut ? ht : ot, this.plotSizeY = ut ? ot : ht, this.spacingBox = gt.spacingBox = { x: ft[3], y: ft[0], width: lt - ft[3] - ft[1], height: dt - ft[0] - ft[2] }, this.plotBox = gt.plotBox = { x: X, y: K, width: ot, height: ht }, pt && (this.clipBox = { x: mt(pt[3]), y: mt(pt[0]), width: mt(this.plotSizeX - pt[1] - pt[3]), height: mt(this.plotSizeY - pt[0] - pt[2]) }), Z || (this.axes.forEach(function(yt) {
            yt.setAxisSize(), yt.setAxisTranslation();
          }), gt.alignElements()), W(this, "afterSetChartSize", { skipAxes: Z });
        }
        resetMargins() {
          W(this, "resetMargins");
          let Z = this, X = Z.options.chart, K = X.plotBorderWidth || 0, ot = K / 2;
          ["margin", "spacing"].forEach(function(ht) {
            let dt = X[ht], lt = L(dt) ? dt : [dt, dt, dt, dt];
            ["Top", "Right", "Bottom", "Left"].forEach(function(ut, ft) {
              Z[ht][ft] = M(X[ht + ut], lt[ft]);
            });
          }), h.forEach(function(ht, dt) {
            Z[ht] = M(Z.margin[dt], Z.spacing[dt]);
          }), Z.axisOffset = [0, 0, 0, 0], Z.clipOffset = [ot, ot, ot, ot], Z.plotBorderWidth = K;
        }
        drawChartBox() {
          let Z = this.options.chart, X = this.renderer, K = this.chartWidth, ot = this.chartHeight, ht = this.styledMode, dt = this.plotBGImage, lt = Z.backgroundColor, ut = Z.plotBackgroundColor, ft = Z.plotBackgroundImage, gt = this.plotLeft, pt = this.plotTop, mt = this.plotWidth, yt = this.plotHeight, vt = this.plotBox, xt = this.clipRect, bt = this.clipBox, Ct = this.chartBackground, wt = this.plotBackground, At = this.plotBorder, St, kt, Et, Pt = "animate";
          Ct || (this.chartBackground = Ct = X.rect().addClass("highcharts-background").add(), Pt = "attr"), ht ? St = kt = Ct.strokeWidth() : (kt = (St = Z.borderWidth || 0) + (Z.shadow ? 8 : 0), Et = { fill: lt || "none" }, (St || Ct["stroke-width"]) && (Et.stroke = Z.borderColor, Et["stroke-width"] = St), Ct.attr(Et).shadow(Z.shadow)), Ct[Pt]({ x: kt / 2, y: kt / 2, width: K - kt - St % 2, height: ot - kt - St % 2, r: Z.borderRadius }), Pt = "animate", wt || (Pt = "attr", this.plotBackground = wt = X.rect().addClass("highcharts-plot-background").add()), wt[Pt](vt), !ht && (wt.attr({ fill: ut || "none" }).shadow(Z.plotShadow), ft && (dt ? (ft !== dt.attr("href") && dt.attr("href", ft), dt.animate(vt)) : this.plotBGImage = X.image(ft, gt, pt, mt, yt).add())), xt ? xt.animate({ width: bt.width, height: bt.height }) : this.clipRect = X.clipRect(bt), Pt = "animate", At || (Pt = "attr", this.plotBorder = At = X.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), ht || At.attr({ stroke: Z.plotBorderColor, "stroke-width": Z.plotBorderWidth || 0, fill: "none" }), At[Pt](At.crisp({ x: gt, y: pt, width: mt, height: yt }, -At.strokeWidth())), this.isDirtyBox = !1, W(this, "afterDrawChartBox");
        }
        propFromSeries() {
          let Z, X, K, ot = this, ht = ot.options.chart, dt = ot.options.series;
          ["inverted", "angular", "polar"].forEach(function(lt) {
            for (X = t[ht.type], K = ht[lt] || X && X.prototype[lt], Z = dt && dt.length; !K && Z--; ) (X = t[dt[Z].type]) && X.prototype[lt] && (K = !0);
            ot[lt] = K;
          });
        }
        linkSeries(Z) {
          let X = this, K = X.series;
          K.forEach(function(ot) {
            ot.linkedSeries.length = 0;
          }), K.forEach(function(ot) {
            let { linkedTo: ht } = ot.options;
            if (Y(ht)) {
              let dt;
              (dt = ht === ":previous" ? X.series[ot.index - 1] : X.get(ht)) && dt.linkedParent !== ot && (dt.linkedSeries.push(ot), ot.linkedParent = dt, dt.enabledDataSorting && ot.setDataSortingOptions(), ot.visible = M(ot.options.visible, dt.options.visible, ot.visible));
            }
          }), W(this, "afterLinkSeries", { isUpdating: Z });
        }
        renderSeries() {
          this.series.forEach(function(Z) {
            Z.translate(), Z.render();
          });
        }
        render() {
          var gt;
          let Z = this.axes, X = this.colorAxis, K = this.renderer, ot = this.options.chart.axisLayoutRuns || 2, ht = (pt) => {
            pt.forEach((mt) => {
              mt.visible && mt.render();
            });
          }, dt = 0, lt = !0, ut, ft = 0;
          for (let pt of (this.setTitle(), W(this, "beforeMargins"), (gt = this.getStacks) == null || gt.call(this), this.getMargins(!0), this.setChartSize(), Z)) {
            let { options: mt } = pt, { labels: yt } = mt;
            if (this.hasCartesianSeries && pt.horiz && pt.visible && yt.enabled && pt.series.length && pt.coll !== "colorAxis" && !this.polar) {
              dt = mt.tickLength, pt.createGroups();
              let vt = new w(pt, 0, "", !0), xt = vt.createLabel("x", yt);
              if (vt.destroy(), xt && M(yt.reserveSpace, !A(mt.crossing)) && (dt = xt.getBBox().height + yt.distance + Math.max(mt.offset || 0, 0)), dt) {
                xt == null || xt.destroy();
                break;
              }
            }
          }
          for (this.plotHeight = Math.max(this.plotHeight - dt, 0); (lt || ut || ot > 1) && ft < ot; ) {
            let pt = this.plotWidth, mt = this.plotHeight;
            for (let yt of Z) ft === 0 ? yt.setScale() : (yt.horiz && lt || !yt.horiz && ut) && yt.setTickInterval(!0);
            ft === 0 ? this.getAxisMargins() : this.getMargins(), lt = pt / this.plotWidth > (ft ? 1 : 1.1), ut = mt / this.plotHeight > (ft ? 1 : 1.05), ft++;
          }
          this.drawChartBox(), this.hasCartesianSeries ? ht(Z) : X && X.length && ht(X), this.seriesGroup || (this.seriesGroup = K.g("series-group").attr({ zIndex: 3 }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
        }
        addCredits(Z) {
          let X = this, K = x(!0, this.options.credits, Z);
          K.enabled && !this.credits && (this.credits = this.renderer.text(K.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
            K.href && (s.location.href = K.href);
          }).attr({ align: K.position.align, zIndex: 8 }), X.styledMode || this.credits.css(K.style), this.credits.add().align(K.position), this.credits.update = function(ot) {
            X.credits = X.credits.destroy(), X.addCredits(ot);
          });
        }
        destroy() {
          let Z, X = this, K = X.axes, ot = X.series, ht = X.container, dt = ht && ht.parentNode;
          for (W(X, "destroy"), X.renderer.forExport ? j(z, X) : z[X.index] = void 0, tt.chartCount--, X.renderTo.removeAttribute("data-highcharts-chart"), q(X), Z = K.length; Z--; ) K[Z] = K[Z].destroy();
          for (this.scroller && this.scroller.destroy && this.scroller.destroy(), Z = ot.length; Z--; ) ot[Z] = ot[Z].destroy();
          ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(lt) {
            let ut = X[lt];
            ut && ut.destroy && (X[lt] = ut.destroy());
          }), ht && (ht.innerHTML = m.emptyHTML, q(ht), dt && S(ht)), T(X, function(lt, ut) {
            delete X[ut];
          });
        }
        firstRender() {
          var ot;
          let Z = this, X = Z.options;
          Z.getContainer(), Z.resetMargins(), Z.setChartSize(), Z.propFromSeries(), Z.getAxes();
          let K = k(X.series) ? X.series : [];
          X.series = [], K.forEach(function(ht) {
            Z.initSeries(ht);
          }), Z.linkSeries(), Z.setSortedData(), W(Z, "beforeRender"), Z.render(), (ot = Z.pointer) == null || ot.getChartPosition(), Z.renderer.imgCount || Z.hasLoaded || Z.onload(), Z.temporaryDisplay(!0);
        }
        onload() {
          this.callbacks.concat([this.callback]).forEach(function(Z) {
            Z && this.index !== void 0 && Z.apply(this, [this]);
          }, this), W(this, "load"), W(this, "render"), c(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
        }
        warnIfA11yModuleNotLoaded() {
          let { options: Z, title: X } = this;
          !Z || this.accessibility || (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (X && X.element.textContent || "").replace(/</g, "&lt;") }), Z.accessibility && Z.accessibility.enabled === !1 || v('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
        }
        addSeries(Z, X, K) {
          let ot, ht = this;
          return Z && (X = M(X, !0), W(ht, "addSeries", { options: Z }, function() {
            ot = ht.initSeries(Z), ht.isDirtyLegend = !0, ht.linkSeries(), ot.enabledDataSorting && ot.setData(Z.data, !1), W(ht, "afterAddSeries", { series: ot }), X && ht.redraw(K);
          })), ot;
        }
        addAxis(Z, X, K, ot) {
          return this.createAxis(X ? "xAxis" : "yAxis", { axis: Z, redraw: K, animation: ot });
        }
        addColorAxis(Z, X, K) {
          return this.createAxis("colorAxis", { axis: Z, redraw: X, animation: K });
        }
        createAxis(Z, X) {
          let K = new $(this, X.axis, Z);
          return M(X.redraw, !0) && this.redraw(X.animation), K;
        }
        showLoading(Z) {
          let X = this, K = X.options, ot = K.loading, ht = function() {
            dt && o(dt, { left: X.plotLeft + "px", top: X.plotTop + "px", width: X.plotWidth + "px", height: X.plotHeight + "px" });
          }, dt = X.loadingDiv, lt = X.loadingSpan;
          dt || (X.loadingDiv = dt = g("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, X.container)), lt || (X.loadingSpan = lt = g("span", { className: "highcharts-loading-inner" }, null, dt), e(X, "redraw", ht)), dt.className = "highcharts-loading", m.setElementHTML(lt, M(Z, K.lang.loading, "")), X.styledMode || (o(dt, P(ot.style, { zIndex: 10 })), o(lt, ot.labelStyle), X.loadingShown || (o(dt, { opacity: 0, display: "" }), a(dt, { opacity: ot.style.opacity || 0.5 }, { duration: ot.showDuration || 0 }))), X.loadingShown = !0, ht();
        }
        hideLoading() {
          let Z = this.options, X = this.loadingDiv;
          X && (X.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || a(X, { opacity: 0 }, { duration: Z.loading.hideDuration || 100, complete: function() {
            o(X, { display: "none" });
          } })), this.loadingShown = !1;
        }
        update(Z, X, K, ot) {
          let ht, dt, lt, ut = this, ft = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, gt = Z.isResponsiveOptions, pt = [];
          W(ut, "update", { options: Z }), gt || ut.setResponsive(!1, !0), Z = n(Z, ut.options), ut.userOptions = x(ut.userOptions, Z);
          let mt = Z.chart;
          mt && (x(!0, ut.options.chart, mt), this.setZoomOptions(), "className" in mt && ut.setClassName(mt.className), ("inverted" in mt || "polar" in mt || "type" in mt) && (ut.propFromSeries(), ht = !0), "alignTicks" in mt && (ht = !0), "events" in mt && R(this, mt), T(mt, function(xt, bt) {
            ut.propsRequireUpdateSeries.indexOf("chart." + bt) !== -1 && (dt = !0), ut.propsRequireDirtyBox.indexOf(bt) !== -1 && (ut.isDirtyBox = !0), ut.propsRequireReflow.indexOf(bt) === -1 || (ut.isDirtyBox = !0, gt || (lt = !0));
          }), !ut.styledMode && mt.style && ut.renderer.setStyle(ut.options.chart.style || {})), !ut.styledMode && Z.colors && (this.options.colors = Z.colors), Z.time && (this.time === d && (this.time = new p(Z.time)), x(!0, ut.options.time, Z.time)), T(Z, function(xt, bt) {
            ut[bt] && typeof ut[bt].update == "function" ? ut[bt].update(xt, !1) : typeof ut[ft[bt]] == "function" ? ut[ft[bt]](xt) : bt !== "colors" && ut.collectionsWithUpdate.indexOf(bt) === -1 && x(!0, ut.options[bt], Z[bt]), bt !== "chart" && ut.propsRequireUpdateSeries.indexOf(bt) !== -1 && (dt = !0);
          }), this.collectionsWithUpdate.forEach(function(xt) {
            Z[xt] && (F(Z[xt]).forEach(function(bt, Ct) {
              let wt, At = c(bt.id);
              At && (wt = ut.get(bt.id)), !wt && ut[xt] && (wt = ut[xt][M(bt.index, Ct)]) && (At && c(wt.options.id) || wt.options.isInternal) && (wt = void 0), wt && wt.coll === xt && (wt.update(bt, !1), K && (wt.touched = !0)), !wt && K && ut.collectionsWithInit[xt] && (ut.collectionsWithInit[xt][0].apply(ut, [bt].concat(ut.collectionsWithInit[xt][1] || []).concat([!1])).touched = !0);
            }), K && ut[xt].forEach(function(bt) {
              bt.touched || bt.options.isInternal ? delete bt.touched : pt.push(bt);
            }));
          }), pt.forEach(function(xt) {
            xt.chart && xt.remove && xt.remove(!1);
          }), ht && ut.axes.forEach(function(xt) {
            xt.update({}, !1);
          }), dt && ut.getSeriesOrderByLinks().forEach(function(xt) {
            xt.chart && xt.update({}, !1);
          }, this);
          let yt = mt && mt.width, vt = mt && (Y(mt.height) ? H(mt.height, yt || ut.chartWidth) : mt.height);
          lt || A(yt) && yt !== ut.chartWidth || A(vt) && vt !== ut.chartHeight ? ut.setSize(yt, vt, ot) : M(X, !0) && ut.redraw(ot), W(ut, "afterUpdate", { options: Z, redraw: X, animation: ot });
        }
        setSubtitle(Z, X) {
          this.applyDescription("subtitle", Z), this.layOutTitles(X);
        }
        setCaption(Z, X) {
          this.applyDescription("caption", Z), this.layOutTitles(X);
        }
        showResetZoom() {
          let Z = this, X = l.lang, K = Z.zooming.resetButton, ot = K.theme, ht = K.relativeTo === "chart" || K.relativeTo === "spacingBox" ? null : "plotBox";
          function dt() {
            Z.zoomOut();
          }
          W(this, "beforeShowResetZoom", null, function() {
            Z.resetZoomButton = Z.renderer.button(X.resetZoom, null, null, dt, ot).attr({ align: K.position.align, title: X.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(K.position, !1, ht);
          }), W(this, "afterShowResetZoom");
        }
        zoomOut() {
          W(this, "selection", { resetSelection: !0 }, () => this.transform({ reset: !0, trigger: "zoom" }));
        }
        pan(Z, X) {
          let K = this, ot = typeof X == "object" ? X : { enabled: X, type: "x" }, ht = ot.type, dt = ht && K[{ x: "xAxis", xy: "axes", y: "yAxis" }[ht]].filter((ut) => ut.options.panningEnabled && !ut.options.isInternal), lt = K.options.chart;
          lt != null && lt.panning && (lt.panning = ot), W(this, "pan", { originalEvent: Z }, () => {
            K.transform({ axes: dt, event: Z, to: { x: Z.chartX - (K.mouseDownX || 0), y: Z.chartY - (K.mouseDownY || 0) }, trigger: "pan" }), o(K.container, { cursor: "move" });
          });
        }
        transform(Z) {
          var yt, vt, xt, bt, Ct;
          let { axes: X = this.axes, event: K, from: ot = {}, reset: ht, selection: dt, to: lt = {}, trigger: ut } = Z, { inverted: ft } = this, gt = !1, pt, mt;
          for (let wt of ((yt = this.hoverPoints) == null || yt.forEach((At) => At.setState()), X)) {
            let { horiz: At, len: St, minPointOffset: kt = 0, options: Et, reversed: Pt } = wt, _t = At ? "width" : "height", Jt = At ? "x" : "y", Ut = M(lt[_t], wt.len), Gt = M(ot[_t], wt.len), jt = 10 > Math.abs(Ut) ? 1 : Ut / Gt, Ee = (ot[Jt] || 0) + Gt / 2 - wt.pos, Pe = Ee - (((vt = lt[Jt]) != null ? vt : wt.pos) + Ut / 2 - wt.pos) / jt, ai = Pt && !ft || !Pt && ft ? -1 : 1;
            if (!ht && (Ee < 0 || Ee > wt.len)) continue;
            let Nt = wt.toValue(Pe, !0) + (dt || wt.isOrdinal ? 0 : kt * ai), It = wt.toValue(Pe + St / jt, !0) - (dt || wt.isOrdinal ? 0 : kt * ai || 0), Rt = wt.allExtremes;
            if (Nt > It && ([Nt, It] = [It, Nt]), jt === 1 && !ht && wt.coll === "yAxis" && !Rt) {
              for (let gi of wt.series) {
                let fe = gi.getExtremes(gi.getProcessedData(!0).yData, !0);
                Rt != null || (Rt = { dataMin: Number.MAX_VALUE, dataMax: -Number.MAX_VALUE }), A(fe.dataMin) && A(fe.dataMax) && (Rt.dataMin = Math.min(fe.dataMin, Rt.dataMin), Rt.dataMax = Math.max(fe.dataMax, Rt.dataMax));
              }
              wt.allExtremes = Rt;
            }
            let { dataMin: Oe, dataMax: Le, min: li, max: hi } = P(wt.getExtremes(), Rt || {}), ci = Oe != null ? Oe : Et.min, di = Le != null ? Le : Et.max, De = It - Nt, ui = wt.categories ? 0 : Math.min(De, di - ci), Ne = ci - ui * (c(Et.min) ? 0 : Et.minPadding), Ie = di + ui * (c(Et.max) ? 0 : Et.maxPadding), pi = wt.allowZoomOutside || jt === 1 || ut !== "zoom" && jt > 1, pe = Math.min((xt = Et.min) != null ? xt : Ne, Ne, pi ? li : Ne), ge = Math.max((bt = Et.max) != null ? bt : Ie, Ie, pi ? hi : Ie);
            (!wt.isOrdinal || wt.options.overscroll || jt !== 1 || ht) && (Nt < pe && (Nt = pe, jt >= 1 && (It = Nt + De)), It > ge && (It = ge, jt >= 1 && (Nt = It - De)), (ht || wt.series.length && (Nt !== li || It !== hi) && Nt >= pe && It <= ge) && (dt ? dt[wt.coll].push({ axis: wt, min: Nt, max: It }) : (wt.isPanning = ut !== "zoom", wt.isPanning && (mt = !0), wt.setExtremes(ht ? void 0 : Nt, ht ? void 0 : It, !1, !1, { move: Pe, trigger: ut, scale: jt }), !ht && (Nt > pe || It < ge) && ut !== "mousewheel" && (pt = !0)), gt = !0), K && (this[At ? "mouseDownX" : "mouseDownY"] = K[At ? "chartX" : "chartY"]));
          }
          return gt && (dt ? W(this, "selection", dt, () => {
            delete Z.selection, Z.trigger = "zoom", this.transform(Z);
          }) : (!pt || mt || this.resetZoomButton ? !pt && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw(ut === "zoom" && ((Ct = this.options.chart.animation) != null ? Ct : this.pointCount < 100)))), gt;
        }
      }
      return P(at.prototype, { callbacks: [], collectionsWithInit: { xAxis: [at.prototype.addAxis, [!0]], yAxis: [at.prototype.addAxis, [!1]], series: [at.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), at;
    }), nt(i, "Extensions/ScrollablePlotArea.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Globals.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Utilities.js"]], function(B, $, J, it) {
      let { stop: st } = B, { composed: tt } = $, { addEvent: V, createElement: _, css: N, defined: D, merge: p, pushUnique: y } = it;
      function m() {
        let u = this.scrollablePlotArea;
        (this.scrollablePixelsX || this.scrollablePixelsY) && !u && (this.scrollablePlotArea = u = new a(this)), u == null || u.applyFixed();
      }
      function w() {
        this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
      }
      class a {
        static compose(b, l, d) {
          y(tt, this.compose) && (V(b, "afterInit", w), V(l, "afterSetChartSize", (C) => this.afterSetSize(C.target, C)), V(l, "render", m), V(d, "show", w));
        }
        static afterSetSize(b, l) {
          let d, C, R, { minWidth: z, minHeight: O } = b.options.chart.scrollablePlotArea || {}, { clipBox: h, plotBox: f, inverted: s, renderer: t } = b;
          if (!t.forExport && (z ? (b.scrollablePixelsX = d = Math.max(0, z - b.chartWidth), d && (b.scrollablePlotBox = p(b.plotBox), f.width = b.plotWidth += d, h[s ? "height" : "width"] += d, R = !0)) : O && (b.scrollablePixelsY = C = Math.max(0, O - b.chartHeight), D(C) && (b.scrollablePlotBox = p(b.plotBox), f.height = b.plotHeight += C, h[s ? "width" : "height"] += C, R = !1)), D(R) && !l.skipAxes)) for (let e of b.axes) e.horiz === R && (e.setAxisSize(), e.setAxisTranslation());
        }
        constructor(b) {
          var r, g;
          let l, d = b.options.chart, C = J.getRendererType(), R = d.scrollablePlotArea || {}, z = this.moveFixedElements.bind(this), O = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
          b.scrollablePixelsX && (O.overflowX = "auto"), b.scrollablePixelsY && (O.overflowY = "auto"), this.chart = b;
          let h = this.parentDiv = _("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, b.renderTo), f = this.scrollingContainer = _("div", { className: "highcharts-scrolling" }, O, h), s = this.innerContainer = _("div", { className: "highcharts-inner-container" }, void 0, f), t = this.fixedDiv = _("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (((r = d.style) == null ? void 0 : r.zIndex) || 0) + 2, top: 0 }, void 0, !0), e = this.fixedRenderer = new C(t, b.chartWidth, b.chartHeight, d.style);
          this.mask = e.path().attr({ fill: d.backgroundColor || "#fff", "fill-opacity": (g = R.opacity) != null ? g : 0.85, zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), f.parentNode.insertBefore(t, f), N(b.renderTo, { overflow: "visible" }), V(b, "afterShowResetZoom", z), V(b, "afterApplyDrilldown", z), V(b, "afterLayOutTitles", z), V(f, "scroll", () => {
            let { pointer: o, hoverPoint: c } = b;
            o && (delete o.chartPosition, c && (l = c), o.runPointActions(void 0, l, !0));
          }), s.appendChild(b.container);
        }
        applyFixed() {
          var A;
          let { chart: b, fixedRenderer: l, isDirty: d, scrollingContainer: C } = this, { axisOffset: R, chartWidth: z, chartHeight: O, container: h, plotHeight: f, plotLeft: s, plotTop: t, plotWidth: e, scrollablePixelsX: r = 0, scrollablePixelsY: g = 0 } = b, { scrollPositionX: o = 0, scrollPositionY: c = 0 } = b.options.chart.scrollablePlotArea || {}, n = z + r, S = O + g;
          l.setSize(z, O), (d == null || d) && (this.isDirty = !1, this.moveFixedElements()), st(b.container), N(h, { width: `${n}px`, height: `${S}px` }), b.renderer.boxWrapper.attr({ width: n, height: S, viewBox: [0, 0, n, S].join(" ") }), (A = b.chartBackground) == null || A.attr({ width: n, height: S }), N(C, { width: `${z}px`, height: `${O}px` }), D(d) || (C.scrollLeft = r * o, C.scrollTop = g * c);
          let j = t - R[0] - 1, v = s - R[3] - 1, P = t + f + R[2] + 1, G = s + e + R[1] + 1, W = s + e - r, Q = t + f - g, k = [["M", 0, 0]];
          r ? k = [["M", 0, j], ["L", s - 1, j], ["L", s - 1, P], ["L", 0, P], ["Z"], ["M", W, j], ["L", z, j], ["L", z, P], ["L", W, P], ["Z"]] : g && (k = [["M", v, 0], ["L", v, t - 1], ["L", G, t - 1], ["L", G, 0], ["Z"], ["M", v, Q], ["L", v, O], ["L", G, O], ["L", G, Q], ["Z"]]), b.redrawTrigger !== "adjustHeight" && this.mask.attr({ d: k });
        }
        moveFixedElements() {
          let b, { container: l, inverted: d, scrollablePixelsX: C, scrollablePixelsY: R } = this.chart, z = this.fixedRenderer, O = a.fixedSelectors;
          for (let h of (C && !d ? b = ".highcharts-yaxis" : C && d || R && !d ? b = ".highcharts-xaxis" : R && d && (b = ".highcharts-yaxis"), b && O.push(`${b}:not(.highcharts-radial-axis)`, `${b}-labels:not(.highcharts-radial-axis-labels)`), O)) [].forEach.call(l.querySelectorAll(h), (f) => {
            (f.namespaceURI === z.SVG_NS ? z.box : z.box.parentNode).appendChild(f), f.style.pointerEvents = "auto";
          });
        }
      }
      return a.fixedSelectors = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-caption", ".highcharts-credits", ".highcharts-drillup-button", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-range-selector-group", ".highcharts-reset-zoom", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"], a;
    }), nt(i, "Core/Axis/Stacking/StackItem.js", [i["Core/Templating.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { format: it } = B, { series: st } = $, { destroyObjectProperties: tt, fireEvent: V, isNumber: _, pick: N } = J;
      return class {
        constructor(D, p, y, m, w) {
          let a = D.chart.inverted, u = D.reversed;
          this.axis = D;
          let b = this.isNegative = !!y != !!u;
          this.options = p = p || {}, this.x = m, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = w, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: p.align || (a ? b ? "left" : "right" : "center"), verticalAlign: p.verticalAlign || (a ? "middle" : b ? "bottom" : "top"), y: p.y, x: p.x }, this.textAlign = p.textAlign || (a ? b ? "right" : "left" : "center");
        }
        destroy() {
          tt(this, this.axis);
        }
        render(D) {
          let p = this.axis.chart, y = this.options, m = y.format, w = m ? it(m, this, p) : y.formatter.call(this);
          if (this.label) this.label.attr({ text: w, visibility: "hidden" });
          else {
            this.label = p.renderer.label(w, null, void 0, y.shape, void 0, void 0, y.useHTML, !1, "stack-labels");
            let a = { r: y.borderRadius || 0, text: w, padding: N(y.padding, 5), visibility: "hidden" };
            p.styledMode || (a.fill = y.backgroundColor, a.stroke = y.borderColor, a["stroke-width"] = y.borderWidth, this.label.css(y.style || {})), this.label.attr(a), this.label.added || this.label.add(D);
          }
          this.label.labelrank = p.plotSizeY, V(this, "afterRender");
        }
        setOffset(D, p, y, m, w, a) {
          let { alignOptions: u, axis: b, label: l, options: d, textAlign: C } = this, R = b.chart, z = this.getStackBox({ xOffset: D, width: p, boxBottom: y, boxTop: m, defaultX: w, xAxis: a }), { verticalAlign: O } = u;
          if (l && z) {
            let h = l.getBBox(void 0, 0), f = l.padding, s = N(d.overflow, "justify") === "justify", t;
            u.x = d.x || 0, u.y = d.y || 0;
            let { x: e, y: r } = this.adjustStackPosition({ labelBox: h, verticalAlign: O, textAlign: C });
            z.x -= e, z.y -= r, l.align(u, !1, z), (t = R.isInsidePlot(l.alignAttr.x + u.x + e, l.alignAttr.y + u.y + r)) || (s = !1), s && st.prototype.justifyDataLabel.call(b, l, u, l.alignAttr, h, z), l.attr({ x: l.alignAttr.x, y: l.alignAttr.y, rotation: d.rotation, rotationOriginX: h.width * { left: 0, center: 0.5, right: 1 }[d.textAlign || "center"], rotationOriginY: h.height / 2 }), N(!s && d.crop, !0) && (t = _(l.x) && _(l.y) && R.isInsidePlot(l.x - f + (l.width || 0), l.y) && R.isInsidePlot(l.x + f, l.y)), l[t ? "show" : "hide"]();
          }
          V(this, "afterSetOffset", { xOffset: D, width: p });
        }
        adjustStackPosition({ labelBox: D, verticalAlign: p, textAlign: y }) {
          let m = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, w = m[p], a = m[y];
          return { x: D.width / 2 + D.width / 2 * a, y: D.height / 2 * w };
        }
        getStackBox(D) {
          let p = this.axis, y = p.chart, { boxTop: m, defaultX: w, xOffset: a, width: u, boxBottom: b } = D, l = p.stacking.usePercentage ? 100 : N(m, this.total, 0), d = p.toPixels(l), C = D.xAxis || y.xAxis[0], R = N(w, C.translate(this.x)) + a, z = Math.abs(d - p.toPixels(b || _(p.min) && p.logarithmic && p.logarithmic.lin2log(p.min) || 0)), O = y.inverted, h = this.isNegative;
          return O ? { x: (h ? d : d - z) - y.plotLeft, y: C.height - R - u + C.top - y.plotTop, width: z, height: u } : { x: R + C.transB - y.plotLeft, y: (h ? d - z : d) - y.plotTop, width: u, height: z };
        }
      };
    }), nt(i, "Core/Axis/Stacking/StackingAxis.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Axis/Axis.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Axis/Stacking/StackItem.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      var tt;
      let { getDeferredAnimation: V } = B, { series: { prototype: _ } } = J, { addEvent: N, correctFloat: D, defined: p, destroyObjectProperties: y, fireEvent: m, isArray: w, isNumber: a, objectEach: u, pick: b } = st;
      function l() {
        let t = this.inverted;
        this.axes.forEach((e) => {
          e.stacking && e.stacking.stacks && e.hasVisibleSeries && (e.stacking.oldStacks = e.stacking.stacks);
        }), this.series.forEach((e) => {
          let r = e.xAxis && e.xAxis.options || {};
          e.options.stacking && e.reserveSpace() && (e.stackKey = [e.type, b(e.options.stack, ""), t ? r.top : r.left, t ? r.height : r.width].join(","));
        });
      }
      function d() {
        var e;
        let t = this.stacking;
        if (t) {
          let r = t.stacks;
          u(r, (g, o) => {
            y(g), delete r[o];
          }), (e = t.stackTotalGroup) == null || e.destroy();
        }
      }
      function C() {
        this.stacking || (this.stacking = new s(this));
      }
      function R(t, e, r, g) {
        return !p(t) || t.x !== e || g && t.stackKey !== g ? t = { x: e, index: 0, key: g, stackKey: g } : t.index++, t.key = [r, e, t.index].join(","), t;
      }
      function z() {
        let t, e = this, r = e.yAxis, g = e.stackKey || "", o = r.stacking.stacks, c = e.processedXData, n = e.options.stacking, S = e[n + "Stacker"];
        S && [g, "-" + g].forEach((j) => {
          var Q;
          let v = c.length, P, G, W;
          for (; v--; ) P = c[v], t = e.getStackIndicator(t, P, e.index, j), G = (Q = o[j]) == null ? void 0 : Q[P], (W = G == null ? void 0 : G.points[t.key || ""]) && S.call(e, W, G, v);
        });
      }
      function O(t, e, r) {
        let g = e.total ? 100 / e.total : 0;
        t[0] = D(t[0] * g), t[1] = D(t[1] * g), this.stackedYData[r] = t[1];
      }
      function h(t) {
        (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? _.setStackedPoints.call(this, t, "group") : t.stacking.resetStacks());
      }
      function f(t, e) {
        var rt, at;
        let r, g, o, c, n, S, j, v, P, G = e || this.options.stacking;
        if (!G || !this.reserveSpace() || ({ group: "xAxis" }[G] || "yAxis") !== t.coll) return;
        let W = this.processedXData, Q = this.processedYData, k = [], A = Q.length, L = this.options, Y = L.threshold || 0, x = L.startFromThreshold ? Y : 0, T = L.stack, M = e ? `${this.type},${G}` : this.stackKey || "", U = "-" + M, H = this.negStacks, q = t.stacking, F = q.stacks, et = q.oldStacks;
        for (q.stacksTouched += 1, j = 0; j < A; j++) {
          v = W[j], P = Q[j], S = (r = this.getStackIndicator(r, v, this.index)).key || "", F[n = (g = H && P < (x ? 0 : Y)) ? U : M] || (F[n] = {}), F[n][v] || ((rt = et[n]) != null && rt[v] ? (F[n][v] = et[n][v], F[n][v].total = null) : F[n][v] = new it(t, t.options.stackLabels, !!g, v, T)), o = F[n][v], P !== null ? (o.points[S] = o.points[this.index] = [b(o.cumulative, x)], p(o.cumulative) || (o.base = S), o.touched = q.stacksTouched, r.index > 0 && this.singleStacks === !1 && (o.points[S][0] = o.points[this.index + "," + v + ",0"][0])) : (delete o.points[S], delete o.points[this.index]);
          let ct = o.total || 0;
          G === "percent" ? (c = g ? M : U, ct = H && ((at = F[c]) != null && at[v]) ? (c = F[c][v]).total = Math.max(c.total || 0, ct) + Math.abs(P) || 0 : D(ct + (Math.abs(P) || 0))) : G === "group" ? (w(P) && (P = P[0]), P !== null && ct++) : ct = D(ct + (P || 0)), G === "group" ? o.cumulative = (ct || 1) - 1 : o.cumulative = D(b(o.cumulative, x) + (P || 0)), o.total = ct, P !== null && (o.points[S].push(o.cumulative), k[j] = o.cumulative, o.hasValidPoints = !0);
        }
        G === "percent" && (q.usePercentage = !0), G !== "group" && (this.stackedYData = k), q.oldStacks = {};
      }
      class s {
        constructor(e) {
          this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = e;
        }
        buildStacks() {
          let e, r, g = this.axis, o = g.series, c = g.coll === "xAxis", n = g.options.reversedStacks, S = o.length;
          for (this.resetStacks(), this.usePercentage = !1, r = S; r--; ) e = o[n ? r : S - r - 1], c && e.setGroupedPoints(g), e.setStackedPoints(g);
          if (!c) for (r = 0; r < S; r++) o[r].modifyStacks();
          m(g, "afterBuildStacks");
        }
        cleanStacks() {
          this.oldStacks && (this.stacks = this.oldStacks, u(this.stacks, (e) => {
            u(e, (r) => {
              r.cumulative = r.total;
            });
          }));
        }
        resetStacks() {
          u(this.stacks, (e) => {
            u(e, (r, g) => {
              a(r.touched) && r.touched < this.stacksTouched ? (r.destroy(), delete e[g]) : (r.total = null, r.cumulative = null);
            });
          });
        }
        renderStackTotals() {
          var S;
          let e = this.axis, r = e.chart, g = r.renderer, o = this.stacks, c = V(r, ((S = e.options.stackLabels) == null ? void 0 : S.animation) || !1), n = this.stackTotalGroup = this.stackTotalGroup || g.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
          n.translate(r.plotLeft, r.plotTop), u(o, (j) => {
            u(j, (v) => {
              v.render(n);
            });
          }), n.animate({ opacity: 1 }, c);
        }
      }
      return (tt || (tt = {})).compose = function(t, e, r) {
        let g = e.prototype, o = r.prototype;
        g.getStacks || (N(t, "init", C), N(t, "destroy", d), g.getStacks = l, o.getStackIndicator = R, o.modifyStacks = z, o.percentStacker = O, o.setGroupedPoints = h, o.setStackedPoints = f);
      }, tt;
    }), nt(i, "Series/Line/LineSeries.js", [i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { defined: it, merge: st, isObject: tt } = J;
      class V extends B {
        drawGraph() {
          let N = this.options, D = (this.gappedPath || this.getGraphPath).call(this), p = this.chart.styledMode;
          [this, ...this.zones].forEach((y, m) => {
            let w, a = y.graph, u = a ? "animate" : "attr", b = y.dashStyle || N.dashStyle;
            a ? (a.endX = this.preventGraphAnimation ? null : D.xMap, a.animate({ d: D })) : D.length && (y.graph = a = this.chart.renderer.path(D).addClass("highcharts-graph" + (m ? ` highcharts-zone-graph-${m - 1} ` : " ") + (m && y.className || "")).attr({ zIndex: 1 }).add(this.group)), a && !p && (w = { stroke: !m && N.lineColor || y.color || this.color || "#cccccc", "stroke-width": N.lineWidth || 0, fill: this.fillGraph && this.color || "none" }, b ? w.dashstyle = b : N.linecap !== "square" && (w["stroke-linecap"] = w["stroke-linejoin"] = "round"), a[u](w).shadow(m < 2 && N.shadow && st({ filterUnits: "userSpaceOnUse" }, tt(N.shadow) ? N.shadow : {}))), a && (a.startX = D.xMap, a.isArea = D.isArea);
          });
        }
        getGraphPath(N, D, p) {
          let y = this, m = y.options, w = [], a = [], u, b = m.step, l = (N = N || y.points).reversed;
          return l && N.reverse(), (b = { right: 1, center: 2 }[b] || b && 3) && l && (b = 4 - b), (N = this.getValidPoints(N, !1, !(m.connectNulls && !D && !p))).forEach(function(d, C) {
            let R, z = d.plotX, O = d.plotY, h = N[C - 1], f = d.isNull || typeof O != "number";
            (d.leftCliff || h && h.rightCliff) && !p && (u = !0), f && !it(D) && C > 0 ? u = !m.connectNulls : f && !D ? u = !0 : (C === 0 || u ? R = [["M", d.plotX, d.plotY]] : y.getPointSpline ? R = [y.getPointSpline(N, d, C)] : b ? (R = b === 1 ? [["L", h.plotX, O]] : b === 2 ? [["L", (h.plotX + z) / 2, h.plotY], ["L", (h.plotX + z) / 2, O]] : [["L", z, h.plotY]]).push(["L", z, O]) : R = [["L", z, O]], a.push(d.x), b && (a.push(d.x), b === 2 && a.push(d.x)), w.push.apply(w, R), u = !1);
          }), w.xMap = a, y.graphPath = w, w;
        }
      }
      return V.defaultOptions = st(B.defaultOptions, { legendSymbol: "lineMarker" }), $.registerSeriesType("line", V), V;
    }), nt(i, "Series/Area/AreaSeriesDefaults.js", [], function() {
      return { threshold: 0, legendSymbol: "areaMarker" };
    }), nt(i, "Series/Area/AreaSeries.js", [i["Series/Area/AreaSeriesDefaults.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { seriesTypes: { line: it } } = $, { extend: st, merge: tt, objectEach: V, pick: _ } = J;
      class N extends it {
        drawGraph() {
          this.areaPath = [], super.drawGraph.apply(this);
          let { areaPath: p, options: y } = this;
          [this, ...this.zones].forEach((m, w) => {
            var d;
            let a = {}, u = m.fillColor || y.fillColor, b = m.area, l = b ? "animate" : "attr";
            b ? (b.endX = this.preventGraphAnimation ? null : p.xMap, b.animate({ d: p })) : (a.zIndex = 0, (b = m.area = this.chart.renderer.path(p).addClass("highcharts-area" + (w ? ` highcharts-zone-area-${w - 1} ` : " ") + (w && m.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (a.fill = u || m.color || this.color, a["fill-opacity"] = u ? 1 : (d = y.fillOpacity) != null ? d : 0.75, b.css({ pointerEvents: this.stickyTracking ? "none" : "auto" })), b[l](a), b.startX = p.xMap, b.shiftUnit = y.step ? 2 : 1;
          });
        }
        getGraphPath(p) {
          let y, m, w, a = it.prototype.getGraphPath, u = this.options, b = u.stacking, l = this.yAxis, d = [], C = [], R = this.index, z = l.stacking.stacks[this.stackKey], O = u.threshold, h = Math.round(l.getThreshold(u.threshold)), f = _(u.connectNulls, b === "percent"), s = function(c, n, S) {
            let j = p[c], v = b && z[j.x].points[R], P = j[S + "Null"] || 0, G = j[S + "Cliff"] || 0, W, Q, k = !0;
            G || P ? (W = (P ? v[0] : v[1]) + G, Q = v[0] + G, k = !!P) : !b && p[n] && p[n].isNull && (W = Q = O), W !== void 0 && (C.push({ plotX: y, plotY: W === null ? h : l.getThreshold(W), isNull: k, isCliff: !0 }), d.push({ plotX: y, plotY: Q === null ? h : l.getThreshold(Q), doCurve: !1 }));
          };
          p = p || this.points, b && (p = this.getStackPoints(p));
          for (let c = 0, n = p.length; c < n; ++c) b || (p[c].leftCliff = p[c].rightCliff = p[c].leftNull = p[c].rightNull = void 0), m = p[c].isNull, y = _(p[c].rectPlotX, p[c].plotX), w = b ? _(p[c].yBottom, h) : h, m && !f || (f || s(c, c - 1, "left"), m && !b && f || (C.push(p[c]), d.push({ x: c, plotX: y, plotY: w })), f || s(c, c + 1, "right"));
          let t = a.call(this, C, !0, !0);
          d.reversed = !0;
          let e = a.call(this, d, !0, !0), r = e[0];
          r && r[0] === "M" && (e[0] = ["L", r[1], r[2]]);
          let g = t.concat(e);
          g.length && g.push(["Z"]);
          let o = a.call(this, C, !1, f);
          return this.chart.series.length > 1 && b && C.some((c) => c.isCliff) && (g.hasStackedCliffs = o.hasStackedCliffs = !0), g.xMap = t.xMap, this.areaPath = g, o;
        }
        getStackPoints(p) {
          let y = this, m = [], w = [], a = this.xAxis, u = this.yAxis, b = u.stacking.stacks[this.stackKey], l = {}, d = u.series, C = d.length, R = u.options.reversedStacks ? 1 : -1, z = d.indexOf(y);
          if (p = p || this.points, this.options.stacking) {
            for (let h = 0; h < p.length; h++) p[h].leftNull = p[h].rightNull = void 0, l[p[h].x] = p[h];
            V(b, function(h, f) {
              h.total !== null && w.push(f);
            }), w.sort(function(h, f) {
              return h - f;
            });
            let O = d.map((h) => h.visible);
            w.forEach(function(h, f) {
              let s = 0, t, e;
              if (l[h] && !l[h].isNull) m.push(l[h]), [-1, 1].forEach(function(r) {
                let g = r === 1 ? "rightNull" : "leftNull", o = b[w[f + r]], c = 0;
                if (o) {
                  let n = z;
                  for (; n >= 0 && n < C; ) {
                    let S = d[n].index;
                    !(t = o.points[S]) && (S === y.index ? l[h][g] = !0 : O[n] && (e = b[h].points[S]) && (c -= e[1] - e[0])), n += R;
                  }
                }
                l[h][r === 1 ? "rightCliff" : "leftCliff"] = c;
              });
              else {
                let r = z;
                for (; r >= 0 && r < C; ) {
                  let g = d[r].index;
                  if (t = b[h].points[g]) {
                    s = t[1];
                    break;
                  }
                  r += R;
                }
                s = _(s, 0), s = u.translate(s, 0, 1, 0, 1), m.push({ isNull: !0, plotX: a.translate(h, 0, 0, 0, 1), x: h, plotY: s, yBottom: s });
              }
            });
          }
          return m;
        }
      }
      return N.defaultOptions = tt(it.defaultOptions, B), st(N.prototype, { singleStacks: !1 }), $.registerSeriesType("area", N), N;
    }), nt(i, "Series/Spline/SplineSeries.js", [i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $) {
      let { line: J } = B.seriesTypes, { merge: it, pick: st } = $;
      class tt extends J {
        getPointSpline(_, N, D) {
          let p, y, m, w, a = N.plotX || 0, u = N.plotY || 0, b = _[D - 1], l = _[D + 1];
          function d(R) {
            return R && !R.isNull && R.doCurve !== !1 && !N.isCliff;
          }
          if (d(b) && d(l)) {
            let R = b.plotX || 0, z = b.plotY || 0, O = l.plotX || 0, h = l.plotY || 0, f = 0;
            p = (1.5 * a + R) / 2.5, y = (1.5 * u + z) / 2.5, m = (1.5 * a + O) / 2.5, w = (1.5 * u + h) / 2.5, m !== p && (f = (w - y) * (m - a) / (m - p) + u - w), y += f, w += f, y > z && y > u ? (y = Math.max(z, u), w = 2 * u - y) : y < z && y < u && (y = Math.min(z, u), w = 2 * u - y), w > h && w > u ? (w = Math.max(h, u), y = 2 * u - w) : w < h && w < u && (w = Math.min(h, u), y = 2 * u - w), N.rightContX = m, N.rightContY = w, N.controlPoints = { low: [p, y], high: [m, w] };
          }
          let C = ["C", st(b.rightContX, b.plotX, 0), st(b.rightContY, b.plotY, 0), st(p, a, 0), st(y, u, 0), a, u];
          return b.rightContX = b.rightContY = void 0, C;
        }
      }
      return tt.defaultOptions = it(J.defaultOptions), B.registerSeriesType("spline", tt), tt;
    }), nt(i, "Series/AreaSpline/AreaSplineSeries.js", [i["Series/Spline/SplineSeries.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { area: it, area: { prototype: st } } = $.seriesTypes, { extend: tt, merge: V } = J;
      class _ extends B {
      }
      return _.defaultOptions = V(B.defaultOptions, it.defaultOptions), tt(_.prototype, { getGraphPath: st.getGraphPath, getStackPoints: st.getStackPoints, drawGraph: st.drawGraph }), $.registerSeriesType("areaspline", _), _;
    }), nt(i, "Series/Column/ColumnSeriesDefaults.js", [], function() {
      return { borderRadius: 3, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
    }), nt(i, "Series/Column/ColumnSeries.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Color/Color.js"], i["Series/Column/ColumnSeriesDefaults.js"], i["Core/Globals.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V) {
      let { animObject: _ } = B, { parse: N } = $, { noop: D } = it, { clamp: p, crisp: y, defined: m, extend: w, fireEvent: a, isArray: u, isNumber: b, merge: l, pick: d, objectEach: C } = V;
      class R extends st {
        animate(O) {
          let h, f, s = this, t = this.yAxis, e = t.pos, r = t.reversed, g = s.options, { clipOffset: o, inverted: c } = this.chart, n = {}, S = c ? "translateX" : "translateY";
          O && o ? (n.scaleY = 1e-3, f = p(t.toPixels(g.threshold), e, e + t.len), c ? (f += r ? -Math.floor(o[0]) : Math.ceil(o[2]), n.translateX = f - t.len) : (f += r ? Math.ceil(o[0]) : -Math.floor(o[2]), n.translateY = f), s.clipBox && s.setClip(), s.group.attr(n)) : (h = Number(s.group.attr(S)), s.group.animate({ scaleY: 1 }, w(_(s.options.animation), { step: function(j, v) {
            s.group && (n[S] = h + v.pos * (e - h), s.group.attr(n));
          } })));
        }
        init(O, h) {
          super.init.apply(this, arguments);
          let f = this;
          (O = f.chart).hasRendered && O.series.forEach(function(s) {
            s.type === f.type && (s.isDirty = !0);
          });
        }
        getColumnMetrics() {
          var P, G;
          let O = this, h = O.options, f = O.xAxis, s = O.yAxis, t = f.options.reversedStacks, e = f.reversed && !t || !f.reversed && t, r = {}, g, o = 0;
          h.grouping === !1 ? o = 1 : O.chart.series.forEach(function(W) {
            let Q, k = W.yAxis, A = W.options;
            W.type === O.type && W.reserveSpace() && s.len === k.len && s.pos === k.pos && (A.stacking && A.stacking !== "group" ? (r[g = W.stackKey] === void 0 && (r[g] = o++), Q = r[g]) : A.grouping !== !1 && (Q = o++), W.columnIndex = Q);
          });
          let c = Math.min(Math.abs(f.transA) * (!((P = f.brokenAxis) != null && P.hasBreaks) && ((G = f.ordinal) == null ? void 0 : G.slope) || h.pointRange || f.closestPointRange || f.tickInterval || 1), f.len), n = c * h.groupPadding, S = (c - 2 * n) / (o || 1), j = Math.min(h.maxPointWidth || f.len, d(h.pointWidth, S * (1 - 2 * h.pointPadding))), v = (O.columnIndex || 0) + (e ? 1 : 0);
          return O.columnMetrics = { width: j, offset: (S - j) / 2 + (n + v * S - c / 2) * (e ? -1 : 1), paddedWidth: S, columnCount: o }, O.columnMetrics;
        }
        crispCol(O, h, f, s) {
          let t = this.borderWidth, e = this.chart.inverted;
          return s = y(h + s, t, e) - (h = y(h, t, e)), this.options.crisp && (f = y(O + f, t) - (O = y(O, t))), { x: O, y: h, width: f, height: s };
        }
        adjustForMissingColumns(O, h, f, s) {
          var t;
          if (!f.isNull && s.columnCount > 1) {
            let e = this.xAxis.series.filter((c) => c.visible).map((c) => c.index), r = 0, g = 0;
            C((t = this.xAxis.stacking) == null ? void 0 : t.stacks, (c) => {
              if (typeof f.x == "number") {
                let n = c[f.x.toString()];
                if (n && u(n.points[this.index])) {
                  let S = Object.keys(n.points).filter((j) => !j.match(",") && n.points[j] && n.points[j].length > 1).map(parseFloat).filter((j) => e.indexOf(j) !== -1).sort((j, v) => v - j);
                  r = S.indexOf(this.index), g = S.length;
                }
              }
            }), r = this.xAxis.reversed ? g - 1 - r : r;
            let o = (g - 1) * s.paddedWidth + h;
            O = (f.plotX || 0) + o / 2 - h - r * s.paddedWidth;
          }
          return O;
        }
        translate() {
          let O = this, h = O.chart, f = O.options, s = O.dense = O.closestPointRange * O.xAxis.transA < 2, t = O.borderWidth = d(f.borderWidth, s ? 0 : 1), e = O.xAxis, r = O.yAxis, g = f.threshold, o = d(f.minPointLength, 5), c = O.getColumnMetrics(), n = c.width, S = O.pointXOffset = c.offset, j = O.dataMin, v = O.dataMax, P = O.translatedThreshold = r.getThreshold(g), G = O.barW = Math.max(n, 1 + 2 * t);
          f.pointPadding && (G = Math.ceil(G)), st.prototype.translate.apply(O), O.points.forEach(function(W) {
            let Q = d(W.yBottom, P), k = 999 + Math.abs(Q), A = W.plotX || 0, L = p(W.plotY, -k, r.len + k), Y, x = Math.min(L, Q), T = Math.max(L, Q) - x, M = n, U = A + S, H = G;
            o && Math.abs(T) < o && (T = o, Y = !r.reversed && !W.negative || r.reversed && W.negative, b(g) && b(v) && W.y === g && v <= g && (r.min || 0) < g && (j !== v || (r.max || 0) <= g) && (Y = !Y, W.negative = !W.negative), x = Math.abs(x - P) > o ? Q - o : P - (Y ? o : 0)), m(W.options.pointWidth) && (U -= Math.round(((M = H = Math.ceil(W.options.pointWidth)) - n) / 2)), f.centerInCategory && !f.stacking && (U = O.adjustForMissingColumns(U, M, W, c)), W.barX = U, W.pointWidth = M, W.tooltipPos = h.inverted ? [p(r.len + r.pos - h.plotLeft - L, r.pos - h.plotLeft, r.len + r.pos - h.plotLeft), e.len + e.pos - h.plotTop - U - H / 2, T] : [e.left - h.plotLeft + U + H / 2, p(L + r.pos - h.plotTop, r.pos - h.plotTop, r.len + r.pos - h.plotTop), T], W.shapeType = O.pointClass.prototype.shapeType || "roundedRect", W.shapeArgs = O.crispCol(U, W.isNull ? P : x, H, W.isNull ? 0 : T);
          }), a(this, "afterColumnTranslate");
        }
        drawGraph() {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        }
        pointAttribs(O, h) {
          let f = this.options, s = this.pointAttrToOptions || {}, t = s.stroke || "borderColor", e = s["stroke-width"] || "borderWidth", r, g, o, c = O && O.color || this.color, n = O && O[t] || f[t] || c, S = O && O.options.dashStyle || f.dashStyle, j = O && O[e] || f[e] || this[e] || 0, v = d(O && O.opacity, f.opacity, 1);
          O && this.zones.length && (g = O.getZone(), c = O.options.color || g && (g.color || O.nonZonedColor) || this.color, g && (n = g.borderColor || n, S = g.dashStyle || S, j = g.borderWidth || j)), h && O && (o = (r = l(f.states[h], O.options.states && O.options.states[h] || {})).brightness, c = r.color || o !== void 0 && N(c).brighten(r.brightness).get() || c, n = r[t] || n, j = r[e] || j, S = r.dashStyle || S, v = d(r.opacity, v));
          let P = { fill: c, stroke: n, "stroke-width": j, opacity: v };
          return S && (P.dashstyle = S), P;
        }
        drawPoints(O = this.points) {
          let h, f = this, s = this.chart, t = f.options, e = s.renderer, r = t.animationLimit || 250;
          O.forEach(function(g) {
            let o = g.plotY, c = g.graphic, n = !!c, S = c && s.pointCount < r ? "animate" : "attr";
            b(o) && g.y !== null ? (h = g.shapeArgs, c && g.hasNewShapeType() && (c = c.destroy()), f.enabledDataSorting && (g.startXPos = f.xAxis.reversed ? -(h && h.width || 0) : f.xAxis.width), !c && (g.graphic = c = e[g.shapeType](h).add(g.group || f.group), c && f.enabledDataSorting && s.hasRendered && s.pointCount < r && (c.attr({ x: g.startXPos }), n = !0, S = "animate")), c && n && c[S](l(h)), s.styledMode || c[S](f.pointAttribs(g, g.selected && "select")).shadow(g.allowShadow !== !1 && t.shadow), c && (c.addClass(g.getClassName(), !0), c.attr({ visibility: g.visible ? "inherit" : "hidden" }))) : c && (g.graphic = c.destroy());
          });
        }
        drawTracker(O = this.points) {
          let h, f = this, s = f.chart, t = s.pointer, e = function(r) {
            let g = t == null ? void 0 : t.getPointFromEvent(r);
            t && g && f.options.enableMouseTracking && (t.isDirectTouch = !0, g.onMouseOver(r));
          };
          O.forEach(function(r) {
            h = u(r.dataLabels) ? r.dataLabels : r.dataLabel ? [r.dataLabel] : [], r.graphic && (r.graphic.element.point = r), h.forEach(function(g) {
              (g.div || g.element).point = r;
            });
          }), f._hasTracking || (f.trackerGroups.forEach(function(r) {
            f[r] && (f[r].addClass("highcharts-tracker").on("mouseover", e).on("mouseout", function(g) {
              t == null || t.onTrackerMouseOut(g);
            }).on("touchstart", e), !s.styledMode && f.options.cursor && f[r].css({ cursor: f.options.cursor }));
          }), f._hasTracking = !0), a(this, "afterDrawTracker");
        }
        remove() {
          let O = this, h = O.chart;
          h.hasRendered && h.series.forEach(function(f) {
            f.type === O.type && (f.isDirty = !0);
          }), st.prototype.remove.apply(O, arguments);
        }
      }
      return R.defaultOptions = l(st.defaultOptions, J), w(R.prototype, { directTouch: !0, getSymbol: D, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), tt.registerSeriesType("column", R), R;
    }), nt(i, "Core/Series/DataLabel.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Templating.js"], i["Core/Utilities.js"]], function(B, $, J) {
      var it;
      let { getDeferredAnimation: st } = B, { format: tt } = $, { defined: V, extend: _, fireEvent: N, isArray: D, isString: p, merge: y, objectEach: m, pick: w, pInt: a, splat: u } = J;
      return function(b) {
        function l() {
          return f(this).some((t) => t == null ? void 0 : t.enabled);
        }
        function d(t, e, r, g, o) {
          var L;
          let { chart: c, enabledDataSorting: n } = this, S = this.isCartesian && c.inverted, j = t.plotX, v = t.plotY, P = r.rotation || 0, G = V(j) && V(v) && c.isInsidePlot(j, Math.round(v), { inverted: S, paneCoordinates: !0, series: this }), W = P === 0 && w(r.overflow, n ? "none" : "justify") === "justify", Q = this.visible && t.visible !== !1 && V(j) && (t.series.forceDL || n && !W || G || w(r.inside, !!this.options.stacking) && g && c.isInsidePlot(j, S ? g.x + 1 : g.y + g.height - 1, { inverted: S, paneCoordinates: !0, series: this })), k = t.pos();
          if (Q && k) {
            var A;
            let Y = e.getBBox(), x = e.getBBox(void 0, 0), T = { right: 1, center: 0.5 }[r.align || 0] || 0, M = { bottom: 1, middle: 0.5 }[r.verticalAlign || 0] || 0;
            if (g = _({ x: k[0], y: Math.round(k[1]), width: 0, height: 0 }, g || {}), r.alignTo === "plotEdges" && this.isCartesian && (g[S ? "x" : "y"] = 0, g[S ? "width" : "height"] = ((L = this.yAxis) == null ? void 0 : L.len) || 0), _(r, { width: Y.width, height: Y.height }), A = g, n && this.xAxis && !W && this.setDataLabelStartPos(t, e, o, G, A), e.align(y(r, { width: x.width, height: x.height }), !1, g, !1), e.alignAttr.x += T * (x.width - Y.width), e.alignAttr.y += M * (x.height - Y.height), e[e.placed ? "animate" : "attr"]({ x: e.alignAttr.x + (Y.width - x.width) / 2, y: e.alignAttr.y + (Y.height - x.height) / 2, rotationOriginX: (e.width || 0) / 2, rotationOriginY: (e.height || 0) / 2 }), W && g.height >= 0) this.justifyDataLabel(e, r, e.alignAttr, Y, g, o);
            else if (w(r.crop, !0)) {
              let { x: U, y: H } = e.alignAttr;
              Q = c.isInsidePlot(U, H, { paneCoordinates: !0, series: this }) && c.isInsidePlot(U + Y.width - 1, H + Y.height - 1, { paneCoordinates: !0, series: this });
            }
            r.shape && !P && e[o ? "attr" : "animate"]({ anchorX: k[0], anchorY: k[1] });
          }
          o && n && (e.placed = !1), Q || n && !W ? (e.show(), e.placed = !0) : (e.hide(), e.placed = !1);
        }
        function C() {
          return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
        }
        function R(t) {
          let e = this.hasRendered || 0, r = this.initDataLabelsGroup().attr({ opacity: +e });
          return !e && r && (this.visible && r.show(), this.options.animation ? r.animate({ opacity: 1 }, t) : r.attr({ opacity: 1 })), r;
        }
        function z(t) {
          var Q;
          let e;
          t = t || this.points;
          let r = this, g = r.chart, o = r.options, c = g.renderer, { backgroundColor: n, plotBackgroundColor: S } = g.options.chart, j = c.getContrast(p(S) && S || p(n) && n || "#000000"), v = f(r), { animation: P, defer: G } = v[0], W = G ? st(g, P, r) : { defer: 0, duration: 0 };
          N(this, "drawDataLabels"), (Q = r.hasDataLabels) != null && Q.call(r) && (e = this.initDataLabels(W), t.forEach((k) => {
            var Y, x;
            let A = k.dataLabels || [];
            u(h(v, k.dlOptions || ((Y = k.options) == null ? void 0 : Y.dataLabels))).forEach((T, M) => {
              let U = T.enabled && (k.visible || k.dataLabelOnHidden) && (!k.isNull || k.dataLabelOnNull) && function(dt, lt) {
                let ut = lt.filter;
                if (ut) {
                  let ft = ut.operator, gt = dt[ut.property], pt = ut.value;
                  return ft === ">" && gt > pt || ft === "<" && gt < pt || ft === ">=" && gt >= pt || ft === "<=" && gt <= pt || ft === "==" && gt == pt || ft === "===" && gt === pt || ft === "!=" && gt != pt || ft === "!==" && gt !== pt;
                }
                return !0;
              }(k, T), { backgroundColor: H, borderColor: q, distance: F, style: et = {} } = T, rt, at, ct, Z, X = {}, K = A[M], ot = !K, ht;
              U && (at = w(T[k.formatPrefix + "Format"], T.format), rt = k.getLabelConfig(), ct = V(at) ? tt(at, rt, g) : (T[k.formatPrefix + "Formatter"] || T.formatter).call(rt, T), Z = T.rotation, !g.styledMode && (et.color = w(T.color, et.color, p(r.color) ? r.color : void 0, "#000000"), et.color === "contrast" ? (H !== "none" && (ht = H), k.contrastColor = c.getContrast(ht !== "auto" && ht || k.color || r.color), et.color = ht || !V(F) && T.inside || 0 > a(F || 0) || o.stacking ? k.contrastColor : j) : delete k.contrastColor, o.cursor && (et.cursor = o.cursor)), X = { r: T.borderRadius || 0, rotation: Z, padding: T.padding, zIndex: 1 }, g.styledMode || (X.fill = H === "auto" ? k.color : H, X.stroke = q === "auto" ? k.color : q, X["stroke-width"] = T.borderWidth), m(X, (dt, lt) => {
                dt === void 0 && delete X[lt];
              })), !K || U && V(ct) && !!K.div == !!T.useHTML && (K.rotation && T.rotation || K.rotation === T.rotation) || (K = void 0, ot = !0), U && V(ct) && (K ? X.text = ct : (K = c.label(ct, 0, 0, T.shape, void 0, void 0, T.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + k.colorIndex + " " + (T.className || "") + (T.useHTML ? " highcharts-tracker" : "")), K && (K.options = T, K.attr(X), g.styledMode ? et.width && K.css({ width: et.width, textOverflow: et.textOverflow }) : K.css(et).shadow(T.shadow), N(K, "beforeAddingDataLabel", { labelOptions: T, point: k }), K.added || K.add(e), r.alignDataLabel(k, K, T, void 0, ot), K.isActive = !0, A[M] && A[M] !== K && A[M].destroy(), A[M] = K));
            });
            let L = A.length;
            for (; L--; ) A[L] && A[L].isActive ? A[L].isActive = !1 : ((x = A[L]) == null || x.destroy(), A.splice(L, 1));
            k.dataLabel = A[0], k.dataLabels = A;
          })), N(this, "afterDrawDataLabels");
        }
        function O(t, e, r, g, o, c) {
          let n = this.chart, S = e.align, j = e.verticalAlign, v = t.box ? 0 : t.padding || 0, P = n.inverted ? this.yAxis : this.xAxis, G = P ? P.left - n.plotLeft : 0, W = n.inverted ? this.xAxis : this.yAxis, Q = W ? W.top - n.plotTop : 0, { x: k = 0, y: A = 0 } = e, L, Y;
          return (L = (r.x || 0) + v + G) < 0 && (S === "right" && k >= 0 ? (e.align = "left", e.inside = !0) : k -= L, Y = !0), (L = (r.x || 0) + g.width - v + G) > n.plotWidth && (S === "left" && k <= 0 ? (e.align = "right", e.inside = !0) : k += n.plotWidth - L, Y = !0), (L = r.y + v + Q) < 0 && (j === "bottom" && A >= 0 ? (e.verticalAlign = "top", e.inside = !0) : A -= L, Y = !0), (L = (r.y || 0) + g.height - v + Q) > n.plotHeight && (j === "top" && A <= 0 ? (e.verticalAlign = "bottom", e.inside = !0) : A += n.plotHeight - L, Y = !0), Y && (e.x = k, e.y = A, t.placed = !c, t.align(e, void 0, o)), Y;
        }
        function h(t, e) {
          let r = [], g;
          if (D(t) && !D(e)) r = t.map(function(o) {
            return y(o, e);
          });
          else if (D(e) && !D(t)) r = e.map(function(o) {
            return y(t, o);
          });
          else if (D(t) || D(e)) {
            if (D(t) && D(e)) for (g = Math.max(t.length, e.length); g--; ) r[g] = y(t[g], e[g]);
          } else r = y(t, e);
          return r;
        }
        function f(t) {
          var r, g;
          let e = t.chart.options.plotOptions;
          return u(h(h((r = e == null ? void 0 : e.series) == null ? void 0 : r.dataLabels, (g = e == null ? void 0 : e[t.type]) == null ? void 0 : g.dataLabels), t.options.dataLabels));
        }
        function s(t, e, r, g, o) {
          let c = this.chart, n = c.inverted, S = this.xAxis, j = S.reversed, v = ((n ? e.height : e.width) || 0) / 2, P = t.pointWidth, G = P ? P / 2 : 0;
          e.startXPos = n ? o.x : j ? -v - G : S.width - v + G, e.startYPos = n ? j ? this.yAxis.height - v + G : -v - G : o.y, g ? e.visibility === "hidden" && (e.show(), e.attr({ opacity: 0 }).animate({ opacity: 1 })) : e.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, e.hide), c.hasRendered && (r && e.attr({ x: e.startXPos, y: e.startYPos }), e.placed = !0);
        }
        b.compose = function(t) {
          let e = t.prototype;
          e.initDataLabels || (e.initDataLabels = R, e.initDataLabelsGroup = C, e.alignDataLabel = d, e.drawDataLabels = z, e.justifyDataLabel = O, e.setDataLabelStartPos = s, e.hasDataLabels = l);
        };
      }(it || (it = {})), it;
    }), nt(i, "Series/Column/ColumnDataLabel.js", [i["Core/Series/DataLabel.js"], i["Core/Globals.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J, it) {
      var st;
      let { composed: tt } = $, { series: V } = J, { merge: _, pick: N, pushUnique: D } = it;
      return function(p) {
        function y(m, w, a, u, b) {
          let l = this.chart.inverted, d = m.series, C = (d.xAxis ? d.xAxis.len : this.chart.plotSizeX) || 0, R = (d.yAxis ? d.yAxis.len : this.chart.plotSizeY) || 0, z = m.dlBox || m.shapeArgs, O = N(m.below, m.plotY > N(this.translatedThreshold, R)), h = N(a.inside, !!this.options.stacking);
          if (z) {
            if (u = _(z), !(a.overflow === "allow" && a.crop === !1)) {
              u.y < 0 && (u.height += u.y, u.y = 0);
              let f = u.y + u.height - R;
              f > 0 && f < u.height - 1 && (u.height -= f);
            }
            l && (u = { x: R - u.y - u.height, y: C - u.x - u.width, width: u.height, height: u.width }), h || (l ? (u.x += O ? 0 : u.width, u.width = 0) : (u.y += O ? u.height : 0, u.height = 0));
          }
          a.align = N(a.align, !l || h ? "center" : O ? "right" : "left"), a.verticalAlign = N(a.verticalAlign, l || h ? "middle" : O ? "top" : "bottom"), V.prototype.alignDataLabel.call(this, m, w, a, u, b), a.inside && m.contrastColor && w.css({ color: m.contrastColor });
        }
        p.compose = function(m) {
          B.compose(V), D(tt, "ColumnDataLabel") && (m.prototype.alignDataLabel = y);
        };
      }(st || (st = {})), st;
    }), nt(i, "Series/Bar/BarSeries.js", [i["Series/Column/ColumnSeries.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { extend: it, merge: st } = J;
      class tt extends B {
      }
      return tt.defaultOptions = st(B.defaultOptions, {}), it(tt.prototype, { inverted: !0 }), $.registerSeriesType("bar", tt), tt;
    }), nt(i, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
      return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
    }), nt(i, "Series/Scatter/ScatterSeries.js", [i["Series/Scatter/ScatterSeriesDefaults.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { column: it, line: st } = $.seriesTypes, { addEvent: tt, extend: V, merge: _ } = J;
      class N extends st {
        applyJitter() {
          let p = this, y = this.options.jitter, m = this.points.length;
          y && this.points.forEach(function(w, a) {
            ["x", "y"].forEach(function(u, b) {
              if (y[u] && !w.isNull) {
                let l = `plot${u.toUpperCase()}`, d = p[`${u}Axis`], C = y[u] * d.transA;
                if (d && !d.logarithmic) {
                  let R = Math.max(0, (w[l] || 0) - C), z = Math.min(d.len, (w[l] || 0) + C);
                  w[l] = R + (z - R) * function(O) {
                    let h = 1e4 * Math.sin(O);
                    return h - Math.floor(h);
                  }(a + b * m), u === "x" && (w.clientX = w.plotX);
                }
              }
            });
          });
        }
        drawGraph() {
          this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
        }
      }
      return N.defaultOptions = _(st.defaultOptions, B), V(N.prototype, { drawTracker: it.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"] }), tt(N, "afterTranslate", function() {
        this.applyJitter();
      }), $.registerSeriesType("scatter", N), N;
    }), nt(i, "Series/CenteredUtilities.js", [i["Core/Globals.js"], i["Core/Series/Series.js"], i["Core/Utilities.js"]], function(B, $, J) {
      var it, st;
      let { deg2rad: tt } = B, { fireEvent: V, isNumber: _, pick: N, relativeLength: D } = J;
      return (st = it || (it = {})).getCenter = function() {
        let p = this.options, y = this.chart, m = 2 * (p.slicedOffset || 0), w = y.plotWidth - 2 * m, a = y.plotHeight - 2 * m, u = p.center, b = Math.min(w, a), l = p.thickness, d, C = p.size, R = p.innerSize || 0, z, O;
        typeof C == "string" && (C = parseFloat(C)), typeof R == "string" && (R = parseFloat(R));
        let h = [N(u[0], "50%"), N(u[1], "50%"), N(C && C < 0 ? void 0 : p.size, "100%"), N(R && R < 0 ? void 0 : p.innerSize || 0, "0%")];
        for (!y.angular || this instanceof $ || (h[3] = 0), z = 0; z < 4; ++z) O = h[z], d = z < 2 || z === 2 && /%$/.test(O), h[z] = D(O, [w, a, b, h[2]][z]) + (d ? m : 0);
        return h[3] > h[2] && (h[3] = h[2]), _(l) && 2 * l < h[2] && l > 0 && (h[3] = h[2] - 2 * l), V(this, "afterGetCenter", { positions: h }), h;
      }, st.getStartAndEndRadians = function(p, y) {
        let m = _(p) ? p : 0, w = _(y) && y > m && y - m < 360 ? y : m + 360;
        return { start: tt * (m + -90), end: tt * (w + -90) };
      }, it;
    }), nt(i, "Series/Pie/PiePoint.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Series/Point.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { setAnimation: it } = B, { addEvent: st, defined: tt, extend: V, isNumber: _, pick: N, relativeLength: D } = J;
      class p extends $ {
        getConnectorPath(m) {
          let w = m.dataLabelPosition, a = m.options || {}, u = a.connectorShape, b = this.connectorShapes[u] || u;
          return w && b.call(this, { ...w.computed, alignment: w.alignment }, w.connectorPosition, a) || [];
        }
        getTranslate() {
          return this.sliced && this.slicedTranslation || { translateX: 0, translateY: 0 };
        }
        haloPath(m) {
          let w = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(w.x, w.y, w.r + m, w.r + m, { innerR: w.r - 1, start: w.start, end: w.end, borderRadius: w.borderRadius });
        }
        constructor(m, w, a) {
          var b;
          super(m, w, a), this.half = 0, (b = this.name) != null || (this.name = "Slice");
          let u = (l) => {
            this.slice(l.type === "select");
          };
          st(this, "select", u), st(this, "unselect", u);
        }
        isValid() {
          return _(this.y) && this.y >= 0;
        }
        setVisible(m, w = !0) {
          m !== this.visible && this.update({ visible: m != null ? m : !this.visible }, w, void 0, !1);
        }
        slice(m, w, a) {
          let u = this.series;
          it(a, u.chart), w = N(w, !0), this.sliced = this.options.sliced = m = tt(m) ? m : !this.sliced, u.options.data[u.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
        }
      }
      return V(p.prototype, { connectorShapes: { fixedOffset: function(y, m, w) {
        let a = m.breakAt, u = m.touchingSliceAt, b = w.softConnector ? ["C", y.x + (y.alignment === "left" ? -5 : 5), y.y, 2 * a.x - u.x, 2 * a.y - u.y, a.x, a.y] : ["L", a.x, a.y];
        return [["M", y.x, y.y], b, ["L", u.x, u.y]];
      }, straight: function(y, m) {
        let w = m.touchingSliceAt;
        return [["M", y.x, y.y], ["L", w.x, w.y]];
      }, crookedLine: function(y, m, w) {
        let { breakAt: a, touchingSliceAt: u } = m, { series: b } = this, [l, d, C] = b.center, R = C / 2, { plotLeft: z, plotWidth: O } = b.chart, h = y.alignment === "left", { x: f, y: s } = y, t = a.x;
        if (w.crookDistance) {
          let r = D(w.crookDistance, 1);
          t = h ? l + R + (O + z - l - R) * (1 - r) : z + (l - R) * r;
        } else t = l + (d - s) * Math.tan((this.angle || 0) - Math.PI / 2);
        let e = [["M", f, s]];
        return (h ? t <= f && t >= a.x : t >= f && t <= a.x) && e.push(["L", t, s]), e.push(["L", a.x, a.y], ["L", u.x, u.y]), e;
      } } }), p;
    }), nt(i, "Series/Pie/PieSeriesDefaults.js", [], function() {
      return { borderRadius: 3, center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { connectorPadding: 5, connectorShape: "crookedLine", crookDistance: void 0, distance: 30, enabled: !0, formatter: function() {
        return this.point.isNull ? void 0 : this.point.name;
      }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
    }), nt(i, "Series/Pie/PieSeries.js", [i["Series/CenteredUtilities.js"], i["Series/Column/ColumnSeries.js"], i["Core/Globals.js"], i["Series/Pie/PiePoint.js"], i["Series/Pie/PieSeriesDefaults.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Renderer/SVG/Symbols.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _, N) {
      let { getStartAndEndRadians: D } = B, { noop: p } = J, { clamp: y, extend: m, fireEvent: w, merge: a, pick: u } = N;
      class b extends tt {
        animate(d) {
          let C = this, R = C.points, z = C.startAngleRad;
          d || R.forEach(function(O) {
            let h = O.graphic, f = O.shapeArgs;
            h && f && (h.attr({ r: u(O.startR, C.center && C.center[3] / 2), start: z, end: z }), h.animate({ r: f.r, start: f.start, end: f.end }, C.options.animation));
          });
        }
        drawEmpty() {
          let d, C, R = this.startAngleRad, z = this.endAngleRad, O = this.options;
          this.total === 0 && this.center ? (d = this.center[0], C = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(d, C, this.center[1] / 2, 0, R, z).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: _.arc(d, C, this.center[2] / 2, 0, { start: R, end: z, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": O.borderWidth, fill: O.fillColor || "none", stroke: O.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
        }
        drawPoints() {
          let d = this.chart.renderer;
          this.points.forEach(function(C) {
            C.graphic && C.hasNewShapeType() && (C.graphic = C.graphic.destroy()), C.graphic || (C.graphic = d[C.shapeType](C.shapeArgs).add(C.series.group), C.delayedRendering = !0);
          });
        }
        generatePoints() {
          super.generatePoints(), this.updateTotals();
        }
        getX(d, C, R, z) {
          let O = this.center, h = this.radii ? this.radii[R.index] || 0 : O[2] / 2, f = z.dataLabelPosition, s = (f == null ? void 0 : f.distance) || 0, t = Math.asin(y((d - O[1]) / (h + s), -1, 1));
          return O[0] + Math.cos(t) * (h + s) * (C ? -1 : 1) + (s > 0 ? (C ? -1 : 1) * (z.padding || 0) : 0);
        }
        hasData() {
          return !!this.processedXData.length;
        }
        redrawPoints() {
          let d, C, R, z, O = this, h = O.chart;
          this.drawEmpty(), O.group && !h.styledMode && O.group.shadow(O.options.shadow), O.points.forEach(function(f) {
            let s = {};
            C = f.graphic, !f.isNull && C ? (z = f.shapeArgs, d = f.getTranslate(), h.styledMode || (R = O.pointAttribs(f, f.selected && "select")), f.delayedRendering ? (C.setRadialReference(O.center).attr(z).attr(d), h.styledMode || C.attr(R).attr({ "stroke-linejoin": "round" }), f.delayedRendering = !1) : (C.setRadialReference(O.center), h.styledMode || a(!0, s, R), a(!0, s, z, d), C.animate(s)), C.attr({ visibility: f.visible ? "inherit" : "hidden" }), C.addClass(f.getClassName(), !0)) : C && (f.graphic = C.destroy());
          });
        }
        sortByAngle(d, C) {
          d.sort(function(R, z) {
            return R.angle !== void 0 && (z.angle - R.angle) * C;
          });
        }
        translate(d) {
          w(this, "translate"), this.generatePoints();
          let C = this.options, R = C.slicedOffset, z = D(C.startAngle, C.endAngle), O = this.startAngleRad = z.start, h = (this.endAngleRad = z.end) - O, f = this.points, s = C.ignoreHiddenPoint, t = f.length, e, r, g, o, c, n, S, j = 0;
          for (d || (this.center = d = this.getCenter()), n = 0; n < t; n++) {
            S = f[n], e = O + j * h, S.isValid() && (!s || S.visible) && (j += S.percentage / 100), r = O + j * h;
            let v = { x: d[0], y: d[1], r: d[2] / 2, innerR: d[3] / 2, start: Math.round(1e3 * e) / 1e3, end: Math.round(1e3 * r) / 1e3 };
            S.shapeType = "arc", S.shapeArgs = v, (g = (r + e) / 2) > 1.5 * Math.PI ? g -= 2 * Math.PI : g < -Math.PI / 2 && (g += 2 * Math.PI), S.slicedTranslation = { translateX: Math.round(Math.cos(g) * R), translateY: Math.round(Math.sin(g) * R) }, o = Math.cos(g) * d[2] / 2, c = Math.sin(g) * d[2] / 2, S.tooltipPos = [d[0] + 0.7 * o, d[1] + 0.7 * c], S.half = g < -Math.PI / 2 || g > Math.PI / 2 ? 1 : 0, S.angle = g;
          }
          w(this, "afterTranslate");
        }
        updateTotals() {
          let d = this.points, C = d.length, R = this.options.ignoreHiddenPoint, z, O, h = 0;
          for (z = 0; z < C; z++) (O = d[z]).isValid() && (!R || O.visible) && (h += O.y);
          for (z = 0, this.total = h; z < C; z++) (O = d[z]).percentage = h > 0 && (O.visible || !R) ? O.y / h * 100 : 0, O.total = h;
        }
      }
      return b.defaultOptions = a(tt.defaultOptions, st), m(b.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawTracker: $.prototype.drawTracker, getCenter: B.getCenter, getSymbol: p, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointAttribs: $.prototype.pointAttribs, pointClass: it, requireSorting: !1, searchPoint: p, trackerGroups: ["group", "dataLabelsGroup"] }), V.registerSeriesType("pie", b), b;
    }), nt(i, "Series/Pie/PieDataLabel.js", [i["Core/Series/DataLabel.js"], i["Core/Globals.js"], i["Core/Renderer/RendererUtilities.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      var tt;
      let { composed: V, noop: _ } = $, { distribute: N } = J, { series: D } = it, { arrayMax: p, clamp: y, defined: m, pick: w, pushUnique: a, relativeLength: u } = st;
      return function(b) {
        let l = { radialDistributionY: function(O, h) {
          var f;
          return (((f = h.dataLabelPosition) == null ? void 0 : f.top) || 0) + O.distributeBox.pos;
        }, radialDistributionX: function(O, h, f, s, t) {
          let e = t.dataLabelPosition;
          return O.getX(f < ((e == null ? void 0 : e.top) || 0) + 2 || f > ((e == null ? void 0 : e.bottom) || 0) - 2 ? s : f, h.half, h, t);
        }, justify: function(O, h, f, s) {
          var t;
          return s[0] + (O.half ? -1 : 1) * (f + (((t = h.dataLabelPosition) == null ? void 0 : t.distance) || 0));
        }, alignToPlotEdges: function(O, h, f, s) {
          let t = O.getBBox().width;
          return h ? t + s : f - t - s;
        }, alignToConnectors: function(O, h, f, s) {
          let t = 0, e;
          return O.forEach(function(r) {
            (e = r.dataLabel.getBBox().width) > t && (t = e);
          }), h ? t + s : f - t - s;
        } };
        function d(O, h) {
          let { center: f, options: s } = this, t = f[2] / 2, e = O.angle || 0, r = Math.cos(e), g = Math.sin(e), o = f[0] + r * t, c = f[1] + g * t, n = Math.min((s.slicedOffset || 0) + (s.borderWidth || 0), h / 5);
          return { natural: { x: o + r * h, y: c + g * h }, computed: {}, alignment: h < 0 ? "center" : O.half ? "right" : "left", connectorPosition: { breakAt: { x: o + r * n, y: c + g * n }, touchingSliceAt: { x: o, y: c } }, distance: h };
        }
        function C() {
          var Q;
          let O = this, h = O.points, f = O.chart, s = f.plotWidth, t = f.plotHeight, e = f.plotLeft, r = Math.round(f.chartWidth / 3), g = O.center, o = g[2] / 2, c = g[1], n = [[], []], S = [0, 0, 0, 0], j = O.dataLabelPositioners, v, P, G, W = 0;
          O.visible && ((Q = O.hasDataLabels) != null && Q.call(O)) && (h.forEach((k) => {
            (k.dataLabels || []).forEach((A) => {
              A.shortened && (A.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), A.shortened = !1);
            });
          }), D.prototype.drawDataLabels.apply(O), h.forEach((k) => {
            (k.dataLabels || []).forEach((A, L) => {
              var M;
              let Y = g[2] / 2, x = A.options, T = u((x == null ? void 0 : x.distance) || 0, Y);
              L === 0 && n[k.half].push(k), !m((M = x == null ? void 0 : x.style) == null ? void 0 : M.width) && A.getBBox().width > r && (A.css({ width: Math.round(0.7 * r) + "px" }), A.shortened = !0), A.dataLabelPosition = this.getDataLabelPosition(k, T), W = Math.max(W, T);
            });
          }), n.forEach((k, A) => {
            let L = k.length, Y = [], x, T, M = 0, U;
            L && (O.sortByAngle(k, A - 0.5), W > 0 && (x = Math.max(0, c - o - W), T = Math.min(c + o + W, f.plotHeight), k.forEach((H) => {
              (H.dataLabels || []).forEach((q) => {
                var et;
                let F = q.dataLabelPosition;
                F && F.distance > 0 && (F.top = Math.max(0, c - o - F.distance), F.bottom = Math.min(c + o + F.distance, f.plotHeight), M = q.getBBox().height || 21, q.lineHeight = f.renderer.fontMetrics(q.text || q).h + 2 * q.padding, H.distributeBox = { target: (((et = q.dataLabelPosition) == null ? void 0 : et.natural.y) || 0) - F.top + q.lineHeight / 2, size: M, rank: H.y }, Y.push(H.distributeBox));
              });
            }), N(Y, U = T + M - x, U / 5)), k.forEach((H) => {
              (H.dataLabels || []).forEach((q) => {
                let F = q.options || {}, et = H.distributeBox, rt = q.dataLabelPosition, at = (rt == null ? void 0 : rt.natural.y) || 0, ct = F.connectorPadding || 0, Z = q.lineHeight || 21, X = (Z - q.getBBox().height) / 2, K = 0, ot = at, ht = "inherit";
                if (rt) {
                  if (Y && m(et) && rt.distance > 0 && (et.pos === void 0 ? ht = "hidden" : (G = et.size, ot = j.radialDistributionY(H, q))), F.justify) K = j.justify(H, q, o, g);
                  else switch (F.alignTo) {
                    case "connectors":
                      K = j.alignToConnectors(k, A, s, e);
                      break;
                    case "plotEdges":
                      K = j.alignToPlotEdges(q, A, s, e);
                      break;
                    default:
                      K = j.radialDistributionX(O, H, ot - X, at, q);
                  }
                  if (rt.attribs = { visibility: ht, align: rt.alignment }, rt.posAttribs = { x: K + (F.x || 0) + ({ left: ct, right: -ct }[rt.alignment] || 0), y: ot + (F.y || 0) - Z / 2 }, rt.computed.x = K, rt.computed.y = ot - X, w(F.crop, !0)) {
                    let dt;
                    K - (P = q.getBBox().width) < ct && A === 1 ? (dt = Math.round(P - K + ct), S[3] = Math.max(dt, S[3])) : K + P > s - ct && A === 0 && (dt = Math.round(K + P - s + ct), S[1] = Math.max(dt, S[1])), ot - G / 2 < 0 ? S[0] = Math.max(Math.round(-ot + G / 2), S[0]) : ot + G / 2 > t && (S[2] = Math.max(Math.round(ot + G / 2 - t), S[2])), rt.sideOverflow = dt;
                  }
                }
              });
            }));
          }), (p(S) === 0 || this.verifyDataLabelOverflow(S)) && (this.placeDataLabels(), this.points.forEach((k) => {
            (k.dataLabels || []).forEach((A) => {
              var T;
              let { connectorColor: L, connectorWidth: Y = 1 } = A.options || {}, x = A.dataLabelPosition;
              if (Y) {
                let M;
                v = A.connector, x && x.distance > 0 ? (M = !v, v || (A.connector = v = f.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + k.colorIndex + (k.className ? " " + k.className : "")).add(O.dataLabelsGroup)), f.styledMode || v.attr({ "stroke-width": Y, stroke: L || k.color || "#666666" }), v[M ? "attr" : "animate"]({ d: k.getConnectorPath(A) }), v.attr({ visibility: (T = x.attribs) == null ? void 0 : T.visibility })) : v && (A.connector = v.destroy());
              }
            });
          })));
        }
        function R() {
          this.points.forEach((O) => {
            (O.dataLabels || []).forEach((h) => {
              var s;
              let f = h.dataLabelPosition;
              f ? (f.sideOverflow && (h.css({ width: Math.max(h.getBBox().width - f.sideOverflow, 0) + "px", textOverflow: (((s = h.options) == null ? void 0 : s.style) || {}).textOverflow || "ellipsis" }), h.shortened = !0), h.attr(f.attribs), h[h.moved ? "animate" : "attr"](f.posAttribs), h.moved = !0) : h && h.attr({ y: -9999 });
            }), delete O.distributeBox;
          }, this);
        }
        function z(O) {
          let h = this.center, f = this.options, s = f.center, t = f.minSize || 80, e = t, r = f.size !== null;
          return !r && (s[0] !== null ? e = Math.max(h[2] - Math.max(O[1], O[3]), t) : (e = Math.max(h[2] - O[1] - O[3], t), h[0] += (O[3] - O[1]) / 2), s[1] !== null ? e = y(e, t, h[2] - Math.max(O[0], O[2])) : (e = y(e, t, h[2] - O[0] - O[2]), h[1] += (O[0] - O[2]) / 2), e < h[2] ? (h[2] = e, h[3] = Math.min(f.thickness ? Math.max(0, e - 2 * f.thickness) : Math.max(0, u(f.innerSize || 0, e)), e), this.translate(h), this.drawDataLabels && this.drawDataLabels()) : r = !0), r;
        }
        b.compose = function(O) {
          if (B.compose(D), a(V, "PieDataLabel")) {
            let h = O.prototype;
            h.dataLabelPositioners = l, h.alignDataLabel = _, h.drawDataLabels = C, h.getDataLabelPosition = d, h.placeDataLabels = R, h.verifyDataLabelOverflow = z;
          }
        };
      }(tt || (tt = {})), tt;
    }), nt(i, "Core/Geometry/GeometryUtilities.js", [], function() {
      var B, $;
      return ($ = B || (B = {})).getCenterOfPoints = function(J) {
        let it = J.reduce((st, tt) => (st.x += tt.x, st.y += tt.y, st), { x: 0, y: 0 });
        return { x: it.x / J.length, y: it.y / J.length };
      }, $.getDistanceBetweenPoints = function(J, it) {
        return Math.sqrt(Math.pow(it.x - J.x, 2) + Math.pow(it.y - J.y, 2));
      }, $.getAngleBetweenPoints = function(J, it) {
        return Math.atan2(it.x - J.x, it.y - J.y);
      }, $.pointInPolygon = function({ x: J, y: it }, st) {
        let tt = st.length, V, _, N = !1;
        for (V = 0, _ = tt - 1; V < tt; _ = V++) {
          let [D, p] = st[V], [y, m] = st[_];
          p > it != m > it && J < (y - D) * (it - p) / (m - p) + D && (N = !N);
        }
        return N;
      }, B;
    }), nt(i, "Extensions/OverlappingDataLabels.js", [i["Core/Geometry/GeometryUtilities.js"], i["Core/Utilities.js"]], function(B, $) {
      let { pointInPolygon: J } = B, { addEvent: it, fireEvent: st, objectEach: tt, pick: V } = $;
      function _(p) {
        let y = p.length, m = (R, z) => !(z.x >= R.x + R.width || z.x + z.width <= R.x || z.y >= R.y + R.height || z.y + z.height <= R.y), w = (R, z) => {
          for (let O of R) if (J({ x: O[0], y: O[1] }, z)) return !0;
          return !1;
        }, a, u, b, l, d, C = !1;
        for (let R = 0; R < y; R++) (a = p[R]) && (a.oldOpacity = a.opacity, a.newOpacity = 1, a.absoluteBox = function(z) {
          var O, h;
          if (z && (!z.alignAttr || z.placed)) {
            let f = z.box ? 0 : z.padding || 0, s = z.alignAttr || { x: z.attr("x"), y: z.attr("y") }, t = z.getBBox();
            return z.width = t.width, z.height = t.height, { x: s.x + (((O = z.parentGroup) == null ? void 0 : O.translateX) || 0) + f, y: s.y + (((h = z.parentGroup) == null ? void 0 : h.translateY) || 0) + f, width: (z.width || 0) - 2 * f, height: (z.height || 0) - 2 * f, polygon: t == null ? void 0 : t.polygon };
          }
        }(a));
        p.sort((R, z) => (z.labelrank || 0) - (R.labelrank || 0));
        for (let R = 0; R < y; ++R) {
          l = (u = p[R]) && u.absoluteBox;
          let z = l == null ? void 0 : l.polygon;
          for (let O = R + 1; O < y; ++O) {
            d = (b = p[O]) && b.absoluteBox;
            let h = !1;
            if (l && d && u !== b && u.newOpacity !== 0 && b.newOpacity !== 0 && u.visibility !== "hidden" && b.visibility !== "hidden") {
              let f = d.polygon;
              if (z && f && z !== f ? w(z, f) && (h = !0) : m(l, d) && (h = !0), h) {
                let s = u.labelrank < b.labelrank ? u : b, t = s.text;
                s.newOpacity = 0, t != null && t.element.querySelector("textPath") && t.hide();
              }
            }
          }
        }
        for (let R of p) N(R, this) && (C = !0);
        C && st(this, "afterHideAllOverlappingLabels");
      }
      function N(p, y) {
        let m, w, a = !1;
        return p && (w = p.newOpacity, p.oldOpacity !== w && (p.hasClass("highcharts-data-label") ? (p[w ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), m = function() {
          y.styledMode || p.css({ pointerEvents: w ? "auto" : "none" });
        }, a = !0, p[p.isOld ? "animate" : "attr"]({ opacity: w }, void 0, m), st(y, "afterHideOverlappingLabel")) : p.attr({ opacity: w })), p.isOld = !0), a;
      }
      function D() {
        var m;
        let p = this, y = [];
        for (let w of p.labelCollectors || []) y = y.concat(w());
        for (let w of p.yAxis || []) w.stacking && w.options.stackLabels && !w.options.stackLabels.allowOverlap && tt(w.stacking.stacks, (a) => {
          tt(a, (u) => {
            u.label && y.push(u.label);
          });
        });
        for (let w of p.series || []) if (w.visible && ((m = w.hasDataLabels) != null && m.call(w))) {
          let a = (u) => {
            for (let b of u) b.visible && (b.dataLabels || []).forEach((l) => {
              var C, R;
              let d = l.options || {};
              l.labelrank = V(d.labelrank, b.labelrank, (C = b.shapeArgs) == null ? void 0 : C.height), ((R = d.allowOverlap) != null ? R : Number(d.distance) > 0) ? (l.oldOpacity = l.opacity, l.newOpacity = 1, N(l, p)) : y.push(l);
            });
          };
          a(w.nodes || []), a(w.points);
        }
        this.hideOverlappingLabels(y);
      }
      return { compose: function(p) {
        let y = p.prototype;
        y.hideOverlappingLabels || (y.hideOverlappingLabels = _, it(p, "render", D));
      } };
    }), nt(i, "Extensions/BorderRadius.js", [i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { defaultOptions: it } = B, { noop: st } = $, { addEvent: tt, extend: V, isObject: _, merge: N, relativeLength: D } = J, p = { radius: 0, scope: "stack", where: void 0 }, y = st, m = st;
      function w(d, C, R, z, O = {}) {
        let h = y(d, C, R, z, O), { innerR: f = 0, r: s = R, start: t = 0, end: e = 0 } = O;
        if (O.open || !O.borderRadius) return h;
        let r = e - t, g = Math.sin(r / 2), o = Math.max(Math.min(D(O.borderRadius || 0, s - f), (s - f) / 2, s * g / (1 + g)), 0), c = Math.min(o, r / Math.PI * 2 * f), n = h.length - 1;
        for (; n--; ) (function(S, j, v) {
          let P, G, W, Q = S[j], k = S[j + 1];
          if (k[0] === "Z" && (k = S[0]), (Q[0] === "M" || Q[0] === "L") && k[0] === "A" ? (P = Q, G = k, W = !0) : Q[0] === "A" && (k[0] === "M" || k[0] === "L") && (P = k, G = Q), P && G && G.params) {
            let A = G[1], L = G[5], Y = G.params, { start: x, end: T, cx: M, cy: U } = Y, H = L ? A - v : A + v, q = H ? Math.asin(v / H) : 0, F = L ? q : -q, et = Math.cos(q) * H;
            W ? (Y.start = x + F, P[1] = M + et * Math.cos(x), P[2] = U + et * Math.sin(x), S.splice(j + 1, 0, ["A", v, v, 0, 0, 1, M + A * Math.cos(Y.start), U + A * Math.sin(Y.start)])) : (Y.end = T - F, G[6] = M + A * Math.cos(Y.end), G[7] = U + A * Math.sin(Y.end), S.splice(j + 1, 0, ["A", v, v, 0, 0, 1, M + et * Math.cos(T), U + et * Math.sin(T)])), G[4] = Math.abs(Y.end - Y.start) < Math.PI ? 0 : 1;
          }
        })(h, n, n > 1 ? c : o);
        return h;
      }
      function a() {
        var d, C;
        if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
          let { options: R, yAxis: z } = this, O = R.stacking === "percent", h = (C = (d = it.plotOptions) == null ? void 0 : d[this.type]) == null ? void 0 : C.borderRadius, f = u(R.borderRadius, _(h) ? h : {}), s = z.options.reversed;
          for (let t of this.points) {
            let { shapeArgs: e } = t;
            if (t.shapeType === "roundedRect" && e) {
              let { width: r = 0, height: g = 0, y: o = 0 } = e, c = o, n = g;
              if (f.scope === "stack" && t.stackTotal) {
                let P = z.translate(O ? 100 : t.stackTotal, !1, !0, !1, !0), G = z.translate(R.threshold || 0, !1, !0, !1, !0), W = this.crispCol(0, Math.min(P, G), 0, Math.abs(P - G));
                c = W.y, n = W.height;
              }
              let S = (t.negative ? -1 : 1) * (s ? -1 : 1) == -1, j = f.where;
              !j && this.is("waterfall") && Math.abs((t.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (j = "all"), j || (j = "end");
              let v = Math.min(D(f.radius, r), r / 2, j === "all" ? g / 2 : 1 / 0) || 0;
              j === "end" && (S && (c -= v), n += v), V(e, { brBoxHeight: n, brBoxY: c, r: v });
            }
          }
        }
      }
      function u(d, C) {
        return _(d) || (d = { radius: d || 0 }), N(p, C, d);
      }
      function b() {
        let d = u(this.options.borderRadius);
        for (let C of this.points) {
          let R = C.shapeArgs;
          R && (R.borderRadius = D(d.radius, (R.r || 0) - (R.innerR || 0)));
        }
      }
      function l(d, C, R, z, O = {}) {
        let h = m(d, C, R, z, O), { r: f = 0, brBoxHeight: s = z, brBoxY: t = C } = O, e = C - t, r = t + s - (C + z), g = e - f > -0.1 ? 0 : f, o = r - f > -0.1 ? 0 : f, c = Math.max(g && e, 0), n = Math.max(o && r, 0), S = [d + g, C], j = [d + R - g, C], v = [d + R, C + g], P = [d + R, C + z - o], G = [d + R - o, C + z], W = [d + o, C + z], Q = [d, C + z - o], k = [d, C + g], A = (L, Y) => Math.sqrt(Math.pow(L, 2) - Math.pow(Y, 2));
        if (c) {
          let L = A(g, g - c);
          S[0] -= L, j[0] += L, v[1] = k[1] = C + g - c;
        }
        if (z < g - c) {
          let L = A(g, g - c - z);
          v[0] = P[0] = d + R - g + L, G[0] = Math.min(v[0], G[0]), W[0] = Math.max(P[0], W[0]), Q[0] = k[0] = d + g - L, v[1] = k[1] = C + z;
        }
        if (n) {
          let L = A(o, o - n);
          G[0] += L, W[0] -= L, P[1] = Q[1] = C + z - o + n;
        }
        if (z < o - n) {
          let L = A(o, o - n - z);
          v[0] = P[0] = d + R - o + L, j[0] = Math.min(v[0], j[0]), S[0] = Math.max(P[0], S[0]), Q[0] = k[0] = d + o - L, P[1] = Q[1] = C;
        }
        return h.length = 0, h.push(["M", ...S], ["L", ...j], ["A", g, g, 0, 0, 1, ...v], ["L", ...P], ["A", o, o, 0, 0, 1, ...G], ["L", ...W], ["A", o, o, 0, 0, 1, ...Q], ["L", ...k], ["A", g, g, 0, 0, 1, ...S], ["Z"]), h;
      }
      return { compose: function(d, C, R) {
        let z = d.types.pie;
        if (!C.symbolCustomAttribs.includes("borderRadius")) {
          let O = R.prototype.symbols;
          tt(d, "afterColumnTranslate", a, { order: 9 }), tt(z, "afterTranslate", b), C.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), y = O.arc, m = O.roundedRect, O.arc = w, O.roundedRect = l;
        }
      }, optionsToObject: u };
    }), nt(i, "Core/Responsive.js", [i["Core/Utilities.js"]], function(B) {
      var $;
      let { diffObjects: J, extend: it, find: st, merge: tt, pick: V, uniqueKey: _ } = B;
      return function(N) {
        function D(y, m) {
          let w = y.condition;
          (w.callback || function() {
            return this.chartWidth <= V(w.maxWidth, Number.MAX_VALUE) && this.chartHeight <= V(w.maxHeight, Number.MAX_VALUE) && this.chartWidth >= V(w.minWidth, 0) && this.chartHeight >= V(w.minHeight, 0);
          }).call(this) && m.push(y._id);
        }
        function p(y, m) {
          let w = this.options.responsive, a = this.currentResponsive, u = [], b;
          !m && w && w.rules && w.rules.forEach((C) => {
            C._id === void 0 && (C._id = _()), this.matchResponsiveRule(C, u);
          }, this);
          let l = tt(...u.map((C) => st((w || {}).rules || [], (R) => R._id === C)).map((C) => C && C.chartOptions));
          l.isResponsiveOptions = !0, u = u.toString() || void 0;
          let d = a && a.ruleIds;
          u === d || (a && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(a.undoOptions, y, !0), this.updatingResponsive = !1), u ? ((b = J(l, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: u, mergedOptions: l, undoOptions: b }, this.updatingResponsive || this.update(l, y, !0)) : this.currentResponsive = void 0);
        }
        N.compose = function(y) {
          let m = y.prototype;
          return m.matchResponsiveRule || it(m, { matchResponsiveRule: D, setResponsive: p }), y;
        };
      }($ || ($ = {})), $;
    }), nt(i, "masters/highcharts.src.js", [i["Core/Globals.js"], i["Core/Utilities.js"], i["Core/Defaults.js"], i["Core/Animation/Fx.js"], i["Core/Animation/AnimationUtilities.js"], i["Core/Renderer/HTML/AST.js"], i["Core/Templating.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Renderer/RendererUtilities.js"], i["Core/Renderer/SVG/SVGElement.js"], i["Core/Renderer/SVG/SVGRenderer.js"], i["Core/Renderer/HTML/HTMLElement.js"], i["Core/Axis/Axis.js"], i["Core/Axis/DateTimeAxis.js"], i["Core/Axis/LogarithmicAxis.js"], i["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], i["Core/Axis/Tick.js"], i["Core/Tooltip.js"], i["Core/Series/Point.js"], i["Core/Pointer.js"], i["Core/Legend/Legend.js"], i["Core/Legend/LegendSymbol.js"], i["Core/Chart/Chart.js"], i["Extensions/ScrollablePlotArea.js"], i["Core/Axis/Stacking/StackingAxis.js"], i["Core/Axis/Stacking/StackItem.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Series/Column/ColumnDataLabel.js"], i["Series/Pie/PieDataLabel.js"], i["Core/Series/DataLabel.js"], i["Extensions/OverlappingDataLabels.js"], i["Extensions/BorderRadius.js"], i["Core/Responsive.js"], i["Core/Color/Color.js"], i["Core/Time.js"]], function(B, $, J, it, st, tt, V, _, N, D, p, y, m, w, a, u, b, l, d, C, R, z, O, h, f, s, t, e, r, g, o, c, n, S, j, v) {
      return B.AST = tt, B.Axis = m, B.Chart = O, B.Color = j, B.DataLabel = o, B.Fx = it, B.HTMLElement = y, B.Legend = R, B.LegendSymbol = z, B.OverlappingDataLabels = B.OverlappingDataLabels || c, B.PlotLineOrBand = u, B.Point = d, B.Pointer = C, B.RendererRegistry = _, B.Series = t, B.SeriesRegistry = e, B.StackItem = s, B.SVGElement = D, B.SVGRenderer = p, B.Templating = V, B.Tick = b, B.Time = v, B.Tooltip = l, B.animate = st.animate, B.animObject = st.animObject, B.chart = O.chart, B.color = j.parse, B.dateFormat = V.dateFormat, B.defaultOptions = J.defaultOptions, B.distribute = N.distribute, B.format = V.format, B.getDeferredAnimation = st.getDeferredAnimation, B.getOptions = J.getOptions, B.numberFormat = V.numberFormat, B.seriesType = e.seriesType, B.setAnimation = st.setAnimation, B.setOptions = J.setOptions, B.stop = st.stop, B.time = J.defaultTime, B.timers = it.timers, n.compose(B.Series, B.SVGElement, B.SVGRenderer), r.compose(B.Series.types.column), o.compose(B.Series), w.compose(B.Axis), y.compose(B.SVGRenderer), R.compose(B.Chart), a.compose(B.Axis), c.compose(B.Chart), g.compose(B.Series.types.pie), u.compose(B.Chart, B.Axis), C.compose(B.Chart), S.compose(B.Chart), h.compose(B.Axis, B.Chart, B.Series), f.compose(B.Axis, B.Chart, B.Series), l.compose(B.Pointer), $.extend(B, $), B;
    }), i["masters/highcharts.src.js"]._modules = i, i["masters/highcharts.src.js"];
  });
})(_i);
var Qt = _i.exports;
const bi = /* @__PURE__ */ ce(Qt), Bs = $e`/**
 * @license Highcharts
 *
 * (c) 2009-2022 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */:root,.highcharts-light{--highcharts-color-0: #2caffe;--highcharts-color-1: #544fc5;--highcharts-color-2: #00e272;--highcharts-color-3: #fe6a35;--highcharts-color-4: #6b8abc;--highcharts-color-5: #d568fb;--highcharts-color-6: #2ee0ca;--highcharts-color-7: #fa4b42;--highcharts-color-8: #feb56a;--highcharts-color-9: #91e8e1;--highcharts-background-color: #ffffff;--highcharts-neutral-color-100: #000000;--highcharts-neutral-color-80: #333333;--highcharts-neutral-color-60: #666666;--highcharts-neutral-color-40: #999999;--highcharts-neutral-color-20: #cccccc;--highcharts-neutral-color-10: #e6e6e6;--highcharts-neutral-color-5: #f2f2f2;--highcharts-neutral-color-3: #f7f7f7;--highcharts-highlight-color-100: #0022ff;--highcharts-highlight-color-80: #334eff;--highcharts-highlight-color-60: #667aff;--highcharts-highlight-color-20: #ccd3ff;--highcharts-highlight-color-10: #e6e9ff;--highcharts-positive-color: #06b535;--highcharts-negative-color: #f21313;--highcharts-annotation-color-0: rgba(130, 170, 255, .4);--highcharts-annotation-color-1: rgba(139, 191, 216, .4);--highcharts-annotation-color-2: rgba(150, 216, 192, .4);--highcharts-annotation-color-3: rgba(156, 229, 161, .4);--highcharts-annotation-color-4: rgba(162, 241, 130, .4);--highcharts-annotation-color-5: rgba(169, 255, 101, .4)}@media (prefers-color-scheme: dark){:root{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}}.highcharts-dark{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}.highcharts-container{position:relative;overflow:hidden;width:100%;height:100%;text-align:left;line-height:normal;z-index:0;-webkit-tap-highlight-color:rgba(0,0,0,0);font-family:Helvetica,Arial,sans-serif;font-size:1rem;-webkit-user-select:none;user-select:none;touch-action:manipulation;outline:none}.highcharts-no-touch-action{touch-action:none}.highcharts-root{display:block}.highcharts-root text{stroke-width:0}.highcharts-strong{font-weight:700}.highcharts-emphasized{font-style:italic}.highcharts-anchor{cursor:pointer}.highcharts-background{fill:var(--highcharts-background-color)}.highcharts-plot-border,.highcharts-plot-background,.highcharts-label-box{fill:none}.highcharts-label text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-box{fill:inherit}.highcharts-tracker-line{stroke-linejoin:round;stroke:#c0c0c000;stroke-width:22;fill:none}.highcharts-tracker-area{fill:#c0c0c000;stroke-width:0}.highcharts-title{fill:var(--highcharts-neutral-color-80);font-size:1.2em;font-weight:700}.highcharts-subtitle{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-line{fill:none;stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-axis-line{stroke-width:0}.highcharts-axis-title{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-labels{fill:var(--highcharts-neutral-color-80);cursor:default;font-size:.8em}.highcharts-grid-line{fill:none;stroke:var(--highcharts-neutral-color-10)}.highcharts-xaxis-grid .highcharts-grid-line{stroke-width:0}.highcharts-tick{stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-tick{stroke-width:0}.highcharts-minor-grid-line{stroke:var(--highcharts-neutral-color-5)}.highcharts-crosshair-thin{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}.highcharts-crosshair-category{stroke:var(--highcharts-highlight-color-20);stroke-opacity:.25}.highcharts-credits{cursor:pointer;fill:var(--highcharts-neutral-color-40);font-size:.6em;transition:fill .25s,font-size .25s}.highcharts-credits:hover{fill:var(--highcharts-neutral-color-100);font-size:.7em}.highcharts-tooltip{cursor:default;pointer-events:none;white-space:nowrap;transition:stroke .15s}.highcharts-tooltip .highcharts-tracker{fill:none;stroke:none}.highcharts-tooltip text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-tooltip .highcharts-header{font-size:.8em}.highcharts-tooltip-box{stroke-width:1px;fill:var(--highcharts-background-color)}.highcharts-tooltip-box{stroke-width:0;fill:var(--highcharts-background-color)}.highcharts-tooltip-box .highcharts-label-box{fill:var(--highcharts-background-color)}div.highcharts-tooltip{filter:none;font-size:.8em}.highcharts-selection-marker{fill:var(--highcharts-highlight-color-80);fill-opacity:.25}.highcharts-graph{fill:none;stroke-width:2px;stroke-linecap:round;stroke-linejoin:round}.highcharts-empty-series{stroke-width:1px;fill:none;stroke:var(--highcharts-neutral-color-20)}.highcharts-state-hover .highcharts-graph{stroke-width:3}.highcharts-point-inactive,.highcharts-series-inactive{opacity:.2;transition:opacity 50ms}.highcharts-state-hover path{transition:stroke-width 50ms}.highcharts-state-normal path{transition:stroke-width .25s}g.highcharts-series,.highcharts-point,.highcharts-markers,.highcharts-data-labels{transition:opacity .25s}.highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),.highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover,.highcharts-point-select),.highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),.highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover){opacity:.2}.highcharts-color-0{fill:var(--highcharts-color-0);stroke:var(--highcharts-color-0)}.highcharts-color-1{fill:var(--highcharts-color-1);stroke:var(--highcharts-color-1)}.highcharts-color-2{fill:var(--highcharts-color-2);stroke:var(--highcharts-color-2)}.highcharts-color-3{fill:var(--highcharts-color-3);stroke:var(--highcharts-color-3)}.highcharts-color-4{fill:var(--highcharts-color-4);stroke:var(--highcharts-color-4)}.highcharts-color-5{fill:var(--highcharts-color-5);stroke:var(--highcharts-color-5)}.highcharts-color-6{fill:var(--highcharts-color-6);stroke:var(--highcharts-color-6)}.highcharts-color-7{fill:var(--highcharts-color-7);stroke:var(--highcharts-color-7)}.highcharts-color-8{fill:var(--highcharts-color-8);stroke:var(--highcharts-color-8)}.highcharts-color-9{fill:var(--highcharts-color-9);stroke:var(--highcharts-color-9)}.highcharts-area{fill-opacity:.75;stroke-width:0}.highcharts-markers{stroke-width:1px;stroke:var(--highcharts-background-color)}.highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover,.highcharts-a11y-marker-visible),.highcharts-a11y-marker-hidden{opacity:0}.highcharts-point{stroke-width:1px}.highcharts-dense-data .highcharts-point{stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{font-size:.7em;font-weight:700}.highcharts-data-label-box{fill:none;stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{fill:var(--highcharts-neutral-color-80)}.highcharts-data-label-connector{fill:none}.highcharts-data-label-hidden{pointer-events:none}.highcharts-halo{fill-opacity:.25;stroke-width:0}.highcharts-series-label text{fill:inherit;font-weight:700}.highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,.highcharts-markers .highcharts-point-select{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-100)}.highcharts-column-series path.highcharts-point,.highcharts-bar-series path.highcharts-point{stroke:var(--highcharts-background-color)}.highcharts-column-series .highcharts-point{transition:fill-opacity .25s}.highcharts-column-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pie-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pie-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-funnel-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-pyramid-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pyramid-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pyramid-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-solidgauge-series .highcharts-point{stroke-width:0}.highcharts-treemap-series .highcharts-point{stroke-width:1px;stroke:var(--highcharts-neutral-color-10);transition:stroke .25s,fill .25s,fill-opacity .25s}.highcharts-treemap-series .highcharts-point-hover{stroke:var(--highcharts-neutral-color-40);transition:stroke 25ms,fill 25ms,fill-opacity 25ms}.highcharts-treemap-series .highcharts-above-level{display:none}.highcharts-treemap-series .highcharts-internal-node{fill:none}.highcharts-treemap-series .highcharts-internal-node-interactive{fill-opacity:.15;cursor:pointer}.highcharts-treemap-series .highcharts-internal-node-interactive:hover{fill-opacity:.75}.highcharts-vector-series .highcharts-point,.highcharts-windbarb-series .highcharts-point{fill:none;stroke-width:2px}.highcharts-lollipop-stem{stroke:var(--highcharts-neutral-color-100)}.highcharts-focus-border{fill:none;stroke-width:2px}.highcharts-legend-item-hidden .highcharts-focus-border{fill:none!important}.highcharts-legend-box{fill:none;stroke-width:0}.highcharts-legend-item>text{fill:var(--highcharts-neutral-color-80);font-weight:700;font-size:.8em;cursor:pointer;stroke-width:0}.highcharts-legend-item:hover text{fill:var(--highcharts-neutral-color-100)}.highcharts-legend-item-hidden *{fill:var(--highcharts-neutral-color-60)!important;stroke:var(--highcharts-neutral-color-60)!important;transition:fill .25s;text-decoration:line-through}.highcharts-legend-nav-active{fill:var(--highcharts-highlight-color-100);cursor:pointer}.highcharts-legend-nav-inactive{fill:var(--highcharts-neutral-color-20)}circle.highcharts-legend-nav-active,circle.highcharts-legend-nav-inactive{fill:#c0c0c000}.highcharts-legend-title-box{fill:none;stroke-width:0}.highcharts-bubble-legend-symbol{stroke-width:2;fill-opacity:.5}.highcharts-bubble-legend-connectors{stroke-width:1}.highcharts-bubble-legend-labels{fill:var(--highcharts-neutral-color-80);font-size:.7em}.highcharts-loading{position:absolute;background-color:var(--highcharts-background-color);opacity:.5;text-align:center;z-index:10;transition:opacity .25s}.highcharts-loading-hidden{height:0!important;opacity:0;overflow:hidden;transition:opacity .25s,height .25s step-end}.highcharts-loading-inner{font-weight:700;position:relative;top:45%}.highcharts-plot-band,.highcharts-pane{fill:var(--highcharts-neutral-color-100);fill-opacity:.05}.highcharts-plot-line{fill:none;stroke:var(--highcharts-neutral-color-40);stroke-width:1px}.highcharts-plot-line-label{font-size:.8em}.highcharts-boxplot-box{fill:var(--highcharts-background-color)}.highcharts-boxplot-median{stroke-width:2px}.highcharts-bubble-series .highcharts-point{fill-opacity:.5}.highcharts-errorbar-series .highcharts-point{stroke:var(--highcharts-neutral-color-100)}.highcharts-gauge-series .highcharts-data-label-box{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-gauge-series .highcharts-dial{fill:var(--highcharts-neutral-color-100);stroke-width:0}.highcharts-polygon-series .highcharts-graph{fill:inherit;stroke-width:0}.highcharts-waterfall-series .highcharts-graph{stroke:var(--highcharts-neutral-color-80);stroke-dasharray:1,3}.highcharts-sankey-series .highcharts-point{stroke-width:0}.highcharts-sankey-series .highcharts-link{transition:fill .25s,fill-opacity .25s;fill-opacity:.5}.highcharts-sankey-series .highcharts-point-hover.highcharts-link{transition:fill 50ms,fill-opacity 50ms;fill-opacity:1}.highcharts-venn-series .highcharts-point{fill-opacity:.75;stroke:var(--highcharts-neutral-color-20);transition:stroke .25s,fill-opacity .25s}.highcharts-venn-series .highcharts-point-hover{fill-opacity:1;stroke:var(--highcharts-neutral-color-20)}.highcharts-timeline-series .highcharts-graph{stroke:var(--highcharts-neutral-color-20)}.highcharts-navigator-mask-outside{fill-opacity:0}.highcharts-navigator-mask-inside{fill:var(--highcharts-highlight-color-60);fill-opacity:.25;cursor:ew-resize}.highcharts-navigator-outline{stroke:var(--highcharts-neutral-color-40);fill:none}.highcharts-navigator-handle{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-neutral-color-5);cursor:ew-resize}.highcharts-navigator-series{fill:var(--highcharts-highlight-color-80);stroke:var(--highcharts-highlight-color-80)}.highcharts-navigator-series .highcharts-graph{stroke-width:1px}.highcharts-navigator-series .highcharts-area{fill-opacity:.05}.highcharts-navigator-xaxis .highcharts-axis-line{stroke-width:0}.highcharts-navigator-xaxis .highcharts-grid-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-10)}.highcharts-navigator-xaxis.highcharts-axis-labels{fill:var(--highcharts-neutral-color-100);font-size:.7em;opacity:.6}.highcharts-navigator-yaxis .highcharts-grid-line{stroke-width:0}.highcharts-scrollbar-thumb{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-20);stroke-width:0}.highcharts-scrollbar-button{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-scrollbar-arrow{fill:var(--highcharts-neutral-color-60)}.highcharts-scrollbar-rifles{stroke:none;stroke-width:1px}.highcharts-scrollbar-track{fill:#fff0;stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-button{fill:var(--highcharts-neutral-color-3);stroke:var(--highcharts-neutral-color-20);cursor:default;stroke-width:1px;transition:fill .25s}.highcharts-button text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-hover{transition:fill 0ms;fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-hover text{fill:var(--highcharts-neutral-color-80)}.highcharts-button-pressed{font-weight:700;fill:var(--highcharts-highlight-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-pressed text{fill:var(--highcharts-neutral-color-80);font-weight:700}.highcharts-button-disabled text{fill:var(--highcharts-neutral-color-80)}.highcharts-range-selector-buttons .highcharts-button{stroke-width:0}.highcharts-range-label rect{fill:none}.highcharts-range-label text{fill:var(--highcharts-neutral-color-60)}.highcharts-range-input rect{fill:none}.highcharts-range-input text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-range-input{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}input.highcharts-range-selector{position:absolute;border:0;width:1px;height:1px;padding:0;text-align:center;left:-9em}.highcharts-crosshair-label text{fill:var(--highcharts-background-color);font-size:1.7em}.highcharts-crosshair-label .highcharts-label-box{fill:inherit}.highcharts-candlestick-series .highcharts-point{stroke:var(--highcharts-neutral-color-100);stroke-width:1px}.highcharts-candlestick-series .highcharts-point-up{fill:var(--highcharts-background-color)}.highcharts-hollowcandlestick-series .highcharts-point-down{fill:var(--highcharts-negative-color);stroke:var(--highcharts-negative-color)}.highcharts-hollowcandlestick-series .highcharts-point-down-bearish-up{fill:var(--highcharts-positive-color);stroke:var(--highcharts-positive-color)}.highcharts-hollowcandlestick-series .highcharts-point-up{fill:transparent;stroke:var(--highcharts-positive-color)}.highcharts-ohlc-series .highcharts-point-hover{stroke-width:3px}.highcharts-flags-series .highcharts-point .highcharts-label-box{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-background-color);transition:fill .25s}.highcharts-flags-series .highcharts-point-hover .highcharts-label-box{stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-highlight-color-20)}.highcharts-flags-series .highcharts-point text{fill:var(--highcharts-neutral-color-100);font-size:.9em;font-weight:700}.highcharts-map-series .highcharts-point{transition:fill .5s,fill-opacity .5s,stroke-width .25s;stroke:var(--highcharts-neutral-color-20);stroke-width:inherit}.highcharts-map-series .highcharts-point-hover{transition:fill 0ms,fill-opacity 0ms;fill-opacity:.5}.highcharts-mapline-series .highcharts-point{fill:none}.highcharts-heatmap-series .highcharts-point{stroke-width:0}.highcharts-map-navigation{font-size:1.3em;font-weight:700;text-align:center}.highcharts-map-navigation.highcharts-button{fill:var(--highcharts-background-color);stroke:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button:hover{fill:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button .highcharts-button-symbol{stroke-width:2px}.highcharts-mapview-inset-border{stroke:var(--highcharts-neutral-color-20);stroke-width:1px;fill:none}.highcharts-coloraxis{stroke-width:0}.highcharts-coloraxis-marker{fill:var(--highcharts-neutral-color-40)}.highcharts-null-point{fill:var(--highcharts-neutral-color-3)}.highcharts-3d-frame{fill:transparent}.highcharts-contextbutton{fill:var(--highcharts-background-color);stroke:none;stroke-linecap:round}.highcharts-contextbutton:hover{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-10)}.highcharts-button-symbol{stroke:var(--highcharts-neutral-color-60);stroke-width:3px}.highcharts-menu{border:none;background:var(--highcharts-background-color);border-radius:3px;padding:.5em;box-shadow:3px 3px 10px #888}.highcharts-menu-item{background:none;border-radius:3px;color:var(--highcharts-neutral-color-80);cursor:pointer;font-size:.8em;list-style-type:none;padding:.5em;transition:background .25s,color .25s}.highcharts-menu-item:hover{background:var(--highcharts-neutral-color-5)}.highcharts-breadcrumbs-button{fill:none;stroke-width:0;cursor:pointer}.highcharts-breadcrumbs-separator{fill:var(--highcharts-neutral-color-60)}.highcharts-drilldown-point{cursor:pointer}.highcharts-drilldown-data-label text,text.highcharts-drilldown-data-label,.highcharts-drilldown-axis-label{cursor:pointer;fill:var(--highcharts-highlight-color-100);font-weight:700;text-decoration:underline}.highcharts-no-data text{font-weight:700;font-size:.8em;fill:var(--highcharts-neutral-color-60)}.highcharts-axis-resizer{cursor:ns-resize;stroke:var(--highcharts-neutral-color-100);stroke-width:2px}.highcharts-bullet-target{stroke-width:0}.highcharts-lineargauge-target,.highcharts-lineargauge-target-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-80)}.highcharts-fibonacci-background-0,.highcharts-pitchfork-inner-background,.highcharts-measure-background{fill:var(--highcharts-annotation-color-0)}.highcharts-fibonacci-background-1{fill:var(--highcharts-annotation-color-1)}.highcharts-fibonacci-background-2{fill:var(--highcharts-annotation-color-2)}.highcharts-fibonacci-background-3,.highcharts-pitchfork-outer-background{fill:var(--highcharts-annotation-color-3)}.highcharts-fibonacci-background-4{fill:var(--highcharts-annotation-color-4)}.highcharts-fibonacci-background-5{fill:var(--highcharts-annotation-color-5)}.highcharts-fibonacci-line{stroke:var(--highcharts-neutral-color-40)}.highcharts-crooked-lines,.highcharts-tunnel-lines,.highcharts-infinity-lines,.highcharts-timecycles-lines,.highcharts-fibonacci-timezones-lines,.highcharts-pitchfork-lines,.highcharts-vertical-line,.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke:var(--highcharts-neutral-color-100);stroke-opacity:.75;fill:none}.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke-dasharray:1,3}.highcharts-tunnel-background{fill:var(--highcharts-color-0)}.highcharts-annotation-shapes{cursor:move}.highcharts-basic-shape{fill:var(--highcharts-neutral-color-100);stroke:var(--highcharts-neutral-color-100);opacity:.74}.highcharts-annotation-label-box{stroke-width:1px;stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-neutral-color-100);fill-opacity:.75}.highcharts-annotation-label text{fill:var(--highcharts-neutral-color-10);font-size:.8em}.highcharts-a11y-proxy-element{border-width:0;background-color:transparent;cursor:pointer;outline:none;opacity:.001;z-index:999;overflow:hidden;padding:0;margin:0;display:block;position:absolute}.highcharts-a11y-proxy-group li{list-style:none}.highcharts-visually-hidden{position:absolute;width:1px;height:1px;overflow:hidden;white-space:nowrap;clip:rect(1px,1px,1px,1px);margin-top:-3px;opacity:.01}.highcharts-a11y-invisible{visibility:hidden}.highcharts-a11y-proxy-container,.highcharts-a11y-proxy-container-before,.highcharts-a11y-proxy-container-after{position:absolute;white-space:nowrap}g.highcharts-series,.highcharts-markers,.highcharts-point{outline:none}.highcharts-treegrid-node-collapsed,.highcharts-treegrid-node-expanded{cursor:pointer}.highcharts-point-connecting-path{fill:none}.highcharts-grid-axis .highcharts-tick,.highcharts-grid-axis .highcharts-axis-line{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}`;
var $i = { exports: {} };
(function(E) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Accessibility module
  *
  * (c) 2010-2024 Highsoft AS
  * Author: Oystein Moseng
  *
  * License: www.highcharts.com/license
  */
  (function(I) {
    E.exports ? (I.default = I, E.exports = I) : I(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(I) {
    var i = I ? I._modules : {};
    function nt(B, $, J, it) {
      B.hasOwnProperty($) || (B[$] = it.apply(null, J), typeof CustomEvent == "function" && I.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: $, module: B[$] } })));
    }
    nt(i, "Accessibility/Utils/HTMLUtilities.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let { doc: J, win: it } = B, { css: st } = $, tt = it.EventTarget && new it.EventTarget() || "none";
      function V(N) {
        if (typeof it.MouseEvent == "function") return new it.MouseEvent(N.type, N);
        if (J.createEvent) {
          let D = J.createEvent("MouseEvent");
          if (D.initMouseEvent) return D.initMouseEvent(N.type, N.bubbles, N.cancelable, N.view || it, N.detail, N.screenX, N.screenY, N.clientX, N.clientY, N.ctrlKey, N.altKey, N.shiftKey, N.metaKey, N.button, N.relatedTarget), D;
        }
        return _(N.type);
      }
      function _(N, D, p) {
        let y = D || { x: 0, y: 0 };
        if (typeof it.MouseEvent == "function") return new it.MouseEvent(N, { bubbles: !0, cancelable: !0, composed: !0, button: 0, buttons: 1, relatedTarget: p || tt, view: it, detail: N === "click" ? 1 : 0, screenX: y.x, screenY: y.y, clientX: y.x, clientY: y.y });
        if (J.createEvent) {
          let m = J.createEvent("MouseEvent");
          if (m.initMouseEvent) return m.initMouseEvent(N, !0, !0, it, N === "click" ? 1 : 0, y.x, y.y, y.x, y.y, !1, !1, !1, !1, 0, null), m;
        }
        return { type: N };
      }
      return { addClass: function(N, D) {
        N.classList ? N.classList.add(D) : 0 > N.className.indexOf(D) && (N.className += " " + D);
      }, cloneMouseEvent: V, cloneTouchEvent: function(N) {
        let D = (y) => {
          let m = [];
          for (let w = 0; w < y.length; ++w) {
            let a = y.item(w);
            a && m.push(a);
          }
          return m;
        };
        if (typeof it.TouchEvent == "function") {
          let y = new it.TouchEvent(N.type, { touches: D(N.touches), targetTouches: D(N.targetTouches), changedTouches: D(N.changedTouches), ctrlKey: N.ctrlKey, shiftKey: N.shiftKey, altKey: N.altKey, metaKey: N.metaKey, bubbles: N.bubbles, cancelable: N.cancelable, composed: N.composed, detail: N.detail, view: N.view });
          return N.defaultPrevented && y.preventDefault(), y;
        }
        let p = V(N);
        return p.touches = N.touches, p.changedTouches = N.changedTouches, p.targetTouches = N.targetTouches, p;
      }, escapeStringForHTML: function(N) {
        return N.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
      }, getElement: function(N) {
        return J.getElementById(N);
      }, getFakeMouseEvent: _, getHeadingTagNameForElement: function(N) {
        let D = (w) => "h" + Math.min(6, parseInt(w.slice(1), 10) + 1), p = (w) => /^H[1-6]$/i.test(w), y = (w) => {
          let a = w;
          for (; a = a.previousSibling; ) {
            let u = a.tagName || "";
            if (p(u)) return u;
          }
          return "";
        }, m = (w) => {
          let a = y(w);
          if (a) return D(a);
          let u = w.parentElement;
          if (!u) return "p";
          let b = u.tagName;
          return p(b) ? D(b) : m(u);
        };
        return m(N);
      }, removeChildNodes: function(N) {
        for (; N.lastChild; ) N.removeChild(N.lastChild);
      }, removeClass: function(N, D) {
        N.classList ? N.classList.remove(D) : N.className = N.className.replace(RegExp(D, "g"), "");
      }, removeElement: function(N) {
        N && N.parentNode && N.parentNode.removeChild(N);
      }, reverseChildNodes: function(N) {
        let D = N.childNodes.length;
        for (; D--; ) N.appendChild(N.childNodes[D]);
      }, simulatedEventTarget: tt, stripHTMLTagsFromString: function(N, D = !1) {
        return typeof N == "string" ? D ? N.replace(/<\/?[^>]+(>|$)/g, "") : N.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : N;
      }, visuallyHideElement: function(N) {
        st(N, { position: "absolute", width: "1px", height: "1px", overflow: "hidden", whiteSpace: "nowrap", clip: "rect(1px, 1px, 1px, 1px)", marginTop: "-3px", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)", filter: "alpha(opacity=1)", opacity: 0.01 });
      } };
    }), nt(i, "Accessibility/A11yI18n.js", [i["Core/Templating.js"], i["Core/Utilities.js"]], function(B, $) {
      var J;
      let { format: it } = B, { getNestedProperty: st, pick: tt } = $;
      return function(V) {
        function _(D, p, y) {
          let m = (l, d) => {
            let C = l.slice(d || 0), R = C.indexOf("{"), z = C.indexOf("}");
            if (R > -1 && z > R) return { statement: C.substring(R + 1, z), begin: d + R + 1, end: d + z };
          }, w = [], a, u, b = 0;
          do
            a = m(D, b), (u = D.substring(b, a && a.begin - 1)).length && w.push({ value: u, type: "constant" }), a && w.push({ value: a.statement, type: "statement" }), b = a ? a.end + 1 : b + 1;
          while (a);
          return w.forEach((l) => {
            l.type === "statement" && (l.value = function(d, C) {
              let R, z, O = d.indexOf("#each("), h = d.indexOf("#plural("), f = d.indexOf("["), s = d.indexOf("]");
              if (O > -1) {
                let e = d.slice(O).indexOf(")") + O, r = d.substring(0, O), g = d.substring(e + 1), o = d.substring(O + 6, e).split(","), c = Number(o[1]), n;
                if (z = "", R = st(o[0], C)) {
                  n = (c = isNaN(c) ? R.length : c) < 0 ? R.length + c : Math.min(c, R.length);
                  for (let S = 0; S < n; ++S) z += r + R[S] + g;
                }
                return z.length ? z : "";
              }
              if (h > -1) {
                var t;
                let e = d.slice(h).indexOf(")") + h, r = d.substring(h + 8, e).split(",");
                switch (Number(st(r[0], C))) {
                  case 0:
                    z = tt(r[4], r[1]);
                    break;
                  case 1:
                    z = tt(r[2], r[1]);
                    break;
                  case 2:
                    z = tt(r[3], r[1]);
                    break;
                  default:
                    z = r[1];
                }
                return z ? (t = z).trim && t.trim() || t.replace(/^\s+|\s+$/g, "") : "";
              }
              if (f > -1) {
                let e, r = d.substring(0, f), g = Number(d.substring(f + 1, s));
                return R = st(r, C), !isNaN(g) && R && (g < 0 ? (e = R[R.length + g]) === void 0 && (e = R[0]) : (e = R[g]) === void 0 && (e = R[R.length - 1])), e !== void 0 ? e : "";
              }
              return "{" + d + "}";
            }(l.value, p));
          }), it(w.reduce((l, d) => l + d.value, ""), p, y);
        }
        function N(D, p) {
          let y = D.split("."), m = this.options.lang, w = 0;
          for (; w < y.length; ++w) m = m && m[y[w]];
          return typeof m == "string" ? _(m, p, this) : "";
        }
        V.compose = function(D) {
          let p = D.prototype;
          p.langFormat || (p.langFormat = N);
        }, V.i18nFormat = _;
      }(J || (J = {})), J;
    }), nt(i, "Accessibility/Utils/ChartUtilities.js", [i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { doc: it } = B, { stripHTMLTagsFromString: st } = $, { defined: tt, find: V, fireEvent: _ } = J;
      function N(p) {
        if (p.points && p.points.length) {
          let y = V(p.points, (m) => !!m.graphic);
          return y && y.graphic && y.graphic.element;
        }
      }
      function D(p) {
        let y = N(p);
        return y && y.parentNode || p.graph && p.graph.element || p.group && p.group.element;
      }
      return { fireEventOnWrappedOrUnwrappedElement: function p(y, m) {
        let w = m.type, a = y.hcEvents;
        it.createEvent && (y.dispatchEvent || y.fireEvent) ? y.dispatchEvent ? y.dispatchEvent(m) : y.fireEvent(w, m) : a && a[w] ? _(y, w, m) : y.element && p(y.element, m);
      }, getChartTitle: function(p) {
        return st(p.options.title.text || p.langFormat("accessibility.defaultChartTitle", { chart: p }), p.renderer.forExport);
      }, getAxisDescription: function(p) {
        var y, m;
        return p && (((y = p.options.accessibility) == null ? void 0 : y.description) || ((m = p.axisTitle) == null ? void 0 : m.textStr) || p.options.id || p.categories && "categories" || p.dateTime && "Time" || "values");
      }, getAxisRangeDescription: function(p) {
        let y = p.options || {};
        return y.accessibility && y.accessibility.rangeDescription !== void 0 ? y.accessibility.rangeDescription : p.categories ? function(m) {
          let w = m.chart;
          return m.dataMax && m.dataMin ? w.langFormat("accessibility.axis.rangeCategories", { chart: w, axis: m, numCategories: m.dataMax - m.dataMin + 1 }) : "";
        }(p) : p.dateTime && (p.min === 0 || p.dataMin === 0) ? function(m) {
          let w = m.chart, a = {}, u = m.dataMin || m.min || 0, b = m.dataMax || m.max || 0, l = "Seconds";
          a.Seconds = (b - u) / 1e3, a.Minutes = a.Seconds / 60, a.Hours = a.Minutes / 60, a.Days = a.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function(C) {
            a[C] > 2 && (l = C);
          });
          let d = a[l].toFixed(l !== "Seconds" && l !== "Minutes" ? 1 : 0);
          return w.langFormat("accessibility.axis.timeRange" + l, { chart: w, axis: m, range: d.replace(".0", "") });
        }(p) : function(m) {
          let w = m.chart, a = w.options, u = a && a.accessibility && a.accessibility.screenReaderSection.axisRangeDateFormat || "", b = { min: m.dataMin || m.min || 0, max: m.dataMax || m.max || 0 }, l = function(d) {
            return m.dateTime ? w.time.dateFormat(u, b[d]) : b[d].toString();
          };
          return w.langFormat("accessibility.axis.rangeFromTo", { chart: w, axis: m, rangeFrom: l("min"), rangeTo: l("max") });
        }(p);
      }, getPointFromXY: function(p, y, m) {
        let w = p.length, a;
        for (; w--; ) if (a = V(p[w].points || [], function(u) {
          return u.x === y && u.y === m;
        })) return a;
      }, getSeriesFirstPointElement: N, getSeriesFromName: function(p, y) {
        return y ? (p.series || []).filter(function(m) {
          return m.name === y;
        }) : p.series;
      }, getSeriesA11yElement: D, unhideChartElementFromAT: function p(y, m) {
        m.setAttribute("aria-hidden", !1), m !== y.renderTo && m.parentNode && m.parentNode !== it.body && (Array.prototype.forEach.call(m.parentNode.childNodes, function(w) {
          w.hasAttribute("aria-hidden") || w.setAttribute("aria-hidden", !0);
        }), p(y, m.parentNode));
      }, hideSeriesFromAT: function(p) {
        let y = D(p);
        y && y.setAttribute("aria-hidden", !0);
      }, scrollAxisToPoint: function(p) {
        let y = p.series.xAxis, m = p.series.yAxis, w = y && y.scrollbar ? y : m, a = w && w.scrollbar;
        if (a && tt(a.to) && tt(a.from)) {
          let u = a.to - a.from, b = function(l, d) {
            if (!tt(l.dataMin) || !tt(l.dataMax)) return 0;
            let C = l.toPixels(l.dataMin), R = l.toPixels(l.dataMax), z = l.coll === "xAxis" ? "x" : "y";
            return (l.toPixels(d[z] || 0) - C) / (R - C);
          }(w, p);
          a.updatePosition(b - u / 2, b + u / 2), _(a, "changed", { from: a.from, to: a.to, trigger: "scrollbar", DOMEvent: null });
        }
      } };
    }), nt(i, "Accessibility/Utils/DOMElementProvider.js", [i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(B, $) {
      let { doc: J } = B, { removeElement: it } = $;
      return class {
        constructor() {
          this.elements = [];
        }
        createElement() {
          let st = J.createElement.apply(J, arguments);
          return this.elements.push(st), st;
        }
        removeElement(st) {
          it(st), this.elements.splice(this.elements.indexOf(st), 1);
        }
        destroyCreatedElements() {
          this.elements.forEach(function(st) {
            it(st);
          }), this.elements = [];
        }
      };
    }), nt(i, "Accessibility/Utils/EventProvider.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let { addEvent: J } = $;
      return class {
        constructor() {
          this.eventRemovers = [];
        }
        addEvent() {
          let it = J.apply(B, arguments);
          return this.eventRemovers.push({ element: arguments[0], remover: it }), it;
        }
        removeEvent(it) {
          let st = this.eventRemovers.map((tt) => tt.remover).indexOf(it);
          this.eventRemovers[st].remover(), this.eventRemovers.splice(st, 1);
        }
        removeAddedEvents() {
          this.eventRemovers.map((it) => it.remover).forEach((it) => it()), this.eventRemovers = [];
        }
      };
    }), nt(i, "Accessibility/AccessibilityComponent.js", [i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/DOMElementProvider.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(B, $, J, it) {
      let { fireEventOnWrappedOrUnwrappedElement: st } = B, { getFakeMouseEvent: tt } = it;
      return class {
        destroy() {
        }
        getKeyboardNavigation() {
          return [];
        }
        init() {
        }
        onChartRender() {
        }
        onChartUpdate() {
        }
        initBase(V, _) {
          this.chart = V, this.eventProvider = new J(), this.domElementProvider = new $(), this.proxyProvider = _, this.keyCodes = { left: 37, right: 39, up: 38, down: 40, enter: 13, space: 32, esc: 27, tab: 9, pageUp: 33, pageDown: 34, end: 35, home: 36 };
        }
        addEvent(V, _, N, D) {
          return this.eventProvider.addEvent(V, _, N, D);
        }
        createElement(V, _) {
          return this.domElementProvider.createElement(V, _);
        }
        fakeClickEvent(V) {
          st(V, tt("click"));
        }
        destroyBase() {
          this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
        }
      };
    }), nt(i, "Accessibility/KeyboardNavigationHandler.js", [i["Core/Utilities.js"]], function(B) {
      let { find: $ } = B;
      return class {
        constructor(J, it) {
          this.chart = J, this.keyCodeMap = it.keyCodeMap || [], this.validate = it.validate, this.init = it.init, this.terminate = it.terminate, this.response = { success: 1, prev: 2, next: 3, noHandler: 4, fail: 5 };
        }
        run(J) {
          let it = J.which || J.keyCode, st = this.response.noHandler, tt = $(this.keyCodeMap, function(V) {
            return V[0].indexOf(it) > -1;
          });
          return tt ? st = tt[1].call(this, it, J) : it === 9 && (st = this.response[J.shiftKey ? "prev" : "next"]), st;
        }
      };
    }), nt(i, "Accessibility/Components/ContainerComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(B, $, J, it, st) {
      let { unhideChartElementFromAT: tt, getChartTitle: V } = J, { doc: _ } = it, { stripHTMLTagsFromString: N } = st;
      return class extends B {
        onChartUpdate() {
          this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
        }
        handleSVGTitleElement() {
          let D = this.chart, p = "highcharts-title-" + D.index, y = N(D.langFormat("accessibility.svgContainerTitle", { chartTitle: V(D) }));
          if (y.length) {
            let m = this.svgTitleElement = this.svgTitleElement || _.createElementNS("http://www.w3.org/2000/svg", "title");
            m.textContent = y, m.id = p, D.renderTo.insertBefore(m, D.renderTo.firstChild);
          }
        }
        setSVGContainerLabel() {
          let D = this.chart, p = D.langFormat("accessibility.svgContainerLabel", { chartTitle: V(D) });
          D.renderer.box && p.length && D.renderer.box.setAttribute("aria-label", p);
        }
        setGraphicContainerAttrs() {
          let D = this.chart, p = D.langFormat("accessibility.graphicContainerLabel", { chartTitle: V(D) });
          p.length && D.container.setAttribute("aria-label", p);
        }
        setRenderToAttrs() {
          let D = this.chart, p = D.options.accessibility.landmarkVerbosity !== "disabled", y = D.langFormat("accessibility.chartContainerLabel", { title: V(D), chart: D });
          y && (D.renderTo.setAttribute("role", p ? "region" : "group"), D.renderTo.setAttribute("aria-label", y));
        }
        makeCreditsAccessible() {
          let D = this.chart, p = D.credits;
          p && (p.textStr && p.element.setAttribute("aria-label", D.langFormat("accessibility.credits", { creditsStr: N(p.textStr, D.renderer.forExport) })), tt(D, p.element));
        }
        getKeyboardNavigation() {
          let D = this.chart;
          return new $(D, { keyCodeMap: [], validate: function() {
            return !0;
          }, init: function() {
            let p = D.accessibility;
            p && p.keyboardNavigation.tabindexContainer.focus();
          } });
        }
        destroy() {
          this.chart.renderTo.setAttribute("aria-hidden", !0);
        }
      };
    }), nt(i, "Accessibility/FocusBorder.js", [i["Core/Utilities.js"]], function(B) {
      var $;
      let { addEvent: J, pick: it } = B;
      return function(st) {
        let tt = ["x", "y", "transform", "width", "height", "r", "d", "stroke-width"];
        function V() {
          let p = this.focusElement, y = this.options.accessibility.keyboardNavigation.focusBorder;
          p && (p.removeFocusBorder(), y.enabled && p.addFocusBorder(y.margin, { stroke: y.style.color, strokeWidth: y.style.lineWidth, r: y.style.borderRadius }));
        }
        function _(p, y) {
          let m = this.options.accessibility.keyboardNavigation.focusBorder, w = y || p.element;
          w && w.focus && (w.hcEvents && w.hcEvents.focusin || J(w, "focusin", function() {
          }), w.focus(), m.hideBrowserFocusOutline && (w.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = p, this.renderFocusBorder();
        }
        function N(p, y) {
          this.focusBorder && this.removeFocusBorder();
          let m = this.getBBox(), w = it(p, 3), a = this.parentGroup, u = this.scaleX || a && a.scaleX, b = this.scaleY || a && a.scaleY, l = (u ? !b : b) ? Math.abs(u || b || 1) : (Math.abs(u || 1) + Math.abs(b || 1)) / 2;
          m.x += this.translateX ? this.translateX : 0, m.y += this.translateY ? this.translateY : 0;
          let d = m.x - w, C = m.y - w, R = m.width + 2 * w, z = m.height + 2 * w, O = !!this.text;
          if (this.element.nodeName === "text" || O) {
            let h, f, s = !!this.rotation, t = O ? { x: s ? 1 : 0, y: 0 } : (h = 0, f = 0, this.attr("text-anchor") === "middle" ? h = f = 0.5 : this.rotation ? h = 0.25 : f = 0.75, { x: h, y: f }), e = +this.attr("x"), r = +this.attr("y");
            if (isNaN(e) || (d = e - m.width * t.x - w), isNaN(r) || (C = r - m.height * t.y - w), O && s) {
              let g = R;
              R = z, z = g, isNaN(e) || (d = e - m.height * t.x - w), isNaN(r) || (C = r - m.width * t.y - w);
            }
          }
          this.focusBorder = this.renderer.rect(d, C, R, z, parseInt((y && y.r || 0).toString(), 10) / l).addClass("highcharts-focus-border").attr({ zIndex: 99 }).add(a), this.renderer.styledMode || this.focusBorder.attr({ stroke: y && y.stroke, "stroke-width": (y && y.strokeWidth || 0) / l }), function(h, ...f) {
            h.focusBorderUpdateHooks || (h.focusBorderUpdateHooks = {}, tt.forEach((s) => {
              let t = s + "Setter", e = h[t] || h._defaultSetter;
              h.focusBorderUpdateHooks[t] = e, h[t] = function() {
                let r = e.apply(h, arguments);
                return h.addFocusBorder.apply(h, f), r;
              };
            }));
          }(this, p, y), function(h) {
            if (h.focusBorderDestroyHook) return;
            let f = h.destroy;
            h.destroy = function() {
              return h.focusBorder && h.focusBorder.destroy && h.focusBorder.destroy(), f.apply(h, arguments);
            }, h.focusBorderDestroyHook = f;
          }(this);
        }
        function D() {
          var p;
          p = this, p.focusBorderUpdateHooks && (Object.keys(p.focusBorderUpdateHooks).forEach((y) => {
            let m = p.focusBorderUpdateHooks[y];
            m === p._defaultSetter ? delete p[y] : p[y] = m;
          }), delete p.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
        }
        st.compose = function(p, y) {
          let m = p.prototype, w = y.prototype;
          m.renderFocusBorder || (m.renderFocusBorder = V, m.setFocusToElement = _), w.addFocusBorder || (w.addFocusBorder = N, w.removeFocusBorder = D);
        };
      }($ || ($ = {})), $;
    }), nt(i, "Accessibility/Utils/Announcer.js", [i["Core/Renderer/HTML/AST.js"], i["Accessibility/Utils/DOMElementProvider.js"], i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      let { doc: tt } = J, { addClass: V, visuallyHideElement: _ } = it, { attr: N } = st;
      return class {
        constructor(D, p) {
          this.chart = D, this.domElementProvider = new $(), this.announceRegion = this.addAnnounceRegion(p);
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        announce(D) {
          B.setElementHTML(this.announceRegion, D), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(() => {
            this.announceRegion.innerHTML = B.emptyHTML, delete this.clearAnnouncementRegionTimer;
          }, 3e3);
        }
        addAnnounceRegion(D) {
          let p = this.chart.announcerContainer || this.createAnnouncerContainer(), y = this.domElementProvider.createElement("div");
          return N(y, { "aria-hidden": !1, "aria-live": D, "aria-atomic": !0 }), this.chart.styledMode ? V(y, "highcharts-visually-hidden") : _(y), p.appendChild(y), y;
        }
        createAnnouncerContainer() {
          let D = this.chart, p = tt.createElement("div");
          return N(p, { "aria-hidden": !1, class: "highcharts-announcer-container" }), p.style.position = "relative", D.renderTo.insertBefore(p, D.renderTo.firstChild), D.announcerContainer = p, p;
        }
      };
    }), nt(i, "Accessibility/Components/AnnotationsA11y.js", [i["Accessibility/Utils/HTMLUtilities.js"]], function(B) {
      let { escapeStringForHTML: $, stripHTMLTagsFromString: J } = B;
      function it(_) {
        return (_.annotations || []).reduce((N, D) => (D.options && D.options.visible !== !1 && (N = N.concat(D.labels)), N), []);
      }
      function st(_) {
        return _.options && _.options.accessibility && _.options.accessibility.description || _.graphic && _.graphic.text && _.graphic.text.textStr || "";
      }
      function tt(_) {
        let N = _.options && _.options.accessibility && _.options.accessibility.description;
        if (N) return N;
        let D = _.chart, p = st(_), y = _.points, m = (l) => l.graphic && l.graphic.element && l.graphic.element.getAttribute("aria-label") || "", w = y.filter((l) => !!l.graphic).map((l) => {
          let d = l.accessibility && l.accessibility.valueDescription || m(l), C = l && l.series.name || "";
          return (C ? C + ", " : "") + "data point " + d;
        }).filter((l) => !!l), a = w.length, u = a > 1 ? "MultiplePoints" : a ? "SinglePoint" : "NoPoints", b = { annotationText: p, annotation: _, numPoints: a, annotationPoint: w[0], additionalAnnotationPoints: w.slice(1) };
        return D.langFormat("accessibility.screenReaderSection.annotations.description" + u, b);
      }
      function V(_) {
        return it(_).map((N) => {
          let D = $(J(tt(N), _.renderer.forExport));
          return D ? `<li>${D}</li>` : "";
        });
      }
      return { getAnnotationsInfoHTML: function(_) {
        let N = _.annotations;
        return N && N.length ? `<ul style="list-style-type: none">${V(_).join(" ")}</ul>` : "";
      }, getAnnotationLabelDescription: tt, getAnnotationListItems: V, getPointAnnotationTexts: function(_) {
        let N = it(_.series.chart).filter((D) => D.points.indexOf(_) > -1);
        return N.length ? N.map((D) => `${st(D)}`) : [];
      } };
    }), nt(i, "Accessibility/Components/InfoRegionsComponent.js", [i["Accessibility/A11yI18n.js"], i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/Announcer.js"], i["Accessibility/Components/AnnotationsA11y.js"], i["Core/Renderer/HTML/AST.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Core/Templating.js"], i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _, N, D) {
      let { getAnnotationsInfoHTML: p } = it, { getAxisDescription: y, getAxisRangeDescription: m, getChartTitle: w, unhideChartElementFromAT: a } = tt, { format: u } = V, { doc: b } = _, { addClass: l, getElement: d, getHeadingTagNameForElement: C, stripHTMLTagsFromString: R, visuallyHideElement: z } = N, { attr: O, pick: h, replaceNested: f } = D;
      function s(t) {
        return f(t, [/<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g, ""]);
      }
      return class extends $ {
        constructor() {
          super(...arguments), this.screenReaderSections = {};
        }
        init() {
          let t = this.chart, e = this;
          this.initRegionsDefinitions(), this.addEvent(t, "aftergetTableAST", function(r) {
            e.onDataTableCreated(r);
          }), this.addEvent(t, "afterViewData", function(r) {
            r.wasHidden && (e.dataTableDiv = r.element, setTimeout(function() {
              e.focusDataTable();
            }, 300));
          }), this.addEvent(t, "afterHideData", function() {
            e.viewDataTableButton && e.viewDataTableButton.setAttribute("aria-expanded", "false");
          }), t.exporting && this.addEvent(t, "afterPrint", function() {
            e.updateAllScreenReaderSections();
          }), this.announcer = new J(t, "assertive");
        }
        initRegionsDefinitions() {
          let t = this, e = this.chart.options.accessibility;
          this.screenReaderSections = { before: { element: null, buildContent: function(r) {
            let g = e.screenReaderSection.beforeChartFormatter;
            return g ? g(r) : t.defaultBeforeChartFormatter(r);
          }, insertIntoDOM: function(r, g) {
            g.renderTo.insertBefore(r, g.renderTo.firstChild);
          }, afterInserted: function() {
            t.sonifyButtonId !== void 0 && t.initSonifyButton(t.sonifyButtonId), t.dataTableButtonId !== void 0 && t.initDataTableButton(t.dataTableButtonId);
          } }, after: { element: null, buildContent: function(r) {
            let g = e.screenReaderSection.afterChartFormatter;
            return g ? g(r) : t.defaultAfterChartFormatter();
          }, insertIntoDOM: function(r, g) {
            g.renderTo.insertBefore(r, g.container.nextSibling);
          }, afterInserted: function() {
            t.chart.accessibility && e.keyboardNavigation.enabled && t.chart.accessibility.keyboardNavigation.updateExitAnchor();
          } } };
        }
        onChartRender() {
          this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
        }
        updateAllScreenReaderSections() {
          let t = this;
          Object.keys(this.screenReaderSections).forEach(function(e) {
            t.updateScreenReaderSection(e);
          });
        }
        getLinkedDescriptionElement() {
          let t = this.chart.options.accessibility.linkedDescription;
          if (!t) return;
          if (typeof t != "string") return t;
          let e = u(t, this.chart), r = b.querySelectorAll(e);
          if (r.length === 1) return r[0];
        }
        setLinkedDescriptionAttrs() {
          let t = this.linkedDescriptionElement;
          t && (t.setAttribute("aria-hidden", "true"), l(t, "highcharts-linked-description"));
        }
        updateScreenReaderSection(t) {
          let e = this.chart, r = this.screenReaderSections[t], g = r.buildContent(e), o = r.element = r.element || this.createElement("div"), c = o.firstChild || this.createElement("div");
          g ? (this.setScreenReaderSectionAttribs(o, t), st.setElementHTML(c, g), o.appendChild(c), r.insertIntoDOM(o, e), e.styledMode ? l(c, "highcharts-visually-hidden") : z(c), a(e, c), r.afterInserted && r.afterInserted()) : (o.parentNode && o.parentNode.removeChild(o), r.element = null);
        }
        setScreenReaderSectionAttribs(t, e) {
          let r = this.chart, g = r.langFormat("accessibility.screenReaderSection." + e + "RegionLabel", { chart: r, chartTitle: w(r) });
          O(t, { id: `highcharts-screen-reader-region-${e}-${r.index}`, "aria-label": g || void 0 }), t.style.position = "relative", g && t.setAttribute("role", r.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
        }
        defaultBeforeChartFormatter() {
          let t = this.chart, e = t.options.accessibility.screenReaderSection.beforeChartFormat;
          if (!e) return "";
          let r = this.getAxesDescription(), g = t.sonify && t.options.sonification && t.options.sonification.enabled, o = "highcharts-a11y-sonify-data-btn-" + t.index, c = "hc-linkto-highcharts-data-table-" + t.index, n = p(t), S = t.langFormat("accessibility.screenReaderSection.annotations.heading", { chart: t }), j = { headingTagName: C(t.renderTo), chartTitle: w(t), typeDescription: this.getTypeDescriptionText(), chartSubtitle: this.getSubtitleText(), chartLongdesc: this.getLongdescText(), xAxisDescription: r.xAxis, yAxisDescription: r.yAxis, playAsSoundButton: g ? this.getSonifyButtonText(o) : "", viewTableButton: t.getCSV ? this.getDataTableButtonText(c) : "", annotationsTitle: n ? S : "", annotationsList: n }, v = B.i18nFormat(e, j, t);
          return this.dataTableButtonId = c, this.sonifyButtonId = o, s(v);
        }
        defaultAfterChartFormatter() {
          let t = this.chart, e = t.options.accessibility.screenReaderSection.afterChartFormat;
          if (!e) return "";
          let r = { endOfChartMarker: this.getEndOfChartMarkerText() };
          return s(B.i18nFormat(e, r, t));
        }
        getLinkedDescription() {
          let t = this.linkedDescriptionElement;
          return R(t && t.innerHTML || "", this.chart.renderer.forExport);
        }
        getLongdescText() {
          let t = this.chart.options, e = t.caption, r = e && e.text, g = this.getLinkedDescription();
          return t.accessibility.description || g || r || "";
        }
        getTypeDescriptionText() {
          let t = this.chart;
          return t.types ? t.options.accessibility.typeDescription || function(e, r) {
            let g = r[0], o = e.series && e.series[0] || {}, c = e.mapView && e.mapView.geoMap && e.mapView.geoMap.title, n = { numSeries: e.series.length, numPoints: o.points && o.points.length, chart: e, mapTitle: c };
            return g ? g === "map" || g === "tiledwebmap" ? n.mapTitle ? e.langFormat("accessibility.chartTypes.mapTypeDescription", n) : e.langFormat("accessibility.chartTypes.unknownMap", n) : e.types.length > 1 ? e.langFormat("accessibility.chartTypes.combinationChart", n) : function(S, j, v) {
              let P = j[0], G = S.langFormat("accessibility.seriesTypeDescriptions." + P, v), W = S.series && S.series.length < 2 ? "Single" : "Multiple";
              return (S.langFormat("accessibility.chartTypes." + P + W, v) || S.langFormat("accessibility.chartTypes.default" + W, v)) + (G ? " " + G : "");
            }(e, r, n) : e.langFormat("accessibility.chartTypes.emptyChart", n);
          }(t, t.types) : "";
        }
        getDataTableButtonText(t) {
          let e = this.chart;
          return '<button id="' + t + '">' + e.langFormat("accessibility.table.viewAsDataTableButtonText", { chart: e, chartTitle: w(e) }) + "</button>";
        }
        getSonifyButtonText(t) {
          let e = this.chart;
          return e.options.sonification && e.options.sonification.enabled === !1 ? "" : '<button id="' + t + '">' + e.langFormat("accessibility.sonification.playAsSoundButtonText", { chart: e, chartTitle: w(e) }) + "</button>";
        }
        getSubtitleText() {
          let t = this.chart.options.subtitle;
          return R(t && t.text || "", this.chart.renderer.forExport);
        }
        getEndOfChartMarkerText() {
          let t = d(`highcharts-end-of-chart-marker-${this.chart.index}`);
          if (t) return t.outerHTML;
          let e = this.chart, r = e.langFormat("accessibility.screenReaderSection.endOfChartMarker", { chart: e });
          return '<div id="highcharts-end-of-chart-marker-' + e.index + '">' + r + "</div>";
        }
        onDataTableCreated(t) {
          let e = this.chart;
          if (e.options.accessibility.enabled) {
            this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
            let r = t.tree.attributes || {};
            r.tabindex = -1, r.summary = e.langFormat("accessibility.table.tableSummary", { chart: e }), t.tree.attributes = r;
          }
        }
        focusDataTable() {
          let t = this.dataTableDiv, e = t && t.getElementsByTagName("table")[0];
          e && e.focus && e.focus();
        }
        initSonifyButton(t) {
          let e = this.sonifyButton = d(t), r = this.chart, g = (o) => {
            e && (e.setAttribute("aria-hidden", "true"), e.setAttribute("aria-label", "")), o.preventDefault(), o.stopPropagation();
            let c = r.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", { chart: r });
            this.announcer.announce(c), setTimeout(() => {
              e && (e.removeAttribute("aria-hidden"), e.removeAttribute("aria-label")), r.sonify && r.sonify();
            }, 1e3);
          };
          e && r && (e.setAttribute("tabindex", -1), e.onclick = function(o) {
            (r.options.accessibility && r.options.accessibility.screenReaderSection.onPlayAsSoundClick || g).call(this, o, r);
          });
        }
        initDataTableButton(t) {
          let e = this.viewDataTableButton = d(t), r = this.chart, g = t.replace("hc-linkto-", "");
          e && (O(e, { tabindex: -1, "aria-expanded": !!d(g) }), e.onclick = r.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
            r.viewData();
          });
        }
        getAxesDescription() {
          let t = this.chart, e = function(S, j) {
            let v = t[S];
            return v.length > 1 || v[0] && h(v[0].options.accessibility && v[0].options.accessibility.enabled, j);
          }, r = !!t.types && 0 > t.types.indexOf("map") && 0 > t.types.indexOf("treemap") && 0 > t.types.indexOf("tilemap"), g = !!t.hasCartesianSeries, o = e("xAxis", !t.angular && g && r), c = e("yAxis", g && r), n = {};
          return o && (n.xAxis = this.getAxisDescriptionText("xAxis")), c && (n.yAxis = this.getAxisDescriptionText("yAxis")), n;
        }
        getAxisDescriptionText(t) {
          let e = this.chart, r = e[t];
          return e.langFormat("accessibility.axis." + t + "Description" + (r.length > 1 ? "Plural" : "Singular"), { chart: e, names: r.map(function(g) {
            return y(g);
          }), ranges: r.map(function(g) {
            return m(g);
          }), numAxes: r.length });
        }
        destroy() {
          this.announcer && this.announcer.destroy();
        }
      };
    }), nt(i, "Accessibility/Components/MenuComponent.js", [i["Core/Utilities.js"], i["Accessibility/AccessibilityComponent.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(B, $, J, it, st) {
      let { attr: tt } = B, { getChartTitle: V, unhideChartElementFromAT: _ } = it, { getFakeMouseEvent: N } = st;
      function D(y) {
        return y.exportSVGElements && y.exportSVGElements[0];
      }
      class p extends $ {
        init() {
          let m = this.chart, w = this;
          this.addEvent(m, "exportMenuShown", function() {
            w.onMenuShown();
          }), this.addEvent(m, "exportMenuHidden", function() {
            w.onMenuHidden();
          }), this.createProxyGroup();
        }
        onMenuHidden() {
          let m = this.chart.exportContextMenu;
          m && m.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
        }
        onMenuShown() {
          let m = this.chart, w = m.exportContextMenu;
          w && (this.addAccessibleContextMenuAttribs(), _(m, w)), this.setExportButtonExpandedState("true");
        }
        setExportButtonExpandedState(m) {
          this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", m);
        }
        onChartRender() {
          let m = this.chart, w = m.focusElement, a = m.accessibility;
          this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && w && w === m.exportingGroup && (w.focusBorder ? m.setFocusToElement(w, this.exportButtonProxy.innerElement) : a && a.keyboardNavigation.tabindexContainer.focus());
        }
        proxyMenuButton() {
          let m = this.chart, w = this.proxyProvider, a = D(m);
          (function(u) {
            let b = u.options.exporting, l = D(u);
            return !!(b && b.enabled !== !1 && b.accessibility && b.accessibility.enabled && l && l.element);
          })(m) && a && (this.exportButtonProxy = w.addProxyElement("chartMenu", { click: a }, "button", { "aria-label": m.langFormat("accessibility.exporting.menuButtonLabel", { chart: m, chartTitle: V(m) }), "aria-expanded": !1, title: m.options.lang.contextButtonTitle || null }));
        }
        createProxyGroup() {
          this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
        }
        addAccessibleContextMenuAttribs() {
          let m = this.chart, w = m.exportDivElements;
          if (w && w.length) {
            w.forEach((u) => {
              u && (u.tagName !== "LI" || u.children && u.children.length ? u.setAttribute("aria-hidden", "true") : u.setAttribute("tabindex", -1));
            });
            let a = w[0] && w[0].parentNode;
            a && tt(a, { "aria-hidden": void 0, "aria-label": m.langFormat("accessibility.exporting.chartMenuLabel", { chart: m }), role: "list" });
          }
        }
        getKeyboardNavigation() {
          let m = this.keyCodes, w = this.chart, a = this;
          return new J(w, { keyCodeMap: [[[m.left, m.up], function() {
            return a.onKbdPrevious(this);
          }], [[m.right, m.down], function() {
            return a.onKbdNext(this);
          }], [[m.enter, m.space], function() {
            return a.onKbdClick(this);
          }]], validate: function() {
            return !!w.exporting && w.options.exporting.enabled !== !1 && w.options.exporting.accessibility.enabled !== !1;
          }, init: function() {
            let u = a.exportButtonProxy, b = a.chart.exportingGroup;
            u && b && w.setFocusToElement(b, u.innerElement);
          }, terminate: function() {
            w.hideExportMenu();
          } });
        }
        onKbdPrevious(m) {
          let w = this.chart, a = w.options.accessibility, u = m.response, b = w.highlightedExportItemIx || 0;
          for (; b--; ) if (w.highlightExportItem(b)) return u.success;
          return a.keyboardNavigation.wrapAround ? (w.highlightLastExportItem(), u.success) : u.prev;
        }
        onKbdNext(m) {
          let w = this.chart, a = w.options.accessibility, u = m.response;
          for (let b = (w.highlightedExportItemIx || 0) + 1; b < w.exportDivElements.length; ++b) if (w.highlightExportItem(b)) return u.success;
          return a.keyboardNavigation.wrapAround ? (w.highlightExportItem(0), u.success) : u.next;
        }
        onKbdClick(m) {
          let w = this.chart, a = w.exportDivElements[w.highlightedExportItemIx], u = D(w).element;
          return w.openMenu ? this.fakeClickEvent(a) : (this.fakeClickEvent(u), w.highlightExportItem(0)), m.response.success;
        }
      }
      return function(y) {
        function m() {
          let b = D(this);
          if (b) {
            let l = b.element;
            l.onclick && l.onclick(N("click"));
          }
        }
        function w() {
          let b = this.exportDivElements;
          b && this.exportContextMenu && this.openMenu && (b.forEach((l) => {
            l && l.className === "highcharts-menu-item" && l.onmouseout && l.onmouseout(N("mouseout"));
          }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
        }
        function a(b) {
          let l = this.exportDivElements && this.exportDivElements[b], d = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
          if (l && l.tagName === "LI" && !(l.children && l.children.length)) {
            let C = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
            return l.focus && C && l.focus(), d && d.onmouseout && d.onmouseout(N("mouseout")), l.onmouseover && l.onmouseover(N("mouseover")), this.highlightedExportItemIx = b, !0;
          }
          return !1;
        }
        function u() {
          if (this.exportDivElements) {
            let b = this.exportDivElements.length;
            for (; b--; ) if (this.highlightExportItem(b)) return !0;
          }
          return !1;
        }
        y.compose = function(b) {
          let l = b.prototype;
          l.hideExportMenu || (l.hideExportMenu = w, l.highlightExportItem = a, l.highlightLastExportItem = u, l.showExportMenu = m);
        };
      }(p || (p = {})), p;
    }), nt(i, "Accessibility/KeyboardNavigation.js", [i["Core/Globals.js"], i["Accessibility/Components/MenuComponent.js"], i["Core/Utilities.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(B, $, J, it, st) {
      let { doc: tt, win: V } = B, { addEvent: _, defined: N, fireEvent: D } = J, { getElement: p, simulatedEventTarget: y } = st;
      class m {
        constructor(a, u) {
          this.currentModuleIx = NaN, this.modules = [], this.init(a, u);
        }
        init(a, u) {
          let b = this.eventProvider = new it();
          this.chart = a, this.components = u, this.modules = [], this.currentModuleIx = 0, this.update(), b.addEvent(this.tabindexContainer, "keydown", (l) => this.onKeydown(l)), b.addEvent(this.tabindexContainer, "focus", (l) => this.onFocus(l)), ["mouseup", "touchend"].forEach((l) => b.addEvent(tt, l, (d) => this.onMouseUp(d))), ["mousedown", "touchstart"].forEach((l) => b.addEvent(a.renderTo, l, () => {
            this.isClickingChart = !0;
          }));
        }
        update(a) {
          let u = this.chart.options.accessibility, b = u && u.keyboardNavigation, l = this.components;
          this.updateContainerTabindex(), b && b.enabled && a && a.length ? (this.modules = a.reduce(function(d, C) {
            let R = l[C].getKeyboardNavigation();
            return d.concat(R);
          }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
        }
        updateExitAnchor() {
          let a = p(`highcharts-end-of-chart-marker-${this.chart.index}`);
          this.removeExitAnchor(), a ? (this.makeElementAnExitAnchor(a), this.exitAnchor = a) : this.createExitAnchor();
        }
        move(a) {
          let u = this.modules && this.modules[this.currentModuleIx];
          u && u.terminate && u.terminate(a), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += a;
          let b = this.modules && this.modules[this.currentModuleIx];
          if (b) {
            if (b.validate && !b.validate()) return this.move(a);
            if (b.init) return b.init(a), !0;
          }
          return this.currentModuleIx = 0, this.exiting = !0, a > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
        }
        onFocus(a) {
          let u = this.chart, b = a.relatedTarget && u.container.contains(a.relatedTarget), l = u.options.accessibility, d = l && l.keyboardNavigation;
          if (d && d.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !b) {
            let C = this.getFirstValidModuleIx();
            C !== null && (this.currentModuleIx = C, this.modules[C].init(1));
          }
          this.keyboardReset = !1, this.exiting = !1;
        }
        onMouseUp(a) {
          if (delete this.isClickingChart, !this.keyboardReset && a.relatedTarget !== y) {
            let u = this.chart;
            if (!a.target || !u.container.contains(a.target)) {
              let b = this.modules && this.modules[this.currentModuleIx || 0];
              b && b.terminate && b.terminate(), this.currentModuleIx = 0;
            }
            u.focusElement && (u.focusElement.removeFocusBorder(), delete u.focusElement), this.keyboardReset = !0;
          }
        }
        onKeydown(a) {
          let u, b = a || V.event, l = this.modules && this.modules.length && this.modules[this.currentModuleIx], d = b.target;
          if ((!d || d.nodeName !== "INPUT" || d.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, l)) {
            let C = l.run(b);
            C === l.response.success ? u = !0 : C === l.response.prev ? u = this.move(-1) : C === l.response.next && (u = this.move(1)), u && (b.preventDefault(), b.stopPropagation());
          }
        }
        updateContainerTabindex() {
          let a, u = this.chart.options.accessibility, b = u && u.keyboardNavigation, l = !(b && b.enabled === !1), d = this.chart, C = d.container;
          d.renderTo.hasAttribute("tabindex") ? (C.removeAttribute("tabindex"), a = d.renderTo) : a = C, this.tabindexContainer = a;
          let R = a.getAttribute("tabindex");
          l && !R ? a.setAttribute("tabindex", "0") : l || d.container.removeAttribute("tabindex");
        }
        createExitAnchor() {
          let a = this.chart, u = this.exitAnchor = tt.createElement("div");
          a.renderTo.appendChild(u), this.makeElementAnExitAnchor(u);
        }
        makeElementAnExitAnchor(a) {
          let u = this.tabindexContainer.getAttribute("tabindex") || 0;
          a.setAttribute("class", "highcharts-exit-anchor"), a.setAttribute("tabindex", u), a.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(a);
        }
        removeExitAnchor() {
          if (this.exitAnchor) {
            let a = this.eventProvider.eventRemovers.find((u) => u.element === this.exitAnchor);
            a && N(a.remover) && this.eventProvider.removeEvent(a.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
          }
        }
        addExitAnchorEventsToEl(a) {
          let u = this.chart, b = this;
          this.eventProvider.addEvent(a, "focus", function(l) {
            let d = l || V.event, C = !(d.relatedTarget && u.container.contains(d.relatedTarget) || b.exiting);
            if (u.focusElement && delete u.focusElement, C) {
              if (b.tabbingInBackwards = !0, b.tabindexContainer.focus(), delete b.tabbingInBackwards, d.preventDefault(), b.modules && b.modules.length) {
                b.currentModuleIx = b.modules.length - 1;
                let R = b.modules[b.currentModuleIx];
                R && R.validate && !R.validate() ? b.move(-1) : R && R.init(-1);
              }
            } else b.exiting = !1;
          });
        }
        getFirstValidModuleIx() {
          let a = this.modules.length;
          for (let u = 0; u < a; ++u) {
            let b = this.modules[u];
            if (!b.validate || b.validate()) return u;
          }
          return null;
        }
        destroy() {
          this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
        }
      }
      return function(w) {
        function a() {
          let b = this;
          D(this, "dismissPopupContent", {}, function() {
            b.tooltip && b.tooltip.hide(0), b.hideExportMenu();
          });
        }
        function u(b) {
          (b.which || b.keyCode) === 27 && B.charts && B.charts.forEach((l) => {
            l && l.dismissPopupContent && l.dismissPopupContent();
          });
        }
        w.compose = function(b) {
          $.compose(b);
          let l = b.prototype;
          return l.dismissPopupContent || (l.dismissPopupContent = a, _(tt, "keydown", u)), b;
        };
      }(m || (m = {})), m;
    }), nt(i, "Accessibility/Components/LegendComponent.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Globals.js"], i["Core/Legend/Legend.js"], i["Core/Utilities.js"], i["Accessibility/AccessibilityComponent.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(B, $, J, it, st, tt, V, _) {
      let { animObject: N } = B, { doc: D } = $, { addEvent: p, fireEvent: y, isNumber: m, pick: w, syncTimeout: a } = it, { getChartTitle: u } = V, { stripHTMLTagsFromString: b, addClass: l, removeClass: d } = _;
      function C(O) {
        let h = O.legend && O.legend.allItems, f = O.options.legend.accessibility || {}, s = O.colorAxis && O.colorAxis.some((t) => !t.dataClasses || !t.dataClasses.length);
        return !!(h && h.length && !s && f.enabled !== !1);
      }
      function R(O, h) {
        let f = h.legendItem || {};
        for (let s of (h.setState(O ? "hover" : "", !0), ["group", "label", "symbol"])) {
          let t = f[s], e = t && t.element || t;
          e && y(e, O ? "mouseover" : "mouseout");
        }
      }
      class z extends st {
        constructor() {
          super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
        }
        init() {
          let h = this;
          this.recreateProxies(), this.addEvent(J, "afterScroll", function() {
            this.chart === h.chart && (h.proxyProvider.updateGroupProxyElementPositions("legend"), h.updateLegendItemProxyVisibility(), h.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(h.highlightedLegendItemIx));
          }), this.addEvent(J, "afterPositionItem", function(f) {
            this.chart === h.chart && this.chart.renderer && h.updateProxyPositionForItem(f.item);
          }), this.addEvent(J, "afterRender", function() {
            this.chart === h.chart && this.chart.renderer && h.recreateProxies() && a(() => h.proxyProvider.updateGroupProxyElementPositions("legend"), N(w(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        updateLegendItemProxyVisibility() {
          let h, f = this.chart, s = f.legend, t = s.allItems || [], e = s.currentPage || 1, r = s.clipHeight || 0;
          t.forEach((g) => {
            if (g.a11yProxyElement) {
              let o = s.pages && s.pages.length, c = g.a11yProxyElement.element, n = !1;
              if (h = g.legendItem || {}, o) {
                let S = h.pageIx || 0;
                n = (h.y || 0) + (h.label ? Math.round(h.label.getBBox().height) : 0) - s.pages[S] > r || S !== e - 1;
              }
              n ? f.styledMode ? l(c, "highcharts-a11y-invisible") : c.style.visibility = "hidden" : (d(c, "highcharts-a11y-invisible"), c.style.visibility = "");
            }
          });
        }
        onChartRender() {
          C(this.chart) || this.removeProxies();
        }
        highlightAdjacentLegendPage(h) {
          let f = this.chart, s = f.legend, t = (s.currentPage || 1) + h, e = s.pages || [];
          if (t > 0 && t <= e.length) {
            let r = 0;
            for (let g of s.allItems) ((g.legendItem || {}).pageIx || 0) + 1 === t && f.highlightLegendItem(r) && (this.highlightedLegendItemIx = r), ++r;
          }
        }
        updateProxyPositionForItem(h) {
          h.a11yProxyElement && h.a11yProxyElement.refreshPosition();
        }
        recreateProxies() {
          let h = D.activeElement, f = this.proxyGroup, s = h && f && f.contains(h);
          return this.removeProxies(), !!C(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), s && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
        }
        removeProxies() {
          this.proxyProvider.removeGroup("legend");
        }
        updateLegendTitle() {
          let h = this.chart, f = b((h.legend && h.legend.options.title && h.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), h.renderer.forExport), s = h.langFormat("accessibility.legend.legendLabel" + (f ? "" : "NoTitle"), { chart: h, legendTitle: f, chartTitle: u(h) });
          this.proxyProvider.updateGroupAttrs("legend", { "aria-label": s });
        }
        addLegendProxyGroup() {
          let h = this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null;
          this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", { "aria-label": "_placeholder_", role: h });
        }
        proxyLegendItems() {
          let h, f = this;
          ((this.chart.legend || {}).allItems || []).forEach((s) => {
            (h = s.legendItem || {}).label && h.label.element && f.proxyLegendItem(s);
          });
        }
        proxyLegendItem(h) {
          let f = h.legendItem || {};
          if (!f.label || !f.group) return;
          let s = this.chart.langFormat("accessibility.legend.legendItem", { chart: this.chart, itemName: b(h.name, this.chart.renderer.forExport), item: h }), t = { tabindex: -1, "aria-pressed": h.visible, "aria-label": s }, e = f.group.div ? f.label : f.group;
          h.a11yProxyElement = this.proxyProvider.addProxyElement("legend", { click: f.label, visual: e.element }, "button", t);
        }
        getKeyboardNavigation() {
          let h = this.keyCodes, f = this, s = this.chart;
          return new tt(s, { keyCodeMap: [[[h.left, h.right, h.up, h.down], function(t) {
            return f.onKbdArrowKey(this, t);
          }], [[h.enter, h.space], function() {
            return f.onKbdClick(this);
          }], [[h.pageDown, h.pageUp], function(t) {
            let e = t === h.pageDown ? 1 : -1;
            return f.highlightAdjacentLegendPage(e), this.response.success;
          }]], validate: function() {
            return f.shouldHaveLegendNavigation();
          }, init: function() {
            s.highlightLegendItem(0), f.highlightedLegendItemIx = 0;
          }, terminate: function() {
            f.highlightedLegendItemIx = -1, s.legend.allItems.forEach((t) => R(!1, t));
          } });
        }
        onKbdArrowKey(h, f) {
          let { keyCodes: { left: s, up: t }, highlightedLegendItemIx: e, chart: r } = this, g = r.legend.allItems.length, o = r.options.accessibility.keyboardNavigation.wrapAround, c = f === s || f === t ? -1 : 1;
          return r.highlightLegendItem(e + c) ? this.highlightedLegendItemIx += c : o && g > 1 && (this.highlightedLegendItemIx = c > 0 ? 0 : g - 1, r.highlightLegendItem(this.highlightedLegendItemIx)), h.response.success;
        }
        onKbdClick(h) {
          let f = this.chart.legend.allItems[this.highlightedLegendItemIx];
          return f && f.a11yProxyElement && f.a11yProxyElement.click(), h.response.success;
        }
        shouldHaveLegendNavigation() {
          if (!C(this.chart)) return !1;
          let h = this.chart, f = (h.options.legend || {}).accessibility || {};
          return !!(h.legend.display && f.keyboardNavigation && f.keyboardNavigation.enabled);
        }
        destroy() {
          this.removeProxies();
        }
      }
      return function(O) {
        function h(s) {
          let t = this.legend.allItems, e = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, r = t[s], g = (r == null ? void 0 : r.legendItem) || {};
          if (r) {
            m(e) && t[e] && R(!1, t[e]), function(n, S) {
              let j = (n.allItems[S].legendItem || {}).pageIx, v = n.currentPage;
              j !== void 0 && j + 1 !== v && n.scroll(1 + j - v);
            }(this.legend, s);
            let o = g.label, c = r.a11yProxyElement && r.a11yProxyElement.innerElement;
            return o && o.element && c && this.setFocusToElement(o, c), R(!0, r), !0;
          }
          return !1;
        }
        function f(s) {
          let t = this.chart.options.accessibility, e = s.item;
          t.enabled && e && e.a11yProxyElement && e.a11yProxyElement.innerElement.setAttribute("aria-pressed", s.visible ? "true" : "false");
        }
        O.compose = function(s, t) {
          let e = s.prototype;
          e.highlightLegendItem || (e.highlightLegendItem = h, p(t, "afterColorizeItem", f));
        };
      }(z || (z = {})), z;
    }), nt(i, "Stock/Navigator/ChartNavigatorComposition.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let J, { isTouchDevice: it } = B, { addEvent: st, merge: tt, pick: V } = $, _ = [];
      function N() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function D() {
        var R;
        let u, b, l, d = this.legend, C = this.navigator;
        if (C) {
          u = d && d.options, b = C.xAxis, l = C.yAxis;
          let { scrollbarHeight: z, scrollButtonSize: O } = C;
          this.inverted ? (C.left = C.opposite ? this.chartWidth - z - C.height : this.spacing[3] + z, C.top = this.plotTop + O) : (C.left = V(b.left, this.plotLeft + O), C.top = C.navigatorOptions.top || this.chartHeight - C.height - z - (((R = this.scrollbar) == null ? void 0 : R.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (u && u.verticalAlign === "bottom" && u.layout !== "proximate" && u.enabled && !u.floating ? d.legendHeight + V(u.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), b && l && (this.inverted ? b.options.left = l.options.left = C.left : b.options.top = l.options.top = C.top, b.setAxisSize(), l.setAxisSize());
        }
      }
      function p(u) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new J(this), V(u.redraw, !0) && this.redraw(u.animation));
      }
      function y() {
        let u = this.options;
        (u.navigator.enabled || u.scrollbar.enabled) && (this.scroller = this.navigator = new J(this));
      }
      function m() {
        let u = this.options, b = u.navigator, l = u.rangeSelector;
        if ((b && b.enabled || l && l.enabled) && (!it && this.zooming.type === "x" || it && this.zooming.pinchType === "x")) return !1;
      }
      function w(u) {
        let b = u.navigator;
        if (b && u.xAxis[0]) {
          let l = u.xAxis[0].getExtremes();
          b.render(l.min, l.max);
        }
      }
      function a(u) {
        let b = u.options.navigator || {}, l = u.options.scrollbar || {};
        !this.navigator && !this.scroller && (b.enabled || l.enabled) && (tt(!0, this.options.navigator, b), tt(!0, this.options.scrollbar, l), delete u.options.navigator, delete u.options.scrollbar);
      }
      return { compose: function(u, b) {
        if ($.pushUnique(_, u)) {
          let l = u.prototype;
          J = b, l.callbacks.push(w), st(u, "afterAddSeries", N), st(u, "afterSetChartSize", D), st(u, "afterUpdate", p), st(u, "beforeRender", y), st(u, "beforeShowResetZoom", m), st(u, "update", a);
        }
      } };
    }), nt(i, "Core/Axis/NavigatorAxisComposition.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let { isTouchDevice: J } = B, { addEvent: it, correctFloat: st, defined: tt, isNumber: V, pick: _ } = $;
      function N() {
        this.navigatorAxis || (this.navigatorAxis = new p(this));
      }
      function D(y) {
        let m, w = this.chart, a = w.options, u = a.navigator, b = this.navigatorAxis, l = w.zooming.pinchType, d = a.rangeSelector, C = w.zooming.type;
        if (this.isXAxis && (u != null && u.enabled || d != null && d.enabled)) {
          if (C === "y" && y.trigger === "zoom") m = !1;
          else if ((y.trigger === "zoom" && C === "xy" || J && l === "xy") && this.options.range) {
            let R = b.previousZoom;
            tt(y.min) ? b.previousZoom = [this.min, this.max] : R && (y.min = R[0], y.max = R[1], b.previousZoom = void 0);
          }
        }
        m !== void 0 && y.preventDefault();
      }
      class p {
        static compose(m) {
          m.keepProps.includes("navigatorAxis") || (m.keepProps.push("navigatorAxis"), it(m, "init", N), it(m, "setExtremes", D));
        }
        constructor(m) {
          this.axis = m;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(m, w, a, u) {
          let b = this.axis, l = (b.pointRange || 0) / 2, d = _(a, b.translate(m, !0, !b.horiz)), C = _(u, b.translate(w, !0, !b.horiz));
          return tt(a) || (d = st(d + l)), tt(u) || (C = st(C - l)), V(d) && V(C) || (d = C = void 0), { min: d, max: C };
        }
      }
      return p;
    }), nt(i, "Stock/Navigator/NavigatorDefaults.js", [i["Core/Color/Color.js"], i["Core/Series/SeriesRegistry.js"]], function(B, $) {
      let { parse: J } = B, { seriesTypes: it } = $;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: J("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: it.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), nt(i, "Stock/Navigator/NavigatorSymbols.js", [i["Core/Renderer/SVG/Symbols.js"], i["Core/Utilities.js"]], function(B, $) {
      let { relativeLength: J } = $;
      return { "navigator-handle": function(it, st, tt, V, _ = {}) {
        let N = _.width ? _.width / 2 : tt, D = J(_.borderRadius || 0, Math.min(2 * N, V));
        return [["M", -1.5, (V = _.height || V) / 2 - 3.5], ["L", -1.5, V / 2 + 4.5], ["M", 0.5, V / 2 - 3.5], ["L", 0.5, V / 2 + 4.5], ...B.rect(-N - 1, 0.5, 2 * N + 1, V, { r: D })];
      } };
    }), nt(i, "Stock/Utilities/StockUtilities.js", [i["Core/Utilities.js"]], function(B) {
      let { defined: $ } = B;
      return { setFixedRange: function(J) {
        let it = this.xAxis[0];
        $(it.dataMax) && $(it.dataMin) && J ? this.fixedRange = Math.min(J, it.dataMax - it.dataMin) : this.fixedRange = J;
      } };
    }), nt(i, "Stock/Navigator/NavigatorComposition.js", [i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Axis/NavigatorAxisComposition.js"], i["Stock/Navigator/NavigatorDefaults.js"], i["Stock/Navigator/NavigatorSymbols.js"], i["Core/Renderer/RendererRegistry.js"], i["Stock/Utilities/StockUtilities.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _) {
      let { setOptions: N } = B, { composed: D } = $, { getRendererType: p } = tt, { setFixedRange: y } = V, { addEvent: m, extend: w, pushUnique: a } = _;
      function u() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(b, l, d) {
        J.compose(l), a(D, "Navigator") && (b.prototype.setFixedRange = y, w(p().prototype.symbols, st), m(d, "afterUpdate", u), N({ navigator: it }));
      } };
    }), nt(i, "Core/Axis/ScrollbarAxis.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      var J;
      let { composed: it } = B, { addEvent: st, defined: tt, pick: V, pushUnique: _ } = $;
      return function(N) {
        let D;
        function p(a) {
          let u = V(a.options && a.options.min, a.min), b = V(a.options && a.options.max, a.max);
          return { axisMin: u, axisMax: b, scrollMin: tt(a.dataMin) ? Math.min(u, a.min, a.dataMin, V(a.threshold, 1 / 0)) : u, scrollMax: tt(a.dataMax) ? Math.max(b, a.max, a.dataMax, V(a.threshold, -1 / 0)) : b };
        }
        function y() {
          let a = this.scrollbar, u = a && !a.options.opposite, b = this.horiz ? 2 : u ? 3 : 1;
          a && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[b] += a.size + (a.options.margin || 0));
        }
        function m() {
          let a = this;
          a.options && a.options.scrollbar && a.options.scrollbar.enabled && (a.options.scrollbar.vertical = !a.horiz, a.options.startOnTick = a.options.endOnTick = !1, a.scrollbar = new D(a.chart.renderer, a.options.scrollbar, a.chart), st(a.scrollbar, "changed", function(u) {
            let b, l, { axisMin: d, axisMax: C, scrollMin: R, scrollMax: z } = p(a), O = z - R;
            if (tt(d) && tt(C))
              if (a.horiz && !a.reversed || !a.horiz && a.reversed ? (b = R + O * this.to, l = R + O * this.from) : (b = R + O * (1 - this.from), l = R + O * (1 - this.to)), this.shouldUpdateExtremes(u.DOMType)) {
                let h = u.DOMType !== "mousemove" && u.DOMType !== "touchmove" && void 0;
                a.setExtremes(l, b, !0, h, u);
              } else this.setRange(this.from, this.to);
          }));
        }
        function w() {
          let a, u, b, { scrollMin: l, scrollMax: d } = p(this), C = this.scrollbar, R = this.axisTitleMargin + (this.titleOffset || 0), z = this.chart.scrollbarsOffsets, O = this.options.margin || 0;
          if (C && z) {
            if (this.horiz) this.opposite || (z[1] += R), C.position(this.left, this.top + this.height + 2 + z[1] - (this.opposite ? O : 0), this.width, this.height), this.opposite || (z[1] += O), a = 1;
            else {
              let h;
              this.opposite && (z[0] += R), h = C.options.opposite ? this.left + this.width + 2 + z[0] - (this.opposite ? 0 : O) : this.opposite ? 0 : O, C.position(h, this.top, this.width, this.height), this.opposite && (z[0] += O), a = 0;
            }
            if (z[a] += C.size + (C.options.margin || 0), isNaN(l) || isNaN(d) || !tt(this.min) || !tt(this.max) || this.dataMin === this.dataMax) C.setRange(0, 1);
            else if (this.min === this.max) {
              let h = this.pointRange / (this.dataMax + 1);
              u = h * this.min, b = h * (this.max + 1), C.setRange(u, b);
            } else u = (this.min - l) / (d - l), b = (this.max - l) / (d - l), this.horiz && !this.reversed || !this.horiz && this.reversed ? C.setRange(u, b) : C.setRange(1 - b, 1 - u);
          }
        }
        N.compose = function(a, u) {
          _(it, "Axis.Scrollbar") && (D = u, st(a, "afterGetOffset", y), st(a, "afterInit", m), st(a, "afterRender", w));
        };
      }(J || (J = {})), J;
    }), nt(i, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), nt(i, "Stock/Scrollbar/Scrollbar.js", [i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Axis/ScrollbarAxis.js"], i["Stock/Scrollbar/ScrollbarDefaults.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      let { defaultOptions: tt } = B, { addEvent: V, correctFloat: _, crisp: N, defined: D, destroyObjectProperties: p, fireEvent: y, merge: m, pick: w, removeEvent: a } = st;
      class u {
        static compose(l) {
          J.compose(l, u);
        }
        static swapXY(l, d) {
          return d && l.forEach((C) => {
            let R, z = C.length;
            for (let O = 0; O < z; O += 2) typeof (R = C[O + 1]) == "number" && (C[O + 1] = C[O + 2], C[O + 2] = R);
          }), l;
        }
        constructor(l, d, C) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(l, d, C);
        }
        addEvents() {
          let l = this.options.inverted ? [1, 0] : [0, 1], d = this.scrollbarButtons, C = this.scrollbarGroup.element, R = this.track.element, z = this.mouseDownHandler.bind(this), O = this.mouseMoveHandler.bind(this), h = this.mouseUpHandler.bind(this), f = [[d[l[0]].element, "click", this.buttonToMinClick.bind(this)], [d[l[1]].element, "click", this.buttonToMaxClick.bind(this)], [R, "click", this.trackClick.bind(this)], [C, "mousedown", z], [C.ownerDocument, "mousemove", O], [C.ownerDocument, "mouseup", h], [C, "touchstart", z], [C.ownerDocument, "touchmove", O], [C.ownerDocument, "touchend", h]];
          f.forEach(function(s) {
            V.apply(null, s);
          }), this._events = f;
        }
        buttonToMaxClick(l) {
          let d = (this.to - this.from) * w(this.options.step, 0.2);
          this.updatePosition(this.from + d, this.to + d), y(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: l });
        }
        buttonToMinClick(l) {
          let d = _(this.to - this.from) * w(this.options.step, 0.2);
          this.updatePosition(_(this.from - d), _(this.to - d)), y(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: l });
        }
        cursorToScrollbarPosition(l) {
          let d = this.options, C = d.minWidth > this.calculatedWidth ? d.minWidth : 0;
          return { chartX: (l.chartX - this.x - this.xOffset) / (this.barWidth - C), chartY: (l.chartY - this.y - this.yOffset) / (this.barWidth - C) };
        }
        destroy() {
          let l = this, d = l.chart.scroller;
          l.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(C) {
            l[C] && l[C].destroy && (l[C] = l[C].destroy());
          }), d && l === d.scrollbar && (d.scrollbar = null, p(d.scrollbarButtons));
        }
        drawScrollbarButton(l) {
          let d = this.renderer, C = this.scrollbarButtons, R = this.options, z = this.size, O = d.g().add(this.group);
          if (C.push(O), R.buttonsEnabled) {
            let h = d.rect().addClass("highcharts-scrollbar-button").add(O);
            this.chart.styledMode || h.attr({ stroke: R.buttonBorderColor, "stroke-width": R.buttonBorderWidth, fill: R.buttonBackgroundColor }), h.attr(h.crisp({ x: -0.5, y: -0.5, width: z, height: z, r: R.buttonBorderRadius }, h.strokeWidth()));
            let f = d.path(u.swapXY([["M", z / 2 + (l ? -1 : 1), z / 2 - 3], ["L", z / 2 + (l ? -1 : 1), z / 2 + 3], ["L", z / 2 + (l ? 2 : -2), z / 2]], R.vertical)).addClass("highcharts-scrollbar-arrow").add(C[l]);
            this.chart.styledMode || f.attr({ fill: R.buttonArrowColor });
          }
        }
        init(l, d, C) {
          this.scrollbarButtons = [], this.renderer = l, this.userOptions = d, this.options = m(it, tt.scrollbar, d), this.options.margin = w(this.options.margin, 10), this.chart = C, this.size = w(this.options.size, this.options.height), d.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(l) {
          var R;
          let d = ((R = this.chart.pointer) == null ? void 0 : R.normalize(l)) || l, C = this.cursorToScrollbarPosition(d);
          this.chartX = C.chartX, this.chartY = C.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(l) {
          var O;
          let d, C = ((O = this.chart.pointer) == null ? void 0 : O.normalize(l)) || l, R = this.options.vertical ? "chartY" : "chartX", z = this.initPositions || [];
          this.grabbedCenter && (!l.touches || l.touches[0][R] !== 0) && (d = this.cursorToScrollbarPosition(C)[R] - this[R], this.hasDragged = !0, this.updatePosition(z[0] + d, z[1] + d), this.hasDragged && y(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: l.type, DOMEvent: l }));
        }
        mouseUpHandler(l) {
          this.hasDragged && y(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: l.type, DOMEvent: l }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(l, d, C, R) {
          let { buttonsEnabled: z, margin: O = 0, vertical: h } = this.options, f = this.rendered ? "animate" : "attr", s = R, t = 0;
          this.group.show(), this.x = l, this.y = d + this.trackBorderWidth, this.width = C, this.height = R, this.xOffset = s, this.yOffset = t, h ? (this.width = this.yOffset = C = t = this.size, this.xOffset = s = 0, this.yOffset = t = z ? this.size : 0, this.barWidth = R - (z ? 2 * C : 0), this.x = l += O) : (this.height = R = this.size, this.xOffset = s = z ? this.size : 0, this.barWidth = C - (z ? 2 * R : 0), this.y = this.y + O), this.group[f]({ translateX: l, translateY: this.y }), this.track[f]({ width: C, height: R }), this.scrollbarButtons[1][f]({ translateX: h ? 0 : C - s, translateY: h ? R - t : 0 });
        }
        removeEvents() {
          this._events.forEach(function(l) {
            a.apply(null, l);
          }), this._events.length = 0;
        }
        render() {
          let l = this.renderer, d = this.options, C = this.size, R = this.chart.styledMode, z = l.g("scrollbar").attr({ zIndex: d.zIndex }).hide().add();
          this.group = z, this.track = l.rect().addClass("highcharts-scrollbar-track").attr({ r: d.trackBorderRadius || 0, height: C, width: C }).add(z), R || this.track.attr({ fill: d.trackBackgroundColor, stroke: d.trackBorderColor, "stroke-width": d.trackBorderWidth });
          let O = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -N(0, O), y: -N(0, O) }), this.scrollbarGroup = l.g().add(z), this.scrollbar = l.rect().addClass("highcharts-scrollbar-thumb").attr({ height: C - O, width: C - O, r: d.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = l.path(u.swapXY([["M", -3, C / 4], ["L", -3, 2 * C / 3], ["M", 0, C / 4], ["L", 0, 2 * C / 3], ["M", 3, C / 4], ["L", 3, 2 * C / 3]], d.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), R || (this.scrollbar.attr({ fill: d.barBackgroundColor, stroke: d.barBorderColor, "stroke-width": d.barBorderWidth }), this.scrollbarRifles.attr({ stroke: d.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-N(0, this.scrollbarStrokeWidth), -N(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(l, d) {
          let C, R, z = this.options, O = z.vertical, h = z.minWidth, f = this.barWidth, s = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!D(f)) return;
          let t = f * Math.min(d, 1);
          C = Math.ceil(f * (l = Math.max(l, 0))), this.calculatedWidth = R = _(t - C), R < h && (C = (f - h + R) * l, R = h);
          let e = Math.floor(C + this.xOffset + this.yOffset), r = R / 2 - 0.5;
          this.from = l, this.to = d, O ? (this.scrollbarGroup[s]({ translateY: e }), this.scrollbar[s]({ height: R }), this.scrollbarRifles[s]({ translateY: r }), this.scrollbarTop = e, this.scrollbarLeft = 0) : (this.scrollbarGroup[s]({ translateX: e }), this.scrollbar[s]({ width: R }), this.scrollbarRifles[s]({ translateX: r }), this.scrollbarLeft = e, this.scrollbarTop = 0), R <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), z.showFull === !1 && (l <= 0 && d >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(l) {
          return w(this.options.liveRedraw, $.svg && !$.isTouchDevice && !this.chart.boosted) || l === "mouseup" || l === "touchend" || !D(l);
        }
        trackClick(l) {
          var O;
          let d = ((O = this.chart.pointer) == null ? void 0 : O.normalize(l)) || l, C = this.to - this.from, R = this.y + this.scrollbarTop, z = this.x + this.scrollbarLeft;
          this.options.vertical && d.chartY > R || !this.options.vertical && d.chartX > z ? this.updatePosition(this.from + C, this.to + C) : this.updatePosition(this.from - C, this.to - C), y(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: l });
        }
        update(l) {
          this.destroy(), this.init(this.chart.renderer, m(!0, this.options, l), this.chart);
        }
        updatePosition(l, d) {
          d > 1 && (l = _(1 - _(d - l)), d = 1), l < 0 && (d = _(d - l), l = 0), this.from = l, this.to = d;
        }
      }
      return u.defaultOptions = it, tt.scrollbar = m(!0, u.defaultOptions, tt.scrollbar), u;
    }), nt(i, "Stock/Navigator/Navigator.js", [i["Core/Axis/Axis.js"], i["Stock/Navigator/ChartNavigatorComposition.js"], i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Axis/NavigatorAxisComposition.js"], i["Stock/Navigator/NavigatorComposition.js"], i["Stock/Scrollbar/Scrollbar.js"], i["Core/Renderer/SVG/SVGRenderer.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _, N) {
      let { defaultOptions: D } = J, { isTouchDevice: p } = it, { prototype: { symbols: y } } = _, { addEvent: m, clamp: w, correctFloat: a, defined: u, destroyObjectProperties: b, erase: l, extend: d, find: C, fireEvent: R, isArray: z, isNumber: O, merge: h, pick: f, removeEvent: s, splat: t } = N;
      function e(g, ...o) {
        let c = [].filter.call(o, O);
        if (c.length) return Math[g].apply(0, c);
      }
      class r {
        static compose(o, c, n) {
          $.compose(o, r), tt.compose(o, c, n);
        }
        constructor(o) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(o);
        }
        drawHandle(o, c, n, S) {
          let j = this.navigatorOptions.handles.height;
          this.handles[c][S](n ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(o, 10) + 0.5 - j) } : { translateX: Math.round(this.left + parseInt(o, 10)), translateY: Math.round(this.top + this.height / 2 - j / 2 - 1) });
        }
        drawOutline(o, c, n, S) {
          let j = this.navigatorOptions.maskInside, v = this.outline.strokeWidth(), P = v / 2, G = v % 2 / 2, W = this.scrollButtonSize, Q = this.size, k = this.top, A = this.height, L = k - P, Y = k + A, x = this.left, T, M;
          n ? (T = k + c + G, c = k + o + G, M = [["M", x + A, k - W - G], ["L", x + A, T], ["L", x, T], ["M", x, c], ["L", x + A, c], ["L", x + A, k + Q + W]], j && M.push(["M", x + A, T - P], ["L", x + A, c + P])) : (x -= W, o += x + W - G, c += x + W - G, M = [["M", x, L], ["L", o, L], ["L", o, Y], ["M", c, Y], ["L", c, L], ["L", x + Q + 2 * W, L]], j && M.push(["M", o - P, L], ["L", c + P, L])), this.outline[S]({ d: M });
        }
        drawMasks(o, c, n, S) {
          let j, v, P, G, W = this.left, Q = this.top, k = this.height;
          n ? (P = [W, W, W], G = [Q, Q + o, Q + c], v = [k, k, k], j = [o, c - o, this.size - c]) : (P = [W, W + o, W + c], G = [Q, Q, Q], v = [o, c - o, this.size - c], j = [k, k, k]), this.shades.forEach((A, L) => {
            A[S]({ x: P[L], y: G[L], width: v[L], height: j[L] });
          });
        }
        renderElements() {
          var W, Q;
          let o = this, c = o.navigatorOptions, n = c.maskInside, S = o.chart, j = S.inverted, v = S.renderer, P = { cursor: j ? "ns-resize" : "ew-resize" }, G = (W = o.navigatorGroup) != null ? W : o.navigatorGroup = v.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!n, n, !n].forEach((k, A) => {
            var Y;
            let L = (Y = o.shades[A]) != null ? Y : o.shades[A] = v.rect().addClass("highcharts-navigator-mask" + (A === 1 ? "-inside" : "-outside")).add(G);
            S.styledMode || (L.attr({ fill: k ? c.maskFill : "rgba(0,0,0,0)" }), A === 1 && L.css(P));
          }), o.outline || (o.outline = v.path().addClass("highcharts-navigator-outline").add(G)), S.styledMode || o.outline.attr({ "stroke-width": c.outlineWidth, stroke: c.outlineColor }), (Q = c.handles) == null ? void 0 : Q.enabled) {
            let k = c.handles, { height: A, width: L } = k;
            [0, 1].forEach((Y) => {
              var T;
              let x = k.symbols[Y];
              if (o.handles[Y] && o.handles[Y].symbolUrl === x) {
                if (!o.handles[Y].isImg && o.handles[Y].symbolName !== x) {
                  let M = y[x].call(y, -L / 2 - 1, 0, L, A);
                  o.handles[Y].attr({ d: M }), o.handles[Y].symbolName = x;
                }
              } else (T = o.handles[Y]) == null || T.destroy(), o.handles[Y] = v.symbol(x, -L / 2 - 1, 0, L, A, k), o.handles[Y].attr({ zIndex: 7 - Y }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][Y]).add(G), o.addMouseEvents();
              S.inverted && o.handles[Y].attr({ rotation: 90, rotationOriginX: Math.floor(-L / 2), rotationOriginY: (A + L) / 2 }), S.styledMode || o.handles[Y].attr({ fill: k.backgroundColor, stroke: k.borderColor, "stroke-width": k.lineWidth, width: k.width, height: k.height, x: -L / 2 - 1, y: 0 }).css(P);
            });
          }
        }
        update(o, c = !1) {
          var j, v;
          let n = this.chart, S = n.options.chart.inverted !== ((j = n.scrollbar) == null ? void 0 : j.options.vertical);
          if (h(!0, n.options.navigator, o), this.navigatorOptions = n.options.navigator || {}, this.setOpposite(), u(o.enabled) || S) return this.destroy(), this.navigatorEnabled = o.enabled || this.navigatorEnabled, this.init(n);
          if (this.navigatorEnabled && (this.isDirty = !0, o.adaptToUpdatedData === !1 && this.baseSeries.forEach((P) => {
            s(P, "updatedData", this.updatedDataHandler);
          }, this), o.adaptToUpdatedData && this.baseSeries.forEach((P) => {
            P.eventsToUnbind.push(m(P, "updatedData", this.updatedDataHandler));
          }, this), (o.series || o.baseSeries) && this.setBaseSeries(void 0, !1), o.height || o.xAxis || o.yAxis)) {
            this.height = (v = o.height) != null ? v : this.height;
            let P = this.getXAxisOffsets();
            this.xAxis.update({ ...o.xAxis, offsets: P, [n.inverted ? "width" : "height"]: this.height, [n.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...o.yAxis, [n.inverted ? "width" : "height"]: this.height }, !1);
          }
          c && n.redraw();
        }
        render(o, c, n, S) {
          let j = this.chart, v = this.xAxis, P = v.pointRange || 0, G = v.navigatorAxis.fake ? j.xAxis[0] : v, W = this.navigatorEnabled, Q = this.rendered, k = j.inverted, A = j.xAxis[0].minRange, L = j.xAxis[0].options.maxRange, Y = this.scrollButtonSize, x, T, M, U = this.scrollbarHeight, H, q;
          if (this.hasDragged && !u(n)) return;
          if (this.isDirty && this.renderElements(), o = a(o - P / 2), c = a(c + P / 2), !O(o) || !O(c)) {
            if (!Q) return;
            n = 0, S = f(v.width, G.width);
          }
          this.left = f(v.left, j.plotLeft + Y + (k ? j.plotWidth : 0));
          let F = this.size = H = f(v.len, (k ? j.plotHeight : j.plotWidth) - 2 * Y);
          x = k ? U : H + 2 * Y, n = f(n, v.toPixels(o, !0)), S = f(S, v.toPixels(c, !0)), O(n) && Math.abs(n) !== 1 / 0 || (n = 0, S = x);
          let et = v.toValue(n, !0), rt = v.toValue(S, !0), at = Math.abs(a(rt - et));
          at < A ? this.grabbedLeft ? n = v.toPixels(rt - A - P, !0) : this.grabbedRight && (S = v.toPixels(et + A + P, !0)) : u(L) && a(at - P) > L && (this.grabbedLeft ? n = v.toPixels(rt - L - P, !0) : this.grabbedRight && (S = v.toPixels(et + L + P, !0))), this.zoomedMax = w(Math.max(n, S), 0, F), this.zoomedMin = w(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(n, S), 0, F), this.range = this.zoomedMax - this.zoomedMin, F = Math.round(this.zoomedMax);
          let ct = Math.round(this.zoomedMin);
          W && (this.navigatorGroup.attr({ visibility: "inherit" }), q = Q && !this.hasDragged ? "animate" : "attr", this.drawMasks(ct, F, k, q), this.drawOutline(ct, F, k, q), this.navigatorOptions.handles.enabled && (this.drawHandle(ct, 0, k, q), this.drawHandle(F, 1, k, q))), this.scrollbar && (k ? (M = this.top - Y, T = this.left - U + (W || !G.opposite ? 0 : (G.titleOffset || 0) + G.axisTitleMargin), U = H + 2 * Y) : (M = this.top + (W ? this.height : -U), T = this.left - Y), this.scrollbar.position(T, M, x, U), this.scrollbar.setRange(this.zoomedMin / (H || 1), this.zoomedMax / (H || 1))), this.rendered = !0, this.isDirty = !1, R(this, "afterRender");
        }
        addMouseEvents() {
          let o = this, c = o.chart, n = c.container, S = [], j, v;
          o.mouseMoveHandler = j = function(P) {
            o.onMouseMove(P);
          }, o.mouseUpHandler = v = function(P) {
            o.onMouseUp(P);
          }, (S = o.getPartsEvents("mousedown")).push(m(c.renderTo, "mousemove", j), m(n.ownerDocument, "mouseup", v), m(c.renderTo, "touchmove", j), m(n.ownerDocument, "touchend", v)), S.concat(o.getPartsEvents("touchstart")), o.eventsToUnbind = S, o.series && o.series[0] && S.push(m(o.series[0].xAxis, "foundExtremes", function() {
            c.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(o) {
          let c = this, n = [];
          return ["shades", "handles"].forEach(function(S) {
            c[S].forEach(function(j, v) {
              n.push(m(j.element, o, function(P) {
                c[S + "Mousedown"](P, v);
              }));
            });
          }), n;
        }
        shadesMousedown(o, c) {
          var Y;
          o = ((Y = this.chart.pointer) == null ? void 0 : Y.normalize(o)) || o;
          let n = this.chart, S = this.xAxis, j = this.zoomedMin, v = this.size, P = this.range, G = this.left, W = o.chartX, Q, k, A, L;
          n.inverted && (W = o.chartY, G = this.top), c === 1 ? (this.grabbedCenter = W, this.fixedWidth = P, this.dragOffset = W - j) : (L = W - G - P / 2, c === 0 ? L = Math.max(0, L) : c === 2 && L + P >= v && (L = v - P, this.reversedExtremes ? (L -= P, k = this.getUnionExtremes().dataMin) : Q = this.getUnionExtremes().dataMax), L !== j && (this.fixedWidth = P, u((A = S.navigatorAxis.toFixedRange(L, L + P, k, Q)).min) && R(this, "setRange", { min: Math.min(A.min, A.max), max: Math.max(A.min, A.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(o, c) {
          var v;
          o = ((v = this.chart.pointer) == null ? void 0 : v.normalize(o)) || o;
          let n = this.chart, S = n.xAxis[0], j = this.reversedExtremes;
          c === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = j ? S.min : S.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = j ? S.max : S.min), n.setFixedRange(void 0);
        }
        onMouseMove(o) {
          var Q;
          let c = this, n = c.chart, S = c.navigatorSize, j = c.range, v = c.dragOffset, P = n.inverted, G = c.left, W;
          (!o.touches || o.touches[0].pageX !== 0) && (W = (o = ((Q = n.pointer) == null ? void 0 : Q.normalize(o)) || o).chartX, P && (G = c.top, W = o.chartY), c.grabbedLeft ? (c.hasDragged = !0, c.render(0, 0, W - G, c.otherHandlePos)) : c.grabbedRight ? (c.hasDragged = !0, c.render(0, 0, c.otherHandlePos, W - G)) : c.grabbedCenter && (c.hasDragged = !0, W < v ? W = v : W > S + v - j && (W = S + v - j), c.render(0, 0, W - v, W - v + j)), c.hasDragged && c.scrollbar && f(c.scrollbar.options.liveRedraw, !p && !this.chart.boosted) && (o.DOMType = o.type, setTimeout(function() {
            c.onMouseUp(o);
          }, 0)));
        }
        onMouseUp(o) {
          let c, n, S, j, v, P, G = this.chart, W = this.xAxis, Q = this.scrollbar, k = o.DOMEvent || o, A = G.inverted, L = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!Q || !Q.hasDragged) || o.trigger === "scrollbar") && (S = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? j = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (v = this.fixedExtreme), this.zoomedMax === this.size && (v = this.reversedExtremes ? S.dataMin : S.dataMax), this.zoomedMin === 0 && (j = this.reversedExtremes ? S.dataMax : S.dataMin), u((P = W.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, j, v)).min) && R(this, "setRange", { min: Math.min(P.min, P.max), max: Math.max(P.min, P.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: k } })), o.DOMType !== "mousemove" && o.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && O(this.zoomedMin) && O(this.zoomedMax) && (n = Math.round(this.zoomedMin), c = Math.round(this.zoomedMax), this.shades && this.drawMasks(n, c, A, L), this.outline && this.drawOutline(n, c, A, L), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(n, 0, A, L), this.drawHandle(c, 1, A, L)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(o) {
            o();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let o = this.baseSeries || [];
          this.navigatorEnabled && o[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && o.forEach(function(c) {
            s(c, "updatedData", this.updatedDataHandler);
          }, this), o[0].xAxis && s(o[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(o) {
          var x;
          let c = o.options, n = c.navigator || {}, S = n.enabled, j = c.scrollbar || {}, v = j.enabled, P = S && n.height || 0, G = v && j.height || 0, W = j.buttonsEnabled && G || 0;
          this.handles = [], this.shades = [], this.chart = o, this.setBaseSeries(), this.height = P, this.scrollbarHeight = G, this.scrollButtonSize = W, this.scrollbarEnabled = v, this.navigatorEnabled = S, this.navigatorOptions = n, this.scrollbarOptions = j, this.setOpposite();
          let Q = this, k = Q.baseSeries, A = o.xAxis.length, L = o.yAxis.length, Y = k && k[0] && k[0].xAxis || o.xAxis[0] || { options: {} };
          if (o.isDirtyBox = !0, Q.navigatorEnabled) {
            let T = this.getXAxisOffsets();
            Q.xAxis = new B(o, h({ breaks: Y.options.breaks, ordinal: Y.options.ordinal, overscroll: Y.options.overscroll }, n.xAxis, { type: "datetime", yAxis: (x = n.yAxis) == null ? void 0 : x.id, index: A, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: Y.options.ordinal ? 0 : Y.options.minPadding, maxPadding: Y.options.ordinal ? 0 : Y.options.maxPadding, zoomEnabled: !1 }, o.inverted ? { offsets: T, width: P } : { offsets: T, height: P }), "xAxis"), Q.yAxis = new B(o, h(n.yAxis, { alignTicks: !1, offset: 0, index: L, isInternal: !0, reversed: f(n.yAxis && n.yAxis.reversed, o.yAxis[0] && o.yAxis[0].reversed, !1), zoomEnabled: !1 }, o.inverted ? { width: P } : { height: P }), "yAxis"), k || n.series.data ? Q.updateNavigatorSeries(!1) : o.series.length === 0 && (Q.unbindRedraw = m(o, "beforeRedraw", function() {
              o.series.length > 0 && !Q.series && (Q.setBaseSeries(), Q.unbindRedraw());
            })), Q.reversedExtremes = o.inverted && !Q.xAxis.reversed || !o.inverted && Q.xAxis.reversed, Q.renderElements(), Q.addMouseEvents();
          } else Q.xAxis = { chart: o, navigatorAxis: { fake: !0 }, translate: function(T, M) {
            let U = o.xAxis[0], H = U.getExtremes(), q = U.len - 2 * W, F = e("min", U.options.min, H.dataMin), et = e("max", U.options.max, H.dataMax) - F;
            return M ? T * et / q + F : q * (T - F) / et;
          }, toPixels: function(T) {
            return this.translate(T);
          }, toValue: function(T) {
            return this.translate(T, !0);
          } }, Q.xAxis.navigatorAxis.axis = Q.xAxis, Q.xAxis.navigatorAxis.toFixedRange = st.prototype.toFixedRange.bind(Q.xAxis.navigatorAxis);
          if (o.options.scrollbar.enabled) {
            let T = h(o.options.scrollbar, { vertical: o.inverted });
            !O(T.margin) && Q.navigatorEnabled && (T.margin = o.inverted ? -3 : 3), o.scrollbar = Q.scrollbar = new V(o.renderer, T, o), m(Q.scrollbar, "changed", function(M) {
              let U = Q.size, H = U * this.to, q = U * this.from;
              Q.hasDragged = Q.scrollbar.hasDragged, Q.render(0, 0, q, H), this.shouldUpdateExtremes(M.DOMType) && setTimeout(function() {
                Q.onMouseUp(M);
              });
            });
          }
          Q.addBaseSeriesEvents(), Q.addChartEvents();
        }
        setOpposite() {
          let o = this.navigatorOptions, c = this.navigatorEnabled, n = this.chart;
          this.opposite = f(o.opposite, !!(!c && n.inverted));
        }
        getUnionExtremes(o) {
          let c, n = this.chart.xAxis[0], S = this.xAxis, j = S.options, v = n.options;
          return o && n.dataMin === null || (c = { dataMin: f(j && j.min, e("min", v.min, n.dataMin, S.dataMin, S.min)), dataMax: f(j && j.max, e("max", v.max, n.dataMax, S.dataMax, S.max)) }), c;
        }
        setBaseSeries(o, c) {
          let n = this.chart, S = this.baseSeries = [];
          o = o || n.options && n.options.navigator.baseSeries || (n.series.length ? C(n.series, (j) => !j.options.isInternal).index : 0), (n.series || []).forEach((j, v) => {
            !j.options.isInternal && (j.options.showInNavigator || (v === o || j.options.id === o) && j.options.showInNavigator !== !1) && S.push(j);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, c);
        }
        updateNavigatorSeries(o, c) {
          var A, L;
          let n = this, S = n.chart, j = n.baseSeries, v = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (A = this.navigatorOptions.xAxis) == null ? void 0 : A.id, yAxis: (L = this.navigatorOptions.yAxis) == null ? void 0 : L.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, P = n.series = (n.series || []).filter((Y) => {
            let x = Y.baseSeries;
            return !(0 > j.indexOf(x)) || (x && (s(x, "updatedData", n.updatedDataHandler), delete x.navigatorSeries), Y.chart && Y.destroy(), !1);
          }), G, W, Q = n.navigatorOptions.series, k;
          j && j.length && j.forEach((Y) => {
            let x = Y.navigatorSeries, T = d({ color: Y.color, visible: Y.visible }, z(Q) ? D.navigator.series : Q);
            if (x && n.navigatorOptions.adaptToUpdatedData === !1) return;
            v.name = "Navigator " + j.length, k = (G = Y.options || {}).navigatorOptions || {}, T.dataLabels = t(T.dataLabels), (W = h(G, v, T, k)).pointRange = f(T.pointRange, k.pointRange, D.plotOptions[W.type || "line"].pointRange);
            let M = k.data || T.data;
            n.hasNavigatorData = n.hasNavigatorData || !!M, W.data = M || G.data && G.data.slice(0), x && x.options ? x.update(W, c) : (Y.navigatorSeries = S.initSeries(W), S.setSortedData(), Y.navigatorSeries.baseSeries = Y, P.push(Y.navigatorSeries));
          }), (Q.data && !(j && j.length) || z(Q)) && (n.hasNavigatorData = !1, (Q = t(Q)).forEach((Y, x) => {
            v.name = "Navigator " + (P.length + 1), (W = h(D.navigator.series, { color: S.series[x] && !S.series[x].options.isInternal && S.series[x].color || S.options.colors[x] || S.options.colors[0] }, v, Y)).data = Y.data, W.data && (n.hasNavigatorData = !0, P.push(S.initSeries(W)));
          })), o && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let o = this, c = o.baseSeries || [];
          c[0] && c[0].xAxis && c[0].eventsToUnbind.push(m(c[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), c.forEach((n) => {
            n.eventsToUnbind.push(m(n, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), n.eventsToUnbind.push(m(n, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && n.xAxis && n.eventsToUnbind.push(m(n, "updatedData", this.updatedDataHandler)), n.eventsToUnbind.push(m(n, "remove", function() {
              c && l(c, n), this.navigatorSeries && (l(o.series, this.navigatorSeries), u(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(o) {
          return this.baseSeries.reduce(function(c, n) {
            return Math.min(c, n.xData && n.xData.length ? n.xData[0] : c);
          }, o);
        }
        modifyNavigatorAxisExtremes() {
          let o = this.xAxis;
          if (o.getExtremes !== void 0) {
            let c = this.getUnionExtremes(!0);
            c && (c.dataMin !== o.min || c.dataMax !== o.max) && (o.min = c.dataMin, o.max = c.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var x;
          let o, c, n = this.chart.navigator, S = this.getExtremes(), j = S.min, v = S.max, P = S.dataMin, G = S.dataMax, W = v - j, Q = n.stickToMin, k = n.stickToMax, A = f((x = this.ordinal) == null ? void 0 : x.convertOverscroll(this.options.overscroll), 0), L = n.series && n.series[0], Y = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (Q && (o = (c = P) + W), k && (o = G + A, Q || (c = Math.max(P, o - W, n.getBaseSeriesMin(L && L.xData ? L.xData[0] : -Number.MAX_VALUE)))), Y && (Q || k) && O(c) && (this.min = this.userMin = c, this.max = this.userMax = o)), n.stickToMin = n.stickToMax = null;
        }
        updatedDataHandler() {
          let o = this.chart.navigator, c = this.navigatorSeries, n = o.reversedExtremes ? Math.round(o.zoomedMin) === 0 : Math.round(o.zoomedMax) >= Math.round(o.size);
          o.stickToMax = f(this.chart.options.navigator && this.chart.options.navigator.stickToMax, n), o.stickToMin = o.shouldStickToMin(this, o), c && !o.hasNavigatorData && (c.options.pointStart = this.xData[0], c.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(o, c) {
          let n = c.getBaseSeriesMin(o.xData[0]), S = o.xAxis, j = S.max, v = S.min, P = S.options.range;
          return !!(O(j) && O(v)) && (P && j - n > 0 ? j - n < P : v <= n);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(m(this.chart, "redraw", function() {
            let o = this.navigator, c = o && (o.baseSeries && o.baseSeries[0] && o.baseSeries[0].xAxis || this.xAxis[0]);
            c && o.render(c.min, c.max);
          }), m(this.chart, "getMargins", function() {
            let o = this.navigator, c = o.opposite ? "plotTop" : "marginBottom";
            this.inverted && (c = o.opposite ? "marginRight" : "plotLeft"), this[c] = (this[c] || 0) + (o.navigatorEnabled || !this.inverted ? o.height + o.scrollbarHeight : 0) + o.navigatorOptions.margin;
          }), m(r, "setRange", function(o) {
            this.chart.xAxis[0].setExtremes(o.min, o.max, o.redraw, o.animation, o.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (l(this.chart.xAxis, this.xAxis), l(this.chart.axes, this.xAxis)), this.yAxis && (l(this.chart.yAxis, this.yAxis), l(this.chart.axes, this.yAxis)), (this.series || []).forEach((o) => {
            o.destroy && o.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((o) => {
            this[o] && this[o].destroy && this[o].destroy(), this[o] = null;
          }), [this.handles].forEach((o) => {
            b(o);
          }), this.navigatorEnabled = !1;
        }
      }
      return r;
    }), nt(i, "Accessibility/Components/NavigatorComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/Announcer.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Stock/Navigator/Navigator.js"], i["Core/Animation/AnimationUtilities.js"], i["Core/Templating.js"], i["Core/Utilities.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/Utils/ChartUtilities.js"]], function(B, $, J, it, st, tt, V, _, N) {
      let { animObject: D } = st, { format: p } = tt, { clamp: y, pick: m, syncTimeout: w } = V, { getFakeMouseEvent: a } = _, { getAxisRangeDescription: u, fireEventOnWrappedOrUnwrappedElement: b } = N;
      return class extends B {
        init() {
          let l = this.chart, d = this;
          this.announcer = new $(l, "polite"), this.addEvent(it, "afterRender", function() {
            this.chart === d.chart && this.chart.renderer && w(() => {
              d.proxyProvider.updateGroupProxyElementPositions("navigator"), d.updateHandleValues();
            }, D(m(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        onChartUpdate() {
          var R, z, O;
          let l = this.chart, d = l.options, C = d.navigator;
          if (C.enabled && ((R = C.accessibility) != null && R.enabled)) {
            let h = d.accessibility.landmarkVerbosity, f = (z = d.lang.accessibility) == null ? void 0 : z.navigator.groupLabel;
            this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", { role: h === "all" ? "region" : "group", "aria-label": p(f, { chart: l }, l) });
            let s = (O = d.lang.accessibility) == null ? void 0 : O.navigator.handleLabel;
            [0, 1].forEach((t) => {
              let e = this.getHandleByIx(t);
              if (e) {
                let r = this.proxyProvider.addProxyElement("navigator", { click: e }, "input", { type: "range", "aria-label": p(s, { handleIx: t, chart: l }, l) });
                this[t ? "maxHandleProxy" : "minHandleProxy"] = r.innerElement, r.innerElement.style.pointerEvents = "none", r.innerElement.oninput = () => this.updateNavigator();
              }
            }), this.updateHandleValues();
          } else this.proxyProvider.removeGroup("navigator");
        }
        getNavigatorHandleNavigation(l) {
          let d = this, C = this.chart, R = l ? this.maxHandleProxy : this.minHandleProxy, z = this.keyCodes;
          return new J(C, { keyCodeMap: [[[z.left, z.right, z.up, z.down], function(O) {
            if (R) {
              let h = O === z.left || O === z.up ? -1 : 1;
              R.value = "" + y(parseFloat(R.value) + h, 0, 100), d.updateNavigator(() => {
                let f = d.getHandleByIx(l);
                f && C.setFocusToElement(f, R);
              });
            }
            return this.response.success;
          }]], init: () => {
            C.setFocusToElement(this.getHandleByIx(l), R);
          }, validate: () => {
            var O;
            return !!(this.getHandleByIx(l) && R && ((O = C.options.navigator.accessibility) != null && O.enabled));
          } });
        }
        getKeyboardNavigation() {
          return [this.getNavigatorHandleNavigation(0), this.getNavigatorHandleNavigation(1)];
        }
        destroy() {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
        }
        updateHandleValues() {
          let l = this.chart.navigator;
          if (l && this.minHandleProxy && this.maxHandleProxy) {
            let d = l.size;
            this.minHandleProxy.value = "" + Math.round(l.zoomedMin / d * 100), this.maxHandleProxy.value = "" + Math.round(l.zoomedMax / d * 100);
          }
        }
        getHandleByIx(l) {
          let d = this.chart.navigator;
          return d && d.handles && d.handles[l];
        }
        updateNavigator(l) {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((d) => {
            var O;
            let C = this.chart, { navigator: R, pointer: z } = C;
            if (R && z && this.minHandleProxy && this.maxHandleProxy) {
              let h = z.getChartPosition(), f = parseFloat(this.minHandleProxy.value) / 100 * R.size, s = parseFloat(this.maxHandleProxy.value) / 100 * R.size;
              [[0, "mousedown", R.zoomedMin], [0, "mousemove", f], [0, "mouseup", f], [1, "mousedown", R.zoomedMax], [1, "mousemove", s], [1, "mouseup", s]].forEach(([r, g, o]) => {
                var n;
                let c = (n = this.getHandleByIx(r)) == null ? void 0 : n.element;
                c && b(c, a(g, { x: h.left + R.left + o, y: h.top + R.top }, c));
              }), d && d();
              let t = (O = C.options.lang.accessibility) == null ? void 0 : O.navigator.changeAnnouncement, e = u(C.xAxis[0]);
              this.announcer.announce(p(t, { axisRangeDescription: e, chart: C }, C));
            }
          }).bind(this, l), 20);
        }
      };
    }), nt(i, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [i["Accessibility/Components/AnnotationsA11y.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Core/Templating.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      let { getPointAnnotationTexts: tt } = B, { getAxisDescription: V, getSeriesFirstPointElement: _, getSeriesA11yElement: N, unhideChartElementFromAT: D } = $, { format: p, numberFormat: y } = J, { reverseChildNodes: m, stripHTMLTagsFromString: w } = it, { find: a, isNumber: u, isString: b, pick: l, defined: d } = st;
      function C(f) {
        let s = f.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
        return !!(s !== !1 && f.points && f.points.length >= +s);
      }
      function R(f, s) {
        let t = f.series, e = t.chart, r = e.options.accessibility.point || {}, g = t.options.accessibility && t.options.accessibility.point || {}, o = t.tooltipOptions || {}, c = e.options.lang;
        return u(s) ? y(s, g.valueDecimals || r.valueDecimals || o.valueDecimals || -1, c.decimalPoint, c.accessibility.thousandsSep || c.thousandsSep) : s;
      }
      function z(f, s) {
        let t = f[s];
        return f.chart.langFormat("accessibility.series." + s + "Description", { name: V(t), series: f });
      }
      function O(f) {
        let s = f.series, t = s.chart.series.length > 1 || s.options.name, e = function(c) {
          let n = c.series, S = n.chart, j = n.options.accessibility, v = j && j.point && j.point.valueDescriptionFormat || S.options.accessibility.point.valueDescriptionFormat, P = l(n.xAxis && n.xAxis.options.accessibility && n.xAxis.options.accessibility.enabled, !S.angular && n.type !== "flowmap"), G = P ? function(W) {
            let Q = function(Y) {
              let x = Y.series, T = x.chart, M = x.options.accessibility && x.options.accessibility.point || {}, U = T.options.accessibility.point || {}, H = x.xAxis && x.xAxis.dateTime;
              if (H) {
                let q = H.getXDateFormat(Y.x || 0, T.options.tooltip.dateTimeLabelFormats), F = M.dateFormatter && M.dateFormatter(Y) || U.dateFormatter && U.dateFormatter(Y) || M.dateFormat || U.dateFormat || q;
                return T.time.dateFormat(F, Y.x || 0, void 0);
              }
            }(W), k = (W.series.xAxis || {}).categories && d(W.category) && ("" + W.category).replace("<br/>", " "), A = d(W.id) && 0 > ("" + W.id).indexOf("highcharts-"), L = "x, " + W.x;
            return W.name || Q || k || (A ? W.id : L);
          }(c) : "";
          return p(v, { point: c, index: d(c.index) ? c.index + 1 : "", xDescription: G, value: function(W) {
            let Q = W.series, k = Q.chart.options.accessibility.point || {}, A = Q.chart.options.accessibility && Q.chart.options.accessibility.point || {}, L = Q.tooltipOptions || {}, Y = A.valuePrefix || k.valuePrefix || L.valuePrefix || "", x = A.valueSuffix || k.valueSuffix || L.valueSuffix || "", T = W.value !== void 0 ? "value" : "y", M = R(W, W[T]);
            return W.isNull ? Q.chart.langFormat("accessibility.series.nullPointValue", { point: W }) : Q.pointArrayMap ? function(U, H, q) {
              let F = H || "", et = q || "", rt = function(at) {
                let ct = R(U, l(U[at], U.options[at]));
                return ct !== void 0 ? at + ": " + F + ct + et : ct;
              };
              return U.series.pointArrayMap.reduce(function(at, ct) {
                let Z = rt(ct);
                return Z ? at + (at.length ? ", " : "") + Z : at;
              }, "");
            }(W, Y, x) : Y + M + x;
          }(c), separator: P ? ", " : "" }, S);
        }(f), r = f.options && f.options.accessibility && f.options.accessibility.description, g = t ? " " + s.name + "." : "", o = function(c) {
          let n = c.series.chart, S = tt(c);
          return S.length ? n.langFormat("accessibility.series.pointAnnotationsDescription", { point: c, annotations: S }) : "";
        }(f);
        return f.accessibility = f.accessibility || {}, f.accessibility.valueDescription = e, e + (r ? " " + r : "") + g + (o ? " " + o : "");
      }
      function h(f) {
        let s = f.chart, t = s.types || [], e = function(P) {
          let G = (P.options.accessibility || {}).description;
          return G && P.chart.langFormat("accessibility.series.description", { description: G, series: P }) || "";
        }(f), r = function(P) {
          return s[P] && s[P].length > 1 && f[P];
        }, g = f.index + 1, o = z(f, "xAxis"), c = z(f, "yAxis"), n = { seriesNumber: g, series: f, chart: s }, S = t.length > 1 ? "Combination" : "", j = s.langFormat("accessibility.series.summary." + f.type + S, n) || s.langFormat("accessibility.series.summary.default" + S, n), v = (r("yAxis") ? " " + c + "." : "") + (r("xAxis") ? " " + o + "." : "");
        return p(l(f.options.accessibility && f.options.accessibility.descriptionFormat, s.options.accessibility.series.descriptionFormat, ""), { seriesDescription: j, authorDescription: e ? " " + e : "", axisDescription: v, series: f, chart: s, seriesNumber: g }, void 0);
      }
      return { defaultPointDescriptionFormatter: O, defaultSeriesDescriptionFormatter: h, describeSeries: function(f) {
        let s = f.chart, t = _(f), e = N(f), r = s.is3d && s.is3d();
        e && (e.lastChild !== t || r || m(e), function(g) {
          let o = function(S) {
            let j = S.options.accessibility || {};
            return !C(S) && !j.exposeAsGroupOnly;
          }(g), c = function(S) {
            let j = S.chart.options.accessibility.keyboardNavigation.seriesNavigation;
            return !!(S.points && (S.points.length < +j.pointNavigationEnabledThreshold || j.pointNavigationEnabledThreshold === !1));
          }(g), n = g.chart.options.accessibility.point.describeNull;
          (o || c) && g.points.forEach((S) => {
            let j = S.graphic && S.graphic.element || function(P) {
              let G = P.series, W = G && G.chart, Q = G && G.is("sunburst"), k = P.isNull, A = W && W.options.accessibility.point.describeNull;
              return k && !Q && A;
            }(S) && function(P) {
              let G = P.series, W = function(Y) {
                let x = Y.index;
                return Y.series && Y.series.data && d(x) && a(Y.series.data, function(T) {
                  return !!(T && T.index !== void 0 && T.index > x && T.graphic && T.graphic.element);
                }) || null;
              }(P), Q = W && W.graphic, k = Q ? Q.parentGroup : G.graph || G.group, A = W ? { x: l(P.plotX, W.plotX, 0), y: l(P.plotY, W.plotY, 0) } : { x: l(P.plotX, 0), y: l(P.plotY, 0) }, L = function(Y, x) {
                let T = Y.series.chart.renderer.rect(x.x, x.y, 1, 1);
                return T.attr({ class: "highcharts-a11y-mock-point", fill: "none", opacity: 0, "fill-opacity": 0, "stroke-opacity": 0 }), T;
              }(P, A);
              if (k && k.element) return P.graphic = L, P.hasMockGraphic = !0, L.add(k), k.element.insertBefore(L.element, Q ? Q.element : null), L.element;
            }(S), v = S.options && S.options.accessibility && S.options.accessibility.enabled === !1;
            if (j) {
              if (S.isNull && !n) {
                j.setAttribute("aria-hidden", !0);
                return;
              }
              j.setAttribute("tabindex", "-1"), g.chart.styledMode || (j.style.outline = "none"), o && !v ? function(P, G) {
                var L, Y, x;
                let W = P.series, Q = ((L = W.options.accessibility) == null ? void 0 : L.point) || {}, k = W.chart.options.accessibility.point || {}, A = w(b(Q.descriptionFormat) && p(Q.descriptionFormat, P, W.chart) || ((Y = Q.descriptionFormatter) == null ? void 0 : Y.call(Q, P)) || b(k.descriptionFormat) && p(k.descriptionFormat, P, W.chart) || ((x = k.descriptionFormatter) == null ? void 0 : x.call(k, P)) || O(P), W.chart.renderer.forExport);
                G.setAttribute("role", "img"), G.setAttribute("aria-label", A);
              }(S, j) : j.setAttribute("aria-hidden", !0);
            }
          });
        }(f), D(s, e), function(g) {
          let o = g.chart, c = o.options.chart, n = c.options3d && c.options3d.enabled, S = o.series.length > 1, j = o.options.accessibility.series.describeSingleSeries, v = (g.options.accessibility || {}).exposeAsGroupOnly;
          return !(n && S) && (S || j || v || C(g));
        }(f) ? function(g, o) {
          let c = g.options.accessibility || {}, n = g.chart.options.accessibility, S = n.landmarkVerbosity;
          c.exposeAsGroupOnly ? o.setAttribute("role", "img") : S === "all" ? o.setAttribute("role", "region") : o.setAttribute("role", "group"), o.setAttribute("tabindex", "-1"), g.chart.styledMode || (o.style.outline = "none"), o.setAttribute("aria-label", w(n.series.descriptionFormatter && n.series.descriptionFormatter(g) || h(g), g.chart.renderer.forExport));
        }(f, e) : e.removeAttribute("aria-label"));
      } };
    }), nt(i, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/Utils/Announcer.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(B, $, J, it, st, tt) {
      let { composed: V } = B, { addEvent: _, defined: N, pushUnique: D } = $, { getChartTitle: p } = it, { defaultPointDescriptionFormatter: y, defaultSeriesDescriptionFormatter: m } = tt;
      function w(u) {
        return !!u.options.accessibility.announceNewData.enabled;
      }
      class a {
        constructor(b) {
          this.dirty = { allSeries: {} }, this.lastAnnouncementTime = 0, this.chart = b;
        }
        init() {
          let b = this.chart, l = b.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
          this.lastAnnouncementTime = 0, this.dirty = { allSeries: {} }, this.eventProvider = new st(), this.announcer = new J(b, l), this.addEventListeners();
        }
        destroy() {
          this.eventProvider.removeAddedEvents(), this.announcer.destroy();
        }
        addEventListeners() {
          let b = this, l = this.chart, d = this.eventProvider;
          d.addEvent(l, "afterApplyDrilldown", function() {
            b.lastAnnouncementTime = 0;
          }), d.addEvent(l, "afterAddSeries", function(C) {
            b.onSeriesAdded(C.series);
          }), d.addEvent(l, "redraw", function() {
            b.announceDirtyData();
          });
        }
        onSeriesAdded(b) {
          w(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[b.name + b.index] = b, this.dirty.newSeries = N(this.dirty.newSeries) ? void 0 : b);
        }
        announceDirtyData() {
          let b = this.chart, l = this;
          if (b.options.accessibility.announceNewData && this.dirty.hasDirty) {
            let d = this.dirty.newPoint;
            d && (d = function(C) {
              let R = C.series.data.filter((z) => C.x === z.x && C.y === z.y);
              return R.length === 1 ? R[0] : C;
            }(d)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((C) => l.dirty.allSeries[C]), this.dirty.newSeries, d), this.dirty = { allSeries: {} };
          }
        }
        queueAnnouncement(b, l, d) {
          let C = this.chart.options.accessibility.announceNewData;
          if (C.enabled) {
            let R = +/* @__PURE__ */ new Date(), z = R - this.lastAnnouncementTime, O = Math.max(0, C.minAnnounceInterval - z), h = function(s, t) {
              let e = (s || []).concat(t || []).reduce((r, g) => (r[g.name + g.index] = g, r), {});
              return Object.keys(e).map((r) => e[r]);
            }(this.queuedAnnouncement && this.queuedAnnouncement.series, b), f = this.buildAnnouncementMessage(h, l, d);
            f && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = { time: R, message: f, series: h }, this.queuedAnnouncementTimer = setTimeout(() => {
              this && this.announcer && (this.lastAnnouncementTime = +/* @__PURE__ */ new Date(), this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
            }, O));
          }
        }
        buildAnnouncementMessage(b, l, d) {
          let C = this.chart, R = C.options.accessibility.announceNewData;
          if (R.announcementFormatter) {
            let f = R.announcementFormatter(b, l, d);
            if (f !== !1) return f.length ? f : null;
          }
          let z = B.charts && B.charts.length > 1 ? "Multiple" : "Single", O = l ? "newSeriesAnnounce" + z : d ? "newPointAnnounce" + z : "newDataAnnounce", h = p(C);
          return C.langFormat("accessibility.announceNewData." + O, { chartTitle: h, seriesDesc: l ? m(l) : null, pointDesc: d ? y(d) : null, point: d, series: l });
        }
      }
      return function(u) {
        function b(d) {
          var z;
          let C = this.chart, R = (z = C.accessibility) == null ? void 0 : z.components.series.newDataAnnouncer;
          R && R.chart === C && w(C) && (R.dirty.newPoint = N(R.dirty.newPoint) ? void 0 : d.point);
        }
        function l() {
          var R;
          let d = this.chart, C = (R = d.accessibility) == null ? void 0 : R.components.series.newDataAnnouncer;
          C && C.chart === d && w(d) && (C.dirty.hasDirty = !0, C.dirty.allSeries[this.name + this.index] = this);
        }
        u.compose = function(d) {
          D(V, "A11y.NDA") && (_(d, "addPoint", b), _(d, "updatedData", l));
        };
      }(a || (a = {})), a;
    }), nt(i, "Accessibility/ProxyElement.js", [i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(B, $, J, it, st) {
      let { doc: tt } = B, { attr: V, css: _, merge: N } = $, { fireEventOnWrappedOrUnwrappedElement: D } = it, { cloneMouseEvent: p, cloneTouchEvent: y, getFakeMouseEvent: m, removeElement: w } = st;
      return class {
        constructor(a, u, b = "button", l, d) {
          this.chart = a, this.target = u, this.eventProvider = new J();
          let C = this.innerElement = tt.createElement(b), R = this.element = l ? tt.createElement(l) : C;
          a.styledMode || this.hideElementVisually(C), l && (l !== "li" || a.styledMode || (R.style.listStyle = "none"), R.appendChild(C), this.element = R), this.updateTarget(u, d);
        }
        click() {
          let a = this.getTargetPosition();
          a.x += a.width / 2, a.y += a.height / 2;
          let u = m("click", a);
          D(this.target.click, u);
        }
        updateTarget(a, u) {
          this.target = a, this.updateCSSClassName();
          let b = u || {};
          Object.keys(b).forEach((d) => {
            b[d] === null && delete b[d];
          });
          let l = this.getTargetAttr(a.click, "aria-label");
          V(this.innerElement, N(l ? { "aria-label": l } : {}, b)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, a.click), this.refreshPosition();
        }
        refreshPosition() {
          let a = this.getTargetPosition();
          _(this.innerElement, { width: (a.width || 1) + "px", height: (a.height || 1) + "px", left: (Math.round(a.x) || 0) + "px", top: (Math.round(a.y) || 0) + "px" });
        }
        remove() {
          this.eventProvider.removeAddedEvents(), w(this.element);
        }
        updateCSSClassName() {
          let a = (C) => C.indexOf("highcharts-no-tooltip") > -1, u = this.chart.legend, b = u.group && u.group.div, l = a(b && b.className || ""), d = a(this.getTargetAttr(this.target.click, "class") || "");
          this.innerElement.className = l || d ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
        }
        addProxyEventsToElement(a, u) {
          ["click", "touchstart", "touchend", "touchcancel", "touchmove", "mouseover", "mouseenter", "mouseleave", "mouseout"].forEach((b) => {
            let l = b.indexOf("touch") === 0;
            this.eventProvider.addEvent(a, b, (d) => {
              let C = l ? y(d) : p(d);
              u && D(u, C), d.stopPropagation(), l || d.preventDefault();
            }, { passive: !1 });
          });
        }
        hideElementVisually(a) {
          _(a, { borderWidth: 0, backgroundColor: "transparent", cursor: "pointer", outline: "none", opacity: 1e-3, filter: "alpha(opacity=1)", zIndex: 999, overflow: "hidden", padding: 0, margin: 0, display: "block", position: "absolute", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)" });
        }
        getTargetPosition() {
          let a = this.target.click, u = a.element ? a.element : a, b = this.target.visual || u, l = this.chart.renderTo, d = this.chart.pointer;
          if (l && (b != null && b.getBoundingClientRect) && d) {
            let C = b.getBoundingClientRect(), R = d.getChartPosition();
            return { x: (C.left - R.left) / R.scaleX, y: (C.top - R.top) / R.scaleY, width: C.right / R.scaleX - C.left / R.scaleX, height: C.bottom / R.scaleY - C.top / R.scaleY };
          }
          return { x: 0, y: 0, width: 1, height: 1 };
        }
        getTargetAttr(a, u) {
          return a.element ? a.element.getAttribute(u) : a.getAttribute(u);
        }
      };
    }), nt(i, "Accessibility/ProxyProvider.js", [i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/DOMElementProvider.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/ProxyElement.js"]], function(B, $, J, it, st, tt) {
      let { doc: V } = B, { attr: _, css: N } = $, { unhideChartElementFromAT: D } = J, { removeChildNodes: p } = st;
      return class {
        constructor(y) {
          this.chart = y, this.domElementProvider = new it(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
        }
        addProxyElement(y, m, w = "button", a) {
          let u = this.groups[y];
          if (!u) throw Error("ProxyProvider.addProxyElement: Invalid group key " + y);
          let b = u.type === "ul" || u.type === "ol" ? "li" : void 0, l = new tt(this.chart, m, w, b, a);
          return u.proxyContainerElement.appendChild(l.element), u.proxyElements.push(l), l;
        }
        addGroup(y, m = "div", w) {
          let a, u = this.groups[y];
          if (u) return u.groupElement;
          let b = this.domElementProvider.createElement(m);
          return w && w.role && m !== "div" ? (a = this.domElementProvider.createElement("div")).appendChild(b) : a = b, a.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + y.replace(/\W/g, "-"), this.groups[y] = { proxyContainerElement: b, groupElement: a, type: m, proxyElements: [] }, _(a, w || {}), m === "ul" && b.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(a), this.updateGroupOrder(this.groupOrder), a;
        }
        updateGroupAttrs(y, m) {
          let w = this.groups[y];
          if (!w) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + y);
          _(w.groupElement, m);
        }
        updateGroupOrder(y) {
          if (this.groupOrder = y.slice(), this.isDOMOrderGroupOrder()) return;
          let m = y.indexOf("series"), w = m > -1 ? y.slice(0, m) : y, a = m > -1 ? y.slice(m + 1) : [], u = V.activeElement;
          ["before", "after"].forEach((b) => {
            let l = this[b === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
            p(l), (b === "before" ? w : a).forEach((d) => {
              let C = this.groups[d];
              C && l.appendChild(C.groupElement);
            });
          }), (this.beforeChartProxyPosContainer.contains(u) || this.afterChartProxyPosContainer.contains(u)) && u && u.focus && u.focus();
        }
        clearGroup(y) {
          let m = this.groups[y];
          if (!m) throw Error("ProxyProvider.clearGroup: Invalid group key " + y);
          p(m.proxyContainerElement);
        }
        removeGroup(y) {
          let m = this.groups[y];
          m && (this.domElementProvider.removeElement(m.groupElement), m.groupElement !== m.proxyContainerElement && this.domElementProvider.removeElement(m.proxyContainerElement), delete this.groups[y]);
        }
        update() {
          this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
        }
        updateProxyElementPositions() {
          Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
        }
        updateGroupProxyElementPositions(y) {
          let m = this.groups[y];
          m && m.proxyElements.forEach((w) => w.refreshPosition());
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        createProxyPosContainer(y) {
          let m = this.domElementProvider.createElement("div");
          return m.setAttribute("aria-hidden", "false"), m.className = "highcharts-a11y-proxy-container" + (y ? "-" + y : ""), N(m, { top: "0", left: "0" }), this.chart.styledMode || (m.style.whiteSpace = "nowrap", m.style.position = "absolute"), m;
        }
        getCurrentGroupOrderInDOM() {
          let y = (u) => {
            let b = Object.keys(this.groups), l = b.length;
            for (; l--; ) {
              let d = b[l], C = this.groups[d];
              if (C && u === C.groupElement) return d;
            }
          }, m = (u) => {
            let b = [], l = u.children;
            for (let d = 0; d < l.length; ++d) {
              let C = y(l[d]);
              C && b.push(C);
            }
            return b;
          }, w = m(this.beforeChartProxyPosContainer), a = m(this.afterChartProxyPosContainer);
          return w.push("series"), w.concat(a);
        }
        isDOMOrderGroupOrder() {
          let y = this.getCurrentGroupOrderInDOM(), m = this.groupOrder.filter((a) => a === "series" || !!this.groups[a]), w = y.length;
          if (w !== m.length) return !1;
          for (; w--; ) if (y[w] !== m[w]) return !1;
          return !0;
        }
        updatePosContainerPositions() {
          let y = this.chart;
          if (y.renderer.forExport) return;
          let m = y.renderer.box;
          y.container.insertBefore(this.afterChartProxyPosContainer, m.nextSibling), y.container.insertBefore(this.beforeChartProxyPosContainer, m), D(this.chart, this.afterChartProxyPosContainer), D(this.chart, this.beforeChartProxyPosContainer);
        }
      };
    }), nt(i, "Accessibility/Components/RangeSelectorComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/Announcer.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      let { unhideChartElementFromAT: tt, getAxisRangeDescription: V } = J, { addEvent: _, attr: N } = st;
      class D extends B {
        init() {
          let y = this.chart;
          this.announcer = new $(y, "polite");
        }
        onChartUpdate() {
          let y = this.chart, m = this, w = y.rangeSelector;
          w && (this.updateSelectorVisibility(), this.setDropdownAttrs(), w.buttons && w.buttons.length && w.buttons.forEach((a) => {
            m.setRangeButtonAttrs(a);
          }), w.maxInput && w.minInput && ["minInput", "maxInput"].forEach(function(a, u) {
            let b = w[a];
            b && (tt(y, b), m.setRangeInputAttrs(b, "accessibility.rangeSelector." + (u ? "max" : "min") + "InputLabel"));
          }));
        }
        updateSelectorVisibility() {
          let y = this.chart, m = y.rangeSelector, w = m && m.dropdown, a = m && m.buttons || [], u = (b) => b.setAttribute("aria-hidden", !0);
          m && m.hasVisibleDropdown && w ? (tt(y, w), a.forEach((b) => u(b.element))) : (w && u(w), a.forEach((b) => tt(y, b.element)));
        }
        setDropdownAttrs() {
          let y = this.chart, m = y.rangeSelector && y.rangeSelector.dropdown;
          if (m) {
            let w = y.langFormat("accessibility.rangeSelector.dropdownLabel", { rangeTitle: y.options.lang.rangeSelectorZoom });
            m.setAttribute("aria-label", w), m.setAttribute("tabindex", -1);
          }
        }
        setRangeButtonAttrs(y) {
          N(y.element, { tabindex: -1, role: "button" });
        }
        setRangeInputAttrs(y, m) {
          let w = this.chart;
          N(y, { tabindex: -1, "aria-label": w.langFormat(m, { chart: w }) });
        }
        onButtonNavKbdArrowKey(y, m) {
          let w = y.response, a = this.keyCodes, u = this.chart, b = u.options.accessibility.keyboardNavigation.wrapAround, l = m === a.left || m === a.up ? -1 : 1;
          return u.highlightRangeSelectorButton(u.highlightedRangeSelectorItemIx + l) ? w.success : b ? (y.init(l), w.success) : w[l > 0 ? "next" : "prev"];
        }
        onButtonNavKbdClick(y) {
          let m = y.response, w = this.chart;
          return w.oldRangeSelectorItemState !== 3 && this.fakeClickEvent(w.rangeSelector.buttons[w.highlightedRangeSelectorItemIx].element), m.success;
        }
        onAfterBtnClick() {
          let y = this.chart, m = V(y.xAxis[0]), w = y.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", { chart: y, axisRangeDescription: m });
          w && this.announcer.announce(w);
        }
        onInputKbdMove(y) {
          let m = this.chart, w = m.rangeSelector, a = m.highlightedInputRangeIx = (m.highlightedInputRangeIx || 0) + y;
          if (a > 1 || a < 0) {
            if (m.accessibility) return m.accessibility.keyboardNavigation.exiting = !0, m.accessibility.keyboardNavigation.tabindexContainer.focus(), m.accessibility.keyboardNavigation.move(y);
          } else if (w) {
            let u = w[a ? "maxDateBox" : "minDateBox"], b = w[a ? "maxInput" : "minInput"];
            u && b && m.setFocusToElement(u, b);
          }
          return !0;
        }
        onInputNavInit(y) {
          let m = this, w = this.chart, a = y > 0 ? 0 : 1, u = w.rangeSelector, b = u && u[a ? "maxDateBox" : "minDateBox"], l = u && u.minInput, d = u && u.maxInput;
          if (w.highlightedInputRangeIx = a, b && l && d) {
            w.setFocusToElement(b, a ? d : l), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
            let C = (O) => {
              (O.which || O.keyCode) === this.keyCodes.tab && m.onInputKbdMove(O.shiftKey ? -1 : 1) && (O.preventDefault(), O.stopPropagation());
            }, R = _(l, "keydown", C), z = _(d, "keydown", C);
            this.removeInputKeydownHandler = () => {
              R(), z();
            };
          }
        }
        onInputNavTerminate() {
          let y = this.chart.rangeSelector || {};
          y.maxInput && y.hideInput("max"), y.minInput && y.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
        }
        initDropdownNav() {
          let y = this.chart, m = y.rangeSelector, w = m && m.dropdown;
          m && w && (y.setFocusToElement(m.buttonGroup, w), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = _(w, "keydown", (a) => {
            let u = (a.which || a.keyCode) === this.keyCodes.tab, b = y.accessibility;
            u && (a.preventDefault(), a.stopPropagation(), b && (b.keyboardNavigation.tabindexContainer.focus(), b.keyboardNavigation.move(a.shiftKey ? -1 : 1)));
          }));
        }
        getRangeSelectorButtonNavigation() {
          let y = this.chart, m = this.keyCodes, w = this;
          return new it(y, { keyCodeMap: [[[m.left, m.right, m.up, m.down], function(a) {
            return w.onButtonNavKbdArrowKey(this, a);
          }], [[m.enter, m.space], function() {
            return w.onButtonNavKbdClick(this);
          }]], validate: function() {
            return !!(y.rangeSelector && y.rangeSelector.buttons && y.rangeSelector.buttons.length);
          }, init: function(a) {
            let u = y.rangeSelector;
            if (u && u.hasVisibleDropdown) w.initDropdownNav();
            else if (u) {
              let b = u.buttons.length - 1;
              y.highlightRangeSelectorButton(a > 0 ? 0 : b);
            }
          }, terminate: function() {
            w.removeDropdownKeydownHandler && (w.removeDropdownKeydownHandler(), delete w.removeDropdownKeydownHandler);
          } });
        }
        getRangeSelectorInputNavigation() {
          let y = this.chart, m = this;
          return new it(y, { keyCodeMap: [], validate: function() {
            return !!(y.rangeSelector && y.rangeSelector.inputGroup && y.rangeSelector.inputGroup.element.style.visibility !== "hidden" && y.options.rangeSelector.inputEnabled !== !1 && y.rangeSelector.minInput && y.rangeSelector.maxInput);
          }, init: function(w) {
            m.onInputNavInit(w);
          }, terminate: function() {
            m.onInputNavTerminate();
          } });
        }
        getKeyboardNavigation() {
          return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
        }
        destroy() {
          this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
        }
      }
      return function(p) {
        function y(w) {
          let a = this.rangeSelector && this.rangeSelector.buttons || [], u = this.highlightedRangeSelectorItemIx, b = this.rangeSelector && this.rangeSelector.selected;
          return u !== void 0 && a[u] && u !== b && a[u].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = w, !!a[w] && (this.setFocusToElement(a[w].box, a[w].element), w !== b && (this.oldRangeSelectorItemState = a[w].state, a[w].setState(1)), !0);
        }
        function m() {
          let w = this.chart.accessibility;
          if (w && w.components.rangeSelector) return w.components.rangeSelector.onAfterBtnClick();
        }
        p.compose = function(w, a) {
          let u = w.prototype;
          u.highlightRangeSelectorButton || (u.highlightRangeSelectorButton = y, _(a, "afterBtnClick", m));
        };
      }(D || (D = {})), D;
    }), nt(i, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      var J;
      let { composed: it } = B, { addEvent: st, merge: tt, pushUnique: V } = $;
      return function(_) {
        function N(u) {
          tt(!0, u, { marker: { enabled: !0, states: { normal: { opacity: 0 } } } });
        }
        function D(u) {
          return u.marker.states && u.marker.states.normal && u.marker.states.normal.opacity;
        }
        function p(u) {
          return !!(u._hasPointMarkers && u.points && u.points.length);
        }
        function y() {
          this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), p(this) && this.points.forEach((u) => {
            u.graphic && (u.graphic[u.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), u.graphic[u.hasForcedA11yMarker === !1 ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
          }));
        }
        function m(u) {
          this.resetA11yMarkerOptions = tt(u.options.marker || {}, this.userOptions.marker || {});
        }
        function w() {
          let u = this.options;
          (function(b) {
            let l = b.chart.options.accessibility.enabled, d = (b.options.accessibility && b.options.accessibility.enabled) !== !1;
            return l && d && function(C) {
              let R = C.chart.options.accessibility;
              return C.points.length < R.series.pointDescriptionEnabledThreshold || R.series.pointDescriptionEnabledThreshold === !1;
            }(b);
          })(this) ? (u.marker && u.marker.enabled === !1 && (this.a11yMarkersForced = !0, N(this.options)), p(this) && function(b) {
            let l = b.points.length;
            for (; l--; ) {
              let d = b.points[l], C = d.options, R = d.hasForcedA11yMarker;
              if (delete d.hasForcedA11yMarker, C.marker) {
                let z = R && D(C) === 0;
                C.marker.enabled && !z ? (tt(!0, C.marker, { states: { normal: { opacity: D(C) || 1 } } }), d.hasForcedA11yMarker = !1) : C.marker.enabled === !1 && (N(C), d.hasForcedA11yMarker = !0);
              }
            }
          }(this)) : this.a11yMarkersForced && (delete this.a11yMarkersForced, function(b) {
            let l = b.resetA11yMarkerOptions;
            if (l) {
              let d = l.states && l.states.normal && l.states.normal.opacity;
              b.userOptions && b.userOptions.marker && (b.userOptions.marker.enabled = !0), b.update({ marker: { enabled: l.enabled, states: { normal: { opacity: d } } } });
            }
          }(this), delete this.resetA11yMarkerOptions);
        }
        function a() {
          this.boosted && this.a11yMarkersForced && (tt(!0, this.options, { marker: { enabled: !1 } }), delete this.a11yMarkersForced);
        }
        _.compose = function(u) {
          V(it, "A11y.FM") && (st(u, "afterSetOptions", m), st(u, "render", w), st(u, "afterRender", y), st(u, "renderCanvas", a));
        };
      }(J || (J = {})), J;
    }), nt(i, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [i["Core/Series/Point.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Utils/ChartUtilities.js"]], function(B, $, J, it, st, tt, V, _) {
      let { seriesTypes: N } = J, { doc: D } = it, { defined: p, fireEvent: y } = st, { getPointFromXY: m, getSeriesFromName: w, scrollAxisToPoint: a } = _;
      function u(O) {
        let h = O.index, f = O.series.points, s = f.length;
        if (f[h] === O) return h;
        for (; s--; ) if (f[s] === O) return s;
      }
      function b(O) {
        let h = O.chart.options.accessibility.keyboardNavigation.seriesNavigation, f = O.options.accessibility || {}, s = f.keyboardNavigation;
        return s && s.enabled === !1 || f.enabled === !1 || O.options.enableMouseTracking === !1 || !O.visible || h.pointNavigationEnabledThreshold && +h.pointNavigationEnabledThreshold <= O.points.length;
      }
      function l(O) {
        let h = O.series.chart.options.accessibility, f = O.options.accessibility && O.options.accessibility.enabled === !1;
        return O.isNull && h.keyboardNavigation.seriesNavigation.skipNullPoints || O.visible === !1 || O.isInside === !1 || f || b(O.series);
      }
      function d(O) {
        let h = O.series || [], f = h.length;
        for (let s = 0; s < f; ++s) if (!b(h[s])) {
          let t = function(e) {
            let r = e.points || [], g = r.length;
            for (let o = 0; o < g; ++o) if (!l(r[o])) return r[o];
            return null;
          }(h[s]);
          if (t) return t;
        }
        return null;
      }
      function C(O) {
        let h = O.series.length, f = !1;
        for (; h-- && (O.highlightedPoint = O.series[h].points[O.series[h].points.length - 1], !(f = O.series[h].highlightNextValidPoint())); ) ;
        return f;
      }
      function R(O) {
        delete O.highlightedPoint;
        let h = d(O);
        return !!h && h.highlight();
      }
      class z {
        constructor(h, f) {
          this.keyCodes = f, this.chart = h;
        }
        init() {
          let h = this, f = this.chart, s = this.eventProvider = new V();
          s.addEvent($, "destroy", function() {
            return h.onSeriesDestroy(this);
          }), s.addEvent(f, "afterApplyDrilldown", function() {
            (function(t) {
              let e = d(t);
              e && e.highlight(!1);
            })(this);
          }), s.addEvent(f, "drilldown", function(t) {
            let e = t.point, r = e.series;
            h.lastDrilledDownPoint = { x: e.x, y: e.y, seriesName: r ? r.name : "" };
          }), s.addEvent(f, "drillupall", function() {
            setTimeout(function() {
              h.onDrillupAll();
            }, 10);
          }), s.addEvent(B, "afterSetState", function() {
            let t = this.graphic && this.graphic.element, e = D.activeElement, r = e && e.getAttribute("class"), g = r && r.indexOf("highcharts-a11y-proxy-element") > -1;
            f.highlightedPoint === this && e !== t && !g && t && t.focus && t.focus();
          });
        }
        onDrillupAll() {
          let h, f = this.lastDrilledDownPoint, s = this.chart, t = f && w(s, f.seriesName);
          f && t && p(f.x) && p(f.y) && (h = m(t, f.x, f.y)), h = h || d(s), s.container && s.container.focus(), h && h.highlight && h.highlight(!1);
        }
        getKeyboardNavigationHandler() {
          let h = this, f = this.keyCodes, s = this.chart, t = s.inverted;
          return new tt(s, { keyCodeMap: [[t ? [f.up, f.down] : [f.left, f.right], function(e) {
            return h.onKbdSideways(this, e);
          }], [t ? [f.left, f.right] : [f.up, f.down], function(e) {
            return h.onKbdVertical(this, e);
          }], [[f.enter, f.space], function(e, r) {
            var o;
            let g = s.highlightedPoint;
            if (g) {
              let { plotLeft: c, plotTop: n } = this.chart, { plotX: S = 0, plotY: j = 0 } = g;
              r = { ...r, chartX: c + S, chartY: n + j, point: g, target: ((o = g.graphic) == null ? void 0 : o.element) || r.target }, y(g.series, "click", r), g.firePointEvent("click", r);
            }
            return this.response.success;
          }], [[f.home], function() {
            return R(s), this.response.success;
          }], [[f.end], function() {
            return C(s), this.response.success;
          }], [[f.pageDown, f.pageUp], function(e) {
            return s.highlightAdjacentSeries(e === f.pageDown), this.response.success;
          }]], init: function() {
            return h.onHandlerInit(this);
          }, validate: function() {
            return !!d(s);
          }, terminate: function() {
            return h.onHandlerTerminate();
          } });
        }
        onKbdSideways(h, f) {
          let s = this.keyCodes, t = f === s.right || f === s.down;
          return this.attemptHighlightAdjacentPoint(h, t);
        }
        onHandlerInit(h) {
          let f = this.chart;
          return f.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && f.highlightedPoint ? f.highlightedPoint.highlight() : R(f), h.response.success;
        }
        onKbdVertical(h, f) {
          let s = this.chart, t = this.keyCodes, e = f === t.down || f === t.right, r = s.options.accessibility.keyboardNavigation.seriesNavigation;
          if (r.mode && r.mode === "serialize") return this.attemptHighlightAdjacentPoint(h, e);
          let g = s.highlightedPoint && s.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
          return s[g](e), h.response.success;
        }
        onHandlerTerminate() {
          let h = this.chart, f = h.options.accessibility.keyboardNavigation;
          h.tooltip && h.tooltip.hide(0);
          let s = h.highlightedPoint && h.highlightedPoint.series;
          s && s.onMouseOut && s.onMouseOut(), h.highlightedPoint && h.highlightedPoint.onMouseOut && h.highlightedPoint.onMouseOut(), f.seriesNavigation.rememberPointFocus || delete h.highlightedPoint;
        }
        attemptHighlightAdjacentPoint(h, f) {
          let s = this.chart, t = s.options.accessibility.keyboardNavigation.wrapAround;
          return s.highlightAdjacentPoint(f) || t && (f ? R(s) : C(s)) ? h.response.success : h.response[f ? "next" : "prev"];
        }
        onSeriesDestroy(h) {
          let f = this.chart;
          f.highlightedPoint && f.highlightedPoint.series === h && (delete f.highlightedPoint, f.focusElement && f.focusElement.removeFocusBorder());
        }
        destroy() {
          this.eventProvider.removeAddedEvents();
        }
      }
      return function(O) {
        function h(r) {
          let g, o, c = this.series, n = this.highlightedPoint, S = n && u(n) || 0, j = n && n.series.points || [], v = this.series && this.series[this.series.length - 1], P = v && v.points && v.points[v.points.length - 1];
          if (!c[0] || !c[0].points) return !1;
          if (n) {
            if (g = c[n.series.index + (r ? 1 : -1)], (o = j[S + (r ? 1 : -1)]) || !g || (o = g.points[r ? 0 : g.points.length - 1]), !o) return !1;
          } else o = r ? c[0].points[0] : P;
          return l(o) ? (b(g = o.series) ? this.highlightedPoint = r ? g.points[g.points.length - 1] : g.points[0] : this.highlightedPoint = o, this.highlightAdjacentPoint(r)) : o.highlight();
        }
        function f(r) {
          let g = this.highlightedPoint, o = 1 / 0, c;
          return !!(p(g.plotX) && p(g.plotY)) && (this.series.forEach((n) => {
            b(n) || n.points.forEach((S) => {
              if (!p(S.plotY) || !p(S.plotX) || S === g) return;
              let j = S.plotY - g.plotY, v = Math.abs(S.plotX - g.plotX), P = Math.abs(j) * Math.abs(j) + v * v * 4;
              n.yAxis && n.yAxis.reversed && (j *= -1), !(j <= 0 && r || j >= 0 && !r || P < 5 || l(S)) && P < o && (o = P, c = S);
            });
          }), !!c && c.highlight());
        }
        function s(r) {
          let g, o, c, n = this.highlightedPoint, S = this.series && this.series[this.series.length - 1], j = S && S.points && S.points[S.points.length - 1];
          return this.highlightedPoint ? !!((g = this.series[n.series.index + (r ? -1 : 1)]) && (o = function(v, P, G, W) {
            let Q = 1 / 0, k, A, L, Y = P.points.length, x = (T) => !(p(T.plotX) && p(T.plotY));
            if (!x(v)) {
              for (; Y--; ) !x(k = P.points[Y]) && (L = (v.plotX - k.plotX) * (v.plotX - k.plotX) * 4 + (v.plotY - k.plotY) * (v.plotY - k.plotY) * 1) < Q && (Q = L, A = Y);
              return p(A) ? P.points[A] : void 0;
            }
          }(n, g))) && (b(g) ? (o.highlight(), (c = this.highlightAdjacentSeries(r)) ? c : (n.highlight(), !1)) : (o.highlight(), o.series.highlightNextValidPoint())) : (g = r ? this.series && this.series[0] : S, !!(o = r ? g && g.points && g.points[0] : j) && o.highlight());
        }
        function t(r = !0) {
          var n, S;
          let g = this.series.chart, o = (S = (n = g.tooltip) == null ? void 0 : n.label) == null ? void 0 : S.element;
          !this.isNull && r ? this.onMouseOver() : g.tooltip && g.tooltip.hide(0), a(this), this.graphic && (g.setFocusToElement(this.graphic), !r && g.focusElement && g.focusElement.removeFocusBorder()), g.highlightedPoint = this;
          let c = o == null ? void 0 : o.getBoundingClientRect().top;
          if (o && c && c < 0) {
            let j = window.scrollY;
            window.scrollTo({ behavior: "smooth", top: j + c });
          }
          return this;
        }
        function e() {
          let r = this.chart.highlightedPoint, g = (r && r.series) === this ? u(r) : 0, o = this.points, c = o.length;
          if (o && c) {
            for (let n = g; n < c; ++n) if (!l(o[n])) return o[n].highlight();
            for (let n = g; n >= 0; --n) if (!l(o[n])) return o[n].highlight();
          }
          return !1;
        }
        O.compose = function(r, g, o) {
          let c = r.prototype, n = g.prototype, S = o.prototype;
          c.highlightAdjacentPoint || (c.highlightAdjacentPoint = h, c.highlightAdjacentPointVertical = f, c.highlightAdjacentSeries = s, n.highlight = t, S.keyboardMoveVertical = !0, ["column", "gantt", "pie"].forEach((j) => {
            N[j] && (N[j].prototype.keyboardMoveVertical = !1);
          }), S.highlightNextValidPoint = e);
        };
      }(z || (z = {})), z;
    }), nt(i, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], i["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], i["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], i["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]], function(B, $, J, it, st, tt) {
      let { hideSeriesFromAT: V } = $, { describeSeries: _ } = st;
      return class extends B {
        static compose(N, D, p) {
          it.compose(p), J.compose(p), tt.compose(N, D, p);
        }
        init() {
          this.newDataAnnouncer = new it(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new tt(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
        }
        hideTooltipFromATWhenShown() {
          let N = this;
          this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
            this.chart === N.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
          });
        }
        hideSeriesLabelsFromATWhenShown() {
          this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
            this.series.forEach(function(N) {
              N.labelBySeries && N.labelBySeries.attr("aria-hidden", !0);
            });
          });
        }
        onChartRender() {
          this.chart.series.forEach(function(N) {
            (N.options.accessibility && N.options.accessibility.enabled) !== !1 && N.visible && N.getPointsCollection().length !== 0 ? _(N) : V(N);
          });
        }
        getKeyboardNavigation() {
          return this.keyboardNavigation.getKeyboardNavigationHandler();
        }
        destroy() {
          this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
        }
      };
    }), nt(i, "Accessibility/Components/ZoomComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Core/Utilities.js"]], function(B, $, J, it, st) {
      let { unhideChartElementFromAT: tt } = $, { getFakeMouseEvent: V } = J, { attr: _, pick: N } = st;
      return class extends B {
        constructor() {
          super(...arguments), this.focusedMapNavButtonIx = -1;
        }
        init() {
          let D = this, p = this.chart;
          this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach((y) => {
            D.addEvent(p, y, function() {
              D.updateProxyOverlays();
            });
          });
        }
        onChartUpdate() {
          let D = this.chart, p = this;
          D.mapNavigation && D.mapNavigation.navButtons.forEach((y, m) => {
            tt(D, y.element), p.setMapNavButtonAttrs(y.element, "accessibility.zoom.mapZoom" + (m ? "Out" : "In"));
          });
        }
        setMapNavButtonAttrs(D, p) {
          let y = this.chart;
          _(D, { tabindex: -1, role: "button", "aria-label": y.langFormat(p, { chart: y }) });
        }
        onChartRender() {
          this.updateProxyOverlays();
        }
        updateProxyOverlays() {
          let D = this.chart;
          if (this.proxyProvider.clearGroup("zoom"), D.resetZoomButton && this.createZoomProxyButton(D.resetZoomButton, "resetZoomProxyButton", D.langFormat("accessibility.zoom.resetZoomButton", { chart: D })), D.drillUpButton && D.breadcrumbs && D.breadcrumbs.list) {
            let p = D.breadcrumbs.list[D.breadcrumbs.list.length - 1];
            this.createZoomProxyButton(D.drillUpButton, "drillUpProxyButton", D.langFormat("accessibility.drillUpButton", { chart: D, buttonText: D.breadcrumbs.getButtonText(p) }));
          }
        }
        createZoomProxyButton(D, p, y) {
          this[p] = this.proxyProvider.addProxyElement("zoom", { click: D }, "button", { "aria-label": y, tabindex: -1 });
        }
        getMapZoomNavigation() {
          let D = this.keyCodes, p = this.chart, y = this;
          return new it(p, { keyCodeMap: [[[D.up, D.down, D.left, D.right], function(m) {
            return y.onMapKbdArrow(this, m);
          }], [[D.tab], function(m, w) {
            return y.onMapKbdTab(this, w);
          }], [[D.space, D.enter], function() {
            return y.onMapKbdClick(this);
          }]], validate: function() {
            return !!(p.mapView && p.mapNavigation && p.mapNavigation.navButtons.length);
          }, init: function(m) {
            return y.onMapNavInit(m);
          } });
        }
        onMapKbdArrow(D, p) {
          let y = this.chart, m = this.keyCodes, w = y.container, a = p === m.up || p === m.down, u = p === m.left || p === m.up ? 1 : -1, b = (a ? y.plotHeight : y.plotWidth) / 10 * u, l = 10 * Math.random(), d = { x: w.offsetLeft + y.plotLeft + y.plotWidth / 2 + l, y: w.offsetTop + y.plotTop + y.plotHeight / 2 + l }, C = a ? { x: d.x, y: d.y + b } : { x: d.x + b, y: d.y };
          return [V("mousedown", d), V("mousemove", C), V("mouseup", C)].forEach((R) => w.dispatchEvent(R)), D.response.success;
        }
        onMapKbdTab(D, p) {
          let y = this.chart, m = D.response, w = p.shiftKey, a = w && !this.focusedMapNavButtonIx || !w && this.focusedMapNavButtonIx;
          if (y.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), a) return y.mapView && y.mapView.zoomBy(), m[w ? "prev" : "next"];
          this.focusedMapNavButtonIx += w ? -1 : 1;
          let u = y.mapNavigation.navButtons[this.focusedMapNavButtonIx];
          return y.setFocusToElement(u.box, u.element), u.setState(2), m.success;
        }
        onMapKbdClick(D) {
          let p = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
          return this.fakeClickEvent(p), D.response.success;
        }
        onMapNavInit(D) {
          let p = this.chart, y = p.mapNavigation.navButtons[0], m = p.mapNavigation.navButtons[1], w = D > 0 ? y : m;
          p.setFocusToElement(w.box, w.element), w.setState(2), this.focusedMapNavButtonIx = D > 0 ? 0 : 1;
        }
        simpleButtonNavigation(D, p, y) {
          let m = this.keyCodes, w = this, a = this.chart;
          return new it(a, { keyCodeMap: [[[m.tab, m.up, m.down, m.left, m.right], function(u, b) {
            let l = u === m.tab && b.shiftKey || u === m.left || u === m.up;
            return this.response[l ? "prev" : "next"];
          }], [[m.space, m.enter], function() {
            return N(y(this, a), this.response.success);
          }]], validate: function() {
            return a[D] && a[D].box && w[p].innerElement;
          }, init: function() {
            a.setFocusToElement(a[D].box, w[p].innerElement);
          } });
        }
        getKeyboardNavigation() {
          return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(D, p) {
            p.zoomOut();
          }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(D, p) {
            return p.drillUp(), D.response.prev;
          }), this.getMapZoomNavigation()];
        }
      };
    }), nt(i, "Accessibility/HighContrastMode.js", [i["Core/Globals.js"]], function(B) {
      let { doc: $, isMS: J, win: it } = B;
      return { isHighContrastModeActive: function() {
        let st = /(Edg)/.test(it.navigator.userAgent);
        if (it.matchMedia && st) return it.matchMedia("(-ms-high-contrast: active)").matches;
        if (J && it.getComputedStyle) {
          let tt = $.createElement("div");
          tt.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", $.body.appendChild(tt);
          let V = (tt.currentStyle || it.getComputedStyle(tt)).backgroundImage;
          return $.body.removeChild(tt), V === "none";
        }
        return it.matchMedia && it.matchMedia("(forced-colors: active)").matches;
      }, setHighContrastTheme: function(st) {
        var _;
        st.highContrastModeActive = !0;
        let tt = st.options.accessibility.highContrastTheme;
        st.update(tt, !1);
        let V = ((_ = tt.colors) == null ? void 0 : _.length) > 1;
        st.series.forEach(function(N) {
          let D = tt.plotOptions[N.type] || {}, p = V && N.colorIndex !== void 0 ? tt.colors[N.colorIndex] : D.color || "window", y = { color: D.color || "windowText", colors: V ? tt.colors : [D.color || "windowText"], borderColor: D.borderColor || "window", fillColor: p };
          N.update(y, !1), N.points && N.points.forEach(function(m) {
            m.options && m.options.color && m.update({ color: D.color || "windowText", borderColor: D.borderColor || "window" }, !1);
          });
        }), st.redraw();
      } };
    }), nt(i, "Accessibility/HighContrastTheme.js", [], function() {
      return { chart: { backgroundColor: "window" }, title: { style: { color: "windowText" } }, subtitle: { style: { color: "windowText" } }, colorAxis: { minColor: "windowText", maxColor: "windowText", stops: [], dataClasses: [] }, colors: ["windowText"], xAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, yAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, tooltip: { backgroundColor: "window", borderColor: "windowText", style: { color: "windowText" } }, plotOptions: { series: { lineColor: "windowText", fillColor: "window", borderColor: "windowText", edgeColor: "windowText", borderWidth: 1, dataLabels: { connectorColor: "windowText", color: "windowText", style: { color: "windowText", textOutline: "none" } }, marker: { lineColor: "windowText", fillColor: "windowText" } }, pie: { color: "window", colors: ["window"], borderColor: "windowText", borderWidth: 1 }, boxplot: { fillColor: "window" }, candlestick: { lineColor: "windowText", fillColor: "window" }, errorbar: { fillColor: "window" } }, legend: { backgroundColor: "window", itemStyle: { color: "windowText" }, itemHoverStyle: { color: "windowText" }, itemHiddenStyle: { color: "#555" }, title: { style: { color: "windowText" } } }, credits: { style: { color: "windowText" } }, drilldown: { activeAxisLabelStyle: { color: "windowText" }, activeDataLabelStyle: { color: "windowText" } }, navigation: { buttonOptions: { symbolStroke: "windowText", theme: { fill: "window" } } }, rangeSelector: { buttonTheme: { fill: "window", stroke: "windowText", style: { color: "windowText" }, states: { hover: { fill: "window", stroke: "windowText", style: { color: "windowText" } }, select: { fill: "#444", stroke: "windowText", style: { color: "windowText" } } } }, inputBoxBorderColor: "windowText", inputStyle: { backgroundColor: "window", color: "windowText" }, labelStyle: { color: "windowText" } }, navigator: { handles: { backgroundColor: "window", borderColor: "windowText" }, outlineColor: "windowText", maskFill: "transparent", series: { color: "windowText", lineColor: "windowText" }, xAxis: { gridLineColor: "windowText" } }, scrollbar: { barBackgroundColor: "#444", barBorderColor: "windowText", buttonArrowColor: "windowText", buttonBackgroundColor: "window", buttonBorderColor: "windowText", rifleColor: "windowText", trackBackgroundColor: "window", trackBorderColor: "windowText" } };
    }), nt(i, "Accessibility/Options/A11yDefaults.js", [], function() {
      return { accessibility: { enabled: !0, screenReaderSection: { beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>", afterChartFormat: "{endOfChartMarker}", axisRangeDateFormat: "%Y-%m-%d %H:%M:%S" }, series: { descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}", describeSingleSeries: !1, pointDescriptionEnabledThreshold: 200 }, point: { valueDescriptionFormat: "{xDescription}{separator}{value}.", describeNull: !0 }, landmarkVerbosity: "all", linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description', highContrastMode: "auto", keyboardNavigation: { enabled: !0, focusBorder: { enabled: !0, hideBrowserFocusOutline: !0, style: { color: "#334eff", lineWidth: 2, borderRadius: 3 }, margin: 2 }, order: ["series", "zoom", "rangeSelector", "navigator", "legend", "chartMenu"], wrapAround: !0, seriesNavigation: { skipNullPoints: !0, pointNavigationEnabledThreshold: !1, rememberPointFocus: !1 } }, announceNewData: { enabled: !1, minAnnounceInterval: 5e3, interruptUser: !1 } }, legend: { accessibility: { enabled: !0, keyboardNavigation: { enabled: !0 } } }, exporting: { accessibility: { enabled: !0 } }, navigator: { accessibility: { enabled: !0 } } };
    }), nt(i, "Accessibility/Options/LangDefaults.js", [], function() {
      return { accessibility: { defaultChartTitle: "Chart", chartContainerLabel: "{title}. Highcharts interactive chart.", svgContainerLabel: "Interactive chart", drillUpButton: "{buttonText}", credits: "Chart credits: {creditsStr}", thousandsSep: ",", svgContainerTitle: "", graphicContainerLabel: "", screenReaderSection: { beforeRegionLabel: "", afterRegionLabel: "", annotations: { heading: "Chart annotations summary", descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}", descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}", descriptionNoPoints: "{annotationText}" }, endOfChartMarker: "End of interactive chart." }, sonification: { playAsSoundButtonText: "Play as sound, {chartTitle}", playAsSoundClickAnnouncement: "Play" }, legend: { legendLabelNoTitle: "Toggle series visibility, {chartTitle}", legendLabel: "Chart legend: {legendTitle}", legendItem: "Show {itemName}" }, zoom: { mapZoomIn: "Zoom chart", mapZoomOut: "Zoom out chart", resetZoomButton: "Reset zoom" }, rangeSelector: { dropdownLabel: "{rangeTitle}", minInputLabel: "Select start date.", maxInputLabel: "Select end date.", clickButtonAnnouncement: "Viewing {axisRangeDescription}" }, navigator: { handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}", groupLabel: "Axis zoom", changeAnnouncement: "{axisRangeDescription}" }, table: { viewAsDataTableButtonText: "View as data table, {chartTitle}", tableSummary: "Table representation of chart." }, announceNewData: { newDataAnnounce: "Updated data for chart {chartTitle}", newSeriesAnnounceSingle: "New data series: {seriesDesc}", newPointAnnounceSingle: "New data point: {pointDesc}", newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}", newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}" }, seriesTypeDescriptions: { boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.", arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.", areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.", bubble: "Bubble charts are scatter charts where each data point also has a size value.", columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.", errorbar: "Errorbar series are used to display the variability of the data.", funnel: "Funnel charts are used to display reduction of data in stages.", pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.", waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value." }, chartTypes: { emptyChart: "Empty chart", mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.", unknownMap: "Map of unspecified region with {numSeries} data series.", combinationChart: "Combination chart with {numSeries} data series.", defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", defaultMultiple: "Chart with {numSeries} data series.", splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", splineMultiple: "Line chart with {numSeries} lines.", lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", lineMultiple: "Line chart with {numSeries} lines.", columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", columnMultiple: "Bar chart with {numSeries} data series.", barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", barMultiple: "Bar chart with {numSeries} data series.", pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.", pieMultiple: "Pie chart with {numSeries} pies.", scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.", scatterMultiple: "Scatter chart with {numSeries} data series.", boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.", boxplotMultiple: "Boxplot with {numSeries} data series.", bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.", bubbleMultiple: "Bubble chart with {numSeries} data series." }, axis: { xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}", xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}", yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", timeRangeDays: "Data range: {range} days.", timeRangeHours: "Data range: {range} hours.", timeRangeMinutes: "Data range: {range} minutes.", timeRangeSeconds: "Data range: {range} seconds.", rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.", rangeCategories: "Data range: {numCategories} categories." }, exporting: { chartMenuLabel: "Chart menu", menuButtonLabel: "View chart menu, {chartTitle}" }, series: { summary: { default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}." }, description: "{description}", xAxisDescription: "X axis, {name}", yAxisDescription: "Y axis, {name}", nullPointValue: "No value", pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}" } } };
    }), nt(i, "Accessibility/Options/DeprecatedOptions.js", [i["Core/Utilities.js"]], function(B) {
      let { error: $, pick: J } = B;
      function it(tt, V, _) {
        let N = tt, D, p = 0;
        for (; p < V.length - 1; ++p) N = N[D = V[p]] = J(N[D], {});
        N[V[V.length - 1]] = _;
      }
      function st(tt, V, _, N) {
        function D(m, w) {
          return w.reduce(function(a, u) {
            return a[u];
          }, m);
        }
        let p = D(tt.options, V), y = D(tt.options, _);
        Object.keys(N).forEach(function(m) {
          let w = p[m];
          w !== void 0 && (it(y, N[m], w), $(32, !1, tt, { [V.join(".") + "." + m]: _.join(".") + "." + N[m].join(".") }));
        });
      }
      return function(tt) {
        (function(V) {
          let _ = V.options.chart, N = V.options.accessibility || {};
          ["description", "typeDescription"].forEach(function(D) {
            _[D] && (N[D] = _[D], $(32, !1, V, { [`chart.${D}`]: `use accessibility.${D}` }));
          });
        })(tt), function(V) {
          V.axes.forEach(function(_) {
            let N = _.options;
            N && N.description && (N.accessibility = N.accessibility || {}, N.accessibility.description = N.description, $(32, !1, V, { "axis.description": "use axis.accessibility.description" }));
          });
        }(tt), tt.series && function(V) {
          let _ = { description: ["accessibility", "description"], exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"], pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"], skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"], "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"] };
          V.series.forEach(function(N) {
            Object.keys(_).forEach(function(D) {
              let p = N.options[D];
              D === "accessibility.pointDescriptionFormatter" && (p = N.options.accessibility && N.options.accessibility.pointDescriptionFormatter), p !== void 0 && (it(N.options, _[D], D === "skipKeyboardNavigation" ? !p : p), $(32, !1, V, { [`series.${D}`]: "series." + _[D].join(".") }));
            });
          });
        }(tt), st(tt, ["accessibility"], ["accessibility"], { pointDateFormat: ["point", "dateFormat"], pointDateFormatter: ["point", "dateFormatter"], pointDescriptionFormatter: ["point", "descriptionFormatter"], pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"], pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"], pointValueDecimals: ["point", "valueDecimals"], pointValuePrefix: ["point", "valuePrefix"], pointValueSuffix: ["point", "valueSuffix"], screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"], describeSingleSeries: ["series", "describeSingleSeries"], seriesDescriptionFormatter: ["series", "descriptionFormatter"], onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"], axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"] }), st(tt, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], { skipNullPoints: ["skipNullPoints"], mode: ["mode"] }), st(tt, ["lang", "accessibility"], ["lang", "accessibility"], { legendItem: ["legend", "legendItem"], legendLabel: ["legend", "legendLabel"], mapZoomIn: ["zoom", "mapZoomIn"], mapZoomOut: ["zoom", "mapZoomOut"], resetZoomButton: ["zoom", "resetZoomButton"], screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"], rangeSelectorButton: ["rangeSelector", "buttonText"], rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"], rangeSelectorMinInput: ["rangeSelector", "minInputLabel"], svgContainerEnd: ["screenReaderSection", "endOfChartMarker"], viewAsDataTable: ["table", "viewAsDataTableButtonText"], tableSummary: ["table", "tableSummary"] });
      };
    }), nt(i, "Accessibility/Accessibility.js", [i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/A11yI18n.js"], i["Accessibility/Components/ContainerComponent.js"], i["Accessibility/FocusBorder.js"], i["Accessibility/Components/InfoRegionsComponent.js"], i["Accessibility/KeyboardNavigation.js"], i["Accessibility/Components/LegendComponent.js"], i["Accessibility/Components/MenuComponent.js"], i["Accessibility/Components/NavigatorComponent.js"], i["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], i["Accessibility/ProxyProvider.js"], i["Accessibility/Components/RangeSelectorComponent.js"], i["Accessibility/Components/SeriesComponent/SeriesComponent.js"], i["Accessibility/Components/ZoomComponent.js"], i["Accessibility/HighContrastMode.js"], i["Accessibility/HighContrastTheme.js"], i["Accessibility/Options/A11yDefaults.js"], i["Accessibility/Options/LangDefaults.js"], i["Accessibility/Options/DeprecatedOptions.js"]], function(B, $, J, it, st, tt, V, _, N, D, p, y, m, w, a, u, b, l, d, C, R, z) {
      let { defaultOptions: O } = B, { doc: h } = $, { addEvent: f, extend: s, fireEvent: t, merge: e } = J, { removeElement: r } = it;
      class g {
        constructor(c) {
          this.init(c);
        }
        init(c) {
          if (this.chart = c, !h.addEventListener) {
            this.zombie = !0, this.components = {}, c.renderTo.setAttribute("aria-hidden", !0);
            return;
          }
          z(c), this.proxyProvider = new w(this.chart), this.initComponents(), this.keyboardNavigation = new N(c, this.components);
        }
        initComponents() {
          let c = this.chart, n = this.proxyProvider, S = c.options.accessibility;
          this.components = { container: new tt(), infoRegions: new _(), legend: new D(), chartMenu: new p(), rangeSelector: new a(), series: new u(), zoom: new b(), navigator: new y() }, S.customComponents && s(this.components, S.customComponents);
          let j = this.components;
          this.getComponentOrder().forEach(function(v) {
            j[v].initBase(c, n), j[v].init();
          });
        }
        getComponentOrder() {
          return this.components ? this.components.series ? ["series"].concat(Object.keys(this.components).filter((c) => c !== "series")) : Object.keys(this.components) : [];
        }
        update() {
          let c = this.components, n = this.chart, S = n.options.accessibility;
          t(n, "beforeA11yUpdate"), n.types = this.getChartTypes();
          let j = S.keyboardNavigation.order;
          this.proxyProvider.updateGroupOrder(j), this.getComponentOrder().forEach(function(v) {
            c[v].onChartUpdate(), t(n, "afterA11yComponentUpdate", { name: v, component: c[v] });
          }), this.keyboardNavigation.update(j), !n.highContrastModeActive && S.highContrastMode !== !1 && (l.isHighContrastModeActive() || S.highContrastMode === !0) && l.setHighContrastTheme(n), t(n, "afterA11yUpdate", { accessibility: this });
        }
        destroy() {
          let c = this.chart || {}, n = this.components;
          Object.keys(n).forEach(function(S) {
            n[S].destroy(), n[S].destroyBase();
          }), this.proxyProvider && this.proxyProvider.destroy(), c.announcerContainer && r(c.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), c.renderTo && c.renderTo.setAttribute("aria-hidden", !0), c.focusElement && c.focusElement.removeFocusBorder();
        }
        getChartTypes() {
          let c = {};
          return this.chart.series.forEach(function(n) {
            c[n.type] = 1;
          }), Object.keys(c);
        }
      }
      return function(o) {
        function c() {
          this.accessibility && this.accessibility.destroy();
        }
        function n() {
          this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
          let P = this.accessibility;
          P && !P.zombie && (P.proxyProvider.updateProxyElementPositions(), P.getComponentOrder().forEach(function(G) {
            P.components[G].onChartRender();
          }));
        }
        function S(P) {
          let G = P.options.accessibility;
          G && (G.customComponents && (this.options.accessibility.customComponents = G.customComponents, delete G.customComponents), e(!0, this.options.accessibility, G), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
        }
        function j() {
          let P = this.accessibility, G = this.options.accessibility, W = this.renderer.boxWrapper.element, Q = this.title;
          if (G && G.enabled) P && !P.zombie ? P.update() : (this.accessibility = P = new o(this), P && !P.zombie && P.update(), W.getAttribute("role") === "img" && W.removeAttribute("role"));
          else if (P) P.destroy && P.destroy(), delete this.accessibility;
          else {
            this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", !1), this.renderTo.setAttribute("aria-label", (Q && Q.element.textContent || "").replace(/</g, "&lt;")), W.setAttribute("aria-hidden", !0);
            let k = document.getElementsByClassName("highcharts-description")[0];
            k && (k.setAttribute("aria-hidden", !1), k.classList.remove("highcharts-linked-description"));
          }
        }
        function v() {
          this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
        }
        o.i18nFormat = st.i18nFormat, o.compose = function(P, G, W, Q, k, A) {
          N.compose(P), m.compose(Q), D.compose(P, G), p.compose(P), u.compose(P, W, Q), st.compose(P), V.compose(P, k), A && a.compose(P, A);
          let L = P.prototype;
          L.updateA11yEnabled || (L.updateA11yEnabled = j, f(P, "destroy", c), f(P, "render", n), f(P, "update", S), ["addSeries", "init"].forEach((Y) => {
            f(P, Y, function() {
              this.a11yDirty = !0;
            });
          }), ["afterApplyDrilldown", "drillupall"].forEach((Y) => {
            f(P, Y, function() {
              let x = this.accessibility;
              x && !x.zombie && x.update();
            });
          }), f(W, "update", v), ["update", "updatedData", "remove"].forEach((Y) => {
            f(Q, Y, function() {
              this.chart.accessibility && (this.chart.a11yDirty = !0);
            });
          }));
        };
      }(g || (g = {})), e(!0, O, C, { accessibility: { highContrastTheme: d }, lang: R }), g;
    }), nt(i, "masters/modules/accessibility.src.js", [i["Core/Globals.js"], i["Accessibility/Accessibility.js"], i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(B, $, J, it, st, tt, V) {
      return B.i18nFormat = $.i18nFormat, B.A11yChartUtilities = it, B.A11yHTMLUtilities = st, B.AccessibilityComponent = J, B.KeyboardNavigationHandler = tt, B.SeriesAccessibilityDescriber = V, $.compose(B.Chart, B.Legend, B.Point, B.Series, B.SVGElement, B.RangeSelector), B;
    });
  });
})($i);
var Rs = $i.exports;
const Fs = /* @__PURE__ */ ce(Rs);
var Vi = typeof global == "object" && global && global.Object === Object && global, zs = typeof self == "object" && self && self.Object === Object && self, Ht = Vi || zs || Function("return this")(), Kt = Ht.Symbol, qi = Object.prototype, Hs = qi.hasOwnProperty, Us = qi.toString, oe = Kt ? Kt.toStringTag : void 0;
function Gs(E) {
  var I = Hs.call(E, oe), i = E[oe];
  try {
    E[oe] = void 0;
    var nt = !0;
  } catch {
  }
  var B = Us.call(E);
  return nt && (I ? E[oe] = i : delete E[oe]), B;
}
var Ws = Object.prototype, Xs = Ws.toString;
function Ys(E) {
  return Xs.call(E);
}
var _s = "[object Null]", $s = "[object Undefined]", xi = Kt ? Kt.toStringTag : void 0;
function ie(E) {
  return E == null ? E === void 0 ? $s : _s : xi && xi in Object(E) ? Gs(E) : Ys(E);
}
function Zt(E) {
  return E != null && typeof E == "object";
}
var Vs = "[object Symbol]";
function Ve(E) {
  return typeof E == "symbol" || Zt(E) && ie(E) == Vs;
}
function Ki(E, I) {
  for (var i = -1, nt = E == null ? 0 : E.length, B = Array(nt); ++i < nt; )
    B[i] = I(E[i], i, E);
  return B;
}
var Bt = Array.isArray, yi = Kt ? Kt.prototype : void 0, vi = yi ? yi.toString : void 0;
function Zi(E) {
  if (typeof E == "string")
    return E;
  if (Bt(E))
    return Ki(E, Zi) + "";
  if (Ve(E))
    return vi ? vi.call(E) : "";
  var I = E + "";
  return I == "0" && 1 / E == -1 / 0 ? "-0" : I;
}
function zt(E) {
  var I = typeof E;
  return E != null && (I == "object" || I == "function");
}
function qe(E) {
  return E;
}
var qs = "[object AsyncFunction]", Ks = "[object Function]", Zs = "[object GeneratorFunction]", Js = "[object Proxy]";
function Ke(E) {
  if (!zt(E))
    return !1;
  var I = ie(E);
  return I == Ks || I == Zs || I == qs || I == Js;
}
var Be = Ht["__core-js_shared__"], wi = function() {
  var E = /[^.]+$/.exec(Be && Be.keys && Be.keys.IE_PROTO || "");
  return E ? "Symbol(src)_1." + E : "";
}();
function Qs(E) {
  return !!wi && wi in E;
}
var tr = Function.prototype, er = tr.toString;
function se(E) {
  if (E != null) {
    try {
      return er.call(E);
    } catch {
    }
    try {
      return E + "";
    } catch {
    }
  }
  return "";
}
var ir = /[\\^$.*+?()[\]{}|]/g, sr = /^\[object .+?Constructor\]$/, rr = Function.prototype, or = Object.prototype, nr = rr.toString, ar = or.hasOwnProperty, lr = RegExp(
  "^" + nr.call(ar).replace(ir, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function hr(E) {
  if (!zt(E) || Qs(E))
    return !1;
  var I = Ke(E) ? lr : sr;
  return I.test(se(E));
}
function cr(E, I) {
  return E == null ? void 0 : E[I];
}
function re(E, I) {
  var i = cr(E, I);
  return hr(i) ? i : void 0;
}
var Ue = re(Ht, "WeakMap"), Ci = Object.create, dr = /* @__PURE__ */ function() {
  function E() {
  }
  return function(I) {
    if (!zt(I))
      return {};
    if (Ci)
      return Ci(I);
    E.prototype = I;
    var i = new E();
    return E.prototype = void 0, i;
  };
}();
function ur(E, I, i) {
  switch (i.length) {
    case 0:
      return E.call(I);
    case 1:
      return E.call(I, i[0]);
    case 2:
      return E.call(I, i[0], i[1]);
    case 3:
      return E.call(I, i[0], i[1], i[2]);
  }
  return E.apply(I, i);
}
function pr(E, I) {
  var i = -1, nt = E.length;
  for (I || (I = Array(nt)); ++i < nt; )
    I[i] = E[i];
  return I;
}
var gr = 800, fr = 16, mr = Date.now;
function br(E) {
  var I = 0, i = 0;
  return function() {
    var nt = mr(), B = fr - (nt - i);
    if (i = nt, B > 0) {
      if (++I >= gr)
        return arguments[0];
    } else
      I = 0;
    return E.apply(void 0, arguments);
  };
}
function xr(E) {
  return function() {
    return E;
  };
}
var xe = function() {
  try {
    var E = re(Object, "defineProperty");
    return E({}, "", {}), E;
  } catch {
  }
}(), yr = xe ? function(E, I) {
  return xe(E, "toString", {
    configurable: !0,
    enumerable: !1,
    value: xr(I),
    writable: !0
  });
} : qe, vr = br(yr), wr = 9007199254740991, Cr = /^(?:0|[1-9]\d*)$/;
function Ae(E, I) {
  var i = typeof E;
  return I = I == null ? wr : I, !!I && (i == "number" || i != "symbol" && Cr.test(E)) && E > -1 && E % 1 == 0 && E < I;
}
function Ze(E, I, i) {
  I == "__proto__" && xe ? xe(E, I, {
    configurable: !0,
    enumerable: !0,
    value: i,
    writable: !0
  }) : E[I] = i;
}
function de(E, I) {
  return E === I || E !== E && I !== I;
}
var Ar = Object.prototype, kr = Ar.hasOwnProperty;
function Ji(E, I, i) {
  var nt = E[I];
  (!(kr.call(E, I) && de(nt, i)) || i === void 0 && !(I in E)) && Ze(E, I, i);
}
function Sr(E, I, i, nt) {
  var B = !i;
  i || (i = {});
  for (var $ = -1, J = I.length; ++$ < J; ) {
    var it = I[$], st = void 0;
    st === void 0 && (st = E[it]), B ? Ze(i, it, st) : Ji(i, it, st);
  }
  return i;
}
var Ai = Math.max;
function Tr(E, I, i) {
  return I = Ai(I === void 0 ? E.length - 1 : I, 0), function() {
    for (var nt = arguments, B = -1, $ = Ai(nt.length - I, 0), J = Array($); ++B < $; )
      J[B] = nt[I + B];
    B = -1;
    for (var it = Array(I + 1); ++B < I; )
      it[B] = nt[B];
    return it[I] = i(J), ur(E, this, it);
  };
}
function Mr(E, I) {
  return vr(Tr(E, I, qe), E + "");
}
var Er = 9007199254740991;
function Je(E) {
  return typeof E == "number" && E > -1 && E % 1 == 0 && E <= Er;
}
function ke(E) {
  return E != null && Je(E.length) && !Ke(E);
}
function Pr(E, I, i) {
  if (!zt(i))
    return !1;
  var nt = typeof I;
  return (nt == "number" ? ke(i) && Ae(I, i.length) : nt == "string" && I in i) ? de(i[I], E) : !1;
}
function Or(E) {
  return Mr(function(I, i) {
    var nt = -1, B = i.length, $ = B > 1 ? i[B - 1] : void 0, J = B > 2 ? i[2] : void 0;
    for ($ = E.length > 3 && typeof $ == "function" ? (B--, $) : void 0, J && Pr(i[0], i[1], J) && ($ = B < 3 ? void 0 : $, B = 1), I = Object(I); ++nt < B; ) {
      var it = i[nt];
      it && E(I, it, nt, $);
    }
    return I;
  });
}
var Lr = Object.prototype;
function Qe(E) {
  var I = E && E.constructor, i = typeof I == "function" && I.prototype || Lr;
  return E === i;
}
function Dr(E, I) {
  for (var i = -1, nt = Array(E); ++i < E; )
    nt[i] = I(i);
  return nt;
}
var Nr = "[object Arguments]";
function ki(E) {
  return Zt(E) && ie(E) == Nr;
}
var Qi = Object.prototype, Ir = Qi.hasOwnProperty, jr = Qi.propertyIsEnumerable, ye = ki(/* @__PURE__ */ function() {
  return arguments;
}()) ? ki : function(E) {
  return Zt(E) && Ir.call(E, "callee") && !jr.call(E, "callee");
};
function Br() {
  return !1;
}
var ts = typeof exports == "object" && exports && !exports.nodeType && exports, Si = ts && typeof module == "object" && module && !module.nodeType && module, Rr = Si && Si.exports === ts, Ti = Rr ? Ht.Buffer : void 0, Fr = Ti ? Ti.isBuffer : void 0, ve = Fr || Br, zr = "[object Arguments]", Hr = "[object Array]", Ur = "[object Boolean]", Gr = "[object Date]", Wr = "[object Error]", Xr = "[object Function]", Yr = "[object Map]", _r = "[object Number]", $r = "[object Object]", Vr = "[object RegExp]", qr = "[object Set]", Kr = "[object String]", Zr = "[object WeakMap]", Jr = "[object ArrayBuffer]", Qr = "[object DataView]", to = "[object Float32Array]", eo = "[object Float64Array]", io = "[object Int8Array]", so = "[object Int16Array]", ro = "[object Int32Array]", oo = "[object Uint8Array]", no = "[object Uint8ClampedArray]", ao = "[object Uint16Array]", lo = "[object Uint32Array]", Mt = {};
Mt[to] = Mt[eo] = Mt[io] = Mt[so] = Mt[ro] = Mt[oo] = Mt[no] = Mt[ao] = Mt[lo] = !0;
Mt[zr] = Mt[Hr] = Mt[Jr] = Mt[Ur] = Mt[Qr] = Mt[Gr] = Mt[Wr] = Mt[Xr] = Mt[Yr] = Mt[_r] = Mt[$r] = Mt[Vr] = Mt[qr] = Mt[Kr] = Mt[Zr] = !1;
function ho(E) {
  return Zt(E) && Je(E.length) && !!Mt[ie(E)];
}
function co(E) {
  return function(I) {
    return E(I);
  };
}
var es = typeof exports == "object" && exports && !exports.nodeType && exports, ae = es && typeof module == "object" && module && !module.nodeType && module, uo = ae && ae.exports === es, Re = uo && Vi.process, Mi = function() {
  try {
    var E = ae && ae.require && ae.require("util").types;
    return E || Re && Re.binding && Re.binding("util");
  } catch {
  }
}(), Ei = Mi && Mi.isTypedArray, ti = Ei ? co(Ei) : ho, po = Object.prototype, go = po.hasOwnProperty;
function is(E, I) {
  var i = Bt(E), nt = !i && ye(E), B = !i && !nt && ve(E), $ = !i && !nt && !B && ti(E), J = i || nt || B || $, it = J ? Dr(E.length, String) : [], st = it.length;
  for (var tt in E)
    (I || go.call(E, tt)) && !(J && // Safari 9 has enumerable `arguments.length` in strict mode.
    (tt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    B && (tt == "offset" || tt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    $ && (tt == "buffer" || tt == "byteLength" || tt == "byteOffset") || // Skip index properties.
    Ae(tt, st))) && it.push(tt);
  return it;
}
function ss(E, I) {
  return function(i) {
    return E(I(i));
  };
}
var fo = ss(Object.keys, Object), mo = Object.prototype, bo = mo.hasOwnProperty;
function xo(E) {
  if (!Qe(E))
    return fo(E);
  var I = [];
  for (var i in Object(E))
    bo.call(E, i) && i != "constructor" && I.push(i);
  return I;
}
function rs(E) {
  return ke(E) ? is(E) : xo(E);
}
function yo(E) {
  var I = [];
  if (E != null)
    for (var i in Object(E))
      I.push(i);
  return I;
}
var vo = Object.prototype, wo = vo.hasOwnProperty;
function Co(E) {
  if (!zt(E))
    return yo(E);
  var I = Qe(E), i = [];
  for (var nt in E)
    nt == "constructor" && (I || !wo.call(E, nt)) || i.push(nt);
  return i;
}
function ei(E) {
  return ke(E) ? is(E, !0) : Co(E);
}
var Ao = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ko = /^\w*$/;
function ii(E, I) {
  if (Bt(E))
    return !1;
  var i = typeof E;
  return i == "number" || i == "symbol" || i == "boolean" || E == null || Ve(E) ? !0 : ko.test(E) || !Ao.test(E) || I != null && E in Object(I);
}
var le = re(Object, "create");
function So() {
  this.__data__ = le ? le(null) : {}, this.size = 0;
}
function To(E) {
  var I = this.has(E) && delete this.__data__[E];
  return this.size -= I ? 1 : 0, I;
}
var Mo = "__lodash_hash_undefined__", Eo = Object.prototype, Po = Eo.hasOwnProperty;
function Oo(E) {
  var I = this.__data__;
  if (le) {
    var i = I[E];
    return i === Mo ? void 0 : i;
  }
  return Po.call(I, E) ? I[E] : void 0;
}
var Lo = Object.prototype, Do = Lo.hasOwnProperty;
function No(E) {
  var I = this.__data__;
  return le ? I[E] !== void 0 : Do.call(I, E);
}
var Io = "__lodash_hash_undefined__";
function jo(E, I) {
  var i = this.__data__;
  return this.size += this.has(E) ? 0 : 1, i[E] = le && I === void 0 ? Io : I, this;
}
function ee(E) {
  var I = -1, i = E == null ? 0 : E.length;
  for (this.clear(); ++I < i; ) {
    var nt = E[I];
    this.set(nt[0], nt[1]);
  }
}
ee.prototype.clear = So;
ee.prototype.delete = To;
ee.prototype.get = Oo;
ee.prototype.has = No;
ee.prototype.set = jo;
function Bo() {
  this.__data__ = [], this.size = 0;
}
function Se(E, I) {
  for (var i = E.length; i--; )
    if (de(E[i][0], I))
      return i;
  return -1;
}
var Ro = Array.prototype, Fo = Ro.splice;
function zo(E) {
  var I = this.__data__, i = Se(I, E);
  if (i < 0)
    return !1;
  var nt = I.length - 1;
  return i == nt ? I.pop() : Fo.call(I, i, 1), --this.size, !0;
}
function Ho(E) {
  var I = this.__data__, i = Se(I, E);
  return i < 0 ? void 0 : I[i][1];
}
function Uo(E) {
  return Se(this.__data__, E) > -1;
}
function Go(E, I) {
  var i = this.__data__, nt = Se(i, E);
  return nt < 0 ? (++this.size, i.push([E, I])) : i[nt][1] = I, this;
}
function Xt(E) {
  var I = -1, i = E == null ? 0 : E.length;
  for (this.clear(); ++I < i; ) {
    var nt = E[I];
    this.set(nt[0], nt[1]);
  }
}
Xt.prototype.clear = Bo;
Xt.prototype.delete = zo;
Xt.prototype.get = Ho;
Xt.prototype.has = Uo;
Xt.prototype.set = Go;
var he = re(Ht, "Map");
function Wo() {
  this.size = 0, this.__data__ = {
    hash: new ee(),
    map: new (he || Xt)(),
    string: new ee()
  };
}
function Xo(E) {
  var I = typeof E;
  return I == "string" || I == "number" || I == "symbol" || I == "boolean" ? E !== "__proto__" : E === null;
}
function Te(E, I) {
  var i = E.__data__;
  return Xo(I) ? i[typeof I == "string" ? "string" : "hash"] : i.map;
}
function Yo(E) {
  var I = Te(this, E).delete(E);
  return this.size -= I ? 1 : 0, I;
}
function _o(E) {
  return Te(this, E).get(E);
}
function $o(E) {
  return Te(this, E).has(E);
}
function Vo(E, I) {
  var i = Te(this, E), nt = i.size;
  return i.set(E, I), this.size += i.size == nt ? 0 : 1, this;
}
function Yt(E) {
  var I = -1, i = E == null ? 0 : E.length;
  for (this.clear(); ++I < i; ) {
    var nt = E[I];
    this.set(nt[0], nt[1]);
  }
}
Yt.prototype.clear = Wo;
Yt.prototype.delete = Yo;
Yt.prototype.get = _o;
Yt.prototype.has = $o;
Yt.prototype.set = Vo;
var qo = "Expected a function";
function si(E, I) {
  if (typeof E != "function" || I != null && typeof I != "function")
    throw new TypeError(qo);
  var i = function() {
    var nt = arguments, B = I ? I.apply(this, nt) : nt[0], $ = i.cache;
    if ($.has(B))
      return $.get(B);
    var J = E.apply(this, nt);
    return i.cache = $.set(B, J) || $, J;
  };
  return i.cache = new (si.Cache || Yt)(), i;
}
si.Cache = Yt;
var Ko = 500;
function Zo(E) {
  var I = si(E, function(nt) {
    return i.size === Ko && i.clear(), nt;
  }), i = I.cache;
  return I;
}
var Jo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Qo = /\\(\\)?/g, tn = Zo(function(E) {
  var I = [];
  return E.charCodeAt(0) === 46 && I.push(""), E.replace(Jo, function(i, nt, B, $) {
    I.push(B ? $.replace(Qo, "$1") : nt || i);
  }), I;
});
function en(E) {
  return E == null ? "" : Zi(E);
}
function Me(E, I) {
  return Bt(E) ? E : ii(E, I) ? [E] : tn(en(E));
}
function ue(E) {
  if (typeof E == "string" || Ve(E))
    return E;
  var I = E + "";
  return I == "0" && 1 / E == -1 / 0 ? "-0" : I;
}
function ri(E, I) {
  I = Me(I, E);
  for (var i = 0, nt = I.length; E != null && i < nt; )
    E = E[ue(I[i++])];
  return i && i == nt ? E : void 0;
}
function sn(E, I, i) {
  var nt = E == null ? void 0 : ri(E, I);
  return nt === void 0 ? i : nt;
}
function os(E, I) {
  for (var i = -1, nt = I.length, B = E.length; ++i < nt; )
    E[B + i] = I[i];
  return E;
}
var oi = ss(Object.getPrototypeOf, Object), rn = "[object Object]", on = Function.prototype, nn = Object.prototype, ns = on.toString, an = nn.hasOwnProperty, ln = ns.call(Object);
function hn(E) {
  if (!Zt(E) || ie(E) != rn)
    return !1;
  var I = oi(E);
  if (I === null)
    return !0;
  var i = an.call(I, "constructor") && I.constructor;
  return typeof i == "function" && i instanceof i && ns.call(i) == ln;
}
function cn() {
  this.__data__ = new Xt(), this.size = 0;
}
function dn(E) {
  var I = this.__data__, i = I.delete(E);
  return this.size = I.size, i;
}
function un(E) {
  return this.__data__.get(E);
}
function pn(E) {
  return this.__data__.has(E);
}
var gn = 200;
function fn(E, I) {
  var i = this.__data__;
  if (i instanceof Xt) {
    var nt = i.__data__;
    if (!he || nt.length < gn - 1)
      return nt.push([E, I]), this.size = ++i.size, this;
    i = this.__data__ = new Yt(nt);
  }
  return i.set(E, I), this.size = i.size, this;
}
function Ft(E) {
  var I = this.__data__ = new Xt(E);
  this.size = I.size;
}
Ft.prototype.clear = cn;
Ft.prototype.delete = dn;
Ft.prototype.get = un;
Ft.prototype.has = pn;
Ft.prototype.set = fn;
var as = typeof exports == "object" && exports && !exports.nodeType && exports, Pi = as && typeof module == "object" && module && !module.nodeType && module, mn = Pi && Pi.exports === as, Oi = mn ? Ht.Buffer : void 0;
Oi && Oi.allocUnsafe;
function bn(E, I) {
  return E.slice();
}
function xn(E, I) {
  for (var i = -1, nt = E == null ? 0 : E.length, B = 0, $ = []; ++i < nt; ) {
    var J = E[i];
    I(J, i, E) && ($[B++] = J);
  }
  return $;
}
function ls() {
  return [];
}
var yn = Object.prototype, vn = yn.propertyIsEnumerable, Li = Object.getOwnPropertySymbols, hs = Li ? function(E) {
  return E == null ? [] : (E = Object(E), xn(Li(E), function(I) {
    return vn.call(E, I);
  }));
} : ls, wn = Object.getOwnPropertySymbols, Cn = wn ? function(E) {
  for (var I = []; E; )
    os(I, hs(E)), E = oi(E);
  return I;
} : ls;
function cs(E, I, i) {
  var nt = I(E);
  return Bt(E) ? nt : os(nt, i(E));
}
function Di(E) {
  return cs(E, rs, hs);
}
function An(E) {
  return cs(E, ei, Cn);
}
var Ge = re(Ht, "DataView"), We = re(Ht, "Promise"), Xe = re(Ht, "Set"), Ni = "[object Map]", kn = "[object Object]", Ii = "[object Promise]", ji = "[object Set]", Bi = "[object WeakMap]", Ri = "[object DataView]", Sn = se(Ge), Tn = se(he), Mn = se(We), En = se(Xe), Pn = se(Ue), Vt = ie;
(Ge && Vt(new Ge(new ArrayBuffer(1))) != Ri || he && Vt(new he()) != Ni || We && Vt(We.resolve()) != Ii || Xe && Vt(new Xe()) != ji || Ue && Vt(new Ue()) != Bi) && (Vt = function(E) {
  var I = ie(E), i = I == kn ? E.constructor : void 0, nt = i ? se(i) : "";
  if (nt)
    switch (nt) {
      case Sn:
        return Ri;
      case Tn:
        return Ni;
      case Mn:
        return Ii;
      case En:
        return ji;
      case Pn:
        return Bi;
    }
  return I;
});
var we = Ht.Uint8Array;
function On(E) {
  var I = new E.constructor(E.byteLength);
  return new we(I).set(new we(E)), I;
}
function Ln(E, I) {
  var i = On(E.buffer);
  return new E.constructor(i, E.byteOffset, E.length);
}
function Dn(E) {
  return typeof E.constructor == "function" && !Qe(E) ? dr(oi(E)) : {};
}
var Nn = "__lodash_hash_undefined__";
function In(E) {
  return this.__data__.set(E, Nn), this;
}
function jn(E) {
  return this.__data__.has(E);
}
function Ce(E) {
  var I = -1, i = E == null ? 0 : E.length;
  for (this.__data__ = new Yt(); ++I < i; )
    this.add(E[I]);
}
Ce.prototype.add = Ce.prototype.push = In;
Ce.prototype.has = jn;
function Bn(E, I) {
  for (var i = -1, nt = E == null ? 0 : E.length; ++i < nt; )
    if (I(E[i], i, E))
      return !0;
  return !1;
}
function Rn(E, I) {
  return E.has(I);
}
var Fn = 1, zn = 2;
function ds(E, I, i, nt, B, $) {
  var J = i & Fn, it = E.length, st = I.length;
  if (it != st && !(J && st > it))
    return !1;
  var tt = $.get(E), V = $.get(I);
  if (tt && V)
    return tt == I && V == E;
  var _ = -1, N = !0, D = i & zn ? new Ce() : void 0;
  for ($.set(E, I), $.set(I, E); ++_ < it; ) {
    var p = E[_], y = I[_];
    if (nt)
      var m = J ? nt(y, p, _, I, E, $) : nt(p, y, _, E, I, $);
    if (m !== void 0) {
      if (m)
        continue;
      N = !1;
      break;
    }
    if (D) {
      if (!Bn(I, function(w, a) {
        if (!Rn(D, a) && (p === w || B(p, w, i, nt, $)))
          return D.push(a);
      })) {
        N = !1;
        break;
      }
    } else if (!(p === y || B(p, y, i, nt, $))) {
      N = !1;
      break;
    }
  }
  return $.delete(E), $.delete(I), N;
}
function Hn(E) {
  var I = -1, i = Array(E.size);
  return E.forEach(function(nt, B) {
    i[++I] = [B, nt];
  }), i;
}
function Un(E) {
  var I = -1, i = Array(E.size);
  return E.forEach(function(nt) {
    i[++I] = nt;
  }), i;
}
var Gn = 1, Wn = 2, Xn = "[object Boolean]", Yn = "[object Date]", _n = "[object Error]", $n = "[object Map]", Vn = "[object Number]", qn = "[object RegExp]", Kn = "[object Set]", Zn = "[object String]", Jn = "[object Symbol]", Qn = "[object ArrayBuffer]", ta = "[object DataView]", Fi = Kt ? Kt.prototype : void 0, Fe = Fi ? Fi.valueOf : void 0;
function ea(E, I, i, nt, B, $, J) {
  switch (i) {
    case ta:
      if (E.byteLength != I.byteLength || E.byteOffset != I.byteOffset)
        return !1;
      E = E.buffer, I = I.buffer;
    case Qn:
      return !(E.byteLength != I.byteLength || !$(new we(E), new we(I)));
    case Xn:
    case Yn:
    case Vn:
      return de(+E, +I);
    case _n:
      return E.name == I.name && E.message == I.message;
    case qn:
    case Zn:
      return E == I + "";
    case $n:
      var it = Hn;
    case Kn:
      var st = nt & Gn;
      if (it || (it = Un), E.size != I.size && !st)
        return !1;
      var tt = J.get(E);
      if (tt)
        return tt == I;
      nt |= Wn, J.set(E, I);
      var V = ds(it(E), it(I), nt, B, $, J);
      return J.delete(E), V;
    case Jn:
      if (Fe)
        return Fe.call(E) == Fe.call(I);
  }
  return !1;
}
var ia = 1, sa = Object.prototype, ra = sa.hasOwnProperty;
function oa(E, I, i, nt, B, $) {
  var J = i & ia, it = Di(E), st = it.length, tt = Di(I), V = tt.length;
  if (st != V && !J)
    return !1;
  for (var _ = st; _--; ) {
    var N = it[_];
    if (!(J ? N in I : ra.call(I, N)))
      return !1;
  }
  var D = $.get(E), p = $.get(I);
  if (D && p)
    return D == I && p == E;
  var y = !0;
  $.set(E, I), $.set(I, E);
  for (var m = J; ++_ < st; ) {
    N = it[_];
    var w = E[N], a = I[N];
    if (nt)
      var u = J ? nt(a, w, N, I, E, $) : nt(w, a, N, E, I, $);
    if (!(u === void 0 ? w === a || B(w, a, i, nt, $) : u)) {
      y = !1;
      break;
    }
    m || (m = N == "constructor");
  }
  if (y && !m) {
    var b = E.constructor, l = I.constructor;
    b != l && "constructor" in E && "constructor" in I && !(typeof b == "function" && b instanceof b && typeof l == "function" && l instanceof l) && (y = !1);
  }
  return $.delete(E), $.delete(I), y;
}
var na = 1, zi = "[object Arguments]", Hi = "[object Array]", me = "[object Object]", aa = Object.prototype, Ui = aa.hasOwnProperty;
function la(E, I, i, nt, B, $) {
  var J = Bt(E), it = Bt(I), st = J ? Hi : Vt(E), tt = it ? Hi : Vt(I);
  st = st == zi ? me : st, tt = tt == zi ? me : tt;
  var V = st == me, _ = tt == me, N = st == tt;
  if (N && ve(E)) {
    if (!ve(I))
      return !1;
    J = !0, V = !1;
  }
  if (N && !V)
    return $ || ($ = new Ft()), J || ti(E) ? ds(E, I, i, nt, B, $) : ea(E, I, st, i, nt, B, $);
  if (!(i & na)) {
    var D = V && Ui.call(E, "__wrapped__"), p = _ && Ui.call(I, "__wrapped__");
    if (D || p) {
      var y = D ? E.value() : E, m = p ? I.value() : I;
      return $ || ($ = new Ft()), B(y, m, i, nt, $);
    }
  }
  return N ? ($ || ($ = new Ft()), oa(E, I, i, nt, B, $)) : !1;
}
function ni(E, I, i, nt, B) {
  return E === I ? !0 : E == null || I == null || !Zt(E) && !Zt(I) ? E !== E && I !== I : la(E, I, i, nt, ni, B);
}
var ha = 1, ca = 2;
function da(E, I, i, nt) {
  var B = i.length, $ = B;
  if (E == null)
    return !$;
  for (E = Object(E); B--; ) {
    var J = i[B];
    if (J[2] ? J[1] !== E[J[0]] : !(J[0] in E))
      return !1;
  }
  for (; ++B < $; ) {
    J = i[B];
    var it = J[0], st = E[it], tt = J[1];
    if (J[2]) {
      if (st === void 0 && !(it in E))
        return !1;
    } else {
      var V = new Ft(), _;
      if (!(_ === void 0 ? ni(tt, st, ha | ca, nt, V) : _))
        return !1;
    }
  }
  return !0;
}
function us(E) {
  return E === E && !zt(E);
}
function ua(E) {
  for (var I = rs(E), i = I.length; i--; ) {
    var nt = I[i], B = E[nt];
    I[i] = [nt, B, us(B)];
  }
  return I;
}
function ps(E, I) {
  return function(i) {
    return i == null ? !1 : i[E] === I && (I !== void 0 || E in Object(i));
  };
}
function pa(E) {
  var I = ua(E);
  return I.length == 1 && I[0][2] ? ps(I[0][0], I[0][1]) : function(i) {
    return i === E || da(i, E, I);
  };
}
function ga(E, I) {
  return E != null && I in Object(E);
}
function fa(E, I, i) {
  I = Me(I, E);
  for (var nt = -1, B = I.length, $ = !1; ++nt < B; ) {
    var J = ue(I[nt]);
    if (!($ = E != null && i(E, J)))
      break;
    E = E[J];
  }
  return $ || ++nt != B ? $ : (B = E == null ? 0 : E.length, !!B && Je(B) && Ae(J, B) && (Bt(E) || ye(E)));
}
function ma(E, I) {
  return E != null && fa(E, I, ga);
}
var ba = 1, xa = 2;
function ya(E, I) {
  return ii(E) && us(I) ? ps(ue(E), I) : function(i) {
    var nt = sn(i, E);
    return nt === void 0 && nt === I ? ma(i, E) : ni(I, nt, ba | xa);
  };
}
function va(E) {
  return function(I) {
    return I == null ? void 0 : I[E];
  };
}
function wa(E) {
  return function(I) {
    return ri(I, E);
  };
}
function Ca(E) {
  return ii(E) ? va(ue(E)) : wa(E);
}
function Aa(E) {
  return typeof E == "function" ? E : E == null ? qe : typeof E == "object" ? Bt(E) ? ya(E[0], E[1]) : pa(E) : Ca(E);
}
function ka(E) {
  return function(I, i, nt) {
    for (var B = -1, $ = Object(I), J = nt(I), it = J.length; it--; ) {
      var st = J[++B];
      if (i($[st], st, $) === !1)
        break;
    }
    return I;
  };
}
var Sa = ka();
function Ye(E, I, i) {
  (i !== void 0 && !de(E[I], i) || i === void 0 && !(I in E)) && Ze(E, I, i);
}
function Ta(E) {
  return Zt(E) && ke(E);
}
function _e(E, I) {
  if (!(I === "constructor" && typeof E[I] == "function") && I != "__proto__")
    return E[I];
}
function Ma(E) {
  return Sr(E, ei(E));
}
function Ea(E, I, i, nt, B, $, J) {
  var it = _e(E, i), st = _e(I, i), tt = J.get(st);
  if (tt) {
    Ye(E, i, tt);
    return;
  }
  var V = $ ? $(it, st, i + "", E, I, J) : void 0, _ = V === void 0;
  if (_) {
    var N = Bt(st), D = !N && ve(st), p = !N && !D && ti(st);
    V = st, N || D || p ? Bt(it) ? V = it : Ta(it) ? V = pr(it) : D ? (_ = !1, V = bn(st)) : p ? (_ = !1, V = Ln(st)) : V = [] : hn(st) || ye(st) ? (V = it, ye(it) ? V = Ma(it) : (!zt(it) || Ke(it)) && (V = Dn(st))) : _ = !1;
  }
  _ && (J.set(st, V), B(V, st, nt, $, J), J.delete(st)), Ye(E, i, V);
}
function gs(E, I, i, nt, B) {
  E !== I && Sa(I, function($, J) {
    if (B || (B = new Ft()), zt($))
      Ea(E, I, J, i, gs, nt, B);
    else {
      var it = nt ? nt(_e(E, J), $, J + "", E, I, B) : void 0;
      it === void 0 && (it = $), Ye(E, J, it);
    }
  }, ei);
}
var Pa = Or(function(E, I, i, nt) {
  gs(E, I, i, nt);
});
function Oa(E, I, i, nt) {
  if (!zt(E))
    return E;
  I = Me(I, E);
  for (var B = -1, $ = I.length, J = $ - 1, it = E; it != null && ++B < $; ) {
    var st = ue(I[B]), tt = i;
    if (st === "__proto__" || st === "constructor" || st === "prototype")
      return E;
    if (B != J) {
      var V = it[st];
      tt = void 0, tt === void 0 && (tt = zt(V) ? V : Ae(I[B + 1]) ? [] : {});
    }
    Ji(it, st, tt), it = it[st];
  }
  return E;
}
function La(E, I, i) {
  for (var nt = -1, B = I.length, $ = {}; ++nt < B; ) {
    var J = I[nt], it = ri(E, J);
    i(it, J) && Oa($, Me(J, E), it);
  }
  return $;
}
function Da(E, I) {
  if (E == null)
    return {};
  var i = Ki(An(E), function(nt) {
    return [nt];
  });
  return I = Aa(I), La(E, i, function(nt, B) {
    return I(nt, B[0]);
  });
}
var qt = /* @__PURE__ */ ((E) => (E.CIRCLE = "circle", E.TRIANGLE = "triangle", E.SQUARE = "square", E.DIAMOND = "diamond", E.TRIANGLE_DOWN = "triangle-down", E))(qt || {}), ne = /* @__PURE__ */ ((E) => (E.SINGLE_LINE = "single-line", E.MULTI_LINE = "multi-line", E.MULTI_LEVEL = "multi-level", E))(ne || {}), te = /* @__PURE__ */ ((E) => (E.LINE = "line", E.BAR = "bar", E.COLUMN = "column", E.SCATTER = "scatter", E.PIE = "pie", E.GAUGE = "gauge", E.AREA = "area", E))(te || {}), Na = /* @__PURE__ */ ((E) => (E.HORIZONTAL = "horizontal", E.VERTICAL = "vertical", E))(Na || {}), fs = /* @__PURE__ */ ((E) => (E[E.HEIGHT = 480] = "HEIGHT", E))(fs || {}), Wt = /* @__PURE__ */ ((E) => (E.STANDARD = "standard-set", E.EXTENDED = "extended-set", E))(Wt || {});
const Gi = " ";
function Ia(E, I = Gi) {
  return typeof I != "string" && (I = Gi), E == null ? void 0 : E.split(I).map((i) => i.trim());
}
var ms = /* @__PURE__ */ ((E) => (E.HORIZONTAL = "row", E.VERTICAL = "column", E))(ms || {}), bs = /* @__PURE__ */ ((E) => (E.CENTER = "center", E.LEFT = "left", E.RIGHT = "right", E))(bs || {}), xs = /* @__PURE__ */ ((E) => (E.BOTTOM = "bottom", E.TOP = "top", E.MIDDLE = "middle", E))(xs || {});
xs.TOP, bs.CENTER, ms.HORIZONTAL;
const ja = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="2" />
</svg>
`, Ba = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="6" />
</svg>
`, Ra = `<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect y="5" width="7" height="7" transform="rotate(-45 0 5)"/>
</svg>
`, Fa = `<svg height="10" width="10" viewbox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect width="10" height="10"/>
</svg>
`, za = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M10 0L5 8L6.99382e-07 -8.74228e-07L10 0Z"/>
</svg>
`, Ha = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M0 8L5 0L10 8H0Z"/>
</svg>
`;
Yi` <beacon-table id="datatable">
  <table>
    <thead>
      <tr>
        <th>Year</th>
        <th>Company A</th>
        <th>Company B</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>2016</th>
        <td>30386</td>
        <td>28504</td>
      </tr>
      <tr>
        <th>2017</th>
        <td>29173</td>
        <td>27460</td>
      </tr>
      <tr>
        <th>2018</th>
        <td>28430</td>
        <td>26690</td>
      </tr>
      <tr>
        <th>2019</th>
        <td>28042</td>
        <td>26453</td>
      </tr>
      <tr>
        <th>2020</th>
        <td>27063</td>
        <td>25916</td>
      </tr>
      <tr>
        <th>2021</th>
        <td>28684</td>
        <td>27376</td>
      </tr>
    </tbody>
  </table>
</beacon-table>`;
const $t = {
  multiLevel: ja,
  circle: Ba,
  triangle: Ha,
  square: Fa,
  diamond: Ra,
  triangleDown: za
};
function Ua(E) {
  const I = [...Object.values(qt)], i = E % I.length;
  return I[i];
}
function ze(E, I, i) {
  if (I)
    return $t.multiLevel;
  const nt = [
    te.LINE,
    te.SCATTER,
    te.AREA
  ];
  if (i && nt.includes(i))
    switch (Ua(E)) {
      case qt.CIRCLE:
        return $t.circle;
      case qt.TRIANGLE:
        return $t.triangle;
      case qt.SQUARE:
        return $t.square;
      case qt.DIAMOND:
        return $t.diamond;
      case qt.TRIANGLE_DOWN:
        return $t.triangleDown;
      default:
        return $t.circle;
    }
  else
    return $t.circle;
}
const be = $e`[beacon-tag-name$=chart] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-50)}[beacon-tag-name$=chart] [slot=subtitle],[beacon-tag-name$=chart] [slot=caption]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300)}.highcharts-tooltip-container{z-index:1200!important}.highcharts-tooltip-container svg{max-inline-size:unset}.beacon-chart-tooltip{background-color:var(--beacon-system-color-background-1);color:var(--beacon-system-color-text-standard);fill:var(--beacon-system-color-background-1)}.beacon-chart-tooltip .highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.beacon-chart-tooltip .highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.beacon-chart-tooltip .highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.beacon-chart-tooltip .highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.beacon-chart-tooltip .highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.beacon-chart-tooltip .highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.beacon-chart-tooltip .highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.beacon-chart-tooltip .highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.beacon-chart-tooltip .highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.beacon-chart-tooltip .highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.beacon-chart-tooltip .highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.beacon-chart-tooltip .highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.negative{fill:var(--beacon-reference-palette-functional-red-3);stroke:var(--beacon-reference-palette-functional-red-3)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.positive{fill:var(--beacon-reference-palette-functional-green-3);stroke:var(--beacon-reference-palette-functional-green-3)}.beacon-chart-tooltip__title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.beacon-chart-tooltip__point,.beacon-chart-tooltip-point__label{align-items:center;display:flex}.beacon-chart-tooltip__point{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);gap:var(--beacon-reference-space-3)}.beacon-chart-tooltip__point:not(:first-of-type){margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip__separator{border:0;border-block-start-color:var(--beacon-system-color-icon-primary-inactive);border-block-start-style:solid;border-block-start-width:var(--beacon-system-width-border-mini)}.beacon-chart-tooltip__point--multi-level .beacon-legend-item__icon{fill:var(--beacon-system-color-icon-primary-inactive)}.beacon-chart-tooltip__footer,.beacon-chart-tooltip__additional-content{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip-point__label{gap:var(--beacon-reference-space-4)}.beacon-chart-tooltip__point-value{font-weight:var(--beacon-system-font-weight-bold)}`, Ga = $e`*{margin:0;padding:0}:host{--component-background-color: transparent;--component-gap-space: var(--beacon-system-space-micro-jumbo);background-color:var(--component-background-color)}.base{padding-block:var(--beacon-reference-space-3)}.chart{block-size:var(--beacon-custom-chart-container-size-block, auto)}.header{margin-block-end:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.caption{margin-block-start:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.highcharts-background{fill:var(--component-background-color)}.highcharts-focus-border{stroke:var(--beacon-system-color-border-focus-outer);stroke-width:var(--beacon-system-width-border-jumbo)}.highcharts-container{color:inherit;font-family:inherit}.highcharts-container :not(.highcharts-tooltip,.highcharts-tooltip-box,.highcharts-button)>text{fill:currentcolor}.highcharts-legend-item .highcharts-focus-border{display:none}.highcharts-legend-navigation{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard)}.highcharts-legend-nav-active{fill:var(--beacon-system-color-icon-secondary)}.highcharts-legend-nav-inactive{fill:var(--beacon-system-color-icon-secondary-inactive)}.beacon-legend-item{--background-color: var(--beacon-system-color-background-1);--legend-item-padding: var(--beacon-system-space-cell-contained);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;background-color:var(--background-color);border-color:transparent;border-radius:var(--beacon-system-radius-corner-standard);border-style:solid;border-width:var(--beacon-system-width-border-normal, 2px);display:flex;gap:var(--beacon-reference-space-3);padding:var(--legend-item-padding)}.beacon-legend-item .beacon-legend-item__label{align-items:center;display:flex;gap:var(--beacon-reference-space-4)}.beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.beacon-legend-item.beacon-legend-item--hover .beacon-legend-item__label-text{text-decoration:underline}.beacon-legend-item.beacon-legend-item--focus{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}.beacon-legend-item.beacon-legend-item--focus:not(dialog){position:relative}.beacon-legend-item .beacon-legend-item__value{font-weight:var(--beacon-system-font-weight-bold)}.highcharts-legend-item-hidden *{text-decoration:none}.highcharts-legend-item-hidden .beacon-legend-item{--background-color: transparent}.highcharts-legend-item-hidden .beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.static-legend .highcharts-legend{pointer-events:none}.static-legend .highcharts-a11y-proxy-group-legend button{cursor:default;pointer-events:none}.static-legend .beacon-legend-item{--background-color: transparent;--legend-item-padding: 0;border-radius:0}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-inline-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-inline-end:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-inline-start:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-block-end:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-block-start:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-10)}@media (width >= 640px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-11)}}@media (width >= 960px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-12)}}@media (width >= 1280px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-13)}}.highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}`;
var Wa = Object.defineProperty, Xa = Object.getOwnPropertyDescriptor, Lt = (E, I, i, nt) => {
  for (var B = nt > 1 ? void 0 : nt ? Xa(I, i) : I, $ = E.length - 1, J; $ >= 0; $--)
    (J = E[$]) && (B = (nt ? J(I, i, B) : J(B)) || B);
  return nt && B && Wa(I, i, B), B;
};
const Ya = ["top", "middle", "bottom"], _a = ["center", "right"], $a = ["horizontal", "vertical"];
function Va(E) {
  return typeof E.legendWidth == "number";
}
function qa(E) {
  return typeof E.maxLegendWidth == "number";
}
function Wi(E) {
  return E.a11yProxyElement !== void 0;
}
function Xi(E) {
  return E.a11yProxyElement !== void 0;
}
var Tt;
const Ot = (Tt = class extends Is {
  constructor() {
    super(...arguments), this.resetSpacing = !0, this._type = te.LINE, this.series = [], this.options = {}, this.staticLegend = !1, this.disableLegend = !1, this.hideLegendMetric = !1, this.legendLayout = Tt.defaultLegendLayout, this.tooltipTitle = "", this.tooltipFooter = "", this.tooltipVariant = ne.SINGLE_LINE, this.disableMarkers = !1, this.percentage = !1, this.decimal = !1, this.decimalPlaces = 1, this.chart = null, this.filteredOptions = {}, this.colorOrder = Wt.STANDARD;
  }
  static get styles() {
    return [super.styles, Bs, Ga];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, be];
  }
  /**
   * The type of chart being rendered. Follows Highcharts chart types.
   * @abstract
   */
  get type() {
    return this._type;
  }
  /**
   * Local options defined on the component-level.
   * @abstract
   */
  get localComponentOptions() {
    return {};
  }
  /**
   * This getter ensures that the chart type is included in the series data
   * when it's passed to highcharts. This ensures that data passed to highcharts
   * is type-safe for users in TS contexts.
   */
  get seriesWithChartType() {
    return this.series.map((I) => ({
      ...I,
      type: this.type
    }));
  }
  /**
   * Global chart options applicable to all charts.
   */
  get chartOptions() {
    const I = this.hideLegendMetric, i = this.percentage, nt = this.decimal, B = this.decimalPlaces, $ = this.type, J = this.addBeaconModeToTooltipContainer.bind(this);
    return {
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      },
      chart: {
        animation: !1,
        colorCount: 12,
        events: {
          /**
           * @this Chart
           *
           * On redraw, we assign styles and classes to the legend items so they can match our design spec.
           * Since we use custom HTML in the formatter, this is not captured on a persistant basis by Highcharts.
           */
          redraw() {
            var it, st, tt;
            if ("hasLoaded" in this && this.hasLoaded) {
              const V = (tt = (st = (it = this.userOptions) == null ? void 0 : it.plotOptions) == null ? void 0 : st.custom) == null ? void 0 : tt.host;
              if (V && V.staticLegend)
                return !1;
              const { allItems: _ } = this.legend;
              _.forEach((N) => {
                if (N instanceof Qt.Point && Wi(N) || N instanceof Qt.Series && Xi(N)) {
                  const {
                    a11yProxyElement: {
                      target: { visual: D }
                    }
                  } = N;
                  if (V == null || V.style.setProperty(
                    "--legend-max-width",
                    D.style.getPropertyValue("width")
                  ), D.dataset.beaconRedrawEvent !== "attached") {
                    const p = D.firstElementChild;
                    D.addEventListener(
                      "mouseover",
                      (y) => {
                        p == null || p.classList.add(
                          "beacon-legend-item--hover"
                        ), (!y.x || !y.y) && (p == null || p.classList.add(
                          "beacon-legend-item--focus"
                        ));
                      }
                    ), D.addEventListener("mouseout", () => {
                      _.forEach((y) => {
                        var m;
                        if (y instanceof Qt.Point && Wi(y) || y instanceof Qt.Series && Xi(y)) {
                          const {
                            a11yProxyElement: {
                              target: { visual: w }
                            }
                          } = y;
                          (m = w == null ? void 0 : w.firstElementChild) == null || m.classList.remove(
                            "beacon-legend-item--hover",
                            "beacon-legend-item--focus"
                          );
                        }
                      });
                    });
                  }
                  D.dataset.beaconRedrawEvent = "attached", Tt.setLegendWidthVariable(this);
                }
              });
            }
            this.reflow();
          }
        },
        // Highcharts default is 400
        // Previous version of Charts didn't take Legend height into account
        // We increase the default height to counteract a possible squished chart
        height: fs.HEIGHT,
        styledMode: !0,
        type: this.type
      },
      credits: {
        enabled: !1
      },
      legend: {
        accessibility: {
          keyboardNavigation: {
            enabled: !this.staticLegend
          }
        },
        align: "center",
        alignColumns: !1,
        enabled: !this.disableLegend,
        labelFormatter() {
          return Tt.legendItemHTML(
            this,
            I,
            i,
            $,
            nt,
            B
          );
        },
        itemDistance: parseFloat(fi) * 16,
        itemMarginBottom: parseFloat(fi) * 16,
        itemMarginTop: 0,
        layout: this.legendLayout.direction,
        navigation: {
          enabled: !1
        },
        symbolRadius: 0,
        symbolPadding: 0,
        symbolWidth: 0,
        useHTML: !0,
        verticalAlign: "bottom",
        width: "100%",
        events: {
          /**
           * @this Series
           *
           * We reverse click interaction on legend items. Instead of toggling off, we toggle isolation and "on" state.
           */
          itemClick: function(it) {
            var D, p, y;
            it.preventDefault();
            const { chart: st } = this, tt = (y = (p = (D = st == null ? void 0 : st.userOptions) == null ? void 0 : D.plotOptions) == null ? void 0 : p.custom) == null ? void 0 : y.host;
            if (tt && tt.staticLegend)
              return !1;
            const { series: V } = st, _ = V.filter((m) => m.visible).length === V.length, N = V.find(
              (m) => it.legendItem instanceof Qt.Series && m.name === it.legendItem.name
            );
            N && (V.length > 1 && _ ? V.forEach((m) => {
              it.legendItem instanceof Qt.Series && m.update(
                {
                  visible: m.name === it.legendItem.name
                },
                !1
              );
            }) : N.update(
              {
                visible: !N.visible
              },
              !1
            ), st.redraw(), st.reflow());
          }
        }
      },
      plotOptions: {
        custom: {
          host: this
        }
      },
      responsive: {
        rules: [
          {
            condition: {
              minWidth: parseInt(ks, 10)
            },
            chartOptions: {
              legend: {
                align: this.legendLayout.horizontal,
                // center, right
                verticalAlign: Tt.setLegendVerticalAlignment(
                  this.legendLayout
                ),
                width: Tt.setLegendWidth(this.legendLayout)
              }
            }
          }
        ]
      },
      series: this.seriesWithChartType,
      subtitle: {
        text: void 0
      },
      symbols: [...Object.values(qt)],
      title: {
        text: void 0
      },
      tooltip: {
        borderRadius: parseFloat(As) * 16,
        className: this.getTooltipClasses(),
        footerFormat: Tt.tooltipFooterHTML(
          Tt.tooltipFooterContentHTML(this.tooltipFooter)
        ),
        headerFormat: Tt.tooltipHeaderHTML(this.tooltipTitle),
        outside: !0,
        padding: Tt.tooltipPadding(this.tooltipVariant),
        pointFormatter() {
          return J(), Tt.tooltipPointHTML(
            this,
            this.series.name,
            this.y
          );
        },
        shadow: {
          color: Cs
        },
        shared: this.tooltipVariant === ne.MULTI_LINE,
        useHTML: !0
      }
    };
  }
  /**
   * Adds a beacon mode class to the Highcharts tooltip container.
   */
  addBeaconModeToTooltipContainer() {
    const I = this.closest('[class*="beacon-on"]');
    setTimeout(() => {
      const i = document.querySelector(
        ".highcharts-tooltip-container"
      );
      if (i && I) {
        const nt = Array.from(i.classList).find(
          ($) => $.startsWith("beacon-on")
        ), B = Array.from(
          I.classList
        ).find(($) => $.startsWith("beacon-on"));
        nt !== B && (nt && i.classList.remove(nt), B && i.classList.add(B));
      }
    }, 0);
  }
  /** Parses the legend layout from a string of options. */
  static createLegendLayout(I) {
    if (!I)
      return this.defaultLegendLayout;
    const i = Ia(I);
    if (!i)
      return this.defaultLegendLayout;
    const nt = i.find(
      (J) => Ya.includes(J)
    ) || this.defaultLegendLayout.vertical, B = i.find(
      (J) => _a.includes(J)
    ) || this.defaultLegendLayout.horizontal;
    let $ = i.find(
      (J) => $a.includes(J)
    ) || this.defaultLegendLayout.direction;
    return i.includes("row") ? $ = "horizontal" : i.includes("column") && ($ = "vertical"), {
      vertical: nt,
      horizontal: B,
      direction: $
    };
  }
  /**
   * Sets a CSS variable on the host that helps control the width of the legend items in a vertical state.
   *
   * Takes into account the active and max widths of the Legend, as well as what direction the Legend is in.
   */
  static setLegendWidthVariable(I, i = !1) {
    var N, D, p, y, m, w, a, u;
    const nt = (D = (N = I.legend) == null ? void 0 : N.options) == null ? void 0 : D.layout, B = (y = (p = I.legend) == null ? void 0 : p.options) == null ? void 0 : y.align, $ = Va(I.legend) ? I.legend.legendWidth : 0, J = qa(I.legend) ? (m = I.legend) == null ? void 0 : m.maxLegendWidth : 0, it = Math.min(J, $), st = (u = (a = (w = I.userOptions) == null ? void 0 : w.plotOptions) == null ? void 0 : a.custom) == null ? void 0 : u.host, tt = st == null ? void 0 : st.style.getPropertyValue("--legend-width");
    i && (st == null || st.style.removeProperty("--legend-width"));
    let V = "auto", _;
    nt === "vertical" && (_ = it, tt && (st == null || st.style.setProperty("--legend-width", _ + "px")), tt && B === "right" ? V = tt : V = _ ? _ + "px" : "auto"), st == null || st.style.setProperty("--legend-width", V);
  }
  /** HTML for the Legend label. */
  static legendItemHTML(I, i, nt, B, $, J) {
    var V, _;
    const { name: it, index: st } = I;
    let tt = "";
    if (B === te.GAUGE && !i) {
      const N = ((V = I == null ? void 0 : I.data[0]) == null ? void 0 : V.y) != null && I.yAxis.userOptions.min != null ? I.data[0].y - I.yAxis.userOptions.min : (_ = I == null ? void 0 : I.data[0]) == null ? void 0 : _.y, D = I.yAxis.userOptions.max != null && I.yAxis.userOptions.min != null ? I.yAxis.userOptions.max - I.yAxis.userOptions.min : I.yAxis.userOptions.max;
      tt = `<span class="beacon-legend-item__value">${Tt.percentageFormatter(nt, N, D, $, J)}</span>`;
    }
    return B === te.PIE && !i && (tt = `<span class="beacon-legend-item__value">${Tt.percentageFormatter(nt, I.y, I.total, $, J)}</span>`), `
      <div class="beacon-legend-item beacon-legend-item--${st}" style="inline-size: var(--legend-width); max-inline-size: var(--legend-max-width, none);">
        <div class="beacon-legend-item__label">
          ${ze(st, !1, B)}
          <span class="beacon-legend-item__label-text">${it}</span>${tt}
        </div>
      </div>
    `;
  }
  /** Forces Legend vertical alignment if necessary, but otherwise will return the requested value. */
  static setLegendVerticalAlignment({
    horizontal: I,
    vertical: i
  }) {
    return I === "center" ? "bottom" : i;
  }
  /** Set the width of the Legend which depends on both alignment and direction. */
  static setLegendWidth({
    horizontal: I,
    vertical: i,
    direction: nt
  }) {
    if (nt === "horizontal" && i !== "middle")
      return "100%";
    if (nt === "vertical")
      return I === "center" ? "100%" : "33%";
  }
  /** HTML classes for the tooltip's elements. */
  getTooltipClasses() {
    return `beacon-chart-tooltip ${this.tooltipVariant} ${this.colorOrder}`.trim();
  }
  /** Sets the padding on the Tooltip based on variant. */
  static tooltipPadding(I) {
    const i = parseFloat(Ss), nt = parseFloat(
      Ts
    );
    let B = i;
    return I !== ne.SINGLE_LINE && (B = i + nt), B * 16;
  }
  /**
   * HTML for the chart tooltip point.
   *
   * Can be used as a helper method for overrides to the point formatter.
   *
   * @example
   * ```ts
   * // Format the value before passing it to the tooltip.
   *
   * const options = {
   *   tooltip: {
   *    pointFormatter() {
   *      const { y } = this;
   *      const percentage = y / 100;
   *
   *      return BeaconChartBase.tooltipPointHTML(this, this.series.name, percentage);
   *    }
   *   }
   * }
   * ```
   */
  static tooltipPointHTML(I, i, nt, B) {
    let $;
    return nt && Number(nt) < 0 ? $ = "negative" : $ = "positive", `
      <div class="beacon-chart-tooltip__point highcharts-color-${I.colorIndex} ${$}">
        <div class="beacon-chart-tooltip-point__label">
          ${B ? "" : ze(I.colorIndex || 0)}
          <span class="beacon-chart-tooltip-point__label-text">${i}</span>
        </div>
        ${nt ? `<div class="beacon-chart-tooltip__point-value">${nt}</div>` : ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Title (Header). */
  static tooltipHeaderHTML(I) {
    return I ? `<div class="beacon-chart-tooltip__title">${I}</div>` : "";
  }
  /** HTML for the Tooltip's additional content slot (Footer). */
  static tooltipFooterContentHTML(I) {
    return I ? `<div class="beacon-chart-tooltip__additional-content">${I}</div>` : "";
  }
  /** HTML for the Tooltip footer that can include both multi-level content and the additional slot content. */
  static tooltipFooterHTML(I, i) {
    return !I && !i ? "" : `
      <div class="beacon-chart-tooltip__footer">
        ${i ? `<hr class="beacon-chart-tooltip__separator"/>${i}` : ""}
        ${I || ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Point belonging to multi-level tooltips. */
  static multiLevelTooltipPointHTML(I, i, nt) {
    return `
      <div class="beacon-chart-tooltip__point beacon-chart-tooltip__point--multi-level">
        <div class="beacon-chart-tooltip-point__label">
          ${nt ? "" : ze(0, !0)}
          <span class="beacon-chart-tooltip-point__label-text">${I}</span>
        </div>
        ${i ? `<div class="beacon-chart-tooltip__point-value">${i}</div>` : ""}
      </div>
    `;
  }
  /** Modify user-supplied options by filtering out keys not leveraged or not accessible by our component. */
  static filterChartOptions(I) {
    return Da(I, (i, nt) => !this.disallowedChartOptions.includes(nt));
  }
  /** Merge all possible chart options into a single object. */
  static createChartOptions(...I) {
    return Pa(
      {},
      ...I,
      function(i, nt) {
        if (Bt(i))
          return i.concat(nt);
      }
    );
  }
  /** Update Highcharts accessibility data when the caption changes. */
  handleCaptionSlotchange() {
    var I;
    (I = this.chart) == null || I.update({
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      }
    });
  }
  /**
   * Apply modifications and modules to the Highcharts package.
   *
   * @todo Exhaust any options for API-styling before DOM manipulation. Keep in mind the symbol is separate from the button of the text label.
   */
  initializeHighcharts(I) {
    I.AST.allowedAttributes.push("transform", "viewbox", "viewBox", "xmlns"), Fs(I), I.addEvent(I.Legend, "afterRender", function() {
      "hasLoaded" in this.chart && this.chart.hasLoaded && (this.chart.reflow(), Tt.setLegendWidthVariable(this.chart));
    }), I.addEvent(I.Chart, "load", this.onChartLoad), I.addEvent(I.Chart, "redraw", this.onChartRedraw);
  }
  /**
   * Callback when Highcharts initially loads the chart.
   * @abstract
   */
  onChartLoad(I) {
  }
  /**
   * Callback when Highcharts redraws an existing chart.
   * @abstract
   */
  onChartRedraw(I) {
  }
  /**
   * Calculates total series for use in chart modifications or restrictions.
   *
   * Calculation of the series length may vary by type of chart.
   */
  calculateSeriesLength(I) {
    var i;
    return (i = I.series) == null ? void 0 : i.length;
  }
  /** Determines the color order by length of series in the chart. */
  static calculateColorOrder(I) {
    return typeof I == "number" && I > 6 ? Wt.EXTENDED : Wt.STANDARD;
  }
  /** Sets the class related to the color order on the host component. */
  applyColorOrder(I) {
    var i;
    switch (I) {
      case Wt.EXTENDED:
        this.classList.toggle(Wt.EXTENDED, !0);
        break;
      case Wt.STANDARD:
      default:
        this.classList.toggle(Wt.STANDARD, !0);
        break;
    }
    (i = this.chart) == null || i.update({
      tooltip: {
        className: this.getTooltipClasses()
      }
    });
  }
  setChart() {
    try {
      return this.chart = this.createChart(), this.chart;
    } catch (I) {
      return console.error(I), this.chart;
    }
  }
  setFilteredOptions() {
    this.filteredOptions = Tt.filterChartOptions(this.options);
  }
  createChart() {
    const I = Tt.createChartOptions(
      this.chartOptions,
      this.localComponentOptions,
      this.filteredOptions
    );
    return bi.chart(this.chartContainer, I);
  }
  updateChart(I) {
    var i;
    (i = this.chart) == null || i.update(I, !0, !0), this.improveChartAccessibility();
  }
  static percentageFormatter(I, i, nt, B, $) {
    let J;
    return I && i != null && nt != null ? J = `${(100 * (i / (nt || 100))).toFixed(B ? $ : 0)}%` : i != null ? J = `${Math.round(i)}` : J = "N/A", J;
  }
  /* Since we are rendering highcharts tooltip outside of the shadow DOM, we need to append the lightDOM styles to body.
   */
  static appendLightDOMStyles() {
    var i;
    if (!document.getElementById("beacon-chart-light-DOM-styles")) {
      const nt = document.createElement("style");
      nt.id = "beacon-chart-light-DOM-styles", nt.textContent = be == null ? void 0 : be.toString(), (i = document == null ? void 0 : document.body) == null || i.append(nt);
    }
  }
  chartBaseInit() {
    this.initializeHighcharts(bi), Tt.appendLightDOMStyles();
  }
  chartLoaded() {
    var I;
    this.setChart(), (I = this.chart) == null || I.reflow();
  }
  /**
   * Removes tab sequential navigation for a button element rendered from HighChart Accessibility module when using the Export Data HighCharts module.
   * We have a github issue open with HighCharts (https://github.com/highcharts/highcharts/issues/22682).
   * TODO: Remove when HighCharts fixes issue
   */
  improveChartAccessibility() {
    var i;
    const I = (i = this.chartContainer) == null ? void 0 : i.querySelector(
      "[id^=hc-linkto-highcharts-data-table-]"
    );
    I == null || I.setAttribute("tabindex", "-1"), I == null || I.setAttribute("aria-expanded", "false");
  }
  willUpdate(I) {
    var it;
    (it = super.willUpdate) == null || it.call(this, I);
    const i = this.hideLegendMetric, nt = this.percentage, B = this.decimal, $ = this.decimalPlaces, J = this.type;
    if (this.chart) {
      if (I.has("chart")) {
        const { chartHeight: st, chartWidth: tt, plotHeight: V, plotWidth: _ } = this.chart;
        this.chartSize = {
          chartHeight: st,
          chartWidth: tt,
          plotHeight: V,
          plotWidth: _
        };
      }
      I.has("series") && this.updateChart({ series: this.seriesWithChartType }), this.seriesLength = this.calculateSeriesLength(this.chart), this.colorOrder = Tt.calculateColorOrder(this.seriesLength), this.applyColorOrder(this.colorOrder), this.chart.reflow();
    }
    I.has("options") && this.options && (this.setFilteredOptions(), this.updateChart(this.filteredOptions)), I.has("legendLayout") && this.legendLayout && this.updateChart({
      legend: {
        align: this.legendLayout.horizontal,
        layout: this.legendLayout.direction,
        labelFormatter() {
          return Tt.legendItemHTML(
            this,
            i,
            nt,
            J,
            B,
            $
          );
        },
        verticalAlign: Tt.setLegendVerticalAlignment(
          this.legendLayout
        ),
        width: Tt.setLegendWidth(this.legendLayout)
      }
    }), (I.has("hideLegendMetric") || I.has("percentage") || I.has("decimal") || I.has("decimalPlaces")) && this.updateChart({
      legend: {
        labelFormatter() {
          return Tt.legendItemHTML(
            this,
            i,
            nt,
            J,
            B,
            $
          );
        }
      }
    }), I.has("disableLegend") && this.updateChart({
      legend: { enabled: !this.disableLegend }
    }), I.has("tooltipTitle") && this.updateChart({
      tooltip: {
        headerFormat: Tt.tooltipHeaderHTML(this.tooltipTitle)
      }
    }), I.has("tooltipFooter") && this.updateChart({
      tooltip: {
        footerFormat: Tt.tooltipFooterHTML(this.tooltipFooter)
      }
    }), I.has("tooltipVariant") && this.tooltipVariant && this.updateChart({
      tooltip: {
        padding: Tt.tooltipPadding(this.tooltipVariant),
        shared: this.tooltipVariant === ne.MULTI_LINE
      }
    });
  }
  render() {
    const I = {
      chart: !0,
      "highcharts-light": !0,
      "static-legend": this.staticLegend
    };
    I["chart--" + this.type] = !0;
    const i = {
      caption: !0
    };
    return Yi`
      <figure class="base">
        <div class="header">
          <div class="header-text">
            <div class="title" id="title">
              <slot name="title" ${je({ container: ".header" })}></slot>
            </div>
            <div class="subtitle" id="subtitle">
              <slot
                name="subtitle"
                ${je({ container: ".header" })}></slot>
            </div>
          </div>
          <div class="menu"></div>
        </div>
        <!-- Force Highcharts light theme -->
        <div
          role="region"
          class=${mi(I)}
          legend-layout="${Object.values(this.legendLayout).join(" ")}"
          aria-labelledby="title"
          aria-describedby="subtitle"></div>
        <figcaption class=${mi(i)}>
          <slot
            name="caption"
            @slotchange=${this.handleCaptionSlotchange}
            ${je({ useParent: !0 })}></slot>
        </figcaption>
      </figure>
    `;
  }
}, Tt.nestedComponents = [Ns], Tt.disallowedChartOptions = [
  "colors",
  "title",
  "caption",
  "subtitle"
], Tt.defaultLegendLayout = {
  direction: "horizontal",
  horizontal: "center",
  vertical: "bottom"
}, Tt);
Lt([
  Dt({
    type: Array
  })
], Ot.prototype, "series", 2);
Lt([
  Dt({
    type: Object
  })
], Ot.prototype, "options", 2);
Lt([
  Dt({ attribute: "static-legend", type: Boolean, reflect: !0 })
], Ot.prototype, "staticLegend", 2);
Lt([
  Dt({ attribute: "disable-legend", type: Boolean })
], Ot.prototype, "disableLegend", 2);
Lt([
  Dt({ attribute: "hide-legend-metric", type: Boolean })
], Ot.prototype, "hideLegendMetric", 2);
Lt([
  Dt({
    attribute: "legend-layout",
    converter: (E) => Ot.createLegendLayout(E)
  })
], Ot.prototype, "legendLayout", 2);
Lt([
  Dt({ attribute: "tooltip-title" })
], Ot.prototype, "tooltipTitle", 2);
Lt([
  Dt({ attribute: "tooltip-footer" })
], Ot.prototype, "tooltipFooter", 2);
Lt([
  Dt({ attribute: "tooltip-variant" })
], Ot.prototype, "tooltipVariant", 2);
Lt([
  Dt({ attribute: "disable-markers", type: Boolean })
], Ot.prototype, "disableMarkers", 2);
Lt([
  Dt({ type: Boolean })
], Ot.prototype, "percentage", 2);
Lt([
  Dt({ type: Boolean })
], Ot.prototype, "decimal", 2);
Lt([
  Dt({ attribute: "decimal-places", type: Number })
], Ot.prototype, "decimalPlaces", 2);
Lt([
  Ms()
], Ot.prototype, "chart", 2);
Lt([
  Ds('[slot="caption"]')
], Ot.prototype, "linkedDescriptionNode", 2);
Lt([
  Es(".chart")
], Ot.prototype, "chartContainer", 2);
Lt([
  Ps
], Ot.prototype, "chartBaseInit", 1);
Lt([
  Os
], Ot.prototype, "chartLoaded", 1);
let Ka = Ot;
var ys = { exports: {} };
(function(E) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Data module
  *
  * (c) 2012-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(I) {
    E.exports ? (I.default = I, E.exports = I) : I(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(I) {
    var i = I ? I._modules : {};
    function nt(B, $, J, it) {
      B.hasOwnProperty($) || (B[$] = it.apply(null, J), typeof CustomEvent == "function" && I.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: $, module: B[$] } })));
    }
    nt(i, "Core/HttpUtilities.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let { win: J } = B, { discardElement: it, objectEach: st } = $, tt = { ajax: function(V) {
        let _ = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, N = new XMLHttpRequest();
        function D(p, y) {
          V.error && V.error(p, y);
        }
        if (!V.url) return !1;
        N.open((V.type || "get").toUpperCase(), V.url, !0), V.headers && V.headers["Content-Type"] || N.setRequestHeader("Content-Type", _[V.dataType || "json"] || _.text), st(V.headers, function(p, y) {
          N.setRequestHeader(y, p);
        }), V.responseType && (N.responseType = V.responseType), N.onreadystatechange = function() {
          let p;
          if (N.readyState === 4) {
            if (N.status === 200) {
              if (V.responseType !== "blob" && (p = N.responseText, V.dataType === "json")) try {
                p = JSON.parse(p);
              } catch (y) {
                if (y instanceof Error) return D(N, y);
              }
              return V.success && V.success(p, N);
            }
            D(N, N.responseText);
          }
        }, V.data && typeof V.data != "string" && (V.data = JSON.stringify(V.data)), N.send(V.data);
      }, getJSON: function(V, _) {
        tt.ajax({ url: V, success: _, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(V, _, N) {
        let D = new J.FormData();
        st(_, function(m, w) {
          D.append(w, m);
        }), D.append("b64", "true");
        let { filename: p, type: y } = _;
        return J.fetch(V, { method: "POST", body: D, ...N }).then((m) => {
          m.ok && m.text().then((w) => {
            let a = document.createElement("a");
            a.href = `data:${y};base64,${w}`, a.download = p, a.click(), it(a);
          });
        });
      } };
      return tt;
    }), nt(i, "Extensions/Data.js", [i["Core/Axis/Axis.js"], i["Core/Chart/Chart.js"], i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/HttpUtilities.js"], i["Core/Series/Point.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _) {
      let { getOptions: N } = J, { doc: D } = it, { ajax: p } = st, { seriesTypes: y } = V, { addEvent: m, defined: w, extend: a, fireEvent: u, isNumber: b, merge: l, objectEach: d, pick: C, splat: R } = _;
      function z(f) {
        return !!(f && (f.rowsURL || f.csvURL || f.columnsURL));
      }
      class O {
        static data(s, t = {}, e) {
          return new O(s, t, e);
        }
        static rowsToColumns(s) {
          let t, e, r, g, o;
          if (s) for (t = 0, o = [], e = s.length; t < e; t++) for (r = 0, g = s[t].length; r < g; r++) o[r] || (o[r] = []), o[r][t] = s[t][r];
          return o;
        }
        constructor(s, t = {}, e) {
          this.rowsToColumns = O.rowsToColumns, this.dateFormats = { "YYYY/mm/dd": { regex: /^(\d{4})[\-\/\.](\d{1,2})[\-\/\.](\d{1,2})$/, parser: function(r) {
            return r ? Date.UTC(+r[1], +r[2] - 1, +r[3]) : NaN;
          } }, "dd/mm/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(r) {
            return r ? Date.UTC(+r[3], +r[2] - 1, +r[1]) : NaN;
          }, alternative: "mm/dd/YYYY" }, "mm/dd/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(r) {
            return r ? Date.UTC(+r[3], +r[1] - 1, +r[2]) : NaN;
          } }, "dd/mm/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(r) {
            if (!r) return NaN;
            let g = /* @__PURE__ */ new Date(), o = +r[3];
            return o > g.getFullYear() - 2e3 ? o += 1900 : o += 2e3, Date.UTC(o, +r[2] - 1, +r[1]);
          }, alternative: "mm/dd/YY" }, "mm/dd/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(r) {
            return r ? Date.UTC(+r[3] + 2e3, +r[1] - 1, +r[2]) : NaN;
          } } }, this.chart = e, this.chartOptions = t, this.options = s, this.rawColumns = [], this.init(s, t, e);
        }
        init(s, t, e) {
          let r = s.decimalPoint, g;
          t && (this.chartOptions = t), e && (this.chart = e), r !== "." && r !== "," && (r = void 0), this.options = s, this.columns = s.columns || this.rowsToColumns(s.rows) || [], this.firstRowAsNames = C(s.firstRowAsNames, this.firstRowAsNames, !0), this.decimalRegex = r && RegExp("^(-?[0-9]+)" + r + "([0-9]+)$"), this.liveDataTimeout !== void 0 && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length && (this.dataFound(), g = !z(s)), g || (g = this.fetchLiveData()), g || (g = !!this.parseCSV().length), g || (g = !!this.parseTable().length), g || (g = this.parseGoogleSpreadsheet()), !g && s.afterComplete && s.afterComplete(this);
        }
        getColumnDistribution() {
          var P, G;
          let s = this.chartOptions, t = this.options, e = [], r = function(W = "line") {
            return (y[W].prototype.pointArrayMap || [0]).length;
          }, g = function(W = "line") {
            return y[W].prototype.pointArrayMap;
          }, o = (P = s == null ? void 0 : s.chart) == null ? void 0 : P.type, c = [], n = [], S = (t == null ? void 0 : t.seriesMapping) || ((G = s == null ? void 0 : s.series) == null ? void 0 : G.map(function() {
            return { x: 0 };
          })) || [], j = 0;
          ((s == null ? void 0 : s.series) || []).forEach((W) => {
            c.push(r(W.type || o));
          }), S.forEach((W) => {
            e.push(W.x || 0);
          }), e.length === 0 && e.push(0), S.forEach((W) => {
            var x, T;
            let Q = new h(), k = c[j] || r(o), A = (T = ((x = s == null ? void 0 : s.series) != null ? x : [])[j]) != null ? T : {}, L = g(A.type || o), Y = L != null ? L : ["y"];
            (w(W.x) || A.isCartesian || !L) && Q.addColumnReader(W.x, "x"), d(W, function(M, U) {
              U !== "x" && Q.addColumnReader(M, U);
            });
            for (let M = 0; M < k; M++) Q.hasReader(Y[M]) || Q.addColumnReader(void 0, Y[M]);
            n.push(Q), j++;
          });
          let v = g(o);
          v === void 0 && (v = ["y"]), this.valueCount = { global: r(o), xColumns: e, individual: c, seriesBuilders: n, globalPointArrayMap: v };
        }
        dataFound() {
          this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), this.parsed() !== !1 && this.complete();
        }
        parseCSV(s) {
          let t = this, e = this.columns = [], r = s || this.options, g = r.startColumn || 0, o = r.endColumn || Number.MAX_VALUE, c = [], n = { ",": 0, ";": 0, "	": 0 }, S = r.csv, j = r.startRow || 0, v = r.endRow || Number.MAX_VALUE, P, G, W = 0;
          if (S && r.beforeParse && (S = r.beforeParse.call(this, S)), S) {
            if (G = S.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(r.lineDelimiter || `
`), (!j || j < 0) && (j = 0), (!v || v >= G.length) && (v = G.length - 1), r.itemDelimiter) P = r.itemDelimiter;
            else {
              let k, A, L;
              k = 0, A = 0, L = !1, G.some(function(Y, x) {
                let T = !1, M, U, H, q = "";
                if (x > 13) return !0;
                for (let F = 0; F < Y.length; F++) {
                  if (M = Y[F], U = Y[F + 1], H = Y[F - 1], M === "#") return;
                  if (M === '"')
                    if (T) {
                      if (H !== '"' && U !== '"') {
                        for (; U === " " && F < Y.length; ) U = Y[++F];
                        n[U] !== void 0 && n[U]++, T = !1;
                      }
                    } else T = !0;
                  else n[M] !== void 0 ? (isNaN(Date.parse(q = q.trim())) ? (isNaN(q) || !isFinite(q)) && n[M]++ : n[M]++, q = "") : q += M;
                  M === "," && A++, M === "." && k++;
                }
              }), n[";"] > n[","] ? L = ";" : (n[","], n[";"], L = ","), r.decimalPoint || (k > A ? r.decimalPoint = "." : r.decimalPoint = ",", t.decimalRegex = RegExp("^(-?[0-9]+)" + r.decimalPoint + "([0-9]+)$")), P = L;
            }
            let Q = 0;
            for (W = j; W <= v; W++) G[W][0] === "#" ? Q++ : function(k, A, L, Y) {
              let x = 0, T = "", M = "", U = "", H = "", q = 0, F = 0;
              function et(ct) {
                T = k[ct], M = k[ct - 1], U = k[ct + 1];
              }
              function rt(ct) {
                c.length < F + 1 && c.push([ct]), c[F][c[F].length - 1] !== ct && c[F].push(ct);
              }
              function at() {
                if (g > q || q > o) {
                  ++q, H = "";
                  return;
                }
                r.columnTypes || (!isNaN(parseFloat(H)) && isFinite(H) ? (H = parseFloat(H), rt("number")) : isNaN(Date.parse(H)) ? rt("string") : (H = H.replace(/\//g, "-"), rt("date"))), e.length < F + 1 && e.push([]), e[F][A] = H, H = "", ++F, ++q;
              }
              if (k.trim().length && k.trim()[0] !== "#") {
                for (; x < k.length; x++) if (et(x), T === '"') for (et(++x); x < k.length && (T !== '"' || M === '"' || U === '"'); ) (T !== '"' || T === '"' && M !== '"') && (H += T), et(++x);
                else T === P ? at() : H += T;
                at();
              }
            }(G[W], W - j - Q);
            (!r.columnTypes || r.columnTypes.length === 0) && c.length && c[0].length && c[0][1] === "date" && !r.dateFormat && (r.dateFormat = function(k, A) {
              var et;
              let L = "YYYY/mm/dd", Y = [], x = [], T, M = [], U, H = 0, q = !1, F;
              for ((!A || A > k.length) && (A = k.length); H < A; H++) if (k[H] !== void 0 && ((et = k[H]) != null && et.length)) for (F = 0, T = k[H].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" "), M = ["", "", ""]; F < T.length; F++) F < M.length && (T[F] = parseInt(T[F], 10), T[F] && (x[F] = !x[F] || x[F] < T[F] ? T[F] : x[F], Y[F] !== void 0 ? Y[F] !== T[F] && (Y[F] = !1) : Y[F] = T[F], T[F] > 31 ? T[F] < 100 ? M[F] = "YY" : M[F] = "YYYY" : T[F] > 12 && T[F] <= 31 ? (M[F] = "dd", q = !0) : M[F].length || (M[F] = "mm")));
              if (q) {
                for (F = 0; F < Y.length; F++) Y[F] !== !1 ? x[F] > 12 && M[F] !== "YY" && M[F] !== "YYYY" && (M[F] = "YY") : x[F] > 12 && M[F] === "mm" && (M[F] = "dd");
                return M.length === 3 && M[1] === "dd" && M[2] === "dd" && (M[2] = "YY"), U = M.join("/"), (r.dateFormats || t.dateFormats)[U] ? U : (u(t, "deduceDateFailed"), L);
              }
              return L;
            }(e[0])), this.dataFound();
          }
          return e;
        }
        parseTable() {
          let s = this.options, t = this.columns || [], e = s.startRow || 0, r = s.endRow || Number.MAX_VALUE, g = s.startColumn || 0, o = s.endColumn || Number.MAX_VALUE;
          if (s.table) {
            let c = s.table;
            typeof c == "string" && (c = D.getElementById(c)), [].forEach.call(c.getElementsByTagName("tr"), (n, S) => {
              S >= e && S <= r && [].forEach.call(n.children, (j, v) => {
                let P = t[v - g], G = 1;
                if ((j.tagName === "TD" || j.tagName === "TH") && v >= g && v <= o) for (t[v - g] || (t[v - g] = []), t[v - g][S - e] = j.innerHTML; S - e >= G && P[S - e - G] === void 0; ) P[S - e - G] = null, G++;
              });
            }), this.dataFound();
          }
          return t;
        }
        fetchLiveData() {
          let s = this, t = this.chart, e = this.options, r = e.enablePolling, g = l(e), o = 0, c = 1e3 * (e.dataRefreshRate || 2);
          return !!z(e) && (c < 1e3 && (c = 1e3), delete e.csvURL, delete e.rowsURL, delete e.columnsURL, function n(S) {
            function j(v, P, G) {
              if (!v || !/^(http|\/|\.\/|\.\.\/)/.test(v)) return v && e.error && e.error("Invalid URL"), !1;
              function W() {
                r && t.liveDataURL === v && (s.liveDataTimeout = setTimeout(n, c));
              }
              return S && (clearTimeout(s.liveDataTimeout), t.liveDataURL = v), p({ url: v, dataType: G || "json", success: function(Q) {
                t != null && t.series && P(Q), W();
              }, error: function(Q, k) {
                var A;
                return ++o < 3 && W(), (A = e.error) == null ? void 0 : A.call(e, k, Q);
              } }), !0;
            }
            j(g.csvURL, function(v) {
              t.update({ data: { csv: v } });
            }, "text") || j(g.rowsURL, function(v) {
              t.update({ data: { rows: v } });
            }) || j(g.columnsURL, function(v) {
              t.update({ data: { columns: v } });
            });
          }(!0), z(e));
        }
        parseGoogleSpreadsheet() {
          let s = this, t = this.options, e = t.googleSpreadsheetKey, r = this.chart, g = Math.max(1e3 * (t.dataRefreshRate || 2), 4e3), o = () => {
            if (t.googleSpreadsheetRange) return t.googleSpreadsheetRange;
            let c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", n = (c.charAt(t.startColumn || 0) || "A") + ((t.startRow || 0) + 1), S = c.charAt(C(t.endColumn, -1)) || "ZZ";
            return w(t.endRow) && (S += t.endRow + 1), `${n}:${S}`;
          };
          return e && (delete t.googleSpreadsheetKey, function c(n) {
            p({ url: ["https://sheets.googleapis.com/v4/spreadsheets", e, "values", o(), "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + t.googleAPIKey].join("/"), dataType: "json", success: function(S) {
              n(S), t.enablePolling && (s.liveDataTimeout = setTimeout(function() {
                c(n);
              }, g));
            }, error: function(S, j) {
              var v;
              return (v = t.error) == null ? void 0 : v.call(t, j, S);
            } });
          }(function(c) {
            let n = c.values;
            if (!n || n.length === 0) return !1;
            let S = n.reduce((j, v) => Math.max(j, v.length), 0);
            n.forEach((j) => {
              for (let v = 0; v < S; v++) j[v] === void 0 && (j[v] = null);
            }), r != null && r.series ? r.update({ data: { columns: n } }) : (s.columns = n, s.dataFound());
          })), !1;
        }
        trim(s, t) {
          return typeof s == "string" && (s = s.replace(/^\s+|\s+$/g, ""), t && /[\d\s]+/.test(s) && (s = s.replace(/\s/g, "")), this.decimalRegex && (s = s.replace(this.decimalRegex, "$1.$2"))), s;
        }
        parseTypes() {
          let s = this.columns || [], t = s.length;
          for (; t--; ) this.parseColumn(s[t], t);
        }
        parseColumn(s, t) {
          var x;
          let e = this.rawColumns, r = this.columns = this.columns || [], g = this.firstRowAsNames, o = ((x = this.valueCount) == null ? void 0 : x.xColumns.indexOf(t)) !== -1, c = [], n = this.chartOptions, S = (this.options.columnTypes || [])[t], j = o && (n == null ? void 0 : n.xAxis) && R(n.xAxis)[0].type === "category" || S === "string", v = w(s.name), P = s.length, G, W, Q, k, A, L, Y;
          for (e[t] || (e[t] = []); P--; ) G = c[P] || s[P], Q = this.trim(G), W = parseFloat(k = this.trim(G, !0)), e[t][P] === void 0 && (e[t][P] = Q), j || P === 0 && g && !v ? s[P] = "" + Q : +k === W ? (s[P] = W, W > 31536e6 && S !== "float" ? s.isDatetime = !0 : s.isNumeric = !0, s[P + 1] !== void 0 && (Y = W > s[P + 1])) : (Q != null && Q.length && (A = this.parseDate(G)), o && b(A) && S !== "float" ? (c[P] = G, s[P] = A, s.isDatetime = !0, s[P + 1] !== void 0 && ((L = A > s[P + 1]) !== Y && Y !== void 0 && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, P = s.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : s.unsorted = !0), Y = L)) : (s[P] = Q === "" ? null : Q, P !== 0 && (s.isDatetime || s.isNumeric) && (s.mixed = !0)));
          if (o && s.mixed && (r[t] = e[t]), o && Y && this.options.sort) {
            for (t = 0; t < r.length; t++) if (r[t].reverse(), g) {
              let T = r[t].pop();
              T && r[t].unshift(T);
            }
          }
        }
        parseDate(s) {
          let t = this.options.parseDate, e, r, g, o = this.options.dateFormat || this.dateFormat, c;
          if (t) e = t(s);
          else if (typeof s == "string") {
            if (o) (g = this.dateFormats[o]) || (g = this.dateFormats["YYYY/mm/dd"]), (c = s.match(g.regex)) && (e = g.parser(c));
            else for (r in this.dateFormats) if (g = this.dateFormats[r], c = s.match(g.regex)) {
              this.dateFormat = o = r, this.alternativeFormat = g.alternative, e = g.parser(c);
              break;
            }
            !c && (s.match(/:.+(GMT|UTC|[Z+\-])/) && (s = s.replace(/\s*(?:GMT|UTC)?([+\-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+\-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), typeof (c = Date.parse(s)) == "object" && c !== null && c.getTime ? e = c.getTime() - 6e4 * c.getTimezoneOffset() : b(c) && (e = c - 6e4 * new Date(c).getTimezoneOffset()));
          }
          return e;
        }
        getData() {
          var s;
          if (this.columns) return (s = this.rowsToColumns(this.columns)) == null ? void 0 : s.slice(1);
        }
        parsed() {
          if (this.options.parsed) return this.options.parsed.call(this, this.columns);
        }
        complete() {
          var k, A, L, Y, x;
          let s = this.columns = this.columns || [], t = this.options, e = [], r = "linear", g, o, c, n, S, j, v, P, G, W, Q;
          if (s.length, t.complete || t.afterComplete) {
            if (this.firstRowAsNames) for (c = 0; c < s.length; c++) {
              let T = s[c];
              w(T.name) || (T.name = C(T.shift(), "").toString());
            }
            for (j = 0, g = [], G = function(T, M) {
              let U, H, q, F = [], et = [];
              for (H = 0; H < T; H += 1) F.push(!0);
              for (U = 0; U < M.length; U += 1) for (H = 0, q = M[U].getReferencedColumnIndexes(); H < q.length; H += 1) F[q[H]] = !1;
              for (H = 0; H < F.length; H += 1) F[H] && et.push(H);
              return et;
            }((s == null ? void 0 : s.length) || 0, this.valueCount.seriesBuilders); j < this.valueCount.seriesBuilders.length; j++) (P = this.valueCount.seriesBuilders[j]).populateColumns(G) && e.push(P);
            for (; G.length > 0; ) {
              for ((P = new h()).addColumnReader(0, "x"), (Q = G.indexOf(0)) !== -1 && G.splice(Q, 1), c = 0; c < this.valueCount.global; c++) P.addColumnReader(void 0, this.valueCount.globalPointArrayMap[c]);
              P.populateColumns(G) && e.push(P);
            }
            if (e.length > 0 && e[0].readers.length > 0 && (W = s == null ? void 0 : s[(k = e[0].readers[0].columnIndex) != null ? k : -1]) !== void 0 && (W.isDatetime ? r = "datetime" : W.isNumeric || (r = "category")), r === "category") for (j = 0; j < e.length; j++) for (S = 0, P = e[j]; S < P.readers.length; S++) P.readers[S].configName === "x" && (P.readers[S].configName = "name");
            for (j = 0; j < e.length; j++) {
              for (n = 0, P = e[j], o = []; n < s[0].length; n++) o[n] = P.read(s, n);
              g[j] = { data: o, pointStart: o[0] && (P.pointIsArray ? (A = o[0]) == null ? void 0 : A[0] : (L = o[0]) == null ? void 0 : L.x) || void 0 }, P.name && (g[j].name = P.name), r === "category" && (g[j].turboThreshold = 0, g[j].pointStart = 0);
            }
            v = { series: g }, r !== "linear" || this.xAxisOptions && this.xAxisOptions.type !== r ? (this.xAxisOptions = { type: r }, r === "category" && (this.xAxisOptions.uniqueNames = !1)) : r = this.xAxisOptions = void 0, this.chart || l(!0, v, { xAxis: this.xAxisOptions || {} }), (Y = t.complete) == null || Y.call(t, v), (x = t.afterComplete) == null || x.call(t, this, v);
          }
        }
        xAxisUpdateHandler(s) {
          let t = this.xAxisOptions;
          t && (!s.options.type && t.type && (s.type = t.type), s.options.uniqueNames || t.uniqueNames !== !1 || (s.uniqueNames = t.uniqueNames));
        }
        update(s, t) {
          var g;
          let e = this.chart, r = e.options;
          s && (s.afterComplete = function(o, c) {
            if (!c) return;
            let n = e.xAxis[0], S = o.xAxisOptions;
            S && n && (n.type !== S.type && !n.options.type || n.uniqueNames && S.uniqueNames === !1 && n.options.uniqueNames === void 0) ? n.update({}, !1) : ((c == null ? void 0 : c.series) || []).forEach(function(j) {
              delete j.pointStart;
            }), e.update(c, t, !0);
          }, l(!0, r.data, s), (g = r.data) != null && g.googleSpreadsheetKey && !s.columns && delete r.data.columns, this.init(r.data || {}, r));
        }
      }
      m(B, "afterSetOptions", function() {
        var f;
        this.isXAxis && (!this.chart.xAxis.length || this.chart.xAxis[0] === this) && ((f = this.chart.data) == null || f.xAxisUpdateHandler(this));
      }), m($, "init", function(f) {
        let s = this, t = f.args[1], e = N().data, r = f.args[0] || {};
        if ((e || r && r.data) && !s.hasDataDef) {
          s.hasDataDef = !0;
          let g = l(e, r.data);
          s.data = new O(a(g, { afterComplete: function(o, c) {
            var j, v, P, G;
            let n, S;
            if (Object.hasOwnProperty.call(r, "series"))
              if (typeof r.series == "object") for (n = Math.max(r.series.length, (v = (j = c == null ? void 0 : c.series) == null ? void 0 : j.length) != null ? v : 0); n--; ) S = r.series[n] || {}, r.series[n] = l(S, (G = (P = c == null ? void 0 : c.series) == null ? void 0 : P[n]) != null ? G : {});
              else delete r.series;
            r = l(c, r), s.data = o, s.init(r, t);
          } }), r, s), f.preventDefault();
        }
      });
      class h {
        constructor() {
          this.readers = [], this.pointIsArray = !0;
        }
        populateColumns(s) {
          let t = !0;
          return this.readers.forEach((e) => {
            e.columnIndex === void 0 && (e.columnIndex = s.shift());
          }), this.readers.forEach((e) => {
            e.columnIndex === void 0 && (t = !1);
          }), t;
        }
        read(s, t) {
          let e = this.pointIsArray, r = e ? [] : {};
          if (this.readers.forEach((g) => {
            let o = s[g.columnIndex][t];
            e ? r.push(o) : g.configName.indexOf(".") > 0 ? tt.prototype.setNestedProperty(r, o, g.configName) : r[g.configName] = o;
          }), this.name === void 0 && this.readers.length >= 2) {
            let g = [];
            this.readers.forEach(function(o) {
              (o.configName === "x" || o.configName === "name" || o.configName === "y") && o.columnIndex !== void 0 && g.push(o.columnIndex);
            }), g.length >= 2 && (g.shift(), g.sort(function(o, c) {
              return o - c;
            })), this.name = s[C(g.shift(), 0)].name;
          }
          return r;
        }
        addColumnReader(s, t) {
          this.readers.push({ columnIndex: s, configName: t }), t === "x" || t === "y" || t === void 0 || (this.pointIsArray = !1);
        }
        getReferencedColumnIndexes() {
          let s, t, e = [];
          for (s = 0; s < this.readers.length; s += 1) (t = this.readers[s]).columnIndex !== void 0 && e.push(t.columnIndex);
          return e;
        }
        hasReader(s) {
          let t;
          for (t = 0; t < this.readers.length; t += 1) if (this.readers[t].configName === s) return !0;
        }
      }
      return O;
    }), nt(i, "masters/modules/data.src.js", [i["Core/Globals.js"], i["Core/HttpUtilities.js"], i["Extensions/Data.js"]], function(B, $, J) {
      return B.Data = B.Data || J, B.HttpUtilities = B.HttpUtilities || $, B.ajax = B.HttpUtilities.ajax, B.data = B.Data.data, B.getJSON = B.HttpUtilities.getJSON, B.post = B.HttpUtilities.post, B;
    });
  });
})(ys);
var Za = ys.exports;
const Ja = /* @__PURE__ */ ce(Za);
var vs = { exports: {} };
(function(E) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(I) {
    E.exports ? (I.default = I, E.exports = I) : I(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(I) {
    var i = I ? I._modules : {};
    function nt(B, $, J, it) {
      B.hasOwnProperty($) || (B[$] = it.apply(null, J), typeof CustomEvent == "function" && I.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: $, module: B[$] } })));
    }
    nt(i, "Extensions/DownloadURL.js", [i["Core/Globals.js"]], function(B) {
      let { isSafari: $, win: J, win: { document: it } } = B, st = J.URL || J.webkitURL || J;
      function tt(V) {
        let _ = V.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
        if (_ && _.length > 3 && J.atob && J.ArrayBuffer && J.Uint8Array && J.Blob && st.createObjectURL) {
          let N = J.atob(_[3]), D = new J.ArrayBuffer(N.length), p = new J.Uint8Array(D);
          for (let y = 0; y < p.length; ++y) p[y] = N.charCodeAt(y);
          return st.createObjectURL(new J.Blob([p], { type: _[1] }));
        }
      }
      return { dataURLtoBlob: tt, downloadURL: function(V, _) {
        let N = J.navigator, D = it.createElement("a");
        if (typeof V != "string" && !(V instanceof String) && N.msSaveOrOpenBlob) {
          N.msSaveOrOpenBlob(V, _);
          return;
        }
        if (V = "" + V, N.userAgent.length > 1e3) throw Error("Input too long");
        let p = /Edge\/\d+/.test(N.userAgent);
        if (($ && typeof V == "string" && V.indexOf("data:application/pdf") === 0 || p || V.length > 2e6) && !(V = tt(V) || "")) throw Error("Failed to convert to blob");
        if (D.download !== void 0) D.href = V, D.download = _, it.body.appendChild(D), D.click(), it.body.removeChild(D);
        else try {
          if (!J.open(V, "chart")) throw Error("Failed to open window");
        } catch {
          J.location.href = V;
        }
      } };
    }), nt(i, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
      return { exporting: { csv: { annotations: { itemDelimiter: "; ", join: !1 }, columnHeaderFormatter: null, dateFormat: "%Y-%m-%d %H:%M:%S", decimalPoint: null, itemDelimiter: null, lineDelimiter: `
` }, showTable: !1, useMultiLevelHeaders: !0, useRowspanHeaders: !0, showExportInProgress: !0 }, lang: { downloadCSV: "Download CSV", downloadXLS: "Download XLS", exportData: { annotationHeader: "Annotations", categoryHeader: "Category", categoryDatetimeHeader: "DateTime" }, viewData: "View data table", hideData: "Hide data table", exportInProgress: "Exporting..." } };
    }), nt(i, "Extensions/ExportData/ExportData.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Defaults.js"], i["Extensions/DownloadURL.js"], i["Extensions/ExportData/ExportDataDefaults.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt) {
      let { getOptions: V, setOptions: _ } = $, { downloadURL: N } = J, { doc: D, win: p } = st, { addEvent: y, defined: m, extend: w, find: a, fireEvent: u, isNumber: b, pick: l } = tt;
      function d(n) {
        var v;
        let S = !!((v = this.options.exporting) != null && v.showExportInProgress), j = p.requestAnimationFrame || setTimeout;
        j(() => {
          S && this.showLoading(this.options.lang.exportInProgress), j(() => {
            try {
              n.call(this);
            } finally {
              S && this.hideLoading();
            }
          });
        });
      }
      function C() {
        d.call(this, () => {
          let n = this.getCSV(!0);
          N(r(n, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(n), this.getFilename() + ".csv");
        });
      }
      function R() {
        d.call(this, () => {
          let n = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
          N(r(n, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + p.btoa(unescape(encodeURIComponent(n))), this.getFilename() + ".xls");
        });
      }
      function z(n) {
        let S = "", j = this.getDataRows(), v = this.options.exporting.csv, P = l(v.decimalPoint, v.itemDelimiter !== "," && n ? 1.1.toLocaleString()[1] : "."), G = l(v.itemDelimiter, P === "," ? ";" : ","), W = v.lineDelimiter;
        return j.forEach((Q, k) => {
          let A = "", L = Q.length;
          for (; L--; ) typeof (A = Q[L]) == "string" && (A = `"${A}"`), typeof A == "number" && P !== "." && (A = A.toString().replace(".", P)), Q[L] = A;
          Q.length = j.length ? j[0].length : 0, S += Q.join(G), k < j.length - 1 && (S += W);
        }), S;
      }
      function O(n) {
        let S, j, v = this.hasParallelCoordinates, P = this.time, G = this.options.exporting && this.options.exporting.csv || {}, W = this.xAxis, Q = {}, k = [], A = [], L = [], Y = this.options.lang.exportData, x = Y.categoryHeader, T = Y.categoryDatetimeHeader, M = function(X, K, ot) {
          if (G.columnHeaderFormatter) {
            let ht = G.columnHeaderFormatter(X, K, ot);
            if (ht !== !1) return ht;
          }
          return X ? X.bindAxes ? n ? { columnTitle: ot > 1 ? K : X.name, topLevelColumnTitle: X.name } : X.name + (ot > 1 ? " (" + K + ")" : "") : X.options.title && X.options.title.text || (X.dateTime ? T : x) : x;
        }, U = function(X, K, ot) {
          let ht = {}, dt = {};
          return K.forEach(function(lt) {
            let ut = (X.keyToAxis && X.keyToAxis[lt] || lt) + "Axis", ft = b(ot) ? X.chart[ut][ot] : X[ut];
            ht[lt] = ft && ft.categories || [], dt[lt] = ft && ft.dateTime;
          }), { categoryMap: ht, dateTimeValueAxisMap: dt };
        }, H = function(X, K) {
          let ot = X.pointArrayMap || ["y"];
          return X.data.some((ht) => ht.y !== void 0 && ht.name) && K && !K.categories && X.exportKey !== "name" ? ["x", ...ot] : ot;
        }, q = [], F, et, rt, at = 0, ct, Z;
        for (ct in this.series.forEach(function(X) {
          let K = X.options.keys, ot = X.xAxis, ht = K || H(X, ot), dt = ht.length, lt = !X.requireSorting && {}, ut = W.indexOf(ot), ft = U(X, ht), gt, pt;
          if (X.options.includeInDataExport !== !1 && !X.options.isInternal && X.visible !== !1) {
            for (a(q, function(mt) {
              return mt[0] === ut;
            }) || q.push([ut, at]), pt = 0; pt < dt; ) rt = M(X, ht[pt], ht.length), L.push(rt.columnTitle || rt), n && A.push(rt.topLevelColumnTitle || rt), pt++;
            gt = { chart: X.chart, autoIncrement: X.autoIncrement, options: X.options, pointArrayMap: X.pointArrayMap, index: X.index }, X.options.data.forEach(function(mt, yt) {
              var At;
              let vt, xt, bt, Ct = { series: gt };
              v && (ft = U(X, ht, yt)), X.pointClass.prototype.applyOptions.apply(Ct, [mt]);
              let wt = X.data[yt] && X.data[yt].name;
              if (vt = ((At = Ct.x) != null ? At : "") + "," + wt, pt = 0, (!ot || X.exportKey === "name" || !v && ot && ot.hasNames && wt) && (vt = wt), lt && (lt[vt] && (vt += "|" + yt), lt[vt] = !0), Q[vt]) {
                let St = `${vt},${Q[vt].pointers[X.index]}`, kt = vt;
                Q[vt].pointers[X.index] && (Q[St] || (Q[St] = [], Q[St].xValues = [], Q[St].pointers = []), vt = St), Q[kt].pointers[X.index] += 1;
              } else {
                Q[vt] = [], Q[vt].xValues = [];
                let St = [];
                for (let kt = 0; kt < X.chart.series.length; kt++) St[kt] = 0;
                Q[vt].pointers = St, Q[vt].pointers[X.index] = 1;
              }
              for (Q[vt].x = Ct.x, Q[vt].name = wt, Q[vt].xValues[ut] = Ct.x; pt < dt; ) bt = Ct[xt = ht[pt]], Q[vt][at + pt] = l(ft.categoryMap[xt][bt], ft.dateTimeValueAxisMap[xt] ? P.dateFormat(G.dateFormat, bt) : null, bt), pt++;
            }), at += pt;
          }
        }), Q) Object.hasOwnProperty.call(Q, ct) && k.push(Q[ct]);
        for (et = n ? [A, L] : [L], at = q.length; at--; ) S = q[at][0], j = q[at][1], F = W[S], k.sort(function(X, K) {
          return X.xValues[S] - K.xValues[S];
        }), Z = M(F), et[0].splice(j, 0, Z), n && et[1] && et[1].splice(j, 0, Z), k.forEach(function(X) {
          let K = X.name;
          F && !m(K) && (F.dateTime ? (X.x instanceof Date && (X.x = X.x.getTime()), K = P.dateFormat(G.dateFormat, X.x)) : K = F.categories ? l(F.names[X.x], F.categories[X.x], X.x) : X.x), X.splice(j, 0, K);
        });
        return u(this, "exportData", { dataRows: et = et.concat(k) }), et;
      }
      function h(n) {
        let S = (j) => {
          if (!j.tagName || j.tagName === "#text") return j.textContent || "";
          let v = j.attributes, P = `<${j.tagName}`;
          return v && Object.keys(v).forEach((G) => {
            let W = v[G];
            P += ` ${G}="${W}"`;
          }), P += ">" + (j.textContent || ""), (j.children || []).forEach((G) => {
            P += S(G);
          }), P += `</${j.tagName}>`;
        };
        return S(this.getTableAST(n));
      }
      function f(n) {
        let S = 0, j = [], v = this.options, P = n ? 1.1.toLocaleString()[1] : ".", G = l(v.exporting.useMultiLevelHeaders, !0), W = this.getDataRows(G), Q = G ? W.shift() : null, k = W.shift(), A = function(T, M) {
          let U = T.length;
          if (M.length !== U) return !1;
          for (; U--; ) if (T[U] !== M[U]) return !1;
          return !0;
        }, L = function(T, M, U, H) {
          let q = l(H, ""), F = "highcharts-text" + (M ? " " + M : "");
          return typeof q == "number" ? (q = q.toString(), P === "," && (q = q.replace(".", P)), F = "highcharts-number") : H || (F = "highcharts-empty"), { tagName: T, attributes: U = w({ class: F }, U), textContent: q };
        };
        v.exporting.tableCaption !== !1 && j.push({ tagName: "caption", attributes: { class: "highcharts-table-caption" }, textContent: l(v.exporting.tableCaption, v.title.text ? v.title.text : "Chart") });
        for (let T = 0, M = W.length; T < M; ++T) W[T].length > S && (S = W[T].length);
        j.push(function(T, M, U) {
          let H = [], q = 0, F = U || M && M.length, et, rt = 0, at;
          if (G && T && M && !A(T, M)) {
            let ct = [];
            for (; q < F; ++q) if ((et = T[q]) === T[q + 1]) ++rt;
            else if (rt) ct.push(L("th", "highcharts-table-topheading", { scope: "col", colspan: rt + 1 }, et)), rt = 0;
            else {
              et === M[q] ? v.exporting.useRowspanHeaders ? (at = 2, delete M[q]) : (at = 1, M[q] = "") : at = 1;
              let Z = L("th", "highcharts-table-topheading", { scope: "col" }, et);
              at > 1 && Z.attributes && (Z.attributes.valign = "top", Z.attributes.rowspan = at), ct.push(Z);
            }
            H.push({ tagName: "tr", children: ct });
          }
          if (M) {
            let ct = [];
            for (q = 0, F = M.length; q < F; ++q) M[q] !== void 0 && ct.push(L("th", null, { scope: "col" }, M[q]));
            H.push({ tagName: "tr", children: ct });
          }
          return { tagName: "thead", children: H };
        }(Q, k, Math.max(S, k.length)));
        let Y = [];
        W.forEach(function(T) {
          let M = [];
          for (let U = 0; U < S; U++) M.push(L(U ? "td" : "th", null, U ? {} : { scope: "row" }, T[U]));
          Y.push({ tagName: "tr", children: M });
        }), j.push({ tagName: "tbody", children: Y });
        let x = { tree: { tagName: "table", id: `highcharts-data-table-${this.index}`, children: j } };
        return u(this, "aftergetTableAST", x), x.tree;
      }
      function s() {
        this.toggleDataTable(!1);
      }
      function t(n) {
        let S = (n = l(n, !this.isDataTableVisible)) && !this.dataTableDiv;
        if (S && (this.dataTableDiv = D.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
          let W = this.dataTableDiv.style, Q = W.display;
          W.display = n ? "block" : "none", n ? (this.dataTableDiv.innerHTML = B.emptyHTML, new B([this.getTableAST()]).addToDOM(this.dataTableDiv), u(this, "afterViewData", { element: this.dataTableDiv, wasHidden: S || Q !== W.display })) : u(this, "afterHideData");
        }
        this.isDataTableVisible = n;
        let j = this.exportDivElements, v = this.options.exporting, P = v && v.buttons && v.buttons.contextButton.menuItems, G = this.options.lang;
        if (v && v.menuItemDefinitions && G && G.viewData && G.hideData && P && j) {
          let W = j[P.indexOf("viewData")];
          W && B.setElementHTML(W, this.isDataTableVisible ? G.hideData : G.viewData);
        }
      }
      function e() {
        this.toggleDataTable(!0);
      }
      function r(n, S) {
        let j = p.navigator, v = p.URL || p.webkitURL || p;
        try {
          if (j.msSaveOrOpenBlob && p.MSBlobBuilder) {
            let P = new p.MSBlobBuilder();
            return P.append(n), P.getBlob("image/svg+xml");
          }
          return v.createObjectURL(new p.Blob(["\uFEFF" + n], { type: S }));
        } catch {
        }
      }
      function g() {
        let n = this, S = n.dataTableDiv, j = (P, G) => P.children[G].textContent, v = (P, G) => (W, Q) => {
          let k, A;
          return k = j(G ? W : Q, P), A = j(G ? Q : W, P), k === "" || A === "" || isNaN(k) || isNaN(A) ? k.toString().localeCompare(A) : k - A;
        };
        if (S && n.options.exporting && n.options.exporting.allowTableSorting) {
          let P = S.querySelector("thead tr");
          P && P.childNodes.forEach((G) => {
            let W = G.closest("table");
            G.addEventListener("click", function() {
              let Q = [...S.querySelectorAll("tr:not(thead tr)")], k = [...G.parentNode.children];
              Q.sort(v(k.indexOf(G), n.ascendingOrderInTable = !n.ascendingOrderInTable)).forEach((A) => {
                W.appendChild(A);
              }), k.forEach((A) => {
                ["highcharts-sort-ascending", "highcharts-sort-descending"].forEach((L) => {
                  A.classList.contains(L) && A.classList.remove(L);
                });
              }), G.classList.add(n.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
            });
          });
        }
      }
      function o() {
        this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
      }
      function c() {
        var n;
        (n = this.dataTableDiv) == null || n.remove();
      }
      return { compose: function(n, S) {
        let j = n.prototype;
        if (!j.getCSV) {
          let v = V().exporting;
          y(n, "afterViewData", g), y(n, "render", o), y(n, "destroy", c), j.downloadCSV = C, j.downloadXLS = R, j.getCSV = z, j.getDataRows = O, j.getTable = h, j.getTableAST = f, j.hideData = s, j.toggleDataTable = t, j.viewData = e, v && (w(v.menuItemDefinitions, { downloadCSV: { textKey: "downloadCSV", onclick: function() {
            this.downloadCSV();
          } }, downloadXLS: { textKey: "downloadXLS", onclick: function() {
            this.downloadXLS();
          } }, viewData: { textKey: "viewData", onclick: function() {
            d.call(this, this.toggleDataTable);
          } } }), v.buttons && v.buttons.contextButton.menuItems && v.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), _(it);
          let { arearange: P, gantt: G, map: W, mapbubble: Q, treemap: k, xrange: A } = S.types;
          P && (P.prototype.keyToAxis = { low: "y", high: "y" }), G && (G.prototype.exportKey = "name", G.prototype.keyToAxis = { start: "x", end: "x" }), W && (W.prototype.exportKey = "name"), Q && (Q.prototype.exportKey = "name"), k && (k.prototype.exportKey = "name"), A && (A.prototype.keyToAxis = { x2: "x" });
        }
      } };
    }), nt(i, "masters/modules/export-data.src.js", [i["Core/Globals.js"], i["Extensions/DownloadURL.js"], i["Extensions/ExportData/ExportData.js"]], function(B, $, J) {
      return B.dataURLtoBlob = B.dataURLtoBlob || $.dataURLtoBlob, B.downloadURL = B.downloadURL || $.downloadURL, J.compose(B.Chart, B.Series), B;
    });
  });
})(vs);
var Qa = vs.exports;
const tl = /* @__PURE__ */ ce(Qa);
var ws = { exports: {} };
(function(E) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(I) {
    E.exports ? (I.default = I, E.exports = I) : I(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(I) {
    var i = I ? I._modules : {};
    function nt(B, $, J, it) {
      B.hasOwnProperty($) || (B[$] = it.apply(null, J), typeof CustomEvent == "function" && I.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: $, module: B[$] } })));
    }
    nt(i, "Core/Chart/ChartNavigationComposition.js", [], function() {
      var B;
      return function($) {
        $.compose = function(it) {
          return it.navigation || (it.navigation = new J(it)), it;
        };
        class J {
          constructor(st) {
            this.updates = [], this.chart = st;
          }
          addUpdate(st) {
            this.chart.navigation.updates.push(st);
          }
          update(st, tt) {
            this.updates.forEach((V) => {
              V.call(this.chart, st, tt);
            });
          }
        }
        $.Additions = J;
      }(B || (B = {})), B;
    }), nt(i, "Extensions/Exporting/ExportingDefaults.js", [i["Core/Globals.js"]], function(B) {
      let { isTouchDevice: $ } = B;
      return { exporting: { allowTableSorting: !0, type: "image/png", url: "https://export.highcharts.com/", pdfFont: { normal: void 0, bold: void 0, bolditalic: void 0, italic: void 0 }, printMaxWidth: 780, scale: 2, buttons: { contextButton: { className: "highcharts-contextbutton", menuClassName: "highcharts-contextmenu", symbol: "menu", titleKey: "contextButtonTitle", menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"] } }, menuItemDefinitions: { viewFullscreen: { textKey: "viewFullscreen", onclick: function() {
        this.fullscreen && this.fullscreen.toggle();
      } }, printChart: { textKey: "printChart", onclick: function() {
        this.print();
      } }, separator: { separator: !0 }, downloadPNG: { textKey: "downloadPNG", onclick: function() {
        this.exportChart();
      } }, downloadJPEG: { textKey: "downloadJPEG", onclick: function() {
        this.exportChart({ type: "image/jpeg" });
      } }, downloadPDF: { textKey: "downloadPDF", onclick: function() {
        this.exportChart({ type: "application/pdf" });
      } }, downloadSVG: { textKey: "downloadSVG", onclick: function() {
        this.exportChart({ type: "image/svg+xml" });
      } } } }, lang: { viewFullscreen: "View in full screen", exitFullscreen: "Exit from full screen", printChart: "Print chart", downloadPNG: "Download PNG image", downloadJPEG: "Download JPEG image", downloadPDF: "Download PDF document", downloadSVG: "Download SVG vector image", contextButtonTitle: "Chart context menu" }, navigation: { buttonOptions: { symbolSize: 14, symbolX: 14.5, symbolY: 13.5, align: "right", buttonSpacing: 3, height: 28, verticalAlign: "top", width: 28, symbolFill: "#666666", symbolStroke: "#666666", symbolStrokeWidth: 3, theme: { fill: "#ffffff", padding: 5, stroke: "none", "stroke-linecap": "round" } }, menuStyle: { border: "none", borderRadius: "3px", background: "#ffffff", padding: "0.5em" }, menuItemStyle: { background: "none", borderRadius: "3px", color: "#333333", padding: "0.5em", fontSize: $ ? "0.9em" : "0.8em", transition: "background 250ms, color 250ms" }, menuItemHoverStyle: { background: "#f2f2f2" } } };
    }), nt(i, "Extensions/Exporting/ExportingSymbols.js", [], function() {
      var B;
      return function($) {
        let J = [];
        function it(tt, V, _, N) {
          return [["M", tt, V + 2.5], ["L", tt + _, V + 2.5], ["M", tt, V + N / 2 + 0.5], ["L", tt + _, V + N / 2 + 0.5], ["M", tt, V + N - 1.5], ["L", tt + _, V + N - 1.5]];
        }
        function st(tt, V, _, N) {
          let D = N / 3 - 2;
          return [].concat(this.circle(_ - D, V, D, D), this.circle(_ - D, V + D + 4, D, D), this.circle(_ - D, V + 2 * (D + 4), D, D));
        }
        $.compose = function(tt) {
          if (J.indexOf(tt) === -1) {
            J.push(tt);
            let V = tt.prototype.symbols;
            V.menu = it, V.menuball = st.bind(V);
          }
        };
      }(B || (B = {})), B;
    }), nt(i, "Extensions/Exporting/Fullscreen.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $, J) {
      let { composed: it } = $, { addEvent: st, fireEvent: tt, pushUnique: V } = J;
      function _() {
        this.fullscreen = new N(this);
      }
      class N {
        static compose(p) {
          V(it, "Fullscreen") && st(p, "beforeRender", _);
        }
        constructor(p) {
          this.chart = p, this.isOpen = !1;
          let y = p.renderTo;
          !this.browserProps && (typeof y.requestFullscreen == "function" ? this.browserProps = { fullscreenChange: "fullscreenchange", requestFullscreen: "requestFullscreen", exitFullscreen: "exitFullscreen" } : y.mozRequestFullScreen ? this.browserProps = { fullscreenChange: "mozfullscreenchange", requestFullscreen: "mozRequestFullScreen", exitFullscreen: "mozCancelFullScreen" } : y.webkitRequestFullScreen ? this.browserProps = { fullscreenChange: "webkitfullscreenchange", requestFullscreen: "webkitRequestFullScreen", exitFullscreen: "webkitExitFullscreen" } : y.msRequestFullscreen && (this.browserProps = { fullscreenChange: "MSFullscreenChange", requestFullscreen: "msRequestFullscreen", exitFullscreen: "msExitFullscreen" }));
        }
        close() {
          let p = this, y = p.chart, m = y.options.chart;
          tt(y, "fullscreenClose", null, function() {
            p.isOpen && p.browserProps && y.container.ownerDocument instanceof Document && y.container.ownerDocument[p.browserProps.exitFullscreen](), p.unbindFullscreenEvent && (p.unbindFullscreenEvent = p.unbindFullscreenEvent()), y.setSize(p.origWidth, p.origHeight, !1), p.origWidth = void 0, p.origHeight = void 0, m.width = p.origWidthOption, m.height = p.origHeightOption, p.origWidthOption = void 0, p.origHeightOption = void 0, p.isOpen = !1, p.setButtonText();
          });
        }
        open() {
          let p = this, y = p.chart, m = y.options.chart;
          tt(y, "fullscreenOpen", null, function() {
            if (m && (p.origWidthOption = m.width, p.origHeightOption = m.height), p.origWidth = y.chartWidth, p.origHeight = y.chartHeight, p.browserProps) {
              let w = st(y.container.ownerDocument, p.browserProps.fullscreenChange, function() {
                p.isOpen ? (p.isOpen = !1, p.close()) : (y.setSize(null, null, !1), p.isOpen = !0, p.setButtonText());
              }), a = st(y, "destroy", w);
              p.unbindFullscreenEvent = () => {
                w(), a();
              };
              let u = y.renderTo[p.browserProps.requestFullscreen]();
              u && u.catch(function() {
                alert("Full screen is not supported inside a frame.");
              });
            }
          });
        }
        setButtonText() {
          let p = this.chart, y = p.exportDivElements, m = p.options.exporting, w = m && m.buttons && m.buttons.contextButton.menuItems, a = p.options.lang;
          if (m && m.menuItemDefinitions && a && a.exitFullscreen && a.viewFullscreen && w && y) {
            let u = y[w.indexOf("viewFullscreen")];
            u && B.setElementHTML(u, this.isOpen ? a.exitFullscreen : m.menuItemDefinitions.viewFullscreen.text || a.viewFullscreen);
          }
        }
        toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }
      return N;
    }), nt(i, "Core/HttpUtilities.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(B, $) {
      let { win: J } = B, { discardElement: it, objectEach: st } = $, tt = { ajax: function(V) {
        let _ = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, N = new XMLHttpRequest();
        function D(p, y) {
          V.error && V.error(p, y);
        }
        if (!V.url) return !1;
        N.open((V.type || "get").toUpperCase(), V.url, !0), V.headers && V.headers["Content-Type"] || N.setRequestHeader("Content-Type", _[V.dataType || "json"] || _.text), st(V.headers, function(p, y) {
          N.setRequestHeader(y, p);
        }), V.responseType && (N.responseType = V.responseType), N.onreadystatechange = function() {
          let p;
          if (N.readyState === 4) {
            if (N.status === 200) {
              if (V.responseType !== "blob" && (p = N.responseText, V.dataType === "json")) try {
                p = JSON.parse(p);
              } catch (y) {
                if (y instanceof Error) return D(N, y);
              }
              return V.success && V.success(p, N);
            }
            D(N, N.responseText);
          }
        }, V.data && typeof V.data != "string" && (V.data = JSON.stringify(V.data)), N.send(V.data);
      }, getJSON: function(V, _) {
        tt.ajax({ url: V, success: _, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(V, _, N) {
        let D = new J.FormData();
        st(_, function(m, w) {
          D.append(w, m);
        }), D.append("b64", "true");
        let { filename: p, type: y } = _;
        return J.fetch(V, { method: "POST", body: D, ...N }).then((m) => {
          m.ok && m.text().then((w) => {
            let a = document.createElement("a");
            a.href = `data:${y};base64,${w}`, a.download = p, a.click(), it(a);
          });
        });
      } };
      return tt;
    }), nt(i, "Extensions/Exporting/Exporting.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Chart/Chart.js"], i["Core/Chart/ChartNavigationComposition.js"], i["Core/Defaults.js"], i["Extensions/Exporting/ExportingDefaults.js"], i["Extensions/Exporting/ExportingSymbols.js"], i["Extensions/Exporting/Fullscreen.js"], i["Core/Globals.js"], i["Core/HttpUtilities.js"], i["Core/Utilities.js"]], function(B, $, J, it, st, tt, V, _, N, D) {
      var p;
      let { defaultOptions: y } = it, { doc: m, SVG_NS: w, win: a } = _, { addEvent: u, css: b, createElement: l, discardElement: d, extend: C, find: R, fireEvent: z, isObject: O, merge: h, objectEach: f, pick: s, removeEvent: t, uniqueKey: e } = D;
      return function(r) {
        let g, o = [/-/, /^(clipPath|cssText|d|height|width)$/, /^font$/, /[lL]ogical(Width|Height)$/, /^parentRule$/, /^(cssRules|ownerRules)$/, /perspective/, /TapHighlightColor/, /^transition/, /^length$/, /^\d+$/], c = ["fill", "stroke", "strokeLinecap", "strokeLinejoin", "strokeWidth", "textAnchor", "x", "y"];
        r.inlineAllowlist = [];
        let n = ["clipPath", "defs", "desc"];
        function S(F) {
          let et, rt, at = this, ct = at.renderer, Z = h(at.options.navigation.buttonOptions, F), X = Z.onclick, K = Z.menuItems, ot = Z.symbolSize || 12;
          if (at.btnCount || (at.btnCount = 0), at.exportDivElements || (at.exportDivElements = [], at.exportSVGElements = []), Z.enabled === !1 || !Z.theme) return;
          let ht = at.styledMode ? {} : Z.theme;
          X ? rt = function(lt) {
            lt && lt.stopPropagation(), X.call(at, lt);
          } : K && (rt = function(lt) {
            lt && lt.stopPropagation(), at.contextMenu(dt.menuClassName, K, dt.translateX || 0, dt.translateY || 0, dt.width || 0, dt.height || 0, dt), dt.setState(2);
          }), Z.text && Z.symbol ? ht.paddingLeft = s(ht.paddingLeft, 30) : Z.text || C(ht, { width: Z.width, height: Z.height, padding: 0 });
          let dt = ct.button(Z.text, 0, 0, rt, ht, void 0, void 0, void 0, void 0, Z.useHTML).addClass(F.className).attr({ title: s(at.options.lang[Z._titleKey || Z.titleKey], "") });
          dt.menuClassName = F.menuClassName || "highcharts-menu-" + at.btnCount++, Z.symbol && (et = ct.symbol(Z.symbol, Math.round((Z.symbolX || 0) - ot / 2), Math.round((Z.symbolY || 0) - ot / 2), ot, ot, { width: ot, height: ot }).addClass("highcharts-button-symbol").attr({ zIndex: 1 }).add(dt), at.styledMode || et.attr({ stroke: Z.symbolStroke, fill: Z.symbolFill, "stroke-width": Z.symbolStrokeWidth || 1 })), dt.add(at.exportingGroup).align(C(Z, { width: dt.width, x: s(Z.x, at.buttonOffset) }), !0, "spacingBox"), at.buttonOffset += ((dt.width || 0) + Z.buttonSpacing) * (Z.align === "right" ? -1 : 1), at.exportSVGElements.push(dt, et);
        }
        function j() {
          if (!this.printReverseInfo) return;
          let { childNodes: F, origDisplay: et, resetParams: rt } = this.printReverseInfo;
          this.moveContainers(this.renderTo), [].forEach.call(F, function(at, ct) {
            at.nodeType === 1 && (at.style.display = et[ct] || "");
          }), this.isPrinting = !1, rt && this.setSize.apply(this, rt), delete this.printReverseInfo, g = void 0, z(this, "afterPrint");
        }
        function v() {
          var at;
          let F = m.body, et = this.options.exporting.printMaxWidth, rt = { childNodes: F.childNodes, origDisplay: [], resetParams: void 0 };
          this.isPrinting = !0, (at = this.pointer) == null || at.reset(void 0, 0), z(this, "beforePrint"), et && this.chartWidth > et && (rt.resetParams = [this.options.chart.width, void 0, !1], this.setSize(et, void 0, !1)), [].forEach.call(rt.childNodes, function(ct, Z) {
            ct.nodeType === 1 && (rt.origDisplay[Z] = ct.style.display, ct.style.display = "none");
          }), this.moveContainers(F), this.printReverseInfo = rt;
        }
        function P(F) {
          F.renderExporting(), u(F, "redraw", F.renderExporting), u(F, "destroy", F.destroyExport);
        }
        function G(F, et, rt, at, ct, Z, X) {
          var mt, yt;
          let K = this, ot = K.options.navigation, ht = K.chartWidth, dt = K.chartHeight, lt = "cache-" + F, ut = Math.max(ct, Z), ft, gt = K[lt];
          gt || (K.exportContextMenu = K[lt] = gt = l("div", { className: F }, { position: "absolute", zIndex: 1e3, padding: ut + "px", pointerEvents: "auto", ...K.renderer.style }, ((mt = K.scrollablePlotArea) == null ? void 0 : mt.fixedDiv) || K.container), ft = l("ul", { className: "highcharts-menu" }, K.styledMode ? {} : { listStyle: "none", margin: 0, padding: 0 }, gt), K.styledMode || b(ft, C({ MozBoxShadow: "3px 3px 10px #888", WebkitBoxShadow: "3px 3px 10px #888", boxShadow: "3px 3px 10px #888" }, ot.menuStyle)), gt.hideMenu = function() {
            b(gt, { display: "none" }), X && X.setState(0), K.openMenu = !1, b(K.renderTo, { overflow: "hidden" }), b(K.container, { overflow: "hidden" }), D.clearTimeout(gt.hideTimer), z(K, "exportMenuHidden");
          }, K.exportEvents.push(u(gt, "mouseleave", function() {
            gt.hideTimer = a.setTimeout(gt.hideMenu, 500);
          }), u(gt, "mouseenter", function() {
            D.clearTimeout(gt.hideTimer);
          }), u(m, "mouseup", function(vt) {
            var xt;
            (xt = K.pointer) != null && xt.inClass(vt.target, F) || gt.hideMenu();
          }), u(gt, "click", function() {
            K.openMenu && gt.hideMenu();
          })), et.forEach(function(vt) {
            if (typeof vt == "string" && (vt = K.options.exporting.menuItemDefinitions[vt]), O(vt, !0)) {
              let xt;
              vt.separator ? xt = l("hr", void 0, void 0, ft) : (vt.textKey === "viewData" && K.isDataTableVisible && (vt.textKey = "hideData"), xt = l("li", { className: "highcharts-menu-item", onclick: function(bt) {
                bt && bt.stopPropagation(), gt.hideMenu(), typeof vt != "string" && vt.onclick && vt.onclick.apply(K, arguments);
              } }, void 0, ft), B.setElementHTML(xt, vt.text || K.options.lang[vt.textKey]), K.styledMode || (xt.onmouseover = function() {
                b(this, ot.menuItemHoverStyle);
              }, xt.onmouseout = function() {
                b(this, ot.menuItemStyle);
              }, b(xt, C({ cursor: "pointer" }, ot.menuItemStyle || {})))), K.exportDivElements.push(xt);
            }
          }), K.exportDivElements.push(ft, gt), K.exportMenuWidth = gt.offsetWidth, K.exportMenuHeight = gt.offsetHeight);
          let pt = { display: "block" };
          rt + (K.exportMenuWidth || 0) > ht ? pt.right = ht - rt - ct - ut + "px" : pt.left = rt - ut + "px", at + Z + (K.exportMenuHeight || 0) > dt && ((yt = X.alignOptions) == null ? void 0 : yt.verticalAlign) !== "top" ? pt.bottom = dt - at - ut + "px" : pt.top = at + Z - ut + "px", b(gt, pt), b(K.renderTo, { overflow: "" }), b(K.container, { overflow: "" }), K.openMenu = !0, z(K, "exportMenuShown");
        }
        function W(F) {
          let et, rt = F ? F.target : this, at = rt.exportSVGElements, ct = rt.exportDivElements, Z = rt.exportEvents;
          at && (at.forEach((X, K) => {
            X && (X.onclick = X.ontouchstart = null, rt[et = "cache-" + X.menuClassName] && delete rt[et], at[K] = X.destroy());
          }), at.length = 0), rt.exportingGroup && (rt.exportingGroup.destroy(), delete rt.exportingGroup), ct && (ct.forEach(function(X, K) {
            X && (D.clearTimeout(X.hideTimer), t(X, "mouseleave"), ct[K] = X.onmouseout = X.onmouseover = X.ontouchstart = X.onclick = null, d(X));
          }), ct.length = 0), Z && (Z.forEach(function(X) {
            X();
          }), Z.length = 0);
        }
        function Q(F, et) {
          let rt = this.getSVGForExport(F, et);
          F = h(this.options.exporting, F), N.post(F.url, { filename: F.filename ? F.filename.replace(/\//g, "-") : this.getFilename(), type: F.type, width: F.width, scale: F.scale, svg: rt }, F.fetchOptions);
        }
        function k() {
          return this.styledMode && this.inlineStyles(), this.container.innerHTML;
        }
        function A() {
          let F = this.userOptions.title && this.userOptions.title.text, et = this.options.exporting.filename;
          return et ? et.replace(/\//g, "-") : (typeof F == "string" && (et = F.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!et || et.length < 5) && (et = "chart"), et);
        }
        function L(F) {
          let et, rt, at = h(this.options, F);
          at.plotOptions = h(this.userOptions.plotOptions, F && F.plotOptions), at.time = h(this.userOptions.time, F && F.time);
          let ct = l("div", null, { position: "absolute", top: "-9999em", width: this.chartWidth + "px", height: this.chartHeight + "px" }, m.body), Z = this.renderTo.style.width, X = this.renderTo.style.height, K = at.exporting.sourceWidth || at.chart.width || /px$/.test(Z) && parseInt(Z, 10) || (at.isGantt ? 800 : 600), ot = at.exporting.sourceHeight || at.chart.height || /px$/.test(X) && parseInt(X, 10) || 400;
          C(at.chart, { animation: !1, renderTo: ct, forExport: !0, renderer: "SVGRenderer", width: K, height: ot }), at.exporting.enabled = !1, delete at.data, at.series = [], this.series.forEach(function(lt) {
            (rt = h(lt.userOptions, { animation: !1, enableMouseTracking: !1, showCheckbox: !1, visible: lt.visible })).isInternal || at.series.push(rt);
          });
          let ht = {};
          this.axes.forEach(function(lt) {
            lt.userOptions.internalKey || (lt.userOptions.internalKey = e()), lt.options.isInternal || (ht[lt.coll] || (ht[lt.coll] = !0, at[lt.coll] = []), at[lt.coll].push(h(lt.userOptions, { visible: lt.visible, type: lt.type, uniqueNames: lt.uniqueNames })));
          }), at.colorAxis = this.userOptions.colorAxis;
          let dt = new this.constructor(at, this.callback);
          return F && ["xAxis", "yAxis", "series"].forEach(function(lt) {
            let ut = {};
            F[lt] && (ut[lt] = F[lt], dt.update(ut));
          }), this.axes.forEach(function(lt) {
            let ut = R(dt.axes, function(mt) {
              return mt.options.internalKey === lt.userOptions.internalKey;
            }), ft = lt.getExtremes(), gt = ft.userMin, pt = ft.userMax;
            ut && (gt !== void 0 && gt !== ut.min || pt !== void 0 && pt !== ut.max) && ut.setExtremes(gt, pt, !0, !1);
          }), et = dt.getChartHTML(), z(this, "getSVG", { chartCopy: dt }), et = this.sanitizeSVG(et, at), at = null, dt.destroy(), d(ct), et;
        }
        function Y(F, et) {
          let rt = this.options.exporting;
          return this.getSVG(h({ chart: { borderRadius: 0 } }, rt.chartOptions, et, { exporting: { sourceWidth: F && F.sourceWidth || rt.sourceWidth, sourceHeight: F && F.sourceHeight || rt.sourceHeight } }));
        }
        function x() {
          let F, et = r.inlineAllowlist, rt = {}, at = m.createElement("iframe");
          b(at, { width: "1px", height: "1px", visibility: "hidden" }), m.body.appendChild(at);
          let ct = at.contentWindow && at.contentWindow.document;
          ct && ct.body.appendChild(ct.createElementNS(w, "svg")), function Z(X) {
            let K, ot, ht, dt, lt, ut, ft = {};
            if (ct && X.nodeType === 1 && n.indexOf(X.nodeName) === -1) {
              if (K = a.getComputedStyle(X, null), ot = X.nodeName === "svg" ? {} : a.getComputedStyle(X.parentNode, null), !rt[X.nodeName]) {
                F = ct.getElementsByTagName("svg")[0], ht = ct.createElementNS(X.namespaceURI, X.nodeName), F.appendChild(ht);
                let gt = a.getComputedStyle(ht, null), pt = {};
                for (let mt in gt) mt.length < 1e3 && typeof gt[mt] == "string" && !/^\d+$/.test(mt) && (pt[mt] = gt[mt]);
                rt[X.nodeName] = pt, X.nodeName === "text" && delete rt.text.fill, F.removeChild(ht);
              }
              for (let gt in K) (_.isFirefox || _.isMS || _.isSafari || Object.hasOwnProperty.call(K, gt)) && function(pt, mt) {
                if (dt = lt = !1, et.length) {
                  for (ut = et.length; ut-- && !lt; ) lt = et[ut].test(mt);
                  dt = !lt;
                }
                for (mt === "transform" && pt === "none" && (dt = !0), ut = o.length; ut-- && !dt; ) {
                  if (mt.length > 1e3) throw Error("Input too long");
                  dt = o[ut].test(mt) || typeof pt == "function";
                }
                !dt && (ot[mt] !== pt || X.nodeName === "svg") && rt[X.nodeName][mt] !== pt && (c && c.indexOf(mt) === -1 ? ft[mt] = pt : pt && X.setAttribute(mt.replace(/[A-Z]/g, function(yt) {
                  return "-" + yt.toLowerCase();
                }), pt));
              }(K[gt], gt);
              if (b(X, ft), X.nodeName === "svg" && X.setAttribute("stroke-width", "1px"), X.nodeName === "text") return;
              [].forEach.call(X.children || X.childNodes, Z);
            }
          }(this.container.querySelector("svg")), F.parentNode.removeChild(F), at.parentNode.removeChild(at);
        }
        function T(F) {
          let { scrollablePlotArea: et } = this;
          (et ? [et.fixedDiv, et.scrollingContainer] : [this.container]).forEach(function(rt) {
            F.appendChild(rt);
          });
        }
        function M() {
          let F = this, et = (rt, at, ct) => {
            F.isDirtyExporting = !0, h(!0, F.options[rt], at), s(ct, !0) && F.redraw();
          };
          F.exporting = { update: function(rt, at) {
            et("exporting", rt, at);
          } }, J.compose(F).navigation.addUpdate((rt, at) => {
            et("navigation", rt, at);
          });
        }
        function U() {
          let F = this;
          F.isPrinting || (g = F, _.isSafari || F.beforePrint(), setTimeout(() => {
            a.focus(), a.print(), _.isSafari || setTimeout(() => {
              F.afterPrint();
            }, 1e3);
          }, 1));
        }
        function H() {
          let F = this, et = F.options.exporting, rt = et.buttons, at = F.isDirtyExporting || !F.exportSVGElements;
          F.buttonOffset = 0, F.isDirtyExporting && F.destroyExport(), at && et.enabled !== !1 && (F.exportEvents = [], F.exportingGroup = F.exportingGroup || F.renderer.g("exporting-group").attr({ zIndex: 3 }).add(), f(rt, function(ct) {
            F.addButton(ct);
          }), F.isDirtyExporting = !1);
        }
        function q(F, et) {
          let rt = F.indexOf("</svg>") + 6, at = F.substr(rt);
          return F = F.substr(0, rt), et && et.exporting && et.exporting.allowHTML && at && (at = '<foreignObject x="0" y="0" width="' + et.chart.width + '" height="' + et.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + at.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", F = F.replace("</svg>", at + "</svg>")), F = F.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ \d]+,[ \d]+,[ \d]+),([ \d\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, " ").replace(/&shy;/g, "­");
        }
        r.compose = function(F, et) {
          tt.compose(et), V.compose(F);
          let rt = F.prototype;
          rt.exportChart || (rt.afterPrint = j, rt.exportChart = Q, rt.inlineStyles = x, rt.print = U, rt.sanitizeSVG = q, rt.getChartHTML = k, rt.getSVG = L, rt.getSVGForExport = Y, rt.getFilename = A, rt.moveContainers = T, rt.beforePrint = v, rt.contextMenu = G, rt.addButton = S, rt.destroyExport = W, rt.renderExporting = H, rt.callbacks.push(P), u(F, "init", M), _.isSafari && a.matchMedia("print").addListener(function(at) {
            g && (at.matches ? g.beforePrint() : g.afterPrint());
          }), y.exporting = h(st.exporting, y.exporting), y.lang = h(st.lang, y.lang), y.navigation = h(st.navigation, y.navigation));
        };
      }(p || (p = {})), p;
    }), nt(i, "masters/modules/exporting.src.js", [i["Core/Globals.js"], i["Extensions/Exporting/Exporting.js"], i["Core/HttpUtilities.js"]], function(B, $, J) {
      return B.HttpUtilities = B.HttpUtilities || J, B.ajax = B.HttpUtilities.ajax, B.getJSON = B.HttpUtilities.getJSON, B.post = B.HttpUtilities.post, $.compose(B.Chart, B.Renderer), B;
    });
  });
})(ws);
var el = ws.exports;
const il = /* @__PURE__ */ ce(el);
var sl = Object.defineProperty, rl = Object.getOwnPropertyDescriptor, He = (E, I, i, nt) => {
  for (var B = nt > 1 ? void 0 : nt ? rl(I, i) : I, $ = E.length - 1, J; $ >= 0; $--)
    (J = E[$]) && (B = (nt ? J(I, i, B) : J(B)) || B);
  return nt && B && sl(I, i, B), B;
};
function ol(E) {
  return !!(E.custom && E.custom.tableElement);
}
function vl(E) {
  let I = class extends E {
    constructor() {
      super(...arguments), this.tableId = void 0, this.disableExporting = !1;
    }
    get localComponentOptions() {
      var i, nt;
      return Ka.createChartOptions(super.localComponentOptions, {
        data: {
          table: this.tableId
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: this.tableId ? I.exportMenuItemsLimited : I.exportMenuItemsDefault
            }
          },
          chartOptions: {
            chart: {
              styledMode: !1
              // Turned off because the exported images don't know the styles we apply
            }
          },
          enabled: !this.disableExporting,
          sourceHeight: (i = this.chartSize) == null ? void 0 : i.chartHeight,
          sourceWidth: (nt = this.chartSize) == null ? void 0 : nt.chartWidth
        },
        plotOptions: {
          custom: {
            tableElement: this.getScopedTagName("beacon-table")
          }
        }
      });
    }
    initializeHighcharts(i) {
      super.initializeHighcharts(i), il(i), tl(i), Ja(i), i.addEvent(i.Chart, "afterViewData", function() {
        const nt = this, B = nt.dataTableDiv.querySelector("table");
        if (!B) return;
        const {
          userOptions: { plotOptions: $ }
        } = nt;
        if ($ && ol($)) {
          const J = document.createElement(
            $.custom.tableElement
          );
          nt.dataTableDiv.appendChild(J), J.appendChild(B);
        }
      });
    }
    willUpdate(i) {
      var nt, B;
      (nt = super.willUpdate) == null || nt.call(this, i), i.has("disableExporting") && ((B = this.chart) == null || B.update({
        exporting: {
          enabled: !this.disableExporting
        }
      }));
    }
  };
  return I.exportMenuItemsDefault = [
    "viewFullscreen",
    "separator",
    "downloadCSV",
    "viewData"
  ], I.exportMenuItemsLimited = [
    "viewFullscreen",
    "separator",
    "downloadCSV"
  ], He([
    Dt({ attribute: "table-id" })
  ], I.prototype, "tableId", 2), He([
    Dt({ type: Boolean, attribute: "disable-exporting" })
  ], I.prototype, "disableExporting", 2), I = He([
    Ls("Exporting")
  ], I), I;
}
export {
  Ka as B,
  te as C,
  fs as D,
  vl as E,
  bi as H,
  Na as a,
  ce as g,
  Qt as h,
  Ia as s
};
